(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2a7c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2a7c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3hyzP", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $263dc7dcf0670b1f$export$ffb0004e005737fa; }, function (v) { return $263dc7dcf0670b1f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $263dc7dcf0670b1f$export$34b9dba7ce09269b; }, function (v) { return $263dc7dcf0670b1f$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $263dc7dcf0670b1f$export$25062201e9e25d76; }, function (v) { return $263dc7dcf0670b1f$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $263dc7dcf0670b1f$export$ffb0004e005737fa;
var $263dc7dcf0670b1f$export$34b9dba7ce09269b;
var $263dc7dcf0670b1f$export$25062201e9e25d76;
"use strict";

var $33gHU = parcelRequire("33gHU");
var $263dc7dcf0670b1f$var$k = Symbol.for("react.element"), $263dc7dcf0670b1f$var$l = Symbol.for("react.fragment"), $263dc7dcf0670b1f$var$m = Object.prototype.hasOwnProperty, $263dc7dcf0670b1f$var$n = $33gHU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $263dc7dcf0670b1f$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $263dc7dcf0670b1f$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$263dc7dcf0670b1f$var$m.call(a, b) && !$263dc7dcf0670b1f$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $263dc7dcf0670b1f$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $263dc7dcf0670b1f$var$n.current
    };
}
$263dc7dcf0670b1f$export$ffb0004e005737fa = $263dc7dcf0670b1f$var$l;
$263dc7dcf0670b1f$export$34b9dba7ce09269b = $263dc7dcf0670b1f$var$q;
$263dc7dcf0670b1f$export$25062201e9e25d76 = $263dc7dcf0670b1f$var$q;

});
parcelRegister("33gHU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hQyZI"));

});
parcelRegister("hQyZI", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $cfe2702563eccd2a$export$dca3b0875bd9a954; }, function (v) { return $cfe2702563eccd2a$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $cfe2702563eccd2a$export$16fa2f45be04daa8; }, function (v) { return $cfe2702563eccd2a$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cfe2702563eccd2a$export$ffb0004e005737fa; }, function (v) { return $cfe2702563eccd2a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $cfe2702563eccd2a$export$e2c29f18771995cb; }, function (v) { return $cfe2702563eccd2a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $cfe2702563eccd2a$export$221d75b3f55bb0bd; }, function (v) { return $cfe2702563eccd2a$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cfe2702563eccd2a$export$5f8d39834fd61797; }, function (v) { return $cfe2702563eccd2a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cfe2702563eccd2a$export$74bf444e3cd11ea5; }, function (v) { return $cfe2702563eccd2a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $cfe2702563eccd2a$export$ae55be85d98224ed; }, function (v) { return $cfe2702563eccd2a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $cfe2702563eccd2a$export$3ba232387fd5d6dd; }, function (v) { return $cfe2702563eccd2a$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $cfe2702563eccd2a$export$e530037191fcd5d7; }, function (v) { return $cfe2702563eccd2a$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $cfe2702563eccd2a$export$fd42f52fd3ae1109; }, function (v) { return $cfe2702563eccd2a$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $cfe2702563eccd2a$export$c8a8987d4410bf2d; }, function (v) { return $cfe2702563eccd2a$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $cfe2702563eccd2a$export$d38cd72104c1f0e9; }, function (v) { return $cfe2702563eccd2a$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $cfe2702563eccd2a$export$7d1e3a5e95ceca43; }, function (v) { return $cfe2702563eccd2a$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $cfe2702563eccd2a$export$257a8862b851cb5b; }, function (v) { return $cfe2702563eccd2a$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $cfe2702563eccd2a$export$a8257692ac88316c; }, function (v) { return $cfe2702563eccd2a$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $cfe2702563eccd2a$export$488013bae63b21da; }, function (v) { return $cfe2702563eccd2a$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $cfe2702563eccd2a$export$7c73462e0d25e514; }, function (v) { return $cfe2702563eccd2a$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $cfe2702563eccd2a$export$7568632d0d33d16d; }, function (v) { return $cfe2702563eccd2a$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $cfe2702563eccd2a$export$88948ce120ea2619; }, function (v) { return $cfe2702563eccd2a$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $cfe2702563eccd2a$export$35808ee640e87ca7; }, function (v) { return $cfe2702563eccd2a$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $cfe2702563eccd2a$export$fae74005e78b1a27; }, function (v) { return $cfe2702563eccd2a$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $cfe2702563eccd2a$export$dc8fbce3eb94dc1e; }, function (v) { return $cfe2702563eccd2a$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $cfe2702563eccd2a$export$6a7bc4e911dc01cf; }, function (v) { return $cfe2702563eccd2a$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $cfe2702563eccd2a$export$6d9c69b0de29b591; }, function (v) { return $cfe2702563eccd2a$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $cfe2702563eccd2a$export$f680877a34711e37; }, function (v) { return $cfe2702563eccd2a$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $cfe2702563eccd2a$export$d5a552a76deda3c2; }, function (v) { return $cfe2702563eccd2a$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $cfe2702563eccd2a$export$aaabe4eda9ed9969; }, function (v) { return $cfe2702563eccd2a$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $cfe2702563eccd2a$export$e5c5a5f917a5871c; }, function (v) { return $cfe2702563eccd2a$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $cfe2702563eccd2a$export$1538c33de8887b59; }, function (v) { return $cfe2702563eccd2a$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $cfe2702563eccd2a$export$13e3392192263954; }, function (v) { return $cfe2702563eccd2a$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $cfe2702563eccd2a$export$b8f5890fc79d6aca; }, function (v) { return $cfe2702563eccd2a$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $cfe2702563eccd2a$export$60241385465d0a34; }, function (v) { return $cfe2702563eccd2a$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $cfe2702563eccd2a$export$306c0aa65ff9ec16; }, function (v) { return $cfe2702563eccd2a$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $cfe2702563eccd2a$export$7b286972b8d8ccbf; }, function (v) { return $cfe2702563eccd2a$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $cfe2702563eccd2a$export$83d89fbfd8236492; }, function (v) { return $cfe2702563eccd2a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $g83i1 = parcelRequire("g83i1");
var $cfe2702563eccd2a$export$dca3b0875bd9a954;
var $cfe2702563eccd2a$export$16fa2f45be04daa8;
var $cfe2702563eccd2a$export$ffb0004e005737fa;
var $cfe2702563eccd2a$export$e2c29f18771995cb;
var $cfe2702563eccd2a$export$221d75b3f55bb0bd;
var $cfe2702563eccd2a$export$5f8d39834fd61797;
var $cfe2702563eccd2a$export$74bf444e3cd11ea5;
var $cfe2702563eccd2a$export$ae55be85d98224ed;
var $cfe2702563eccd2a$export$3ba232387fd5d6dd;
var $cfe2702563eccd2a$export$e530037191fcd5d7;
var $cfe2702563eccd2a$export$fd42f52fd3ae1109;
var $cfe2702563eccd2a$export$c8a8987d4410bf2d;
var $cfe2702563eccd2a$export$d38cd72104c1f0e9;
var $cfe2702563eccd2a$export$7d1e3a5e95ceca43;
var $cfe2702563eccd2a$export$257a8862b851cb5b;
var $cfe2702563eccd2a$export$a8257692ac88316c;
var $cfe2702563eccd2a$export$488013bae63b21da;
var $cfe2702563eccd2a$export$7c73462e0d25e514;
var $cfe2702563eccd2a$export$7568632d0d33d16d;
var $cfe2702563eccd2a$export$88948ce120ea2619;
var $cfe2702563eccd2a$export$35808ee640e87ca7;
var $cfe2702563eccd2a$export$fae74005e78b1a27;
var $cfe2702563eccd2a$export$dc8fbce3eb94dc1e;
var $cfe2702563eccd2a$export$6a7bc4e911dc01cf;
var $cfe2702563eccd2a$export$6d9c69b0de29b591;
var $cfe2702563eccd2a$export$f680877a34711e37;
var $cfe2702563eccd2a$export$d5a552a76deda3c2;
var $cfe2702563eccd2a$export$aaabe4eda9ed9969;
var $cfe2702563eccd2a$export$e5c5a5f917a5871c;
var $cfe2702563eccd2a$export$1538c33de8887b59;
var $cfe2702563eccd2a$export$13e3392192263954;
var $cfe2702563eccd2a$export$b8f5890fc79d6aca;
var $cfe2702563eccd2a$export$60241385465d0a34;
var $cfe2702563eccd2a$export$306c0aa65ff9ec16;
var $cfe2702563eccd2a$export$7b286972b8d8ccbf;
var $cfe2702563eccd2a$export$83d89fbfd8236492;
"use strict";
var $cfe2702563eccd2a$var$l = Symbol.for("react.element"), $cfe2702563eccd2a$var$n = Symbol.for("react.portal"), $cfe2702563eccd2a$var$p = Symbol.for("react.fragment"), $cfe2702563eccd2a$var$q = Symbol.for("react.strict_mode"), $cfe2702563eccd2a$var$r = Symbol.for("react.profiler"), $cfe2702563eccd2a$var$t = Symbol.for("react.provider"), $cfe2702563eccd2a$var$u = Symbol.for("react.context"), $cfe2702563eccd2a$var$v = Symbol.for("react.forward_ref"), $cfe2702563eccd2a$var$w = Symbol.for("react.suspense"), $cfe2702563eccd2a$var$x = Symbol.for("react.memo"), $cfe2702563eccd2a$var$y = Symbol.for("react.lazy"), $cfe2702563eccd2a$var$z = Symbol.iterator;
function $cfe2702563eccd2a$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cfe2702563eccd2a$var$z && a[$cfe2702563eccd2a$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $cfe2702563eccd2a$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $cfe2702563eccd2a$var$C = Object.assign, $cfe2702563eccd2a$var$D = {};
function $cfe2702563eccd2a$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cfe2702563eccd2a$var$D;
    this.updater = e || $cfe2702563eccd2a$var$B;
}
$cfe2702563eccd2a$var$E.prototype.isReactComponent = {};
$cfe2702563eccd2a$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$cfe2702563eccd2a$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $cfe2702563eccd2a$var$F() {}
$cfe2702563eccd2a$var$F.prototype = $cfe2702563eccd2a$var$E.prototype;
function $cfe2702563eccd2a$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $cfe2702563eccd2a$var$D;
    this.updater = e || $cfe2702563eccd2a$var$B;
}
var $cfe2702563eccd2a$var$H = $cfe2702563eccd2a$var$G.prototype = new $cfe2702563eccd2a$var$F;
$cfe2702563eccd2a$var$H.constructor = $cfe2702563eccd2a$var$G;
$cfe2702563eccd2a$var$C($cfe2702563eccd2a$var$H, $cfe2702563eccd2a$var$E.prototype);
$cfe2702563eccd2a$var$H.isPureReactComponent = !0;
var $cfe2702563eccd2a$var$I = Array.isArray, $cfe2702563eccd2a$var$J = Object.prototype.hasOwnProperty, $cfe2702563eccd2a$var$K = {
    current: null
}, $cfe2702563eccd2a$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cfe2702563eccd2a$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$cfe2702563eccd2a$var$J.call(b, d) && !$cfe2702563eccd2a$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $cfe2702563eccd2a$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $cfe2702563eccd2a$var$K.current
    };
}
function $cfe2702563eccd2a$var$N(a, b) {
    return {
        $$typeof: $cfe2702563eccd2a$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $cfe2702563eccd2a$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cfe2702563eccd2a$var$l;
}
function $cfe2702563eccd2a$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $cfe2702563eccd2a$var$P = /\/+/g;
function $cfe2702563eccd2a$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $cfe2702563eccd2a$var$escape("" + a.key) : b.toString(36);
}
function $cfe2702563eccd2a$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $g83i1._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $cfe2702563eccd2a$var$l:
                case $cfe2702563eccd2a$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $cfe2702563eccd2a$var$Q(h, 0) : d, $cfe2702563eccd2a$var$I(c) ? (e = "", null != a && (e = a.replace($cfe2702563eccd2a$var$P, "$&/") + "/"), $cfe2702563eccd2a$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($cfe2702563eccd2a$var$O(c) && (c = $cfe2702563eccd2a$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($cfe2702563eccd2a$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($cfe2702563eccd2a$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $cfe2702563eccd2a$var$Q(k, g);
        h += $cfe2702563eccd2a$var$R(k, b, e, f, c);
    }
    else if (f = $cfe2702563eccd2a$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $cfe2702563eccd2a$var$Q(k, g++), h += $cfe2702563eccd2a$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $cfe2702563eccd2a$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $cfe2702563eccd2a$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $cfe2702563eccd2a$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $cfe2702563eccd2a$var$U = {
    current: null
}, $cfe2702563eccd2a$var$V = {
    transition: null
}, $cfe2702563eccd2a$var$W = {
    ReactCurrentDispatcher: $cfe2702563eccd2a$var$U,
    ReactCurrentBatchConfig: $cfe2702563eccd2a$var$V,
    ReactCurrentOwner: $cfe2702563eccd2a$var$K
};
function $cfe2702563eccd2a$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$cfe2702563eccd2a$export$dca3b0875bd9a954 = {
    map: $cfe2702563eccd2a$var$S,
    forEach: function forEach(a, b, e) {
        $cfe2702563eccd2a$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $cfe2702563eccd2a$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $cfe2702563eccd2a$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$cfe2702563eccd2a$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$cfe2702563eccd2a$export$16fa2f45be04daa8 = $cfe2702563eccd2a$var$E;
$cfe2702563eccd2a$export$ffb0004e005737fa = $cfe2702563eccd2a$var$p;
$cfe2702563eccd2a$export$e2c29f18771995cb = $cfe2702563eccd2a$var$r;
$cfe2702563eccd2a$export$221d75b3f55bb0bd = $cfe2702563eccd2a$var$G;
$cfe2702563eccd2a$export$5f8d39834fd61797 = $cfe2702563eccd2a$var$q;
$cfe2702563eccd2a$export$74bf444e3cd11ea5 = $cfe2702563eccd2a$var$w;
$cfe2702563eccd2a$export$ae55be85d98224ed = $cfe2702563eccd2a$var$W;
$cfe2702563eccd2a$export$3ba232387fd5d6dd = $cfe2702563eccd2a$var$X;
$cfe2702563eccd2a$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $cfe2702563eccd2a$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $cfe2702563eccd2a$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$cfe2702563eccd2a$var$J.call(b, f) && !$cfe2702563eccd2a$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $cfe2702563eccd2a$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$cfe2702563eccd2a$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $cfe2702563eccd2a$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $cfe2702563eccd2a$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$cfe2702563eccd2a$export$c8a8987d4410bf2d = $cfe2702563eccd2a$var$M;
$cfe2702563eccd2a$export$d38cd72104c1f0e9 = function(a) {
    var b = $cfe2702563eccd2a$var$M.bind(null, a);
    b.type = a;
    return b;
};
$cfe2702563eccd2a$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$cfe2702563eccd2a$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $cfe2702563eccd2a$var$v,
        render: a
    };
};
$cfe2702563eccd2a$export$a8257692ac88316c = $cfe2702563eccd2a$var$O;
$cfe2702563eccd2a$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $cfe2702563eccd2a$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $cfe2702563eccd2a$var$T
    };
};
$cfe2702563eccd2a$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $cfe2702563eccd2a$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$cfe2702563eccd2a$export$7568632d0d33d16d = function(a) {
    var b = $cfe2702563eccd2a$var$V.transition;
    $cfe2702563eccd2a$var$V.transition = {};
    try {
        a();
    } finally{
        $cfe2702563eccd2a$var$V.transition = b;
    }
};
$cfe2702563eccd2a$export$88948ce120ea2619 = $cfe2702563eccd2a$var$X;
$cfe2702563eccd2a$export$35808ee640e87ca7 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useCallback(a, b);
};
$cfe2702563eccd2a$export$fae74005e78b1a27 = function(a) {
    return $cfe2702563eccd2a$var$U.current.useContext(a);
};
$cfe2702563eccd2a$export$dc8fbce3eb94dc1e = function() {};
$cfe2702563eccd2a$export$6a7bc4e911dc01cf = function(a) {
    return $cfe2702563eccd2a$var$U.current.useDeferredValue(a);
};
$cfe2702563eccd2a$export$6d9c69b0de29b591 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useEffect(a, b);
};
$cfe2702563eccd2a$export$f680877a34711e37 = function() {
    return $cfe2702563eccd2a$var$U.current.useId();
};
$cfe2702563eccd2a$export$d5a552a76deda3c2 = function(a, b, e) {
    return $cfe2702563eccd2a$var$U.current.useImperativeHandle(a, b, e);
};
$cfe2702563eccd2a$export$aaabe4eda9ed9969 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useInsertionEffect(a, b);
};
$cfe2702563eccd2a$export$e5c5a5f917a5871c = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useLayoutEffect(a, b);
};
$cfe2702563eccd2a$export$1538c33de8887b59 = function(a, b) {
    return $cfe2702563eccd2a$var$U.current.useMemo(a, b);
};
$cfe2702563eccd2a$export$13e3392192263954 = function(a, b, e) {
    return $cfe2702563eccd2a$var$U.current.useReducer(a, b, e);
};
$cfe2702563eccd2a$export$b8f5890fc79d6aca = function(a) {
    return $cfe2702563eccd2a$var$U.current.useRef(a);
};
$cfe2702563eccd2a$export$60241385465d0a34 = function(a) {
    return $cfe2702563eccd2a$var$U.current.useState(a);
};
$cfe2702563eccd2a$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $cfe2702563eccd2a$var$U.current.useSyncExternalStore(a, b, e);
};
$cfe2702563eccd2a$export$7b286972b8d8ccbf = function() {
    return $cfe2702563eccd2a$var$U.current.useTransition();
};
$cfe2702563eccd2a$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("g83i1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bbdff1f8b3da5642$export$71511d61b312f219; });
function $bbdff1f8b3da5642$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRegister("fdPHT", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b1502ddb39c03b09$export$ae55be85d98224ed; }, function (v) { return $b1502ddb39c03b09$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b1502ddb39c03b09$export$d39a5bbd09211389; }, function (v) { return $b1502ddb39c03b09$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b1502ddb39c03b09$export$882461b6382ed46c; }, function (v) { return $b1502ddb39c03b09$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b1502ddb39c03b09$export$466bfc07425424d5; }, function (v) { return $b1502ddb39c03b09$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b1502ddb39c03b09$export$cd75ccfd720a3cd4; }, function (v) { return $b1502ddb39c03b09$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b1502ddb39c03b09$export$fa8d919ba61d84db; }, function (v) { return $b1502ddb39c03b09$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b1502ddb39c03b09$export$757ceba2d55c277e; }, function (v) { return $b1502ddb39c03b09$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b1502ddb39c03b09$export$b3890eb0ae9dca99; }, function (v) { return $b1502ddb39c03b09$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b1502ddb39c03b09$export$502457920280e6be; }, function (v) { return $b1502ddb39c03b09$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b1502ddb39c03b09$export$c78a37762a8d58e1; }, function (v) { return $b1502ddb39c03b09$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b1502ddb39c03b09$export$dc54d992c10e8a18; }, function (v) { return $b1502ddb39c03b09$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b1502ddb39c03b09$export$83d89fbfd8236492; }, function (v) { return $b1502ddb39c03b09$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $g83i1 = parcelRequire("g83i1");
var $b1502ddb39c03b09$export$ae55be85d98224ed;
var $b1502ddb39c03b09$export$d39a5bbd09211389;
var $b1502ddb39c03b09$export$882461b6382ed46c;
var $b1502ddb39c03b09$export$466bfc07425424d5;
var $b1502ddb39c03b09$export$cd75ccfd720a3cd4;
var $b1502ddb39c03b09$export$fa8d919ba61d84db;
var $b1502ddb39c03b09$export$757ceba2d55c277e;
var $b1502ddb39c03b09$export$b3890eb0ae9dca99;
var $b1502ddb39c03b09$export$502457920280e6be;
var $b1502ddb39c03b09$export$c78a37762a8d58e1;
var $b1502ddb39c03b09$export$dc54d992c10e8a18;
var $b1502ddb39c03b09$export$83d89fbfd8236492;
"use strict";

var $33gHU = parcelRequire("33gHU");

var $bE6KD = parcelRequire("bE6KD");
function $b1502ddb39c03b09$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b1502ddb39c03b09$var$da = new Set, $b1502ddb39c03b09$var$ea = {};
function $b1502ddb39c03b09$var$fa(a, b) {
    $b1502ddb39c03b09$var$ha(a, b);
    $b1502ddb39c03b09$var$ha(a + "Capture", b);
}
function $b1502ddb39c03b09$var$ha(a, b) {
    $b1502ddb39c03b09$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b1502ddb39c03b09$var$da.add(b[a]);
}
var $b1502ddb39c03b09$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b1502ddb39c03b09$var$ja = Object.prototype.hasOwnProperty, $b1502ddb39c03b09$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b1502ddb39c03b09$var$la = {}, $b1502ddb39c03b09$var$ma = {};
function $b1502ddb39c03b09$var$oa(a) {
    if ($b1502ddb39c03b09$var$ja.call($b1502ddb39c03b09$var$ma, a)) return !0;
    if ($b1502ddb39c03b09$var$ja.call($b1502ddb39c03b09$var$la, a)) return !1;
    if ($b1502ddb39c03b09$var$ka.test(a)) return $b1502ddb39c03b09$var$ma[a] = !0;
    $b1502ddb39c03b09$var$la[a] = !0;
    return !1;
}
function $b1502ddb39c03b09$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $g83i1._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b1502ddb39c03b09$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b1502ddb39c03b09$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b1502ddb39c03b09$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b1502ddb39c03b09$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b1502ddb39c03b09$var$ra = /[\-:]([a-z])/g;
function $b1502ddb39c03b09$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b1502ddb39c03b09$var$ra, $b1502ddb39c03b09$var$sa);
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b1502ddb39c03b09$var$ra, $b1502ddb39c03b09$var$sa);
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b1502ddb39c03b09$var$ra, $b1502ddb39c03b09$var$sa);
    $b1502ddb39c03b09$var$z[b] = new $b1502ddb39c03b09$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b1502ddb39c03b09$var$z.xlinkHref = new $b1502ddb39c03b09$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b1502ddb39c03b09$var$z[a] = new $b1502ddb39c03b09$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b1502ddb39c03b09$var$ta(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$z.hasOwnProperty(b) ? $b1502ddb39c03b09$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b1502ddb39c03b09$var$qa(b, c, e, d) && (c = null), d || null === e ? $b1502ddb39c03b09$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b1502ddb39c03b09$var$ua = $33gHU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b1502ddb39c03b09$var$va = Symbol.for("react.element"), $b1502ddb39c03b09$var$wa = Symbol.for("react.portal"), $b1502ddb39c03b09$var$ya = Symbol.for("react.fragment"), $b1502ddb39c03b09$var$za = Symbol.for("react.strict_mode"), $b1502ddb39c03b09$var$Aa = Symbol.for("react.profiler"), $b1502ddb39c03b09$var$Ba = Symbol.for("react.provider"), $b1502ddb39c03b09$var$Ca = Symbol.for("react.context"), $b1502ddb39c03b09$var$Da = Symbol.for("react.forward_ref"), $b1502ddb39c03b09$var$Ea = Symbol.for("react.suspense"), $b1502ddb39c03b09$var$Fa = Symbol.for("react.suspense_list"), $b1502ddb39c03b09$var$Ga = Symbol.for("react.memo"), $b1502ddb39c03b09$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b1502ddb39c03b09$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b1502ddb39c03b09$var$Ja = Symbol.iterator;
function $b1502ddb39c03b09$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b1502ddb39c03b09$var$Ja && a[$b1502ddb39c03b09$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b1502ddb39c03b09$var$A = Object.assign, $b1502ddb39c03b09$var$La;
function $b1502ddb39c03b09$var$Ma(a) {
    if (void 0 === $b1502ddb39c03b09$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b1502ddb39c03b09$var$La = b && b[1] || "";
    }
    return "\n" + $b1502ddb39c03b09$var$La + a;
}
var $b1502ddb39c03b09$var$Na = !1;
function $b1502ddb39c03b09$var$Oa(a, b) {
    if (!a || $b1502ddb39c03b09$var$Na) return "";
    $b1502ddb39c03b09$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b1502ddb39c03b09$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b1502ddb39c03b09$var$Ma(a) : "";
}
function $b1502ddb39c03b09$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b1502ddb39c03b09$var$Ma(a.type);
        case 16:
            return $b1502ddb39c03b09$var$Ma("Lazy");
        case 13:
            return $b1502ddb39c03b09$var$Ma("Suspense");
        case 19:
            return $b1502ddb39c03b09$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b1502ddb39c03b09$var$Oa(a.type, !1), a;
        case 11:
            return a = $b1502ddb39c03b09$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b1502ddb39c03b09$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b1502ddb39c03b09$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b1502ddb39c03b09$var$ya:
            return "Fragment";
        case $b1502ddb39c03b09$var$wa:
            return "Portal";
        case $b1502ddb39c03b09$var$Aa:
            return "Profiler";
        case $b1502ddb39c03b09$var$za:
            return "StrictMode";
        case $b1502ddb39c03b09$var$Ea:
            return "Suspense";
        case $b1502ddb39c03b09$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b1502ddb39c03b09$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b1502ddb39c03b09$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b1502ddb39c03b09$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b1502ddb39c03b09$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b1502ddb39c03b09$var$Qa(a.type) || "Memo";
        case $b1502ddb39c03b09$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b1502ddb39c03b09$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b1502ddb39c03b09$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b1502ddb39c03b09$var$Qa(b);
        case 8:
            return b === $b1502ddb39c03b09$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b1502ddb39c03b09$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $g83i1._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b1502ddb39c03b09$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b1502ddb39c03b09$var$Ua(a) {
    var b = $b1502ddb39c03b09$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b1502ddb39c03b09$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b1502ddb39c03b09$var$Ua(a));
}
function $b1502ddb39c03b09$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b1502ddb39c03b09$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b1502ddb39c03b09$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b1502ddb39c03b09$var$Ya(a, b) {
    var c = b.checked;
    return $b1502ddb39c03b09$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b1502ddb39c03b09$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b1502ddb39c03b09$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b1502ddb39c03b09$var$ab(a, b) {
    b = b.checked;
    null != b && $b1502ddb39c03b09$var$ta(a, "checked", b, !1);
}
function $b1502ddb39c03b09$var$bb(a, b) {
    $b1502ddb39c03b09$var$ab(a, b);
    var c = $b1502ddb39c03b09$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b1502ddb39c03b09$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b1502ddb39c03b09$var$cb(a, b.type, $b1502ddb39c03b09$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b1502ddb39c03b09$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b1502ddb39c03b09$var$cb(a, b, c) {
    if ("number" !== b || $b1502ddb39c03b09$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b1502ddb39c03b09$var$eb = Array.isArray;
function $b1502ddb39c03b09$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b1502ddb39c03b09$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b1502ddb39c03b09$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b1502ddb39c03b09$var$p(91));
    return $b1502ddb39c03b09$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b1502ddb39c03b09$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b1502ddb39c03b09$var$p(92));
            if ($b1502ddb39c03b09$var$eb(c)) {
                if (1 < c.length) throw Error($b1502ddb39c03b09$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b1502ddb39c03b09$var$Sa(c)
    };
}
function $b1502ddb39c03b09$var$ib(a, b) {
    var c = $b1502ddb39c03b09$var$Sa(b.value), d = $b1502ddb39c03b09$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b1502ddb39c03b09$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b1502ddb39c03b09$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b1502ddb39c03b09$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b1502ddb39c03b09$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b1502ddb39c03b09$var$mb, $b1502ddb39c03b09$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b1502ddb39c03b09$var$mb = $b1502ddb39c03b09$var$mb || document.createElement("div");
        $b1502ddb39c03b09$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b1502ddb39c03b09$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b1502ddb39c03b09$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b1502ddb39c03b09$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b1502ddb39c03b09$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b1502ddb39c03b09$var$pb).forEach(function(a) {
    $b1502ddb39c03b09$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b1502ddb39c03b09$var$pb[b] = $b1502ddb39c03b09$var$pb[a];
    });
});
function $b1502ddb39c03b09$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b1502ddb39c03b09$var$pb.hasOwnProperty(a) && $b1502ddb39c03b09$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b1502ddb39c03b09$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b1502ddb39c03b09$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b1502ddb39c03b09$var$tb = $b1502ddb39c03b09$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b1502ddb39c03b09$var$ub(a, b) {
    if (b) {
        if ($b1502ddb39c03b09$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b1502ddb39c03b09$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b1502ddb39c03b09$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b1502ddb39c03b09$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b1502ddb39c03b09$var$p(62));
    }
}
function $b1502ddb39c03b09$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b1502ddb39c03b09$var$wb = null;
function $b1502ddb39c03b09$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b1502ddb39c03b09$var$yb = null, $b1502ddb39c03b09$var$zb = null, $b1502ddb39c03b09$var$Ab = null;
function $b1502ddb39c03b09$var$Bb(a) {
    if (a = $b1502ddb39c03b09$var$Cb(a)) {
        if ("function" !== typeof $b1502ddb39c03b09$var$yb) throw Error($b1502ddb39c03b09$var$p(280));
        var b = a.stateNode;
        b && (b = $b1502ddb39c03b09$var$Db(b), $b1502ddb39c03b09$var$yb(a.stateNode, a.type, b));
    }
}
function $b1502ddb39c03b09$var$Eb(a) {
    $b1502ddb39c03b09$var$zb ? $b1502ddb39c03b09$var$Ab ? $b1502ddb39c03b09$var$Ab.push(a) : $b1502ddb39c03b09$var$Ab = [
        a
    ] : $b1502ddb39c03b09$var$zb = a;
}
function $b1502ddb39c03b09$var$Fb() {
    if ($b1502ddb39c03b09$var$zb) {
        var a = $b1502ddb39c03b09$var$zb, b = $b1502ddb39c03b09$var$Ab;
        $b1502ddb39c03b09$var$Ab = $b1502ddb39c03b09$var$zb = null;
        $b1502ddb39c03b09$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b1502ddb39c03b09$var$Bb(b[a]);
    }
}
function $b1502ddb39c03b09$var$Gb(a, b) {
    return a(b);
}
function $b1502ddb39c03b09$var$Hb() {}
var $b1502ddb39c03b09$var$Ib = !1;
function $b1502ddb39c03b09$var$Jb(a, b, c) {
    if ($b1502ddb39c03b09$var$Ib) return a(b, c);
    $b1502ddb39c03b09$var$Ib = !0;
    try {
        return $b1502ddb39c03b09$var$Gb(a, b, c);
    } finally{
        if ($b1502ddb39c03b09$var$Ib = !1, null !== $b1502ddb39c03b09$var$zb || null !== $b1502ddb39c03b09$var$Ab) $b1502ddb39c03b09$var$Hb(), $b1502ddb39c03b09$var$Fb();
    }
}
function $b1502ddb39c03b09$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b1502ddb39c03b09$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b1502ddb39c03b09$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $g83i1._)(c)));
    return c;
}
var $b1502ddb39c03b09$var$Lb = !1;
if ($b1502ddb39c03b09$var$ia) try {
    var $b1502ddb39c03b09$var$Mb = {};
    Object.defineProperty($b1502ddb39c03b09$var$Mb, "passive", {
        get: function get() {
            $b1502ddb39c03b09$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b1502ddb39c03b09$var$Mb, $b1502ddb39c03b09$var$Mb);
    window.removeEventListener("test", $b1502ddb39c03b09$var$Mb, $b1502ddb39c03b09$var$Mb);
} catch (a) {
    $b1502ddb39c03b09$var$Lb = !1;
}
function $b1502ddb39c03b09$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b1502ddb39c03b09$var$Ob = !1, $b1502ddb39c03b09$var$Pb = null, $b1502ddb39c03b09$var$Qb = !1, $b1502ddb39c03b09$var$Rb = null, $b1502ddb39c03b09$var$Sb = {
    onError: function onError(a) {
        $b1502ddb39c03b09$var$Ob = !0;
        $b1502ddb39c03b09$var$Pb = a;
    }
};
function $b1502ddb39c03b09$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b1502ddb39c03b09$var$Ob = !1;
    $b1502ddb39c03b09$var$Pb = null;
    $b1502ddb39c03b09$var$Nb.apply($b1502ddb39c03b09$var$Sb, arguments);
}
function $b1502ddb39c03b09$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b1502ddb39c03b09$var$Tb.apply(this, arguments);
    if ($b1502ddb39c03b09$var$Ob) {
        if ($b1502ddb39c03b09$var$Ob) {
            var l = $b1502ddb39c03b09$var$Pb;
            $b1502ddb39c03b09$var$Ob = !1;
            $b1502ddb39c03b09$var$Pb = null;
        } else throw Error($b1502ddb39c03b09$var$p(198));
        $b1502ddb39c03b09$var$Qb || ($b1502ddb39c03b09$var$Qb = !0, $b1502ddb39c03b09$var$Rb = l);
    }
}
function $b1502ddb39c03b09$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b1502ddb39c03b09$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b1502ddb39c03b09$var$Xb(a) {
    if ($b1502ddb39c03b09$var$Vb(a) !== a) throw Error($b1502ddb39c03b09$var$p(188));
}
function $b1502ddb39c03b09$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b1502ddb39c03b09$var$Vb(a);
        if (null === b) throw Error($b1502ddb39c03b09$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b1502ddb39c03b09$var$Xb(e), a;
                if (f === d) return $b1502ddb39c03b09$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b1502ddb39c03b09$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b1502ddb39c03b09$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b1502ddb39c03b09$var$p(190));
    }
    if (3 !== c.tag) throw Error($b1502ddb39c03b09$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b1502ddb39c03b09$var$Zb(a) {
    a = $b1502ddb39c03b09$var$Yb(a);
    return null !== a ? $b1502ddb39c03b09$var$$b(a) : null;
}
function $b1502ddb39c03b09$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b1502ddb39c03b09$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b1502ddb39c03b09$var$ac = $bE6KD.unstable_scheduleCallback, $b1502ddb39c03b09$var$bc = $bE6KD.unstable_cancelCallback, $b1502ddb39c03b09$var$cc = $bE6KD.unstable_shouldYield, $b1502ddb39c03b09$var$dc = $bE6KD.unstable_requestPaint, $b1502ddb39c03b09$var$B = $bE6KD.unstable_now, $b1502ddb39c03b09$var$ec = $bE6KD.unstable_getCurrentPriorityLevel, $b1502ddb39c03b09$var$fc = $bE6KD.unstable_ImmediatePriority, $b1502ddb39c03b09$var$gc = $bE6KD.unstable_UserBlockingPriority, $b1502ddb39c03b09$var$hc = $bE6KD.unstable_NormalPriority, $b1502ddb39c03b09$var$ic = $bE6KD.unstable_LowPriority, $b1502ddb39c03b09$var$jc = $bE6KD.unstable_IdlePriority, $b1502ddb39c03b09$var$kc = null, $b1502ddb39c03b09$var$lc = null;
function $b1502ddb39c03b09$var$mc(a) {
    if ($b1502ddb39c03b09$var$lc && "function" === typeof $b1502ddb39c03b09$var$lc.onCommitFiberRoot) try {
        $b1502ddb39c03b09$var$lc.onCommitFiberRoot($b1502ddb39c03b09$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b1502ddb39c03b09$var$oc = Math.clz32 ? Math.clz32 : $b1502ddb39c03b09$var$nc, $b1502ddb39c03b09$var$pc = Math.log, $b1502ddb39c03b09$var$qc = Math.LN2;
function $b1502ddb39c03b09$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b1502ddb39c03b09$var$pc(a) / $b1502ddb39c03b09$var$qc | 0) | 0;
}
var $b1502ddb39c03b09$var$rc = 64, $b1502ddb39c03b09$var$sc = 4194304;
function $b1502ddb39c03b09$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b1502ddb39c03b09$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b1502ddb39c03b09$var$tc(h) : (f &= g, 0 !== f && (d = $b1502ddb39c03b09$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b1502ddb39c03b09$var$tc(g) : 0 !== f && (d = $b1502ddb39c03b09$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b1502ddb39c03b09$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b1502ddb39c03b09$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b1502ddb39c03b09$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b1502ddb39c03b09$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b1502ddb39c03b09$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b1502ddb39c03b09$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b1502ddb39c03b09$var$yc() {
    var a = $b1502ddb39c03b09$var$rc;
    $b1502ddb39c03b09$var$rc <<= 1;
    0 === ($b1502ddb39c03b09$var$rc & 4194240) && ($b1502ddb39c03b09$var$rc = 64);
    return a;
}
function $b1502ddb39c03b09$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b1502ddb39c03b09$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b1502ddb39c03b09$var$oc(b);
    a[b] = c;
}
function $b1502ddb39c03b09$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b1502ddb39c03b09$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b1502ddb39c03b09$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b1502ddb39c03b09$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b1502ddb39c03b09$var$C = 0;
function $b1502ddb39c03b09$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b1502ddb39c03b09$var$Ec, $b1502ddb39c03b09$var$Fc, $b1502ddb39c03b09$var$Gc, $b1502ddb39c03b09$var$Hc, $b1502ddb39c03b09$var$Ic, $b1502ddb39c03b09$var$Jc = !1, $b1502ddb39c03b09$var$Kc = [], $b1502ddb39c03b09$var$Lc = null, $b1502ddb39c03b09$var$Mc = null, $b1502ddb39c03b09$var$Nc = null, $b1502ddb39c03b09$var$Oc = new Map, $b1502ddb39c03b09$var$Pc = new Map, $b1502ddb39c03b09$var$Qc = [], $b1502ddb39c03b09$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b1502ddb39c03b09$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b1502ddb39c03b09$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b1502ddb39c03b09$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b1502ddb39c03b09$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b1502ddb39c03b09$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b1502ddb39c03b09$var$Pc.delete(b.pointerId);
    }
}
function $b1502ddb39c03b09$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b1502ddb39c03b09$var$Cb(b), null !== b && $b1502ddb39c03b09$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b1502ddb39c03b09$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b1502ddb39c03b09$var$Lc = $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b1502ddb39c03b09$var$Mc = $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b1502ddb39c03b09$var$Nc = $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b1502ddb39c03b09$var$Oc.set(f, $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b1502ddb39c03b09$var$Pc.set(f, $b1502ddb39c03b09$var$Tc($b1502ddb39c03b09$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b1502ddb39c03b09$var$Vc(a) {
    var b = $b1502ddb39c03b09$var$Wc(a.target);
    if (null !== b) {
        var c = $b1502ddb39c03b09$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b1502ddb39c03b09$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b1502ddb39c03b09$var$Ic(a.priority, function() {
                        $b1502ddb39c03b09$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b1502ddb39c03b09$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b1502ddb39c03b09$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b1502ddb39c03b09$var$wb = d;
            c.target.dispatchEvent(d);
            $b1502ddb39c03b09$var$wb = null;
        } else return b = $b1502ddb39c03b09$var$Cb(c), null !== b && $b1502ddb39c03b09$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b1502ddb39c03b09$var$Zc(a, b, c) {
    $b1502ddb39c03b09$var$Xc(a) && c.delete(b);
}
function $b1502ddb39c03b09$var$$c() {
    $b1502ddb39c03b09$var$Jc = !1;
    null !== $b1502ddb39c03b09$var$Lc && $b1502ddb39c03b09$var$Xc($b1502ddb39c03b09$var$Lc) && ($b1502ddb39c03b09$var$Lc = null);
    null !== $b1502ddb39c03b09$var$Mc && $b1502ddb39c03b09$var$Xc($b1502ddb39c03b09$var$Mc) && ($b1502ddb39c03b09$var$Mc = null);
    null !== $b1502ddb39c03b09$var$Nc && $b1502ddb39c03b09$var$Xc($b1502ddb39c03b09$var$Nc) && ($b1502ddb39c03b09$var$Nc = null);
    $b1502ddb39c03b09$var$Oc.forEach($b1502ddb39c03b09$var$Zc);
    $b1502ddb39c03b09$var$Pc.forEach($b1502ddb39c03b09$var$Zc);
}
function $b1502ddb39c03b09$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b1502ddb39c03b09$var$Jc || ($b1502ddb39c03b09$var$Jc = !0, $bE6KD.unstable_scheduleCallback($bE6KD.unstable_NormalPriority, $b1502ddb39c03b09$var$$c)));
}
function $b1502ddb39c03b09$var$bd(a) {
    function b(b) {
        return $b1502ddb39c03b09$var$ad(b, a);
    }
    if (0 < $b1502ddb39c03b09$var$Kc.length) {
        $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Kc[0], a);
        for(var c = 1; c < $b1502ddb39c03b09$var$Kc.length; c++){
            var d = $b1502ddb39c03b09$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b1502ddb39c03b09$var$Lc && $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Lc, a);
    null !== $b1502ddb39c03b09$var$Mc && $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Mc, a);
    null !== $b1502ddb39c03b09$var$Nc && $b1502ddb39c03b09$var$ad($b1502ddb39c03b09$var$Nc, a);
    $b1502ddb39c03b09$var$Oc.forEach(b);
    $b1502ddb39c03b09$var$Pc.forEach(b);
    for(c = 0; c < $b1502ddb39c03b09$var$Qc.length; c++)d = $b1502ddb39c03b09$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b1502ddb39c03b09$var$Qc.length && (c = $b1502ddb39c03b09$var$Qc[0], null === c.blockedOn);)$b1502ddb39c03b09$var$Vc(c), null === c.blockedOn && $b1502ddb39c03b09$var$Qc.shift();
}
var $b1502ddb39c03b09$var$cd = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig, $b1502ddb39c03b09$var$dd = !0;
function $b1502ddb39c03b09$var$ed(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$C, f = $b1502ddb39c03b09$var$cd.transition;
    $b1502ddb39c03b09$var$cd.transition = null;
    try {
        $b1502ddb39c03b09$var$C = 1, $b1502ddb39c03b09$var$fd(a, b, c, d);
    } finally{
        $b1502ddb39c03b09$var$C = e, $b1502ddb39c03b09$var$cd.transition = f;
    }
}
function $b1502ddb39c03b09$var$gd(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$C, f = $b1502ddb39c03b09$var$cd.transition;
    $b1502ddb39c03b09$var$cd.transition = null;
    try {
        $b1502ddb39c03b09$var$C = 4, $b1502ddb39c03b09$var$fd(a, b, c, d);
    } finally{
        $b1502ddb39c03b09$var$C = e, $b1502ddb39c03b09$var$cd.transition = f;
    }
}
function $b1502ddb39c03b09$var$fd(a, b, c, d) {
    if ($b1502ddb39c03b09$var$dd) {
        var e = $b1502ddb39c03b09$var$Yc(a, b, c, d);
        if (null === e) $b1502ddb39c03b09$var$hd(a, b, d, $b1502ddb39c03b09$var$id, c), $b1502ddb39c03b09$var$Sc(a, d);
        else if ($b1502ddb39c03b09$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b1502ddb39c03b09$var$Sc(a, d), b & 4 && -1 < $b1502ddb39c03b09$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b1502ddb39c03b09$var$Cb(e);
                null !== f && $b1502ddb39c03b09$var$Ec(f);
                f = $b1502ddb39c03b09$var$Yc(a, b, c, d);
                null === f && $b1502ddb39c03b09$var$hd(a, b, d, $b1502ddb39c03b09$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b1502ddb39c03b09$var$hd(a, b, d, null, c);
    }
}
var $b1502ddb39c03b09$var$id = null;
function $b1502ddb39c03b09$var$Yc(a, b, c, d) {
    $b1502ddb39c03b09$var$id = null;
    a = $b1502ddb39c03b09$var$xb(d);
    a = $b1502ddb39c03b09$var$Wc(a);
    if (null !== a) {
        if (b = $b1502ddb39c03b09$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b1502ddb39c03b09$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b1502ddb39c03b09$var$id = a;
    return null;
}
function $b1502ddb39c03b09$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b1502ddb39c03b09$var$ec()){
                case $b1502ddb39c03b09$var$fc:
                    return 1;
                case $b1502ddb39c03b09$var$gc:
                    return 4;
                case $b1502ddb39c03b09$var$hc:
                case $b1502ddb39c03b09$var$ic:
                    return 16;
                case $b1502ddb39c03b09$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b1502ddb39c03b09$var$kd = null, $b1502ddb39c03b09$var$ld = null, $b1502ddb39c03b09$var$md = null;
function $b1502ddb39c03b09$var$nd() {
    if ($b1502ddb39c03b09$var$md) return $b1502ddb39c03b09$var$md;
    var a, b = $b1502ddb39c03b09$var$ld, c = b.length, d, e = "value" in $b1502ddb39c03b09$var$kd ? $b1502ddb39c03b09$var$kd.value : $b1502ddb39c03b09$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b1502ddb39c03b09$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b1502ddb39c03b09$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b1502ddb39c03b09$var$pd() {
    return !0;
}
function $b1502ddb39c03b09$var$qd() {
    return !1;
}
function $b1502ddb39c03b09$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b1502ddb39c03b09$var$pd : $b1502ddb39c03b09$var$qd;
        this.isPropagationStopped = $b1502ddb39c03b09$var$qd;
        return this;
    }
    $b1502ddb39c03b09$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $g83i1._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $b1502ddb39c03b09$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $g83i1._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $b1502ddb39c03b09$var$pd);
        },
        persist: function persist() {},
        isPersistent: $b1502ddb39c03b09$var$pd
    });
    return b;
}
var $b1502ddb39c03b09$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b1502ddb39c03b09$var$td = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$sd), $b1502ddb39c03b09$var$ud = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    view: 0,
    detail: 0
}), $b1502ddb39c03b09$var$vd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$ud), $b1502ddb39c03b09$var$wd, $b1502ddb39c03b09$var$xd, $b1502ddb39c03b09$var$yd, $b1502ddb39c03b09$var$Ad = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b1502ddb39c03b09$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b1502ddb39c03b09$var$yd && ($b1502ddb39c03b09$var$yd && "mousemove" === a.type ? ($b1502ddb39c03b09$var$wd = a.screenX - $b1502ddb39c03b09$var$yd.screenX, $b1502ddb39c03b09$var$xd = a.screenY - $b1502ddb39c03b09$var$yd.screenY) : $b1502ddb39c03b09$var$xd = $b1502ddb39c03b09$var$wd = 0, $b1502ddb39c03b09$var$yd = a);
        return $b1502ddb39c03b09$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $b1502ddb39c03b09$var$xd;
    }
}), $b1502ddb39c03b09$var$Bd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Ad), $b1502ddb39c03b09$var$Cd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$Ad, {
    dataTransfer: 0
}), $b1502ddb39c03b09$var$Dd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Cd), $b1502ddb39c03b09$var$Ed = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    relatedTarget: 0
}), $b1502ddb39c03b09$var$Fd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Ed), $b1502ddb39c03b09$var$Gd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b1502ddb39c03b09$var$Hd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Gd), $b1502ddb39c03b09$var$Id = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b1502ddb39c03b09$var$Jd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Id), $b1502ddb39c03b09$var$Kd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    data: 0
}), $b1502ddb39c03b09$var$Ld = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Kd), $b1502ddb39c03b09$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b1502ddb39c03b09$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b1502ddb39c03b09$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b1502ddb39c03b09$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b1502ddb39c03b09$var$Od[a]) ? !!b[a] : !1;
}
function $b1502ddb39c03b09$var$zd() {
    return $b1502ddb39c03b09$var$Pd;
}
var $b1502ddb39c03b09$var$Qd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $b1502ddb39c03b09$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b1502ddb39c03b09$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b1502ddb39c03b09$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b1502ddb39c03b09$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $b1502ddb39c03b09$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $b1502ddb39c03b09$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b1502ddb39c03b09$var$Rd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Qd), $b1502ddb39c03b09$var$Sd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b1502ddb39c03b09$var$Td = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Sd), $b1502ddb39c03b09$var$Ud = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b1502ddb39c03b09$var$zd
}), $b1502ddb39c03b09$var$Vd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Ud), $b1502ddb39c03b09$var$Wd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b1502ddb39c03b09$var$Xd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Wd), $b1502ddb39c03b09$var$Yd = $b1502ddb39c03b09$var$A({}, $b1502ddb39c03b09$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b1502ddb39c03b09$var$Zd = $b1502ddb39c03b09$var$rd($b1502ddb39c03b09$var$Yd), $b1502ddb39c03b09$var$$d = [
    9,
    13,
    27,
    32
], $b1502ddb39c03b09$var$ae = $b1502ddb39c03b09$var$ia && "CompositionEvent" in window, $b1502ddb39c03b09$var$be = null;
$b1502ddb39c03b09$var$ia && "documentMode" in document && ($b1502ddb39c03b09$var$be = document.documentMode);
var $b1502ddb39c03b09$var$ce = $b1502ddb39c03b09$var$ia && "TextEvent" in window && !$b1502ddb39c03b09$var$be, $b1502ddb39c03b09$var$de = $b1502ddb39c03b09$var$ia && (!$b1502ddb39c03b09$var$ae || $b1502ddb39c03b09$var$be && 8 < $b1502ddb39c03b09$var$be && 11 >= $b1502ddb39c03b09$var$be), $b1502ddb39c03b09$var$ee = String.fromCharCode(32), $b1502ddb39c03b09$var$fe = !1;
function $b1502ddb39c03b09$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b1502ddb39c03b09$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b1502ddb39c03b09$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b1502ddb39c03b09$var$ie = !1;
function $b1502ddb39c03b09$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b1502ddb39c03b09$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b1502ddb39c03b09$var$fe = !0;
            return $b1502ddb39c03b09$var$ee;
        case "textInput":
            return a = b.data, a === $b1502ddb39c03b09$var$ee && $b1502ddb39c03b09$var$fe ? null : a;
        default:
            return null;
    }
}
function $b1502ddb39c03b09$var$ke(a, b) {
    if ($b1502ddb39c03b09$var$ie) return "compositionend" === a || !$b1502ddb39c03b09$var$ae && $b1502ddb39c03b09$var$ge(a, b) ? (a = $b1502ddb39c03b09$var$nd(), $b1502ddb39c03b09$var$md = $b1502ddb39c03b09$var$ld = $b1502ddb39c03b09$var$kd = null, $b1502ddb39c03b09$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b1502ddb39c03b09$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b1502ddb39c03b09$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b1502ddb39c03b09$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b1502ddb39c03b09$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b1502ddb39c03b09$var$ne(a, b, c, d) {
    $b1502ddb39c03b09$var$Eb(d);
    b = $b1502ddb39c03b09$var$oe(b, "onChange");
    0 < b.length && (c = new $b1502ddb39c03b09$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b1502ddb39c03b09$var$pe = null, $b1502ddb39c03b09$var$qe = null;
function $b1502ddb39c03b09$var$re(a) {
    $b1502ddb39c03b09$var$se(a, 0);
}
function $b1502ddb39c03b09$var$te(a) {
    var b = $b1502ddb39c03b09$var$ue(a);
    if ($b1502ddb39c03b09$var$Wa(b)) return a;
}
function $b1502ddb39c03b09$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b1502ddb39c03b09$var$we = !1;
if ($b1502ddb39c03b09$var$ia) {
    var $b1502ddb39c03b09$var$xe;
    if ($b1502ddb39c03b09$var$ia) {
        var $b1502ddb39c03b09$var$ye = "oninput" in document;
        if (!$b1502ddb39c03b09$var$ye) {
            var $b1502ddb39c03b09$var$ze = document.createElement("div");
            $b1502ddb39c03b09$var$ze.setAttribute("oninput", "return;");
            $b1502ddb39c03b09$var$ye = "function" === typeof $b1502ddb39c03b09$var$ze.oninput;
        }
        $b1502ddb39c03b09$var$xe = $b1502ddb39c03b09$var$ye;
    } else $b1502ddb39c03b09$var$xe = !1;
    $b1502ddb39c03b09$var$we = $b1502ddb39c03b09$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b1502ddb39c03b09$var$Ae() {
    $b1502ddb39c03b09$var$pe && ($b1502ddb39c03b09$var$pe.detachEvent("onpropertychange", $b1502ddb39c03b09$var$Be), $b1502ddb39c03b09$var$qe = $b1502ddb39c03b09$var$pe = null);
}
function $b1502ddb39c03b09$var$Be(a) {
    if ("value" === a.propertyName && $b1502ddb39c03b09$var$te($b1502ddb39c03b09$var$qe)) {
        var b = [];
        $b1502ddb39c03b09$var$ne(b, $b1502ddb39c03b09$var$qe, a, $b1502ddb39c03b09$var$xb(a));
        $b1502ddb39c03b09$var$Jb($b1502ddb39c03b09$var$re, b);
    }
}
function $b1502ddb39c03b09$var$Ce(a, b, c) {
    "focusin" === a ? ($b1502ddb39c03b09$var$Ae(), $b1502ddb39c03b09$var$pe = b, $b1502ddb39c03b09$var$qe = c, $b1502ddb39c03b09$var$pe.attachEvent("onpropertychange", $b1502ddb39c03b09$var$Be)) : "focusout" === a && $b1502ddb39c03b09$var$Ae();
}
function $b1502ddb39c03b09$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b1502ddb39c03b09$var$te($b1502ddb39c03b09$var$qe);
}
function $b1502ddb39c03b09$var$Ee(a, b) {
    if ("click" === a) return $b1502ddb39c03b09$var$te(b);
}
function $b1502ddb39c03b09$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b1502ddb39c03b09$var$te(b);
}
function $b1502ddb39c03b09$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b1502ddb39c03b09$var$He = "function" === typeof Object.is ? Object.is : $b1502ddb39c03b09$var$Ge;
function $b1502ddb39c03b09$var$Ie(a, b) {
    if ($b1502ddb39c03b09$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b1502ddb39c03b09$var$ja.call(b, e) || !$b1502ddb39c03b09$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b1502ddb39c03b09$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b1502ddb39c03b09$var$Ke(a, b) {
    var c = $b1502ddb39c03b09$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b1502ddb39c03b09$var$Je(c);
    }
}
function $b1502ddb39c03b09$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b1502ddb39c03b09$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b1502ddb39c03b09$var$Me() {
    for(var a = window, b = $b1502ddb39c03b09$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b1502ddb39c03b09$var$Xa(a.document);
    }
    return b;
}
function $b1502ddb39c03b09$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b1502ddb39c03b09$var$Oe(a) {
    var b = $b1502ddb39c03b09$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b1502ddb39c03b09$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b1502ddb39c03b09$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b1502ddb39c03b09$var$Ke(c, f);
                var g = $b1502ddb39c03b09$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b1502ddb39c03b09$var$Pe = $b1502ddb39c03b09$var$ia && "documentMode" in document && 11 >= document.documentMode, $b1502ddb39c03b09$var$Qe = null, $b1502ddb39c03b09$var$Re = null, $b1502ddb39c03b09$var$Se = null, $b1502ddb39c03b09$var$Te = !1;
function $b1502ddb39c03b09$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b1502ddb39c03b09$var$Te || null == $b1502ddb39c03b09$var$Qe || $b1502ddb39c03b09$var$Qe !== $b1502ddb39c03b09$var$Xa(d) || (d = $b1502ddb39c03b09$var$Qe, "selectionStart" in d && $b1502ddb39c03b09$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b1502ddb39c03b09$var$Se && $b1502ddb39c03b09$var$Ie($b1502ddb39c03b09$var$Se, d) || ($b1502ddb39c03b09$var$Se = d, d = $b1502ddb39c03b09$var$oe($b1502ddb39c03b09$var$Re, "onSelect"), 0 < d.length && (b = new $b1502ddb39c03b09$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b1502ddb39c03b09$var$Qe)));
}
function $b1502ddb39c03b09$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b1502ddb39c03b09$var$We = {
    animationend: $b1502ddb39c03b09$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b1502ddb39c03b09$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b1502ddb39c03b09$var$Ve("Animation", "AnimationStart"),
    transitionend: $b1502ddb39c03b09$var$Ve("Transition", "TransitionEnd")
}, $b1502ddb39c03b09$var$Xe = {}, $b1502ddb39c03b09$var$Ye = {};
$b1502ddb39c03b09$var$ia && ($b1502ddb39c03b09$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b1502ddb39c03b09$var$We.animationend.animation, delete $b1502ddb39c03b09$var$We.animationiteration.animation, delete $b1502ddb39c03b09$var$We.animationstart.animation), "TransitionEvent" in window || delete $b1502ddb39c03b09$var$We.transitionend.transition);
function $b1502ddb39c03b09$var$Ze(a) {
    if ($b1502ddb39c03b09$var$Xe[a]) return $b1502ddb39c03b09$var$Xe[a];
    if (!$b1502ddb39c03b09$var$We[a]) return a;
    var b = $b1502ddb39c03b09$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b1502ddb39c03b09$var$Ye) return $b1502ddb39c03b09$var$Xe[a] = b[c];
    return a;
}
var $b1502ddb39c03b09$var$$e = $b1502ddb39c03b09$var$Ze("animationend"), $b1502ddb39c03b09$var$af = $b1502ddb39c03b09$var$Ze("animationiteration"), $b1502ddb39c03b09$var$bf = $b1502ddb39c03b09$var$Ze("animationstart"), $b1502ddb39c03b09$var$cf = $b1502ddb39c03b09$var$Ze("transitionend"), $b1502ddb39c03b09$var$df = new Map, $b1502ddb39c03b09$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b1502ddb39c03b09$var$ff(a, b) {
    $b1502ddb39c03b09$var$df.set(a, b);
    $b1502ddb39c03b09$var$fa(b, [
        a
    ]);
}
for(var $b1502ddb39c03b09$var$gf = 0; $b1502ddb39c03b09$var$gf < $b1502ddb39c03b09$var$ef.length; $b1502ddb39c03b09$var$gf++){
    var $b1502ddb39c03b09$var$hf = $b1502ddb39c03b09$var$ef[$b1502ddb39c03b09$var$gf], $b1502ddb39c03b09$var$jf = $b1502ddb39c03b09$var$hf.toLowerCase(), $b1502ddb39c03b09$var$kf = $b1502ddb39c03b09$var$hf[0].toUpperCase() + $b1502ddb39c03b09$var$hf.slice(1);
    $b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$jf, "on" + $b1502ddb39c03b09$var$kf);
}
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$$e, "onAnimationEnd");
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$af, "onAnimationIteration");
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$bf, "onAnimationStart");
$b1502ddb39c03b09$var$ff("dblclick", "onDoubleClick");
$b1502ddb39c03b09$var$ff("focusin", "onFocus");
$b1502ddb39c03b09$var$ff("focusout", "onBlur");
$b1502ddb39c03b09$var$ff($b1502ddb39c03b09$var$cf, "onTransitionEnd");
$b1502ddb39c03b09$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b1502ddb39c03b09$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b1502ddb39c03b09$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b1502ddb39c03b09$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b1502ddb39c03b09$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b1502ddb39c03b09$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b1502ddb39c03b09$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b1502ddb39c03b09$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b1502ddb39c03b09$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b1502ddb39c03b09$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b1502ddb39c03b09$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b1502ddb39c03b09$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b1502ddb39c03b09$var$lf));
function $b1502ddb39c03b09$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b1502ddb39c03b09$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b1502ddb39c03b09$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b1502ddb39c03b09$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b1502ddb39c03b09$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b1502ddb39c03b09$var$Qb) throw a = $b1502ddb39c03b09$var$Rb, $b1502ddb39c03b09$var$Qb = !1, $b1502ddb39c03b09$var$Rb = null, a;
}
function $b1502ddb39c03b09$var$D(a, b) {
    var c = b[$b1502ddb39c03b09$var$of];
    void 0 === c && (c = b[$b1502ddb39c03b09$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b1502ddb39c03b09$var$pf(b, a, 2, !1), c.add(d));
}
function $b1502ddb39c03b09$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b1502ddb39c03b09$var$pf(c, a, d, b);
}
var $b1502ddb39c03b09$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b1502ddb39c03b09$var$sf(a) {
    if (!a[$b1502ddb39c03b09$var$rf]) {
        a[$b1502ddb39c03b09$var$rf] = !0;
        $b1502ddb39c03b09$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b1502ddb39c03b09$var$mf.has(b) || $b1502ddb39c03b09$var$qf(b, !1, a), $b1502ddb39c03b09$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b1502ddb39c03b09$var$rf] || (b[$b1502ddb39c03b09$var$rf] = !0, $b1502ddb39c03b09$var$qf("selectionchange", !1, b));
    }
}
function $b1502ddb39c03b09$var$pf(a, b, c, d) {
    switch($b1502ddb39c03b09$var$jd(b)){
        case 1:
            var e = $b1502ddb39c03b09$var$ed;
            break;
        case 4:
            e = $b1502ddb39c03b09$var$gd;
            break;
        default:
            e = $b1502ddb39c03b09$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b1502ddb39c03b09$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b1502ddb39c03b09$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b1502ddb39c03b09$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b1502ddb39c03b09$var$Jb(function() {
        var _$d = f, _$e = $b1502ddb39c03b09$var$xb(c), g = [];
        a: {
            var h = $b1502ddb39c03b09$var$df.get(a);
            if (void 0 !== h) {
                var k = $b1502ddb39c03b09$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b1502ddb39c03b09$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b1502ddb39c03b09$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b1502ddb39c03b09$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b1502ddb39c03b09$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b1502ddb39c03b09$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b1502ddb39c03b09$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b1502ddb39c03b09$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b1502ddb39c03b09$var$Vd;
                        break;
                    case $b1502ddb39c03b09$var$$e:
                    case $b1502ddb39c03b09$var$af:
                    case $b1502ddb39c03b09$var$bf:
                        k = $b1502ddb39c03b09$var$Hd;
                        break;
                    case $b1502ddb39c03b09$var$cf:
                        k = $b1502ddb39c03b09$var$Xd;
                        break;
                    case "scroll":
                        k = $b1502ddb39c03b09$var$vd;
                        break;
                    case "wheel":
                        k = $b1502ddb39c03b09$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b1502ddb39c03b09$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b1502ddb39c03b09$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b1502ddb39c03b09$var$Kb(w, x), null != F && t.push($b1502ddb39c03b09$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b1502ddb39c03b09$var$wb && (n = c.relatedTarget || c.fromElement) && ($b1502ddb39c03b09$var$Wc(n) || n[$b1502ddb39c03b09$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $b1502ddb39c03b09$var$Wc(n) : null, null !== n && (J = $b1502ddb39c03b09$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $b1502ddb39c03b09$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b1502ddb39c03b09$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b1502ddb39c03b09$var$ue(k);
                        u = null == n ? h : $b1502ddb39c03b09$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b1502ddb39c03b09$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b1502ddb39c03b09$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b1502ddb39c03b09$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b1502ddb39c03b09$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b1502ddb39c03b09$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b1502ddb39c03b09$var$vf(t);
                                x = $b1502ddb39c03b09$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b1502ddb39c03b09$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b1502ddb39c03b09$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $b1502ddb39c03b09$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b1502ddb39c03b09$var$ve;
                else if ($b1502ddb39c03b09$var$me(h)) {
                    if ($b1502ddb39c03b09$var$we) na = $b1502ddb39c03b09$var$Fe;
                    else {
                        na = $b1502ddb39c03b09$var$De;
                        var xa = $b1502ddb39c03b09$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b1502ddb39c03b09$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $b1502ddb39c03b09$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b1502ddb39c03b09$var$cb(h, "number", h.value);
            }
            xa = _$d ? $b1502ddb39c03b09$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($b1502ddb39c03b09$var$me(xa) || "true" === xa.contentEditable) $b1502ddb39c03b09$var$Qe = xa, $b1502ddb39c03b09$var$Re = _$d, $b1502ddb39c03b09$var$Se = null;
                    break;
                case "focusout":
                    $b1502ddb39c03b09$var$Se = $b1502ddb39c03b09$var$Re = $b1502ddb39c03b09$var$Qe = null;
                    break;
                case "mousedown":
                    $b1502ddb39c03b09$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b1502ddb39c03b09$var$Te = !1;
                    $b1502ddb39c03b09$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($b1502ddb39c03b09$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b1502ddb39c03b09$var$Ue(g, c, _$e);
            }
            var $a;
            if ($b1502ddb39c03b09$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b1502ddb39c03b09$var$ie ? $b1502ddb39c03b09$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b1502ddb39c03b09$var$de && "ko" !== c.locale && ($b1502ddb39c03b09$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b1502ddb39c03b09$var$ie && ($a = $b1502ddb39c03b09$var$nd()) : ($b1502ddb39c03b09$var$kd = _$e, $b1502ddb39c03b09$var$ld = "value" in $b1502ddb39c03b09$var$kd ? $b1502ddb39c03b09$var$kd.value : $b1502ddb39c03b09$var$kd.textContent, $b1502ddb39c03b09$var$ie = !0)), xa = $b1502ddb39c03b09$var$oe(_$d, ba), 0 < xa.length && (ba = new $b1502ddb39c03b09$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b1502ddb39c03b09$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b1502ddb39c03b09$var$ce ? $b1502ddb39c03b09$var$je(a, c) : $b1502ddb39c03b09$var$ke(a, c)) _$d = $b1502ddb39c03b09$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $b1502ddb39c03b09$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $b1502ddb39c03b09$var$se(g, b);
    });
}
function $b1502ddb39c03b09$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b1502ddb39c03b09$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b1502ddb39c03b09$var$Kb(a, c), null != f && d.unshift($b1502ddb39c03b09$var$tf(a, f, e)), f = $b1502ddb39c03b09$var$Kb(a, b), null != f && d.push($b1502ddb39c03b09$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b1502ddb39c03b09$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b1502ddb39c03b09$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b1502ddb39c03b09$var$Kb(c, f), null != k && g.unshift($b1502ddb39c03b09$var$tf(c, k, h))) : e || (k = $b1502ddb39c03b09$var$Kb(c, f), null != k && g.push($b1502ddb39c03b09$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b1502ddb39c03b09$var$xf = /\r\n?/g, $b1502ddb39c03b09$var$yf = /\u0000|\uFFFD/g;
function $b1502ddb39c03b09$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b1502ddb39c03b09$var$xf, "\n").replace($b1502ddb39c03b09$var$yf, "");
}
function $b1502ddb39c03b09$var$Af(a, b, c) {
    b = $b1502ddb39c03b09$var$zf(b);
    if ($b1502ddb39c03b09$var$zf(a) !== b && c) throw Error($b1502ddb39c03b09$var$p(425));
}
function $b1502ddb39c03b09$var$Bf() {}
var $b1502ddb39c03b09$var$Cf = null, $b1502ddb39c03b09$var$Df = null;
function $b1502ddb39c03b09$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b1502ddb39c03b09$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b1502ddb39c03b09$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b1502ddb39c03b09$var$Hf = "function" === typeof Promise ? Promise : void 0, $b1502ddb39c03b09$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b1502ddb39c03b09$var$Hf ? function Jf(a) {
    return $b1502ddb39c03b09$var$Hf.resolve(null).then(a).catch($b1502ddb39c03b09$var$If);
} : $b1502ddb39c03b09$var$Ff;
function $b1502ddb39c03b09$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b1502ddb39c03b09$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b1502ddb39c03b09$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b1502ddb39c03b09$var$bd(b);
}
function $b1502ddb39c03b09$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b1502ddb39c03b09$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b1502ddb39c03b09$var$Nf = Math.random().toString(36).slice(2), $b1502ddb39c03b09$var$Of = "__reactFiber$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$Pf = "__reactProps$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$uf = "__reactContainer$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$of = "__reactEvents$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$Qf = "__reactListeners$" + $b1502ddb39c03b09$var$Nf, $b1502ddb39c03b09$var$Rf = "__reactHandles$" + $b1502ddb39c03b09$var$Nf;
function $b1502ddb39c03b09$var$Wc(a) {
    var b = a[$b1502ddb39c03b09$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b1502ddb39c03b09$var$uf] || c[$b1502ddb39c03b09$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b1502ddb39c03b09$var$Mf(a); null !== a;){
                if (c = a[$b1502ddb39c03b09$var$Of]) return c;
                a = $b1502ddb39c03b09$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b1502ddb39c03b09$var$Cb(a) {
    a = a[$b1502ddb39c03b09$var$Of] || a[$b1502ddb39c03b09$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b1502ddb39c03b09$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b1502ddb39c03b09$var$p(33));
}
function $b1502ddb39c03b09$var$Db(a) {
    return a[$b1502ddb39c03b09$var$Pf] || null;
}
var $b1502ddb39c03b09$var$Sf = [], $b1502ddb39c03b09$var$Tf = -1;
function $b1502ddb39c03b09$var$Uf(a) {
    return {
        current: a
    };
}
function $b1502ddb39c03b09$var$E(a) {
    0 > $b1502ddb39c03b09$var$Tf || (a.current = $b1502ddb39c03b09$var$Sf[$b1502ddb39c03b09$var$Tf], $b1502ddb39c03b09$var$Sf[$b1502ddb39c03b09$var$Tf] = null, $b1502ddb39c03b09$var$Tf--);
}
function $b1502ddb39c03b09$var$G(a, b) {
    $b1502ddb39c03b09$var$Tf++;
    $b1502ddb39c03b09$var$Sf[$b1502ddb39c03b09$var$Tf] = a.current;
    a.current = b;
}
var $b1502ddb39c03b09$var$Vf = {}, $b1502ddb39c03b09$var$H = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$Vf), $b1502ddb39c03b09$var$Wf = $b1502ddb39c03b09$var$Uf(!1), $b1502ddb39c03b09$var$Xf = $b1502ddb39c03b09$var$Vf;
function $b1502ddb39c03b09$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b1502ddb39c03b09$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b1502ddb39c03b09$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b1502ddb39c03b09$var$$f() {
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H);
}
function $b1502ddb39c03b09$var$ag(a, b, c) {
    if ($b1502ddb39c03b09$var$H.current !== $b1502ddb39c03b09$var$Vf) throw Error($b1502ddb39c03b09$var$p(168));
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$H, b);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wf, c);
}
function $b1502ddb39c03b09$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b1502ddb39c03b09$var$p(108, $b1502ddb39c03b09$var$Ra(a) || "Unknown", e));
    return $b1502ddb39c03b09$var$A({}, c, d);
}
function $b1502ddb39c03b09$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b1502ddb39c03b09$var$Vf;
    $b1502ddb39c03b09$var$Xf = $b1502ddb39c03b09$var$H.current;
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$H, a);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wf, $b1502ddb39c03b09$var$Wf.current);
    return !0;
}
function $b1502ddb39c03b09$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b1502ddb39c03b09$var$p(169));
    c ? (a = $b1502ddb39c03b09$var$bg(a, b, $b1502ddb39c03b09$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H), $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$H, a)) : $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wf, c);
}
var $b1502ddb39c03b09$var$eg = null, $b1502ddb39c03b09$var$fg = !1, $b1502ddb39c03b09$var$gg = !1;
function $b1502ddb39c03b09$var$hg(a) {
    null === $b1502ddb39c03b09$var$eg ? $b1502ddb39c03b09$var$eg = [
        a
    ] : $b1502ddb39c03b09$var$eg.push(a);
}
function $b1502ddb39c03b09$var$ig(a) {
    $b1502ddb39c03b09$var$fg = !0;
    $b1502ddb39c03b09$var$hg(a);
}
function $b1502ddb39c03b09$var$jg() {
    if (!$b1502ddb39c03b09$var$gg && null !== $b1502ddb39c03b09$var$eg) {
        $b1502ddb39c03b09$var$gg = !0;
        var a = 0, b = $b1502ddb39c03b09$var$C;
        try {
            var c = $b1502ddb39c03b09$var$eg;
            for($b1502ddb39c03b09$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b1502ddb39c03b09$var$eg = null;
            $b1502ddb39c03b09$var$fg = !1;
        } catch (e) {
            throw null !== $b1502ddb39c03b09$var$eg && ($b1502ddb39c03b09$var$eg = $b1502ddb39c03b09$var$eg.slice(a + 1)), $b1502ddb39c03b09$var$ac($b1502ddb39c03b09$var$fc, $b1502ddb39c03b09$var$jg), e;
        } finally{
            $b1502ddb39c03b09$var$C = b, $b1502ddb39c03b09$var$gg = !1;
        }
    }
    return null;
}
var $b1502ddb39c03b09$var$kg = [], $b1502ddb39c03b09$var$lg = 0, $b1502ddb39c03b09$var$mg = null, $b1502ddb39c03b09$var$ng = 0, $b1502ddb39c03b09$var$og = [], $b1502ddb39c03b09$var$pg = 0, $b1502ddb39c03b09$var$qg = null, $b1502ddb39c03b09$var$rg = 1, $b1502ddb39c03b09$var$sg = "";
function $b1502ddb39c03b09$var$tg(a, b) {
    $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg++] = $b1502ddb39c03b09$var$ng;
    $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg++] = $b1502ddb39c03b09$var$mg;
    $b1502ddb39c03b09$var$mg = a;
    $b1502ddb39c03b09$var$ng = b;
}
function $b1502ddb39c03b09$var$ug(a, b, c) {
    $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$rg;
    $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$sg;
    $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$qg;
    $b1502ddb39c03b09$var$qg = a;
    var d = $b1502ddb39c03b09$var$rg;
    a = $b1502ddb39c03b09$var$sg;
    var e = 32 - $b1502ddb39c03b09$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b1502ddb39c03b09$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b1502ddb39c03b09$var$rg = 1 << 32 - $b1502ddb39c03b09$var$oc(b) + e | c << e | d;
        $b1502ddb39c03b09$var$sg = f + a;
    } else $b1502ddb39c03b09$var$rg = 1 << f | c << e | d, $b1502ddb39c03b09$var$sg = a;
}
function $b1502ddb39c03b09$var$vg(a) {
    null !== a.return && ($b1502ddb39c03b09$var$tg(a, 1), $b1502ddb39c03b09$var$ug(a, 1, 0));
}
function $b1502ddb39c03b09$var$wg(a) {
    for(; a === $b1502ddb39c03b09$var$mg;)$b1502ddb39c03b09$var$mg = $b1502ddb39c03b09$var$kg[--$b1502ddb39c03b09$var$lg], $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg] = null, $b1502ddb39c03b09$var$ng = $b1502ddb39c03b09$var$kg[--$b1502ddb39c03b09$var$lg], $b1502ddb39c03b09$var$kg[$b1502ddb39c03b09$var$lg] = null;
    for(; a === $b1502ddb39c03b09$var$qg;)$b1502ddb39c03b09$var$qg = $b1502ddb39c03b09$var$og[--$b1502ddb39c03b09$var$pg], $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg] = null, $b1502ddb39c03b09$var$sg = $b1502ddb39c03b09$var$og[--$b1502ddb39c03b09$var$pg], $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg] = null, $b1502ddb39c03b09$var$rg = $b1502ddb39c03b09$var$og[--$b1502ddb39c03b09$var$pg], $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg] = null;
}
var $b1502ddb39c03b09$var$xg = null, $b1502ddb39c03b09$var$yg = null, $b1502ddb39c03b09$var$I = !1, $b1502ddb39c03b09$var$zg = null;
function $b1502ddb39c03b09$var$Ag(a, b) {
    var c = $b1502ddb39c03b09$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b1502ddb39c03b09$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b1502ddb39c03b09$var$xg = a, $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b1502ddb39c03b09$var$xg = a, $b1502ddb39c03b09$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b1502ddb39c03b09$var$qg ? {
                id: $b1502ddb39c03b09$var$rg,
                overflow: $b1502ddb39c03b09$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b1502ddb39c03b09$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b1502ddb39c03b09$var$xg = a, $b1502ddb39c03b09$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b1502ddb39c03b09$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b1502ddb39c03b09$var$Eg(a) {
    if ($b1502ddb39c03b09$var$I) {
        var b = $b1502ddb39c03b09$var$yg;
        if (b) {
            var c = b;
            if (!$b1502ddb39c03b09$var$Cg(a, b)) {
                if ($b1502ddb39c03b09$var$Dg(a)) throw Error($b1502ddb39c03b09$var$p(418));
                b = $b1502ddb39c03b09$var$Lf(c.nextSibling);
                var d = $b1502ddb39c03b09$var$xg;
                b && $b1502ddb39c03b09$var$Cg(a, b) ? $b1502ddb39c03b09$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b1502ddb39c03b09$var$I = !1, $b1502ddb39c03b09$var$xg = a);
            }
        } else {
            if ($b1502ddb39c03b09$var$Dg(a)) throw Error($b1502ddb39c03b09$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b1502ddb39c03b09$var$I = !1;
            $b1502ddb39c03b09$var$xg = a;
        }
    }
}
function $b1502ddb39c03b09$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b1502ddb39c03b09$var$xg = a;
}
function $b1502ddb39c03b09$var$Gg(a) {
    if (a !== $b1502ddb39c03b09$var$xg) return !1;
    if (!$b1502ddb39c03b09$var$I) return $b1502ddb39c03b09$var$Fg(a), $b1502ddb39c03b09$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b1502ddb39c03b09$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b1502ddb39c03b09$var$yg)) {
        if ($b1502ddb39c03b09$var$Dg(a)) throw $b1502ddb39c03b09$var$Hg(), Error($b1502ddb39c03b09$var$p(418));
        for(; b;)$b1502ddb39c03b09$var$Ag(a, b), b = $b1502ddb39c03b09$var$Lf(b.nextSibling);
    }
    $b1502ddb39c03b09$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b1502ddb39c03b09$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b1502ddb39c03b09$var$yg = null;
        }
    } else $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$xg ? $b1502ddb39c03b09$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b1502ddb39c03b09$var$Hg() {
    for(var a = $b1502ddb39c03b09$var$yg; a;)a = $b1502ddb39c03b09$var$Lf(a.nextSibling);
}
function $b1502ddb39c03b09$var$Ig() {
    $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$xg = null;
    $b1502ddb39c03b09$var$I = !1;
}
function $b1502ddb39c03b09$var$Jg(a) {
    null === $b1502ddb39c03b09$var$zg ? $b1502ddb39c03b09$var$zg = [
        a
    ] : $b1502ddb39c03b09$var$zg.push(a);
}
var $b1502ddb39c03b09$var$Kg = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig;
function $b1502ddb39c03b09$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b1502ddb39c03b09$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b1502ddb39c03b09$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b1502ddb39c03b09$var$p(284));
        if (!c._owner) throw Error($b1502ddb39c03b09$var$p(290, a));
    }
    return a;
}
function $b1502ddb39c03b09$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b1502ddb39c03b09$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b1502ddb39c03b09$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b1502ddb39c03b09$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b1502ddb39c03b09$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b1502ddb39c03b09$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b1502ddb39c03b09$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b1502ddb39c03b09$var$Ha && $b1502ddb39c03b09$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b1502ddb39c03b09$var$Lg(a, b, c), d.return = a, d;
        d = $b1502ddb39c03b09$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b1502ddb39c03b09$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b1502ddb39c03b09$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b1502ddb39c03b09$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b1502ddb39c03b09$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    return c = $b1502ddb39c03b09$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b1502ddb39c03b09$var$Lg(a, null, b), c.return = a, c;
                case $b1502ddb39c03b09$var$wa:
                    return b = $b1502ddb39c03b09$var$Sg(b, a.mode, c), b.return = a, b;
                case $b1502ddb39c03b09$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b1502ddb39c03b09$var$eb(b) || $b1502ddb39c03b09$var$Ka(b)) return b = $b1502ddb39c03b09$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b1502ddb39c03b09$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b1502ddb39c03b09$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b1502ddb39c03b09$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b1502ddb39c03b09$var$eb(c) || $b1502ddb39c03b09$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b1502ddb39c03b09$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b1502ddb39c03b09$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b1502ddb39c03b09$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b1502ddb39c03b09$var$eb(d) || $b1502ddb39c03b09$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b1502ddb39c03b09$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b1502ddb39c03b09$var$Ka(h);
        if ("function" !== typeof l) throw Error($b1502ddb39c03b09$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b1502ddb39c03b09$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b1502ddb39c03b09$var$I && $b1502ddb39c03b09$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b1502ddb39c03b09$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b1502ddb39c03b09$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b1502ddb39c03b09$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b1502ddb39c03b09$var$Ha && $b1502ddb39c03b09$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b1502ddb39c03b09$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b1502ddb39c03b09$var$ya ? (d = $b1502ddb39c03b09$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b1502ddb39c03b09$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b1502ddb39c03b09$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b1502ddb39c03b09$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b1502ddb39c03b09$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b1502ddb39c03b09$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b1502ddb39c03b09$var$eb(f)) return n(a, d, f, h);
            if ($b1502ddb39c03b09$var$Ka(f)) return t(a, d, f, h);
            $b1502ddb39c03b09$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b1502ddb39c03b09$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b1502ddb39c03b09$var$Ug = $b1502ddb39c03b09$var$Og(!0), $b1502ddb39c03b09$var$Vg = $b1502ddb39c03b09$var$Og(!1), $b1502ddb39c03b09$var$Wg = $b1502ddb39c03b09$var$Uf(null), $b1502ddb39c03b09$var$Xg = null, $b1502ddb39c03b09$var$Yg = null, $b1502ddb39c03b09$var$Zg = null;
function $b1502ddb39c03b09$var$$g() {
    $b1502ddb39c03b09$var$Zg = $b1502ddb39c03b09$var$Yg = $b1502ddb39c03b09$var$Xg = null;
}
function $b1502ddb39c03b09$var$ah(a) {
    var b = $b1502ddb39c03b09$var$Wg.current;
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wg);
    a._currentValue = b;
}
function $b1502ddb39c03b09$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b1502ddb39c03b09$var$ch(a, b) {
    $b1502ddb39c03b09$var$Xg = a;
    $b1502ddb39c03b09$var$Zg = $b1502ddb39c03b09$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b1502ddb39c03b09$var$dh = !0), a.firstContext = null);
}
function $b1502ddb39c03b09$var$eh(a) {
    var b = a._currentValue;
    if ($b1502ddb39c03b09$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b1502ddb39c03b09$var$Yg) {
            if (null === $b1502ddb39c03b09$var$Xg) throw Error($b1502ddb39c03b09$var$p(308));
            $b1502ddb39c03b09$var$Yg = a;
            $b1502ddb39c03b09$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b1502ddb39c03b09$var$Yg = $b1502ddb39c03b09$var$Yg.next = a;
    }
    return b;
}
var $b1502ddb39c03b09$var$fh = null;
function $b1502ddb39c03b09$var$gh(a) {
    null === $b1502ddb39c03b09$var$fh ? $b1502ddb39c03b09$var$fh = [
        a
    ] : $b1502ddb39c03b09$var$fh.push(a);
}
function $b1502ddb39c03b09$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b1502ddb39c03b09$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b1502ddb39c03b09$var$ih(a, d);
}
function $b1502ddb39c03b09$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b1502ddb39c03b09$var$jh = !1;
function $b1502ddb39c03b09$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b1502ddb39c03b09$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b1502ddb39c03b09$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b1502ddb39c03b09$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b1502ddb39c03b09$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b1502ddb39c03b09$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b1502ddb39c03b09$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b1502ddb39c03b09$var$ih(a, c);
}
function $b1502ddb39c03b09$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b1502ddb39c03b09$var$Cc(a, c);
    }
}
function $b1502ddb39c03b09$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b1502ddb39c03b09$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b1502ddb39c03b09$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b1502ddb39c03b09$var$A({}, q, r);
                            break a;
                        case 2:
                            $b1502ddb39c03b09$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b1502ddb39c03b09$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b1502ddb39c03b09$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b1502ddb39c03b09$var$p(191, e));
            e.call(d);
        }
    }
}
var $b1502ddb39c03b09$var$th = {}, $b1502ddb39c03b09$var$uh = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$th), $b1502ddb39c03b09$var$vh = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$th), $b1502ddb39c03b09$var$wh = $b1502ddb39c03b09$var$Uf($b1502ddb39c03b09$var$th);
function $b1502ddb39c03b09$var$xh(a) {
    if (a === $b1502ddb39c03b09$var$th) throw Error($b1502ddb39c03b09$var$p(174));
    return a;
}
function $b1502ddb39c03b09$var$yh(a, b) {
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$wh, b);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$vh, a);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$uh, $b1502ddb39c03b09$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b1502ddb39c03b09$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b1502ddb39c03b09$var$lb(b, a);
    }
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$uh);
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$uh, b);
}
function $b1502ddb39c03b09$var$zh() {
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$uh);
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$vh);
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$wh);
}
function $b1502ddb39c03b09$var$Ah(a) {
    $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$wh.current);
    var b = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
    var c = $b1502ddb39c03b09$var$lb(b, a.type);
    b !== c && ($b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$vh, a), $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$uh, c));
}
function $b1502ddb39c03b09$var$Bh(a) {
    $b1502ddb39c03b09$var$vh.current === a && ($b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$uh), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$vh));
}
var $b1502ddb39c03b09$var$L = $b1502ddb39c03b09$var$Uf(0);
function $b1502ddb39c03b09$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b1502ddb39c03b09$var$Dh = [];
function $b1502ddb39c03b09$var$Eh() {
    for(var a = 0; a < $b1502ddb39c03b09$var$Dh.length; a++)$b1502ddb39c03b09$var$Dh[a]._workInProgressVersionPrimary = null;
    $b1502ddb39c03b09$var$Dh.length = 0;
}
var $b1502ddb39c03b09$var$Fh = $b1502ddb39c03b09$var$ua.ReactCurrentDispatcher, $b1502ddb39c03b09$var$Gh = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig, $b1502ddb39c03b09$var$Hh = 0, $b1502ddb39c03b09$var$M = null, $b1502ddb39c03b09$var$N = null, $b1502ddb39c03b09$var$O = null, $b1502ddb39c03b09$var$Ih = !1, $b1502ddb39c03b09$var$Jh = !1, $b1502ddb39c03b09$var$Kh = 0, $b1502ddb39c03b09$var$Lh = 0;
function $b1502ddb39c03b09$var$P() {
    throw Error($b1502ddb39c03b09$var$p(321));
}
function $b1502ddb39c03b09$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b1502ddb39c03b09$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b1502ddb39c03b09$var$Nh(a, b, c, d, e, f) {
    $b1502ddb39c03b09$var$Hh = f;
    $b1502ddb39c03b09$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b1502ddb39c03b09$var$Fh.current = null === a || null === a.memoizedState ? $b1502ddb39c03b09$var$Oh : $b1502ddb39c03b09$var$Ph;
    a = c(d, e);
    if ($b1502ddb39c03b09$var$Jh) {
        f = 0;
        do {
            $b1502ddb39c03b09$var$Jh = !1;
            $b1502ddb39c03b09$var$Kh = 0;
            if (25 <= f) throw Error($b1502ddb39c03b09$var$p(301));
            f += 1;
            $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$N = null;
            b.updateQueue = null;
            $b1502ddb39c03b09$var$Fh.current = $b1502ddb39c03b09$var$Qh;
            a = c(d, e);
        }while ($b1502ddb39c03b09$var$Jh);
    }
    $b1502ddb39c03b09$var$Fh.current = $b1502ddb39c03b09$var$Rh;
    b = null !== $b1502ddb39c03b09$var$N && null !== $b1502ddb39c03b09$var$N.next;
    $b1502ddb39c03b09$var$Hh = 0;
    $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$N = $b1502ddb39c03b09$var$M = null;
    $b1502ddb39c03b09$var$Ih = !1;
    if (b) throw Error($b1502ddb39c03b09$var$p(300));
    return a;
}
function $b1502ddb39c03b09$var$Sh() {
    var a = 0 !== $b1502ddb39c03b09$var$Kh;
    $b1502ddb39c03b09$var$Kh = 0;
    return a;
}
function $b1502ddb39c03b09$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b1502ddb39c03b09$var$O ? $b1502ddb39c03b09$var$M.memoizedState = $b1502ddb39c03b09$var$O = a : $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$O.next = a;
    return $b1502ddb39c03b09$var$O;
}
function $b1502ddb39c03b09$var$Uh() {
    if (null === $b1502ddb39c03b09$var$N) {
        var a = $b1502ddb39c03b09$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b1502ddb39c03b09$var$N.next;
    var b = null === $b1502ddb39c03b09$var$O ? $b1502ddb39c03b09$var$M.memoizedState : $b1502ddb39c03b09$var$O.next;
    if (null !== b) $b1502ddb39c03b09$var$O = b, $b1502ddb39c03b09$var$N = a;
    else {
        if (null === a) throw Error($b1502ddb39c03b09$var$p(310));
        $b1502ddb39c03b09$var$N = a;
        a = {
            memoizedState: $b1502ddb39c03b09$var$N.memoizedState,
            baseState: $b1502ddb39c03b09$var$N.baseState,
            baseQueue: $b1502ddb39c03b09$var$N.baseQueue,
            queue: $b1502ddb39c03b09$var$N.queue,
            next: null
        };
        null === $b1502ddb39c03b09$var$O ? $b1502ddb39c03b09$var$M.memoizedState = $b1502ddb39c03b09$var$O = a : $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$O.next = a;
    }
    return $b1502ddb39c03b09$var$O;
}
function $b1502ddb39c03b09$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b1502ddb39c03b09$var$Wh(a) {
    var b = $b1502ddb39c03b09$var$Uh(), c = b.queue;
    if (null === c) throw Error($b1502ddb39c03b09$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b1502ddb39c03b09$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b1502ddb39c03b09$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b1502ddb39c03b09$var$M.lanes |= m;
                $b1502ddb39c03b09$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b1502ddb39c03b09$var$He(d, b.memoizedState) || ($b1502ddb39c03b09$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b1502ddb39c03b09$var$M.lanes |= f, $b1502ddb39c03b09$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b1502ddb39c03b09$var$Xh(a) {
    var b = $b1502ddb39c03b09$var$Uh(), c = b.queue;
    if (null === c) throw Error($b1502ddb39c03b09$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b1502ddb39c03b09$var$He(f, b.memoizedState) || ($b1502ddb39c03b09$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b1502ddb39c03b09$var$Yh() {}
function $b1502ddb39c03b09$var$Zh(a, b) {
    var c = $b1502ddb39c03b09$var$M, d = $b1502ddb39c03b09$var$Uh(), e = b(), f = !$b1502ddb39c03b09$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b1502ddb39c03b09$var$dh = !0);
    d = d.queue;
    $b1502ddb39c03b09$var$$h($b1502ddb39c03b09$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b1502ddb39c03b09$var$O && $b1502ddb39c03b09$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b1502ddb39c03b09$var$bi(9, $b1502ddb39c03b09$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b1502ddb39c03b09$var$Q) throw Error($b1502ddb39c03b09$var$p(349));
        0 !== ($b1502ddb39c03b09$var$Hh & 30) || $b1502ddb39c03b09$var$di(c, b, e);
    }
    return e;
}
function $b1502ddb39c03b09$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b1502ddb39c03b09$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b1502ddb39c03b09$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b1502ddb39c03b09$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b1502ddb39c03b09$var$ei(b) && $b1502ddb39c03b09$var$fi(a);
}
function $b1502ddb39c03b09$var$ai(a, b, c) {
    return c(function() {
        $b1502ddb39c03b09$var$ei(b) && $b1502ddb39c03b09$var$fi(a);
    });
}
function $b1502ddb39c03b09$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b1502ddb39c03b09$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b1502ddb39c03b09$var$fi(a) {
    var b = $b1502ddb39c03b09$var$ih(a, 1);
    null !== b && $b1502ddb39c03b09$var$gi(b, a, 1, -1);
}
function $b1502ddb39c03b09$var$hi(a) {
    var b = $b1502ddb39c03b09$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b1502ddb39c03b09$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b1502ddb39c03b09$var$ii.bind(null, $b1502ddb39c03b09$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b1502ddb39c03b09$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b1502ddb39c03b09$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b1502ddb39c03b09$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b1502ddb39c03b09$var$ji() {
    return $b1502ddb39c03b09$var$Uh().memoizedState;
}
function $b1502ddb39c03b09$var$ki(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$Th();
    $b1502ddb39c03b09$var$M.flags |= a;
    e.memoizedState = $b1502ddb39c03b09$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b1502ddb39c03b09$var$li(a, b, c, d) {
    var e = $b1502ddb39c03b09$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b1502ddb39c03b09$var$N) {
        var g = $b1502ddb39c03b09$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b1502ddb39c03b09$var$Mh(d, g.deps)) {
            e.memoizedState = $b1502ddb39c03b09$var$bi(b, c, f, d);
            return;
        }
    }
    $b1502ddb39c03b09$var$M.flags |= a;
    e.memoizedState = $b1502ddb39c03b09$var$bi(1 | b, c, f, d);
}
function $b1502ddb39c03b09$var$mi(a, b) {
    return $b1502ddb39c03b09$var$ki(8390656, 8, a, b);
}
function $b1502ddb39c03b09$var$$h(a, b) {
    return $b1502ddb39c03b09$var$li(2048, 8, a, b);
}
function $b1502ddb39c03b09$var$ni(a, b) {
    return $b1502ddb39c03b09$var$li(4, 2, a, b);
}
function $b1502ddb39c03b09$var$oi(a, b) {
    return $b1502ddb39c03b09$var$li(4, 4, a, b);
}
function $b1502ddb39c03b09$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b1502ddb39c03b09$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b1502ddb39c03b09$var$li(4, 4, $b1502ddb39c03b09$var$pi.bind(null, b, a), c);
}
function $b1502ddb39c03b09$var$ri() {}
function $b1502ddb39c03b09$var$si(a, b) {
    var c = $b1502ddb39c03b09$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b1502ddb39c03b09$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b1502ddb39c03b09$var$ti(a, b) {
    var c = $b1502ddb39c03b09$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b1502ddb39c03b09$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b1502ddb39c03b09$var$ui(a, b, c) {
    if (0 === ($b1502ddb39c03b09$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b1502ddb39c03b09$var$dh = !0), a.memoizedState = c;
    $b1502ddb39c03b09$var$He(c, b) || (c = $b1502ddb39c03b09$var$yc(), $b1502ddb39c03b09$var$M.lanes |= c, $b1502ddb39c03b09$var$rh |= c, a.baseState = !0);
    return b;
}
function $b1502ddb39c03b09$var$vi(a, b) {
    var c = $b1502ddb39c03b09$var$C;
    $b1502ddb39c03b09$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b1502ddb39c03b09$var$Gh.transition;
    $b1502ddb39c03b09$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b1502ddb39c03b09$var$C = c, $b1502ddb39c03b09$var$Gh.transition = d;
    }
}
function $b1502ddb39c03b09$var$wi() {
    return $b1502ddb39c03b09$var$Uh().memoizedState;
}
function $b1502ddb39c03b09$var$xi(a, b, c) {
    var d = $b1502ddb39c03b09$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b1502ddb39c03b09$var$zi(a)) $b1502ddb39c03b09$var$Ai(b, c);
    else if (c = $b1502ddb39c03b09$var$hh(a, b, c, d), null !== c) {
        var e = $b1502ddb39c03b09$var$R();
        $b1502ddb39c03b09$var$gi(c, a, d, e);
        $b1502ddb39c03b09$var$Bi(c, b, d);
    }
}
function $b1502ddb39c03b09$var$ii(a, b, c) {
    var d = $b1502ddb39c03b09$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b1502ddb39c03b09$var$zi(a)) $b1502ddb39c03b09$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b1502ddb39c03b09$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b1502ddb39c03b09$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b1502ddb39c03b09$var$hh(a, b, e, d);
        null !== c && (e = $b1502ddb39c03b09$var$R(), $b1502ddb39c03b09$var$gi(c, a, d, e), $b1502ddb39c03b09$var$Bi(c, b, d));
    }
}
function $b1502ddb39c03b09$var$zi(a) {
    var b = a.alternate;
    return a === $b1502ddb39c03b09$var$M || null !== b && b === $b1502ddb39c03b09$var$M;
}
function $b1502ddb39c03b09$var$Ai(a, b) {
    $b1502ddb39c03b09$var$Jh = $b1502ddb39c03b09$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b1502ddb39c03b09$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b1502ddb39c03b09$var$Cc(a, c);
    }
}
var $b1502ddb39c03b09$var$Rh = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: $b1502ddb39c03b09$var$P,
    useContext: $b1502ddb39c03b09$var$P,
    useEffect: $b1502ddb39c03b09$var$P,
    useImperativeHandle: $b1502ddb39c03b09$var$P,
    useInsertionEffect: $b1502ddb39c03b09$var$P,
    useLayoutEffect: $b1502ddb39c03b09$var$P,
    useMemo: $b1502ddb39c03b09$var$P,
    useReducer: $b1502ddb39c03b09$var$P,
    useRef: $b1502ddb39c03b09$var$P,
    useState: $b1502ddb39c03b09$var$P,
    useDebugValue: $b1502ddb39c03b09$var$P,
    useDeferredValue: $b1502ddb39c03b09$var$P,
    useTransition: $b1502ddb39c03b09$var$P,
    useMutableSource: $b1502ddb39c03b09$var$P,
    useSyncExternalStore: $b1502ddb39c03b09$var$P,
    useId: $b1502ddb39c03b09$var$P,
    unstable_isNewReconciler: !1
}, $b1502ddb39c03b09$var$Oh = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: function useCallback(a, b) {
        $b1502ddb39c03b09$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b1502ddb39c03b09$var$eh,
    useEffect: $b1502ddb39c03b09$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b1502ddb39c03b09$var$ki(4194308, 4, $b1502ddb39c03b09$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $b1502ddb39c03b09$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $b1502ddb39c03b09$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $b1502ddb39c03b09$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $b1502ddb39c03b09$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b1502ddb39c03b09$var$xi.bind(null, $b1502ddb39c03b09$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $b1502ddb39c03b09$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b1502ddb39c03b09$var$hi,
    useDebugValue: $b1502ddb39c03b09$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $b1502ddb39c03b09$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $b1502ddb39c03b09$var$hi(!1), b = a[0];
        a = $b1502ddb39c03b09$var$vi.bind(null, a[1]);
        $b1502ddb39c03b09$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $b1502ddb39c03b09$var$M, e = $b1502ddb39c03b09$var$Th();
        if ($b1502ddb39c03b09$var$I) {
            if (void 0 === c) throw Error($b1502ddb39c03b09$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b1502ddb39c03b09$var$Q) throw Error($b1502ddb39c03b09$var$p(349));
            0 !== ($b1502ddb39c03b09$var$Hh & 30) || $b1502ddb39c03b09$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b1502ddb39c03b09$var$mi($b1502ddb39c03b09$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b1502ddb39c03b09$var$bi(9, $b1502ddb39c03b09$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $b1502ddb39c03b09$var$Th(), b = $b1502ddb39c03b09$var$Q.identifierPrefix;
        if ($b1502ddb39c03b09$var$I) {
            var c = $b1502ddb39c03b09$var$sg;
            var d = $b1502ddb39c03b09$var$rg;
            c = (d & ~(1 << 32 - $b1502ddb39c03b09$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b1502ddb39c03b09$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b1502ddb39c03b09$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b1502ddb39c03b09$var$Ph = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: $b1502ddb39c03b09$var$si,
    useContext: $b1502ddb39c03b09$var$eh,
    useEffect: $b1502ddb39c03b09$var$$h,
    useImperativeHandle: $b1502ddb39c03b09$var$qi,
    useInsertionEffect: $b1502ddb39c03b09$var$ni,
    useLayoutEffect: $b1502ddb39c03b09$var$oi,
    useMemo: $b1502ddb39c03b09$var$ti,
    useReducer: $b1502ddb39c03b09$var$Wh,
    useRef: $b1502ddb39c03b09$var$ji,
    useState: function useState() {
        return $b1502ddb39c03b09$var$Wh($b1502ddb39c03b09$var$Vh);
    },
    useDebugValue: $b1502ddb39c03b09$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b1502ddb39c03b09$var$Uh();
        return $b1502ddb39c03b09$var$ui(b, $b1502ddb39c03b09$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b1502ddb39c03b09$var$Wh($b1502ddb39c03b09$var$Vh)[0], b = $b1502ddb39c03b09$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b1502ddb39c03b09$var$Yh,
    useSyncExternalStore: $b1502ddb39c03b09$var$Zh,
    useId: $b1502ddb39c03b09$var$wi,
    unstable_isNewReconciler: !1
}, $b1502ddb39c03b09$var$Qh = {
    readContext: $b1502ddb39c03b09$var$eh,
    useCallback: $b1502ddb39c03b09$var$si,
    useContext: $b1502ddb39c03b09$var$eh,
    useEffect: $b1502ddb39c03b09$var$$h,
    useImperativeHandle: $b1502ddb39c03b09$var$qi,
    useInsertionEffect: $b1502ddb39c03b09$var$ni,
    useLayoutEffect: $b1502ddb39c03b09$var$oi,
    useMemo: $b1502ddb39c03b09$var$ti,
    useReducer: $b1502ddb39c03b09$var$Xh,
    useRef: $b1502ddb39c03b09$var$ji,
    useState: function useState() {
        return $b1502ddb39c03b09$var$Xh($b1502ddb39c03b09$var$Vh);
    },
    useDebugValue: $b1502ddb39c03b09$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b1502ddb39c03b09$var$Uh();
        return null === $b1502ddb39c03b09$var$N ? b.memoizedState = a : $b1502ddb39c03b09$var$ui(b, $b1502ddb39c03b09$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b1502ddb39c03b09$var$Xh($b1502ddb39c03b09$var$Vh)[0], b = $b1502ddb39c03b09$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b1502ddb39c03b09$var$Yh,
    useSyncExternalStore: $b1502ddb39c03b09$var$Zh,
    useId: $b1502ddb39c03b09$var$wi,
    unstable_isNewReconciler: !1
};
function $b1502ddb39c03b09$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b1502ddb39c03b09$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b1502ddb39c03b09$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b1502ddb39c03b09$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b1502ddb39c03b09$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $b1502ddb39c03b09$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $b1502ddb39c03b09$var$R(), e = $b1502ddb39c03b09$var$yi(a), f = $b1502ddb39c03b09$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b1502ddb39c03b09$var$nh(a, f, e);
        null !== b && ($b1502ddb39c03b09$var$gi(b, a, e, d), $b1502ddb39c03b09$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $b1502ddb39c03b09$var$R(), e = $b1502ddb39c03b09$var$yi(a), f = $b1502ddb39c03b09$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b1502ddb39c03b09$var$nh(a, f, e);
        null !== b && ($b1502ddb39c03b09$var$gi(b, a, e, d), $b1502ddb39c03b09$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $b1502ddb39c03b09$var$R(), d = $b1502ddb39c03b09$var$yi(a), e = $b1502ddb39c03b09$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b1502ddb39c03b09$var$nh(a, e, d);
        null !== b && ($b1502ddb39c03b09$var$gi(b, a, d, c), $b1502ddb39c03b09$var$oh(b, a, d));
    }
};
function $b1502ddb39c03b09$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b1502ddb39c03b09$var$Ie(c, d) || !$b1502ddb39c03b09$var$Ie(e, f) : !0;
}
function $b1502ddb39c03b09$var$Gi(a, b, c) {
    var d = !1, e = $b1502ddb39c03b09$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b1502ddb39c03b09$var$eh(f) : (e = $b1502ddb39c03b09$var$Zf(b) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b1502ddb39c03b09$var$Yf(a, e) : $b1502ddb39c03b09$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b1502ddb39c03b09$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b1502ddb39c03b09$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b1502ddb39c03b09$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b1502ddb39c03b09$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b1502ddb39c03b09$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b1502ddb39c03b09$var$eh(f) : (f = $b1502ddb39c03b09$var$Zf(b) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, e.context = $b1502ddb39c03b09$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b1502ddb39c03b09$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b1502ddb39c03b09$var$Ei.enqueueReplaceState(e, e.state, null), $b1502ddb39c03b09$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b1502ddb39c03b09$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b1502ddb39c03b09$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b1502ddb39c03b09$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b1502ddb39c03b09$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b1502ddb39c03b09$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b1502ddb39c03b09$var$Ni(a, b, c) {
    c = $b1502ddb39c03b09$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b1502ddb39c03b09$var$Oi || ($b1502ddb39c03b09$var$Oi = !0, $b1502ddb39c03b09$var$Pi = d);
        $b1502ddb39c03b09$var$Li(a, b);
    };
    return c;
}
function $b1502ddb39c03b09$var$Qi(a, b, c) {
    c = $b1502ddb39c03b09$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b1502ddb39c03b09$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b1502ddb39c03b09$var$Li(a, b);
        "function" !== typeof d && (null === $b1502ddb39c03b09$var$Ri ? $b1502ddb39c03b09$var$Ri = new Set([
            this
        ]) : $b1502ddb39c03b09$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $b1502ddb39c03b09$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b1502ddb39c03b09$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b1502ddb39c03b09$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b1502ddb39c03b09$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b1502ddb39c03b09$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b1502ddb39c03b09$var$mh(-1, 1), b.tag = 2, $b1502ddb39c03b09$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b1502ddb39c03b09$var$Wi = $b1502ddb39c03b09$var$ua.ReactCurrentOwner, $b1502ddb39c03b09$var$dh = !1;
function $b1502ddb39c03b09$var$Xi(a, b, c, d) {
    b.child = null === a ? $b1502ddb39c03b09$var$Vg(b, null, c, d) : $b1502ddb39c03b09$var$Ug(b, a.child, c, d);
}
function $b1502ddb39c03b09$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b1502ddb39c03b09$var$ch(b, e);
    d = $b1502ddb39c03b09$var$Nh(a, b, c, d, f, e);
    c = $b1502ddb39c03b09$var$Sh();
    if (null !== a && !$b1502ddb39c03b09$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b1502ddb39c03b09$var$Zi(a, b, e);
    $b1502ddb39c03b09$var$I && c && $b1502ddb39c03b09$var$vg(b);
    b.flags |= 1;
    $b1502ddb39c03b09$var$Xi(a, b, d, e);
    return b.child;
}
function $b1502ddb39c03b09$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b1502ddb39c03b09$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b1502ddb39c03b09$var$bj(a, b, f, d, e);
        a = $b1502ddb39c03b09$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b1502ddb39c03b09$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b1502ddb39c03b09$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b1502ddb39c03b09$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b1502ddb39c03b09$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b1502ddb39c03b09$var$Ie(f, d) && a.ref === b.ref) {
            if ($b1502ddb39c03b09$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b1502ddb39c03b09$var$dh = !0);
            else return b.lanes = a.lanes, $b1502ddb39c03b09$var$Zi(a, b, e);
        }
    }
    return $b1502ddb39c03b09$var$cj(a, b, c, d, e);
}
function $b1502ddb39c03b09$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj), $b1502ddb39c03b09$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj), $b1502ddb39c03b09$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj);
            $b1502ddb39c03b09$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$ej, $b1502ddb39c03b09$var$fj), $b1502ddb39c03b09$var$fj |= d;
    $b1502ddb39c03b09$var$Xi(a, b, e, c);
    return b.child;
}
function $b1502ddb39c03b09$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b1502ddb39c03b09$var$cj(a, b, c, d, e) {
    var f = $b1502ddb39c03b09$var$Zf(c) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current;
    f = $b1502ddb39c03b09$var$Yf(b, f);
    $b1502ddb39c03b09$var$ch(b, e);
    c = $b1502ddb39c03b09$var$Nh(a, b, c, d, f, e);
    d = $b1502ddb39c03b09$var$Sh();
    if (null !== a && !$b1502ddb39c03b09$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b1502ddb39c03b09$var$Zi(a, b, e);
    $b1502ddb39c03b09$var$I && d && $b1502ddb39c03b09$var$vg(b);
    b.flags |= 1;
    $b1502ddb39c03b09$var$Xi(a, b, c, e);
    return b.child;
}
function $b1502ddb39c03b09$var$hj(a, b, c, d, e) {
    if ($b1502ddb39c03b09$var$Zf(c)) {
        var f = !0;
        $b1502ddb39c03b09$var$cg(b);
    } else f = !1;
    $b1502ddb39c03b09$var$ch(b, e);
    if (null === b.stateNode) $b1502ddb39c03b09$var$ij(a, b), $b1502ddb39c03b09$var$Gi(b, c, d), $b1502ddb39c03b09$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b1502ddb39c03b09$var$eh(l) : (l = $b1502ddb39c03b09$var$Zf(c) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, l = $b1502ddb39c03b09$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b1502ddb39c03b09$var$Hi(b, g, d, l);
        $b1502ddb39c03b09$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b1502ddb39c03b09$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b1502ddb39c03b09$var$Wf.current || $b1502ddb39c03b09$var$jh ? ("function" === typeof m && ($b1502ddb39c03b09$var$Di(b, c, m, d), k = b.memoizedState), (h = $b1502ddb39c03b09$var$jh || $b1502ddb39c03b09$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b1502ddb39c03b09$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b1502ddb39c03b09$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b1502ddb39c03b09$var$eh(k) : (k = $b1502ddb39c03b09$var$Zf(c) ? $b1502ddb39c03b09$var$Xf : $b1502ddb39c03b09$var$H.current, k = $b1502ddb39c03b09$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b1502ddb39c03b09$var$Hi(b, g, d, k);
        $b1502ddb39c03b09$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b1502ddb39c03b09$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b1502ddb39c03b09$var$Wf.current || $b1502ddb39c03b09$var$jh ? ("function" === typeof y && ($b1502ddb39c03b09$var$Di(b, c, y, d), n = b.memoizedState), (l = $b1502ddb39c03b09$var$jh || $b1502ddb39c03b09$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b1502ddb39c03b09$var$jj(a, b, c, d, f, e);
}
function $b1502ddb39c03b09$var$jj(a, b, c, d, e, f) {
    $b1502ddb39c03b09$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b1502ddb39c03b09$var$dg(b, c, !1), $b1502ddb39c03b09$var$Zi(a, b, f);
    d = b.stateNode;
    $b1502ddb39c03b09$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b1502ddb39c03b09$var$Ug(b, a.child, null, f), b.child = $b1502ddb39c03b09$var$Ug(b, null, h, f)) : $b1502ddb39c03b09$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b1502ddb39c03b09$var$dg(b, c, !0);
    return b.child;
}
function $b1502ddb39c03b09$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b1502ddb39c03b09$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b1502ddb39c03b09$var$ag(a, b.context, !1);
    $b1502ddb39c03b09$var$yh(a, b.containerInfo);
}
function $b1502ddb39c03b09$var$lj(a, b, c, d, e) {
    $b1502ddb39c03b09$var$Ig();
    $b1502ddb39c03b09$var$Jg(e);
    b.flags |= 256;
    $b1502ddb39c03b09$var$Xi(a, b, c, d);
    return b.child;
}
var $b1502ddb39c03b09$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b1502ddb39c03b09$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b1502ddb39c03b09$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b1502ddb39c03b09$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, e & 1);
    if (null === a) {
        $b1502ddb39c03b09$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b1502ddb39c03b09$var$pj(g, d, 0, null), a = $b1502ddb39c03b09$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b1502ddb39c03b09$var$nj(c), b.memoizedState = $b1502ddb39c03b09$var$mj, a) : $b1502ddb39c03b09$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b1502ddb39c03b09$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b1502ddb39c03b09$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b1502ddb39c03b09$var$Pg(h, f) : (f = $b1502ddb39c03b09$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b1502ddb39c03b09$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b1502ddb39c03b09$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b1502ddb39c03b09$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b1502ddb39c03b09$var$qj(a, b) {
    b = $b1502ddb39c03b09$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b1502ddb39c03b09$var$sj(a, b, c, d) {
    null !== d && $b1502ddb39c03b09$var$Jg(d);
    $b1502ddb39c03b09$var$Ug(b, a.child, null, c);
    a = $b1502ddb39c03b09$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b1502ddb39c03b09$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b1502ddb39c03b09$var$Ki(Error($b1502ddb39c03b09$var$p(422))), $b1502ddb39c03b09$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b1502ddb39c03b09$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b1502ddb39c03b09$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b1502ddb39c03b09$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b1502ddb39c03b09$var$nj(g);
        b.memoizedState = $b1502ddb39c03b09$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b1502ddb39c03b09$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b1502ddb39c03b09$var$p(419));
        d = $b1502ddb39c03b09$var$Ki(f, d, void 0);
        return $b1502ddb39c03b09$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b1502ddb39c03b09$var$dh || h) {
        d = $b1502ddb39c03b09$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b1502ddb39c03b09$var$ih(a, e), $b1502ddb39c03b09$var$gi(d, a, e, -1));
        }
        $b1502ddb39c03b09$var$tj();
        d = $b1502ddb39c03b09$var$Ki(Error($b1502ddb39c03b09$var$p(421)));
        return $b1502ddb39c03b09$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b1502ddb39c03b09$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(e.nextSibling);
    $b1502ddb39c03b09$var$xg = b;
    $b1502ddb39c03b09$var$I = !0;
    $b1502ddb39c03b09$var$zg = null;
    null !== a && ($b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$rg, $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$sg, $b1502ddb39c03b09$var$og[$b1502ddb39c03b09$var$pg++] = $b1502ddb39c03b09$var$qg, $b1502ddb39c03b09$var$rg = a.id, $b1502ddb39c03b09$var$sg = a.overflow, $b1502ddb39c03b09$var$qg = b);
    b = $b1502ddb39c03b09$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b1502ddb39c03b09$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b1502ddb39c03b09$var$bh(a.return, b, c);
}
function $b1502ddb39c03b09$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b1502ddb39c03b09$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b1502ddb39c03b09$var$Xi(a, b, d.children, c);
    d = $b1502ddb39c03b09$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b1502ddb39c03b09$var$vj(a, c, b);
            else if (19 === a.tag) $b1502ddb39c03b09$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b1502ddb39c03b09$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b1502ddb39c03b09$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b1502ddb39c03b09$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b1502ddb39c03b09$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b1502ddb39c03b09$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b1502ddb39c03b09$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b1502ddb39c03b09$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b1502ddb39c03b09$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b1502ddb39c03b09$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b1502ddb39c03b09$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b1502ddb39c03b09$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b1502ddb39c03b09$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b1502ddb39c03b09$var$kj(b);
            $b1502ddb39c03b09$var$Ig();
            break;
        case 5:
            $b1502ddb39c03b09$var$Ah(b);
            break;
        case 1:
            $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$cg(b);
            break;
        case 4:
            $b1502ddb39c03b09$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b1502ddb39c03b09$var$oj(a, b, c);
                $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1);
                a = $b1502ddb39c03b09$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b1502ddb39c03b09$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b1502ddb39c03b09$var$dj(a, b, c);
    }
    return $b1502ddb39c03b09$var$Zi(a, b, c);
}
var $b1502ddb39c03b09$var$zj, $b1502ddb39c03b09$var$Aj, $b1502ddb39c03b09$var$Bj, $b1502ddb39c03b09$var$Cj;
$b1502ddb39c03b09$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b1502ddb39c03b09$var$Aj = function Aj() {};
$b1502ddb39c03b09$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b1502ddb39c03b09$var$Ya(a, e);
                d = $b1502ddb39c03b09$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b1502ddb39c03b09$var$A({}, e, {
                    value: void 0
                });
                d = $b1502ddb39c03b09$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b1502ddb39c03b09$var$gb(a, e);
                d = $b1502ddb39c03b09$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b1502ddb39c03b09$var$Bf);
        }
        $b1502ddb39c03b09$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b1502ddb39c03b09$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b1502ddb39c03b09$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b1502ddb39c03b09$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b1502ddb39c03b09$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b1502ddb39c03b09$var$Dj(a, b) {
    if (!$b1502ddb39c03b09$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b1502ddb39c03b09$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b1502ddb39c03b09$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b1502ddb39c03b09$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b1502ddb39c03b09$var$S(b), null;
        case 1:
            return $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$$f(), $b1502ddb39c03b09$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b1502ddb39c03b09$var$zh();
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H);
            $b1502ddb39c03b09$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b1502ddb39c03b09$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b1502ddb39c03b09$var$zg && ($b1502ddb39c03b09$var$Fj($b1502ddb39c03b09$var$zg), $b1502ddb39c03b09$var$zg = null));
            $b1502ddb39c03b09$var$Aj(a, b);
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 5:
            $b1502ddb39c03b09$var$Bh(b);
            var e = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b1502ddb39c03b09$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b1502ddb39c03b09$var$p(166));
                    $b1502ddb39c03b09$var$S(b);
                    return null;
                }
                a = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
                if ($b1502ddb39c03b09$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b1502ddb39c03b09$var$Of] = b;
                    d[$b1502ddb39c03b09$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b1502ddb39c03b09$var$D("cancel", d);
                            $b1502ddb39c03b09$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b1502ddb39c03b09$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b1502ddb39c03b09$var$lf.length; e++)$b1502ddb39c03b09$var$D($b1502ddb39c03b09$var$lf[e], d);
                            break;
                        case "source":
                            $b1502ddb39c03b09$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b1502ddb39c03b09$var$D("error", d);
                            $b1502ddb39c03b09$var$D("load", d);
                            break;
                        case "details":
                            $b1502ddb39c03b09$var$D("toggle", d);
                            break;
                        case "input":
                            $b1502ddb39c03b09$var$Za(d, f);
                            $b1502ddb39c03b09$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b1502ddb39c03b09$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b1502ddb39c03b09$var$hb(d, f), $b1502ddb39c03b09$var$D("invalid", d);
                    }
                    $b1502ddb39c03b09$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b1502ddb39c03b09$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b1502ddb39c03b09$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b1502ddb39c03b09$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b1502ddb39c03b09$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b1502ddb39c03b09$var$Va(d);
                            $b1502ddb39c03b09$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b1502ddb39c03b09$var$Va(d);
                            $b1502ddb39c03b09$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b1502ddb39c03b09$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b1502ddb39c03b09$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b1502ddb39c03b09$var$Of] = b;
                    a[$b1502ddb39c03b09$var$Pf] = d;
                    $b1502ddb39c03b09$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b1502ddb39c03b09$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b1502ddb39c03b09$var$D("cancel", a);
                                $b1502ddb39c03b09$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b1502ddb39c03b09$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b1502ddb39c03b09$var$lf.length; e++)$b1502ddb39c03b09$var$D($b1502ddb39c03b09$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b1502ddb39c03b09$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b1502ddb39c03b09$var$D("error", a);
                                $b1502ddb39c03b09$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b1502ddb39c03b09$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b1502ddb39c03b09$var$Za(a, d);
                                e = $b1502ddb39c03b09$var$Ya(a, d);
                                $b1502ddb39c03b09$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b1502ddb39c03b09$var$A({}, d, {
                                    value: void 0
                                });
                                $b1502ddb39c03b09$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b1502ddb39c03b09$var$hb(a, d);
                                e = $b1502ddb39c03b09$var$gb(a, d);
                                $b1502ddb39c03b09$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b1502ddb39c03b09$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b1502ddb39c03b09$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b1502ddb39c03b09$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b1502ddb39c03b09$var$ob(a, k) : "number" === typeof k && $b1502ddb39c03b09$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b1502ddb39c03b09$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b1502ddb39c03b09$var$D("scroll", a) : null != k && $b1502ddb39c03b09$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b1502ddb39c03b09$var$Va(a);
                                $b1502ddb39c03b09$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b1502ddb39c03b09$var$Va(a);
                                $b1502ddb39c03b09$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b1502ddb39c03b09$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b1502ddb39c03b09$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b1502ddb39c03b09$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b1502ddb39c03b09$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b1502ddb39c03b09$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b1502ddb39c03b09$var$p(166));
                c = $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$wh.current);
                $b1502ddb39c03b09$var$xh($b1502ddb39c03b09$var$uh.current);
                if ($b1502ddb39c03b09$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b1502ddb39c03b09$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b1502ddb39c03b09$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b1502ddb39c03b09$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b1502ddb39c03b09$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b1502ddb39c03b09$var$Of] = b, b.stateNode = d;
            }
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 13:
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b1502ddb39c03b09$var$I && null !== $b1502ddb39c03b09$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b1502ddb39c03b09$var$Hg(), $b1502ddb39c03b09$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b1502ddb39c03b09$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b1502ddb39c03b09$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b1502ddb39c03b09$var$p(317));
                        f[$b1502ddb39c03b09$var$Of] = b;
                    } else $b1502ddb39c03b09$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b1502ddb39c03b09$var$S(b);
                    f = !1;
                } else null !== $b1502ddb39c03b09$var$zg && ($b1502ddb39c03b09$var$Fj($b1502ddb39c03b09$var$zg), $b1502ddb39c03b09$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b1502ddb39c03b09$var$L.current & 1) ? 0 === $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$T = 3) : $b1502ddb39c03b09$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 4:
            return $b1502ddb39c03b09$var$zh(), $b1502ddb39c03b09$var$Aj(a, b), null === a && $b1502ddb39c03b09$var$sf(b.stateNode.containerInfo), $b1502ddb39c03b09$var$S(b), null;
        case 10:
            return $b1502ddb39c03b09$var$ah(b.type._context), $b1502ddb39c03b09$var$S(b), null;
        case 17:
            return $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$$f(), $b1502ddb39c03b09$var$S(b), null;
        case 19:
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
            f = b.memoizedState;
            if (null === f) return $b1502ddb39c03b09$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b1502ddb39c03b09$var$Dj(f, !1);
                else {
                    if (0 !== $b1502ddb39c03b09$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b1502ddb39c03b09$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b1502ddb39c03b09$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, $b1502ddb39c03b09$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b1502ddb39c03b09$var$B() > $b1502ddb39c03b09$var$Gj && (b.flags |= 128, d = !0, $b1502ddb39c03b09$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b1502ddb39c03b09$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b1502ddb39c03b09$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b1502ddb39c03b09$var$I) return $b1502ddb39c03b09$var$S(b), null;
                    } else 2 * $b1502ddb39c03b09$var$B() - f.renderingStartTime > $b1502ddb39c03b09$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b1502ddb39c03b09$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b1502ddb39c03b09$var$B(), b.sibling = null, c = $b1502ddb39c03b09$var$L.current, $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$L, d ? c & 1 | 2 : c & 1), b;
            $b1502ddb39c03b09$var$S(b);
            return null;
        case 22:
        case 23:
            return $b1502ddb39c03b09$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b1502ddb39c03b09$var$fj & 1073741824) && ($b1502ddb39c03b09$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b1502ddb39c03b09$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b1502ddb39c03b09$var$p(156, b.tag));
}
function $b1502ddb39c03b09$var$Ij(a, b) {
    $b1502ddb39c03b09$var$wg(b);
    switch(b.tag){
        case 1:
            return $b1502ddb39c03b09$var$Zf(b.type) && $b1502ddb39c03b09$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b1502ddb39c03b09$var$zh(), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf), $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H), $b1502ddb39c03b09$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b1502ddb39c03b09$var$Bh(b), null;
        case 13:
            $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b1502ddb39c03b09$var$p(340));
                $b1502ddb39c03b09$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L), null;
        case 4:
            return $b1502ddb39c03b09$var$zh(), null;
        case 10:
            return $b1502ddb39c03b09$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b1502ddb39c03b09$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b1502ddb39c03b09$var$Jj = !1, $b1502ddb39c03b09$var$U = !1, $b1502ddb39c03b09$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b1502ddb39c03b09$var$V = null;
function $b1502ddb39c03b09$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b1502ddb39c03b09$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b1502ddb39c03b09$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b1502ddb39c03b09$var$W(a, b, d);
    }
}
var $b1502ddb39c03b09$var$Nj = !1;
function $b1502ddb39c03b09$var$Oj(a, b) {
    $b1502ddb39c03b09$var$Cf = $b1502ddb39c03b09$var$dd;
    a = $b1502ddb39c03b09$var$Me();
    if ($b1502ddb39c03b09$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b1502ddb39c03b09$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b1502ddb39c03b09$var$dd = !1;
    for($b1502ddb39c03b09$var$V = b; null !== $b1502ddb39c03b09$var$V;)if (b = $b1502ddb39c03b09$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b1502ddb39c03b09$var$V = a;
    else for(; null !== $b1502ddb39c03b09$var$V;){
        b = $b1502ddb39c03b09$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b1502ddb39c03b09$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b1502ddb39c03b09$var$p(163));
            }
        } catch (F) {
            $b1502ddb39c03b09$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b1502ddb39c03b09$var$V = a;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
    n = $b1502ddb39c03b09$var$Nj;
    $b1502ddb39c03b09$var$Nj = !1;
    return n;
}
function $b1502ddb39c03b09$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b1502ddb39c03b09$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b1502ddb39c03b09$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b1502ddb39c03b09$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b1502ddb39c03b09$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b1502ddb39c03b09$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b1502ddb39c03b09$var$Of], delete b[$b1502ddb39c03b09$var$Pf], delete b[$b1502ddb39c03b09$var$of], delete b[$b1502ddb39c03b09$var$Qf], delete b[$b1502ddb39c03b09$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b1502ddb39c03b09$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b1502ddb39c03b09$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b1502ddb39c03b09$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b1502ddb39c03b09$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b1502ddb39c03b09$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b1502ddb39c03b09$var$Vj(a, b, c), a = a.sibling; null !== a;)$b1502ddb39c03b09$var$Vj(a, b, c), a = a.sibling;
}
function $b1502ddb39c03b09$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b1502ddb39c03b09$var$Wj(a, b, c), a = a.sibling; null !== a;)$b1502ddb39c03b09$var$Wj(a, b, c), a = a.sibling;
}
var $b1502ddb39c03b09$var$X = null, $b1502ddb39c03b09$var$Xj = !1;
function $b1502ddb39c03b09$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b1502ddb39c03b09$var$Zj(a, b, c), c = c.sibling;
}
function $b1502ddb39c03b09$var$Zj(a, b, c) {
    if ($b1502ddb39c03b09$var$lc && "function" === typeof $b1502ddb39c03b09$var$lc.onCommitFiberUnmount) try {
        $b1502ddb39c03b09$var$lc.onCommitFiberUnmount($b1502ddb39c03b09$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b1502ddb39c03b09$var$U || $b1502ddb39c03b09$var$Lj(c, b);
        case 6:
            var d = $b1502ddb39c03b09$var$X, e = $b1502ddb39c03b09$var$Xj;
            $b1502ddb39c03b09$var$X = null;
            $b1502ddb39c03b09$var$Yj(a, b, c);
            $b1502ddb39c03b09$var$X = d;
            $b1502ddb39c03b09$var$Xj = e;
            null !== $b1502ddb39c03b09$var$X && ($b1502ddb39c03b09$var$Xj ? (a = $b1502ddb39c03b09$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b1502ddb39c03b09$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b1502ddb39c03b09$var$X && ($b1502ddb39c03b09$var$Xj ? (a = $b1502ddb39c03b09$var$X, c = c.stateNode, 8 === a.nodeType ? $b1502ddb39c03b09$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b1502ddb39c03b09$var$Kf(a, c), $b1502ddb39c03b09$var$bd(a)) : $b1502ddb39c03b09$var$Kf($b1502ddb39c03b09$var$X, c.stateNode));
            break;
        case 4:
            d = $b1502ddb39c03b09$var$X;
            e = $b1502ddb39c03b09$var$Xj;
            $b1502ddb39c03b09$var$X = c.stateNode.containerInfo;
            $b1502ddb39c03b09$var$Xj = !0;
            $b1502ddb39c03b09$var$Yj(a, b, c);
            $b1502ddb39c03b09$var$X = d;
            $b1502ddb39c03b09$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b1502ddb39c03b09$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b1502ddb39c03b09$var$Mj(c, b, g) : 0 !== (f & 4) && $b1502ddb39c03b09$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b1502ddb39c03b09$var$U && ($b1502ddb39c03b09$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b1502ddb39c03b09$var$W(c, b, h);
            }
            $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        case 21:
            $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b1502ddb39c03b09$var$U = (d = $b1502ddb39c03b09$var$U) || null !== c.memoizedState, $b1502ddb39c03b09$var$Yj(a, b, c), $b1502ddb39c03b09$var$U = d) : $b1502ddb39c03b09$var$Yj(a, b, c);
            break;
        default:
            $b1502ddb39c03b09$var$Yj(a, b, c);
    }
}
function $b1502ddb39c03b09$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b1502ddb39c03b09$var$Kj);
        b.forEach(function(b) {
            var d = $b1502ddb39c03b09$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b1502ddb39c03b09$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b1502ddb39c03b09$var$X = h.stateNode;
                        $b1502ddb39c03b09$var$Xj = !1;
                        break a;
                    case 3:
                        $b1502ddb39c03b09$var$X = h.stateNode.containerInfo;
                        $b1502ddb39c03b09$var$Xj = !0;
                        break a;
                    case 4:
                        $b1502ddb39c03b09$var$X = h.stateNode.containerInfo;
                        $b1502ddb39c03b09$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b1502ddb39c03b09$var$X) throw Error($b1502ddb39c03b09$var$p(160));
            $b1502ddb39c03b09$var$Zj(f, g, e);
            $b1502ddb39c03b09$var$X = null;
            $b1502ddb39c03b09$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b1502ddb39c03b09$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b1502ddb39c03b09$var$dk(b, a), b = b.sibling;
}
function $b1502ddb39c03b09$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 4) {
                try {
                    $b1502ddb39c03b09$var$Pj(3, a, a.return), $b1502ddb39c03b09$var$Qj(3, a);
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
                try {
                    $b1502ddb39c03b09$var$Pj(5, a, a.return);
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            d & 512 && null !== c && $b1502ddb39c03b09$var$Lj(c, c.return);
            break;
        case 5:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            d & 512 && null !== c && $b1502ddb39c03b09$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b1502ddb39c03b09$var$ob(e, "");
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b1502ddb39c03b09$var$ab(e, f);
                    $b1502ddb39c03b09$var$vb(h, g);
                    var l = $b1502ddb39c03b09$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b1502ddb39c03b09$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b1502ddb39c03b09$var$nb(e, q) : "children" === m ? $b1502ddb39c03b09$var$ob(e, q) : $b1502ddb39c03b09$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b1502ddb39c03b09$var$bb(e, f);
                            break;
                        case "textarea":
                            $b1502ddb39c03b09$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b1502ddb39c03b09$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b1502ddb39c03b09$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b1502ddb39c03b09$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b1502ddb39c03b09$var$Pf] = f;
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b1502ddb39c03b09$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b1502ddb39c03b09$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b1502ddb39c03b09$var$bd(b.containerInfo);
            } catch (t) {
                $b1502ddb39c03b09$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            break;
        case 13:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b1502ddb39c03b09$var$fk = $b1502ddb39c03b09$var$B()));
            d & 4 && $b1502ddb39c03b09$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b1502ddb39c03b09$var$U = (l = $b1502ddb39c03b09$var$U) || m, $b1502ddb39c03b09$var$ck(b, a), $b1502ddb39c03b09$var$U = l) : $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b1502ddb39c03b09$var$V = a, m = a.child; null !== m;){
                    for(q = $b1502ddb39c03b09$var$V = m; null !== $b1502ddb39c03b09$var$V;){
                        r = $b1502ddb39c03b09$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b1502ddb39c03b09$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b1502ddb39c03b09$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b1502ddb39c03b09$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b1502ddb39c03b09$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b1502ddb39c03b09$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b1502ddb39c03b09$var$V = y) : $b1502ddb39c03b09$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b1502ddb39c03b09$var$rb("display", g));
                            } catch (t) {
                                $b1502ddb39c03b09$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b1502ddb39c03b09$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b1502ddb39c03b09$var$ck(b, a);
            $b1502ddb39c03b09$var$ek(a);
            d & 4 && $b1502ddb39c03b09$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b1502ddb39c03b09$var$ck(b, a), $b1502ddb39c03b09$var$ek(a);
    }
}
function $b1502ddb39c03b09$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b1502ddb39c03b09$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b1502ddb39c03b09$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b1502ddb39c03b09$var$ob(e, ""), d.flags &= -33);
                    var f = $b1502ddb39c03b09$var$Uj(a);
                    $b1502ddb39c03b09$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b1502ddb39c03b09$var$Uj(a);
                    $b1502ddb39c03b09$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b1502ddb39c03b09$var$p(161));
            }
        } catch (k) {
            $b1502ddb39c03b09$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b1502ddb39c03b09$var$hk(a, b, c) {
    $b1502ddb39c03b09$var$V = a;
    $b1502ddb39c03b09$var$ik(a, b, c);
}
function $b1502ddb39c03b09$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b1502ddb39c03b09$var$V;){
        var e = $b1502ddb39c03b09$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b1502ddb39c03b09$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b1502ddb39c03b09$var$U;
                h = $b1502ddb39c03b09$var$Jj;
                var l = $b1502ddb39c03b09$var$U;
                $b1502ddb39c03b09$var$Jj = g;
                if (($b1502ddb39c03b09$var$U = k) && !l) for($b1502ddb39c03b09$var$V = e; null !== $b1502ddb39c03b09$var$V;)g = $b1502ddb39c03b09$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b1502ddb39c03b09$var$jk(e) : null !== k ? (k.return = g, $b1502ddb39c03b09$var$V = k) : $b1502ddb39c03b09$var$jk(e);
                for(; null !== f;)$b1502ddb39c03b09$var$V = f, $b1502ddb39c03b09$var$ik(f, b, c), f = f.sibling;
                $b1502ddb39c03b09$var$V = e;
                $b1502ddb39c03b09$var$Jj = h;
                $b1502ddb39c03b09$var$U = l;
            }
            $b1502ddb39c03b09$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b1502ddb39c03b09$var$V = f) : $b1502ddb39c03b09$var$kk(a, b, c);
    }
}
function $b1502ddb39c03b09$var$kk(a) {
    for(; null !== $b1502ddb39c03b09$var$V;){
        var b = $b1502ddb39c03b09$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b1502ddb39c03b09$var$U || $b1502ddb39c03b09$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b1502ddb39c03b09$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b1502ddb39c03b09$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b1502ddb39c03b09$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b1502ddb39c03b09$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b1502ddb39c03b09$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b1502ddb39c03b09$var$p(163));
                }
                $b1502ddb39c03b09$var$U || b.flags & 512 && $b1502ddb39c03b09$var$Rj(b);
            } catch (r) {
                $b1502ddb39c03b09$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b1502ddb39c03b09$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b1502ddb39c03b09$var$V = c;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
}
function $b1502ddb39c03b09$var$gk(a) {
    for(; null !== $b1502ddb39c03b09$var$V;){
        var b = $b1502ddb39c03b09$var$V;
        if (b === a) {
            $b1502ddb39c03b09$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b1502ddb39c03b09$var$V = c;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
}
function $b1502ddb39c03b09$var$jk(a) {
    for(; null !== $b1502ddb39c03b09$var$V;){
        var b = $b1502ddb39c03b09$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b1502ddb39c03b09$var$Qj(4, b);
                    } catch (k) {
                        $b1502ddb39c03b09$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b1502ddb39c03b09$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b1502ddb39c03b09$var$Rj(b);
                    } catch (k) {
                        $b1502ddb39c03b09$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b1502ddb39c03b09$var$Rj(b);
                    } catch (k) {
                        $b1502ddb39c03b09$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b1502ddb39c03b09$var$W(b, b.return, k);
        }
        if (b === a) {
            $b1502ddb39c03b09$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b1502ddb39c03b09$var$V = h;
            break;
        }
        $b1502ddb39c03b09$var$V = b.return;
    }
}
var $b1502ddb39c03b09$var$lk = Math.ceil, $b1502ddb39c03b09$var$mk = $b1502ddb39c03b09$var$ua.ReactCurrentDispatcher, $b1502ddb39c03b09$var$nk = $b1502ddb39c03b09$var$ua.ReactCurrentOwner, $b1502ddb39c03b09$var$ok = $b1502ddb39c03b09$var$ua.ReactCurrentBatchConfig, $b1502ddb39c03b09$var$K = 0, $b1502ddb39c03b09$var$Q = null, $b1502ddb39c03b09$var$Y = null, $b1502ddb39c03b09$var$Z = 0, $b1502ddb39c03b09$var$fj = 0, $b1502ddb39c03b09$var$ej = $b1502ddb39c03b09$var$Uf(0), $b1502ddb39c03b09$var$T = 0, $b1502ddb39c03b09$var$pk = null, $b1502ddb39c03b09$var$rh = 0, $b1502ddb39c03b09$var$qk = 0, $b1502ddb39c03b09$var$rk = 0, $b1502ddb39c03b09$var$sk = null, $b1502ddb39c03b09$var$tk = null, $b1502ddb39c03b09$var$fk = 0, $b1502ddb39c03b09$var$Gj = Infinity, $b1502ddb39c03b09$var$uk = null, $b1502ddb39c03b09$var$Oi = !1, $b1502ddb39c03b09$var$Pi = null, $b1502ddb39c03b09$var$Ri = null, $b1502ddb39c03b09$var$vk = !1, $b1502ddb39c03b09$var$wk = null, $b1502ddb39c03b09$var$xk = 0, $b1502ddb39c03b09$var$yk = 0, $b1502ddb39c03b09$var$zk = null, $b1502ddb39c03b09$var$Ak = -1, $b1502ddb39c03b09$var$Bk = 0;
function $b1502ddb39c03b09$var$R() {
    return 0 !== ($b1502ddb39c03b09$var$K & 6) ? $b1502ddb39c03b09$var$B() : -1 !== $b1502ddb39c03b09$var$Ak ? $b1502ddb39c03b09$var$Ak : $b1502ddb39c03b09$var$Ak = $b1502ddb39c03b09$var$B();
}
function $b1502ddb39c03b09$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b1502ddb39c03b09$var$K & 2) && 0 !== $b1502ddb39c03b09$var$Z) return $b1502ddb39c03b09$var$Z & -$b1502ddb39c03b09$var$Z;
    if (null !== $b1502ddb39c03b09$var$Kg.transition) return 0 === $b1502ddb39c03b09$var$Bk && ($b1502ddb39c03b09$var$Bk = $b1502ddb39c03b09$var$yc()), $b1502ddb39c03b09$var$Bk;
    a = $b1502ddb39c03b09$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b1502ddb39c03b09$var$jd(a.type);
    return a;
}
function $b1502ddb39c03b09$var$gi(a, b, c, d) {
    if (50 < $b1502ddb39c03b09$var$yk) throw $b1502ddb39c03b09$var$yk = 0, $b1502ddb39c03b09$var$zk = null, Error($b1502ddb39c03b09$var$p(185));
    $b1502ddb39c03b09$var$Ac(a, c, d);
    if (0 === ($b1502ddb39c03b09$var$K & 2) || a !== $b1502ddb39c03b09$var$Q) a === $b1502ddb39c03b09$var$Q && (0 === ($b1502ddb39c03b09$var$K & 2) && ($b1502ddb39c03b09$var$qk |= c), 4 === $b1502ddb39c03b09$var$T && $b1502ddb39c03b09$var$Ck(a, $b1502ddb39c03b09$var$Z)), $b1502ddb39c03b09$var$Dk(a, d), 1 === c && 0 === $b1502ddb39c03b09$var$K && 0 === (b.mode & 1) && ($b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$fg && $b1502ddb39c03b09$var$jg());
}
function $b1502ddb39c03b09$var$Dk(a, b) {
    var c = a.callbackNode;
    $b1502ddb39c03b09$var$wc(a, b);
    var d = $b1502ddb39c03b09$var$uc(a, a === $b1502ddb39c03b09$var$Q ? $b1502ddb39c03b09$var$Z : 0);
    if (0 === d) null !== c && $b1502ddb39c03b09$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b1502ddb39c03b09$var$bc(c);
        if (1 === b) 0 === a.tag ? $b1502ddb39c03b09$var$ig($b1502ddb39c03b09$var$Ek.bind(null, a)) : $b1502ddb39c03b09$var$hg($b1502ddb39c03b09$var$Ek.bind(null, a)), $b1502ddb39c03b09$var$Jf(function() {
            0 === ($b1502ddb39c03b09$var$K & 6) && $b1502ddb39c03b09$var$jg();
        }), c = null;
        else {
            switch($b1502ddb39c03b09$var$Dc(d)){
                case 1:
                    c = $b1502ddb39c03b09$var$fc;
                    break;
                case 4:
                    c = $b1502ddb39c03b09$var$gc;
                    break;
                case 16:
                    c = $b1502ddb39c03b09$var$hc;
                    break;
                case 536870912:
                    c = $b1502ddb39c03b09$var$jc;
                    break;
                default:
                    c = $b1502ddb39c03b09$var$hc;
            }
            c = $b1502ddb39c03b09$var$Fk(c, $b1502ddb39c03b09$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b1502ddb39c03b09$var$Gk(a, b) {
    $b1502ddb39c03b09$var$Ak = -1;
    $b1502ddb39c03b09$var$Bk = 0;
    if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(327));
    var c = a.callbackNode;
    if ($b1502ddb39c03b09$var$Hk() && a.callbackNode !== c) return null;
    var d = $b1502ddb39c03b09$var$uc(a, a === $b1502ddb39c03b09$var$Q ? $b1502ddb39c03b09$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b1502ddb39c03b09$var$Ik(a, d);
    else {
        b = d;
        var e = $b1502ddb39c03b09$var$K;
        $b1502ddb39c03b09$var$K |= 2;
        var f = $b1502ddb39c03b09$var$Jk();
        if ($b1502ddb39c03b09$var$Q !== a || $b1502ddb39c03b09$var$Z !== b) $b1502ddb39c03b09$var$uk = null, $b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$Kk(a, b);
        for(;;)try {
            $b1502ddb39c03b09$var$Lk();
            break;
        } catch (h) {
            $b1502ddb39c03b09$var$Mk(a, h);
        }
        $b1502ddb39c03b09$var$$g();
        $b1502ddb39c03b09$var$mk.current = f;
        $b1502ddb39c03b09$var$K = e;
        null !== $b1502ddb39c03b09$var$Y ? b = 0 : ($b1502ddb39c03b09$var$Q = null, $b1502ddb39c03b09$var$Z = 0, b = $b1502ddb39c03b09$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b1502ddb39c03b09$var$xc(a), 0 !== e && (d = e, b = $b1502ddb39c03b09$var$Nk(a, e)));
        if (1 === b) throw c = $b1502ddb39c03b09$var$pk, $b1502ddb39c03b09$var$Kk(a, 0), $b1502ddb39c03b09$var$Ck(a, d), $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), c;
        if (6 === b) $b1502ddb39c03b09$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b1502ddb39c03b09$var$Ok(e) && (b = $b1502ddb39c03b09$var$Ik(a, d), 2 === b && (f = $b1502ddb39c03b09$var$xc(a), 0 !== f && (d = f, b = $b1502ddb39c03b09$var$Nk(a, f))), 1 === b)) throw c = $b1502ddb39c03b09$var$pk, $b1502ddb39c03b09$var$Kk(a, 0), $b1502ddb39c03b09$var$Ck(a, d), $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b1502ddb39c03b09$var$p(345));
                case 2:
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                case 3:
                    $b1502ddb39c03b09$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b1502ddb39c03b09$var$fk + 500 - $b1502ddb39c03b09$var$B(), 10 < b)) {
                        if (0 !== $b1502ddb39c03b09$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b1502ddb39c03b09$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b1502ddb39c03b09$var$Ff($b1502ddb39c03b09$var$Pk.bind(null, a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk), b);
                        break;
                    }
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                case 4:
                    $b1502ddb39c03b09$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b1502ddb39c03b09$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b1502ddb39c03b09$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b1502ddb39c03b09$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b1502ddb39c03b09$var$Ff($b1502ddb39c03b09$var$Pk.bind(null, a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk), d);
                        break;
                    }
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                case 5:
                    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
                    break;
                default:
                    throw Error($b1502ddb39c03b09$var$p(329));
            }
        }
    }
    $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B());
    return a.callbackNode === c ? $b1502ddb39c03b09$var$Gk.bind(null, a) : null;
}
function $b1502ddb39c03b09$var$Nk(a, b) {
    var c = $b1502ddb39c03b09$var$sk;
    a.current.memoizedState.isDehydrated && ($b1502ddb39c03b09$var$Kk(a, b).flags |= 256);
    a = $b1502ddb39c03b09$var$Ik(a, b);
    2 !== a && (b = $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$tk = c, null !== b && $b1502ddb39c03b09$var$Fj(b));
    return a;
}
function $b1502ddb39c03b09$var$Fj(a) {
    null === $b1502ddb39c03b09$var$tk ? $b1502ddb39c03b09$var$tk = a : $b1502ddb39c03b09$var$tk.push.apply($b1502ddb39c03b09$var$tk, a);
}
function $b1502ddb39c03b09$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b1502ddb39c03b09$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b1502ddb39c03b09$var$Ck(a, b) {
    b &= ~$b1502ddb39c03b09$var$rk;
    b &= ~$b1502ddb39c03b09$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b1502ddb39c03b09$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b1502ddb39c03b09$var$Ek(a) {
    if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(327));
    $b1502ddb39c03b09$var$Hk();
    var b = $b1502ddb39c03b09$var$uc(a, 0);
    if (0 === (b & 1)) return $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), null;
    var c = $b1502ddb39c03b09$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b1502ddb39c03b09$var$xc(a);
        0 !== d && (b = d, c = $b1502ddb39c03b09$var$Nk(a, d));
    }
    if (1 === c) throw c = $b1502ddb39c03b09$var$pk, $b1502ddb39c03b09$var$Kk(a, 0), $b1502ddb39c03b09$var$Ck(a, b), $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B()), c;
    if (6 === c) throw Error($b1502ddb39c03b09$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b1502ddb39c03b09$var$Pk(a, $b1502ddb39c03b09$var$tk, $b1502ddb39c03b09$var$uk);
    $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B());
    return null;
}
function $b1502ddb39c03b09$var$Qk(a, b) {
    var c = $b1502ddb39c03b09$var$K;
    $b1502ddb39c03b09$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b1502ddb39c03b09$var$K = c, 0 === $b1502ddb39c03b09$var$K && ($b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$fg && $b1502ddb39c03b09$var$jg());
    }
}
function $b1502ddb39c03b09$var$Rk(a) {
    null !== $b1502ddb39c03b09$var$wk && 0 === $b1502ddb39c03b09$var$wk.tag && 0 === ($b1502ddb39c03b09$var$K & 6) && $b1502ddb39c03b09$var$Hk();
    var b = $b1502ddb39c03b09$var$K;
    $b1502ddb39c03b09$var$K |= 1;
    var c = $b1502ddb39c03b09$var$ok.transition, d = $b1502ddb39c03b09$var$C;
    try {
        if ($b1502ddb39c03b09$var$ok.transition = null, $b1502ddb39c03b09$var$C = 1, a) return a();
    } finally{
        $b1502ddb39c03b09$var$C = d, $b1502ddb39c03b09$var$ok.transition = c, $b1502ddb39c03b09$var$K = b, 0 === ($b1502ddb39c03b09$var$K & 6) && $b1502ddb39c03b09$var$jg();
    }
}
function $b1502ddb39c03b09$var$Hj() {
    $b1502ddb39c03b09$var$fj = $b1502ddb39c03b09$var$ej.current;
    $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$ej);
}
function $b1502ddb39c03b09$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b1502ddb39c03b09$var$Gf(c));
    if (null !== $b1502ddb39c03b09$var$Y) for(c = $b1502ddb39c03b09$var$Y.return; null !== c;){
        var d = c;
        $b1502ddb39c03b09$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b1502ddb39c03b09$var$$f();
                break;
            case 3:
                $b1502ddb39c03b09$var$zh();
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$Wf);
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$H);
                $b1502ddb39c03b09$var$Eh();
                break;
            case 5:
                $b1502ddb39c03b09$var$Bh(d);
                break;
            case 4:
                $b1502ddb39c03b09$var$zh();
                break;
            case 13:
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
                break;
            case 19:
                $b1502ddb39c03b09$var$E($b1502ddb39c03b09$var$L);
                break;
            case 10:
                $b1502ddb39c03b09$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b1502ddb39c03b09$var$Hj();
        }
        c = c.return;
    }
    $b1502ddb39c03b09$var$Q = a;
    $b1502ddb39c03b09$var$Y = a = $b1502ddb39c03b09$var$Pg(a.current, null);
    $b1502ddb39c03b09$var$Z = $b1502ddb39c03b09$var$fj = b;
    $b1502ddb39c03b09$var$T = 0;
    $b1502ddb39c03b09$var$pk = null;
    $b1502ddb39c03b09$var$rk = $b1502ddb39c03b09$var$qk = $b1502ddb39c03b09$var$rh = 0;
    $b1502ddb39c03b09$var$tk = $b1502ddb39c03b09$var$sk = null;
    if (null !== $b1502ddb39c03b09$var$fh) {
        for(b = 0; b < $b1502ddb39c03b09$var$fh.length; b++)if (c = $b1502ddb39c03b09$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b1502ddb39c03b09$var$fh = null;
    }
    return a;
}
function $b1502ddb39c03b09$var$Mk(a, b) {
    do {
        var c = $b1502ddb39c03b09$var$Y;
        try {
            $b1502ddb39c03b09$var$$g();
            $b1502ddb39c03b09$var$Fh.current = $b1502ddb39c03b09$var$Rh;
            if ($b1502ddb39c03b09$var$Ih) {
                for(var d = $b1502ddb39c03b09$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b1502ddb39c03b09$var$Ih = !1;
            }
            $b1502ddb39c03b09$var$Hh = 0;
            $b1502ddb39c03b09$var$O = $b1502ddb39c03b09$var$N = $b1502ddb39c03b09$var$M = null;
            $b1502ddb39c03b09$var$Jh = !1;
            $b1502ddb39c03b09$var$Kh = 0;
            $b1502ddb39c03b09$var$nk.current = null;
            if (null === c || null === c.return) {
                $b1502ddb39c03b09$var$T = 1;
                $b1502ddb39c03b09$var$pk = b;
                $b1502ddb39c03b09$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b1502ddb39c03b09$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b1502ddb39c03b09$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b1502ddb39c03b09$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b1502ddb39c03b09$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b1502ddb39c03b09$var$Si(f, l, b);
                            $b1502ddb39c03b09$var$tj();
                            break a;
                        }
                        k = Error($b1502ddb39c03b09$var$p(426));
                    }
                } else if ($b1502ddb39c03b09$var$I && h.mode & 1) {
                    var J = $b1502ddb39c03b09$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b1502ddb39c03b09$var$Vi(J, g, h, f, b);
                        $b1502ddb39c03b09$var$Jg($b1502ddb39c03b09$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b1502ddb39c03b09$var$Ji(k, h);
                4 !== $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$T = 2);
                null === $b1502ddb39c03b09$var$sk ? $b1502ddb39c03b09$var$sk = [
                    f
                ] : $b1502ddb39c03b09$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b1502ddb39c03b09$var$Ni(f, k, b);
                            $b1502ddb39c03b09$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b1502ddb39c03b09$var$Ri || !$b1502ddb39c03b09$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b1502ddb39c03b09$var$Qi(f, h, b);
                                $b1502ddb39c03b09$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b1502ddb39c03b09$var$Sk(c);
        } catch (na) {
            b = na;
            $b1502ddb39c03b09$var$Y === c && null !== c && ($b1502ddb39c03b09$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b1502ddb39c03b09$var$Jk() {
    var a = $b1502ddb39c03b09$var$mk.current;
    $b1502ddb39c03b09$var$mk.current = $b1502ddb39c03b09$var$Rh;
    return null === a ? $b1502ddb39c03b09$var$Rh : a;
}
function $b1502ddb39c03b09$var$tj() {
    if (0 === $b1502ddb39c03b09$var$T || 3 === $b1502ddb39c03b09$var$T || 2 === $b1502ddb39c03b09$var$T) $b1502ddb39c03b09$var$T = 4;
    null === $b1502ddb39c03b09$var$Q || 0 === ($b1502ddb39c03b09$var$rh & 268435455) && 0 === ($b1502ddb39c03b09$var$qk & 268435455) || $b1502ddb39c03b09$var$Ck($b1502ddb39c03b09$var$Q, $b1502ddb39c03b09$var$Z);
}
function $b1502ddb39c03b09$var$Ik(a, b) {
    var c = $b1502ddb39c03b09$var$K;
    $b1502ddb39c03b09$var$K |= 2;
    var d = $b1502ddb39c03b09$var$Jk();
    if ($b1502ddb39c03b09$var$Q !== a || $b1502ddb39c03b09$var$Z !== b) $b1502ddb39c03b09$var$uk = null, $b1502ddb39c03b09$var$Kk(a, b);
    for(;;)try {
        $b1502ddb39c03b09$var$Tk();
        break;
    } catch (e) {
        $b1502ddb39c03b09$var$Mk(a, e);
    }
    $b1502ddb39c03b09$var$$g();
    $b1502ddb39c03b09$var$K = c;
    $b1502ddb39c03b09$var$mk.current = d;
    if (null !== $b1502ddb39c03b09$var$Y) throw Error($b1502ddb39c03b09$var$p(261));
    $b1502ddb39c03b09$var$Q = null;
    $b1502ddb39c03b09$var$Z = 0;
    return $b1502ddb39c03b09$var$T;
}
function $b1502ddb39c03b09$var$Tk() {
    for(; null !== $b1502ddb39c03b09$var$Y;)$b1502ddb39c03b09$var$Uk($b1502ddb39c03b09$var$Y);
}
function $b1502ddb39c03b09$var$Lk() {
    for(; null !== $b1502ddb39c03b09$var$Y && !$b1502ddb39c03b09$var$cc();)$b1502ddb39c03b09$var$Uk($b1502ddb39c03b09$var$Y);
}
function $b1502ddb39c03b09$var$Uk(a) {
    var b = $b1502ddb39c03b09$var$Vk(a.alternate, a, $b1502ddb39c03b09$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b1502ddb39c03b09$var$Sk(a) : $b1502ddb39c03b09$var$Y = b;
    $b1502ddb39c03b09$var$nk.current = null;
}
function $b1502ddb39c03b09$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b1502ddb39c03b09$var$Ej(c, b, $b1502ddb39c03b09$var$fj), null !== c) {
                $b1502ddb39c03b09$var$Y = c;
                return;
            }
        } else {
            c = $b1502ddb39c03b09$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b1502ddb39c03b09$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b1502ddb39c03b09$var$T = 6;
                $b1502ddb39c03b09$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b1502ddb39c03b09$var$Y = b;
            return;
        }
        $b1502ddb39c03b09$var$Y = b = a;
    }while (null !== b);
    0 === $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$T = 5);
}
function $b1502ddb39c03b09$var$Pk(a, b, c) {
    var d = $b1502ddb39c03b09$var$C, e = $b1502ddb39c03b09$var$ok.transition;
    try {
        $b1502ddb39c03b09$var$ok.transition = null, $b1502ddb39c03b09$var$C = 1, $b1502ddb39c03b09$var$Wk(a, b, c, d);
    } finally{
        $b1502ddb39c03b09$var$ok.transition = e, $b1502ddb39c03b09$var$C = d;
    }
    return null;
}
function $b1502ddb39c03b09$var$Wk(a, b, c, d) {
    do $b1502ddb39c03b09$var$Hk();
    while (null !== $b1502ddb39c03b09$var$wk);
    if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b1502ddb39c03b09$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b1502ddb39c03b09$var$Bc(a, f);
    a === $b1502ddb39c03b09$var$Q && ($b1502ddb39c03b09$var$Y = $b1502ddb39c03b09$var$Q = null, $b1502ddb39c03b09$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b1502ddb39c03b09$var$vk || ($b1502ddb39c03b09$var$vk = !0, $b1502ddb39c03b09$var$Fk($b1502ddb39c03b09$var$hc, function() {
        $b1502ddb39c03b09$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b1502ddb39c03b09$var$ok.transition;
        $b1502ddb39c03b09$var$ok.transition = null;
        var g = $b1502ddb39c03b09$var$C;
        $b1502ddb39c03b09$var$C = 1;
        var h = $b1502ddb39c03b09$var$K;
        $b1502ddb39c03b09$var$K |= 4;
        $b1502ddb39c03b09$var$nk.current = null;
        $b1502ddb39c03b09$var$Oj(a, c);
        $b1502ddb39c03b09$var$dk(c, a);
        $b1502ddb39c03b09$var$Oe($b1502ddb39c03b09$var$Df);
        $b1502ddb39c03b09$var$dd = !!$b1502ddb39c03b09$var$Cf;
        $b1502ddb39c03b09$var$Df = $b1502ddb39c03b09$var$Cf = null;
        a.current = c;
        $b1502ddb39c03b09$var$hk(c, a, e);
        $b1502ddb39c03b09$var$dc();
        $b1502ddb39c03b09$var$K = h;
        $b1502ddb39c03b09$var$C = g;
        $b1502ddb39c03b09$var$ok.transition = f;
    } else a.current = c;
    $b1502ddb39c03b09$var$vk && ($b1502ddb39c03b09$var$vk = !1, $b1502ddb39c03b09$var$wk = a, $b1502ddb39c03b09$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b1502ddb39c03b09$var$Ri = null);
    $b1502ddb39c03b09$var$mc(c.stateNode, d);
    $b1502ddb39c03b09$var$Dk(a, $b1502ddb39c03b09$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b1502ddb39c03b09$var$Oi) throw $b1502ddb39c03b09$var$Oi = !1, a = $b1502ddb39c03b09$var$Pi, $b1502ddb39c03b09$var$Pi = null, a;
    0 !== ($b1502ddb39c03b09$var$xk & 1) && 0 !== a.tag && $b1502ddb39c03b09$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b1502ddb39c03b09$var$zk ? $b1502ddb39c03b09$var$yk++ : ($b1502ddb39c03b09$var$yk = 0, $b1502ddb39c03b09$var$zk = a) : $b1502ddb39c03b09$var$yk = 0;
    $b1502ddb39c03b09$var$jg();
    return null;
}
function $b1502ddb39c03b09$var$Hk() {
    if (null !== $b1502ddb39c03b09$var$wk) {
        var a = $b1502ddb39c03b09$var$Dc($b1502ddb39c03b09$var$xk), b = $b1502ddb39c03b09$var$ok.transition, c = $b1502ddb39c03b09$var$C;
        try {
            $b1502ddb39c03b09$var$ok.transition = null;
            $b1502ddb39c03b09$var$C = 16 > a ? 16 : a;
            if (null === $b1502ddb39c03b09$var$wk) var d = !1;
            else {
                a = $b1502ddb39c03b09$var$wk;
                $b1502ddb39c03b09$var$wk = null;
                $b1502ddb39c03b09$var$xk = 0;
                if (0 !== ($b1502ddb39c03b09$var$K & 6)) throw Error($b1502ddb39c03b09$var$p(331));
                var e = $b1502ddb39c03b09$var$K;
                $b1502ddb39c03b09$var$K |= 4;
                for($b1502ddb39c03b09$var$V = a.current; null !== $b1502ddb39c03b09$var$V;){
                    var f = $b1502ddb39c03b09$var$V, g = f.child;
                    if (0 !== ($b1502ddb39c03b09$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b1502ddb39c03b09$var$V = l; null !== $b1502ddb39c03b09$var$V;){
                                    var m = $b1502ddb39c03b09$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b1502ddb39c03b09$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b1502ddb39c03b09$var$V = q;
                                    else for(; null !== $b1502ddb39c03b09$var$V;){
                                        m = $b1502ddb39c03b09$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b1502ddb39c03b09$var$Sj(m);
                                        if (m === l) {
                                            $b1502ddb39c03b09$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b1502ddb39c03b09$var$V = r;
                                            break;
                                        }
                                        $b1502ddb39c03b09$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b1502ddb39c03b09$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b1502ddb39c03b09$var$V = g;
                    else b: for(; null !== $b1502ddb39c03b09$var$V;){
                        f = $b1502ddb39c03b09$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b1502ddb39c03b09$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b1502ddb39c03b09$var$V = x;
                            break b;
                        }
                        $b1502ddb39c03b09$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b1502ddb39c03b09$var$V = w; null !== $b1502ddb39c03b09$var$V;){
                    g = $b1502ddb39c03b09$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b1502ddb39c03b09$var$V = u;
                    else b: for(g = w; null !== $b1502ddb39c03b09$var$V;){
                        h = $b1502ddb39c03b09$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b1502ddb39c03b09$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b1502ddb39c03b09$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b1502ddb39c03b09$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b1502ddb39c03b09$var$V = F;
                            break b;
                        }
                        $b1502ddb39c03b09$var$V = h.return;
                    }
                }
                $b1502ddb39c03b09$var$K = e;
                $b1502ddb39c03b09$var$jg();
                if ($b1502ddb39c03b09$var$lc && "function" === typeof $b1502ddb39c03b09$var$lc.onPostCommitFiberRoot) try {
                    $b1502ddb39c03b09$var$lc.onPostCommitFiberRoot($b1502ddb39c03b09$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b1502ddb39c03b09$var$C = c, $b1502ddb39c03b09$var$ok.transition = b;
        }
    }
    return !1;
}
function $b1502ddb39c03b09$var$Xk(a, b, c) {
    b = $b1502ddb39c03b09$var$Ji(c, b);
    b = $b1502ddb39c03b09$var$Ni(a, b, 1);
    a = $b1502ddb39c03b09$var$nh(a, b, 1);
    b = $b1502ddb39c03b09$var$R();
    null !== a && ($b1502ddb39c03b09$var$Ac(a, 1, b), $b1502ddb39c03b09$var$Dk(a, b));
}
function $b1502ddb39c03b09$var$W(a, b, c) {
    if (3 === a.tag) $b1502ddb39c03b09$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b1502ddb39c03b09$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b1502ddb39c03b09$var$Ri || !$b1502ddb39c03b09$var$Ri.has(d))) {
                a = $b1502ddb39c03b09$var$Ji(c, a);
                a = $b1502ddb39c03b09$var$Qi(b, a, 1);
                b = $b1502ddb39c03b09$var$nh(b, a, 1);
                a = $b1502ddb39c03b09$var$R();
                null !== b && ($b1502ddb39c03b09$var$Ac(b, 1, a), $b1502ddb39c03b09$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b1502ddb39c03b09$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b1502ddb39c03b09$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b1502ddb39c03b09$var$Q === a && ($b1502ddb39c03b09$var$Z & c) === c && (4 === $b1502ddb39c03b09$var$T || 3 === $b1502ddb39c03b09$var$T && ($b1502ddb39c03b09$var$Z & 130023424) === $b1502ddb39c03b09$var$Z && 500 > $b1502ddb39c03b09$var$B() - $b1502ddb39c03b09$var$fk ? $b1502ddb39c03b09$var$Kk(a, 0) : $b1502ddb39c03b09$var$rk |= c);
    $b1502ddb39c03b09$var$Dk(a, b);
}
function $b1502ddb39c03b09$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b1502ddb39c03b09$var$sc, $b1502ddb39c03b09$var$sc <<= 1, 0 === ($b1502ddb39c03b09$var$sc & 130023424) && ($b1502ddb39c03b09$var$sc = 4194304)));
    var c = $b1502ddb39c03b09$var$R();
    a = $b1502ddb39c03b09$var$ih(a, b);
    null !== a && ($b1502ddb39c03b09$var$Ac(a, b, c), $b1502ddb39c03b09$var$Dk(a, c));
}
function $b1502ddb39c03b09$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b1502ddb39c03b09$var$Yk(a, c);
}
function $b1502ddb39c03b09$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b1502ddb39c03b09$var$p(314));
    }
    null !== d && d.delete(b);
    $b1502ddb39c03b09$var$Yk(a, c);
}
var $b1502ddb39c03b09$var$Vk;
$b1502ddb39c03b09$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b1502ddb39c03b09$var$Wf.current) $b1502ddb39c03b09$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b1502ddb39c03b09$var$dh = !1, $b1502ddb39c03b09$var$yj(a, b, c);
            $b1502ddb39c03b09$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b1502ddb39c03b09$var$dh = !1, $b1502ddb39c03b09$var$I && 0 !== (b.flags & 1048576) && $b1502ddb39c03b09$var$ug(b, $b1502ddb39c03b09$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b1502ddb39c03b09$var$ij(a, b);
            a = b.pendingProps;
            var e = $b1502ddb39c03b09$var$Yf(b, $b1502ddb39c03b09$var$H.current);
            $b1502ddb39c03b09$var$ch(b, c);
            e = $b1502ddb39c03b09$var$Nh(null, b, d, a, e, c);
            var f = $b1502ddb39c03b09$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b1502ddb39c03b09$var$Zf(d) ? (f = !0, $b1502ddb39c03b09$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b1502ddb39c03b09$var$kh(b), e.updater = $b1502ddb39c03b09$var$Ei, b.stateNode = e, e._reactInternals = b, $b1502ddb39c03b09$var$Ii(b, d, a, c), b = $b1502ddb39c03b09$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b1502ddb39c03b09$var$I && f && $b1502ddb39c03b09$var$vg(b), $b1502ddb39c03b09$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b1502ddb39c03b09$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b1502ddb39c03b09$var$Zk(d);
                a = $b1502ddb39c03b09$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b1502ddb39c03b09$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b1502ddb39c03b09$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b1502ddb39c03b09$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b1502ddb39c03b09$var$$i(null, b, d, $b1502ddb39c03b09$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b1502ddb39c03b09$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b1502ddb39c03b09$var$kj(b);
                if (null === a) throw Error($b1502ddb39c03b09$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b1502ddb39c03b09$var$lh(a, b);
                $b1502ddb39c03b09$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b1502ddb39c03b09$var$Ji(Error($b1502ddb39c03b09$var$p(423)), b);
                        b = $b1502ddb39c03b09$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b1502ddb39c03b09$var$Ji(Error($b1502ddb39c03b09$var$p(424)), b);
                        b = $b1502ddb39c03b09$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b1502ddb39c03b09$var$yg = $b1502ddb39c03b09$var$Lf(b.stateNode.containerInfo.firstChild), $b1502ddb39c03b09$var$xg = b, $b1502ddb39c03b09$var$I = !0, $b1502ddb39c03b09$var$zg = null, c = $b1502ddb39c03b09$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b1502ddb39c03b09$var$Ig();
                    if (d === e) {
                        b = $b1502ddb39c03b09$var$Zi(a, b, c);
                        break a;
                    }
                    $b1502ddb39c03b09$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b1502ddb39c03b09$var$Ah(b), null === a && $b1502ddb39c03b09$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b1502ddb39c03b09$var$Ef(d, e) ? g = null : null !== f && $b1502ddb39c03b09$var$Ef(d, f) && (b.flags |= 32), $b1502ddb39c03b09$var$gj(a, b), $b1502ddb39c03b09$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b1502ddb39c03b09$var$Eg(b), null;
        case 13:
            return $b1502ddb39c03b09$var$oj(a, b, c);
        case 4:
            return $b1502ddb39c03b09$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b1502ddb39c03b09$var$Ug(b, null, d, c) : $b1502ddb39c03b09$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$Yi(a, b, d, e, c);
        case 7:
            return $b1502ddb39c03b09$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b1502ddb39c03b09$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b1502ddb39c03b09$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b1502ddb39c03b09$var$G($b1502ddb39c03b09$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b1502ddb39c03b09$var$He(f.value, g)) {
                        if (f.children === e.children && !$b1502ddb39c03b09$var$Wf.current) {
                            b = $b1502ddb39c03b09$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b1502ddb39c03b09$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b1502ddb39c03b09$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b1502ddb39c03b09$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b1502ddb39c03b09$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b1502ddb39c03b09$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b1502ddb39c03b09$var$ch(b, c), e = $b1502ddb39c03b09$var$eh(e), d = d(e), b.flags |= 1, $b1502ddb39c03b09$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b1502ddb39c03b09$var$Ci(d, b.pendingProps), e = $b1502ddb39c03b09$var$Ci(d.type, e), $b1502ddb39c03b09$var$$i(a, b, d, e, c);
        case 15:
            return $b1502ddb39c03b09$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b1502ddb39c03b09$var$Ci(d, e), $b1502ddb39c03b09$var$ij(a, b), b.tag = 1, $b1502ddb39c03b09$var$Zf(d) ? (a = !0, $b1502ddb39c03b09$var$cg(b)) : a = !1, $b1502ddb39c03b09$var$ch(b, c), $b1502ddb39c03b09$var$Gi(b, d, e), $b1502ddb39c03b09$var$Ii(b, d, e, c), $b1502ddb39c03b09$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b1502ddb39c03b09$var$xj(a, b, c);
        case 22:
            return $b1502ddb39c03b09$var$dj(a, b, c);
    }
    throw Error($b1502ddb39c03b09$var$p(156, b.tag));
};
function $b1502ddb39c03b09$var$Fk(a, b) {
    return $b1502ddb39c03b09$var$ac(a, b);
}
function $b1502ddb39c03b09$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b1502ddb39c03b09$var$Bg(a, b, c, d) {
    return new $b1502ddb39c03b09$var$$k(a, b, c, d);
}
function $b1502ddb39c03b09$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b1502ddb39c03b09$var$Zk(a) {
    if ("function" === typeof a) return $b1502ddb39c03b09$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b1502ddb39c03b09$var$Da) return 11;
        if (a === $b1502ddb39c03b09$var$Ga) return 14;
    }
    return 2;
}
function $b1502ddb39c03b09$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b1502ddb39c03b09$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b1502ddb39c03b09$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b1502ddb39c03b09$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b1502ddb39c03b09$var$ya:
            return $b1502ddb39c03b09$var$Tg(c.children, e, f, b);
        case $b1502ddb39c03b09$var$za:
            g = 8;
            e |= 8;
            break;
        case $b1502ddb39c03b09$var$Aa:
            return a = $b1502ddb39c03b09$var$Bg(12, c, b, e | 2), a.elementType = $b1502ddb39c03b09$var$Aa, a.lanes = f, a;
        case $b1502ddb39c03b09$var$Ea:
            return a = $b1502ddb39c03b09$var$Bg(13, c, b, e), a.elementType = $b1502ddb39c03b09$var$Ea, a.lanes = f, a;
        case $b1502ddb39c03b09$var$Fa:
            return a = $b1502ddb39c03b09$var$Bg(19, c, b, e), a.elementType = $b1502ddb39c03b09$var$Fa, a.lanes = f, a;
        case $b1502ddb39c03b09$var$Ia:
            return $b1502ddb39c03b09$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b1502ddb39c03b09$var$Ba:
                    g = 10;
                    break a;
                case $b1502ddb39c03b09$var$Ca:
                    g = 9;
                    break a;
                case $b1502ddb39c03b09$var$Da:
                    g = 11;
                    break a;
                case $b1502ddb39c03b09$var$Ga:
                    g = 14;
                    break a;
                case $b1502ddb39c03b09$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b1502ddb39c03b09$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $g83i1._)(a), ""));
    }
    b = $b1502ddb39c03b09$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b1502ddb39c03b09$var$Tg(a, b, c, d) {
    a = $b1502ddb39c03b09$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b1502ddb39c03b09$var$pj(a, b, c, d) {
    a = $b1502ddb39c03b09$var$Bg(22, a, d, b);
    a.elementType = $b1502ddb39c03b09$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b1502ddb39c03b09$var$Qg(a, b, c) {
    a = $b1502ddb39c03b09$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b1502ddb39c03b09$var$Sg(a, b, c) {
    b = $b1502ddb39c03b09$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b1502ddb39c03b09$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b1502ddb39c03b09$var$zc(0);
    this.expirationTimes = $b1502ddb39c03b09$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b1502ddb39c03b09$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b1502ddb39c03b09$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b1502ddb39c03b09$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b1502ddb39c03b09$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b1502ddb39c03b09$var$kh(f);
    return a;
}
function $b1502ddb39c03b09$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b1502ddb39c03b09$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b1502ddb39c03b09$var$dl(a) {
    if (!a) return $b1502ddb39c03b09$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b1502ddb39c03b09$var$Vb(a) !== a || 1 !== a.tag) throw Error($b1502ddb39c03b09$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b1502ddb39c03b09$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b1502ddb39c03b09$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b1502ddb39c03b09$var$Zf(c)) return $b1502ddb39c03b09$var$bg(a, c, b);
    }
    return b;
}
function $b1502ddb39c03b09$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b1502ddb39c03b09$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b1502ddb39c03b09$var$dl(null);
    c = a.current;
    d = $b1502ddb39c03b09$var$R();
    e = $b1502ddb39c03b09$var$yi(c);
    f = $b1502ddb39c03b09$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b1502ddb39c03b09$var$nh(c, f, e);
    a.current.lanes = e;
    $b1502ddb39c03b09$var$Ac(a, e, d);
    $b1502ddb39c03b09$var$Dk(a, d);
    return a;
}
function $b1502ddb39c03b09$var$fl(a, b, c, d) {
    var e = b.current, f = $b1502ddb39c03b09$var$R(), g = $b1502ddb39c03b09$var$yi(e);
    c = $b1502ddb39c03b09$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b1502ddb39c03b09$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b1502ddb39c03b09$var$nh(e, b, g);
    null !== a && ($b1502ddb39c03b09$var$gi(a, e, g, f), $b1502ddb39c03b09$var$oh(a, e, g));
    return g;
}
function $b1502ddb39c03b09$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b1502ddb39c03b09$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b1502ddb39c03b09$var$il(a, b) {
    $b1502ddb39c03b09$var$hl(a, b);
    (a = a.alternate) && $b1502ddb39c03b09$var$hl(a, b);
}
function $b1502ddb39c03b09$var$jl() {
    return null;
}
var $b1502ddb39c03b09$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $b1502ddb39c03b09$var$ll(a) {
    this._internalRoot = a;
}
$b1502ddb39c03b09$var$ml.prototype.render = $b1502ddb39c03b09$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b1502ddb39c03b09$var$p(409));
    $b1502ddb39c03b09$var$fl(a, b, null, null);
};
$b1502ddb39c03b09$var$ml.prototype.unmount = $b1502ddb39c03b09$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b1502ddb39c03b09$var$Rk(function() {
            $b1502ddb39c03b09$var$fl(null, a, null, null);
        });
        b[$b1502ddb39c03b09$var$uf] = null;
    }
};
function $b1502ddb39c03b09$var$ml(a) {
    this._internalRoot = a;
}
$b1502ddb39c03b09$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b1502ddb39c03b09$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b1502ddb39c03b09$var$Qc.length && 0 !== b && b < $b1502ddb39c03b09$var$Qc[c].priority; c++);
        $b1502ddb39c03b09$var$Qc.splice(c, 0, a);
        0 === c && $b1502ddb39c03b09$var$Vc(a);
    }
};
function $b1502ddb39c03b09$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b1502ddb39c03b09$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b1502ddb39c03b09$var$pl() {}
function $b1502ddb39c03b09$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $b1502ddb39c03b09$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $b1502ddb39c03b09$var$el(b, d, a, 0, null, !1, !1, "", $b1502ddb39c03b09$var$pl);
        a._reactRootContainer = g;
        a[$b1502ddb39c03b09$var$uf] = g.current;
        $b1502ddb39c03b09$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b1502ddb39c03b09$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $b1502ddb39c03b09$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $b1502ddb39c03b09$var$bl(a, 0, !1, null, null, !1, !1, "", $b1502ddb39c03b09$var$pl);
    a._reactRootContainer = k;
    a[$b1502ddb39c03b09$var$uf] = k.current;
    $b1502ddb39c03b09$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b1502ddb39c03b09$var$Rk(function() {
        $b1502ddb39c03b09$var$fl(b, k, c, d);
    });
    return k;
}
function $b1502ddb39c03b09$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $b1502ddb39c03b09$var$gl(g);
                h.call(_$a);
            };
        }
        $b1502ddb39c03b09$var$fl(b, g, a, e);
    } else g = $b1502ddb39c03b09$var$ql(c, b, a, e, d);
    return $b1502ddb39c03b09$var$gl(g);
}
$b1502ddb39c03b09$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b1502ddb39c03b09$var$tc(b.pendingLanes);
                0 !== c && ($b1502ddb39c03b09$var$Cc(b, c | 1), $b1502ddb39c03b09$var$Dk(b, $b1502ddb39c03b09$var$B()), 0 === ($b1502ddb39c03b09$var$K & 6) && ($b1502ddb39c03b09$var$Gj = $b1502ddb39c03b09$var$B() + 500, $b1502ddb39c03b09$var$jg()));
            }
            break;
        case 13:
            $b1502ddb39c03b09$var$Rk(function() {
                var b = $b1502ddb39c03b09$var$ih(a, 1);
                if (null !== b) {
                    var c = $b1502ddb39c03b09$var$R();
                    $b1502ddb39c03b09$var$gi(b, a, 1, c);
                }
            }), $b1502ddb39c03b09$var$il(a, 1);
    }
};
$b1502ddb39c03b09$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $b1502ddb39c03b09$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b1502ddb39c03b09$var$R();
            $b1502ddb39c03b09$var$gi(b, a, 134217728, c);
        }
        $b1502ddb39c03b09$var$il(a, 134217728);
    }
};
$b1502ddb39c03b09$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $b1502ddb39c03b09$var$yi(a), c = $b1502ddb39c03b09$var$ih(a, b);
        if (null !== c) {
            var d = $b1502ddb39c03b09$var$R();
            $b1502ddb39c03b09$var$gi(c, a, b, d);
        }
        $b1502ddb39c03b09$var$il(a, b);
    }
};
$b1502ddb39c03b09$var$Hc = function Hc() {
    return $b1502ddb39c03b09$var$C;
};
$b1502ddb39c03b09$var$Ic = function Ic(a, b) {
    var c = $b1502ddb39c03b09$var$C;
    try {
        return $b1502ddb39c03b09$var$C = a, b();
    } finally{
        $b1502ddb39c03b09$var$C = c;
    }
};
$b1502ddb39c03b09$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $b1502ddb39c03b09$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b1502ddb39c03b09$var$Db(d);
                        if (!e) throw Error($b1502ddb39c03b09$var$p(90));
                        $b1502ddb39c03b09$var$Wa(d);
                        $b1502ddb39c03b09$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b1502ddb39c03b09$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b1502ddb39c03b09$var$fb(a, !!c.multiple, b, !1);
    }
};
$b1502ddb39c03b09$var$Gb = $b1502ddb39c03b09$var$Qk;
$b1502ddb39c03b09$var$Hb = $b1502ddb39c03b09$var$Rk;
var $b1502ddb39c03b09$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b1502ddb39c03b09$var$Cb,
        $b1502ddb39c03b09$var$ue,
        $b1502ddb39c03b09$var$Db,
        $b1502ddb39c03b09$var$Eb,
        $b1502ddb39c03b09$var$Fb,
        $b1502ddb39c03b09$var$Qk
    ]
}, $b1502ddb39c03b09$var$tl = {
    findFiberByHostInstance: $b1502ddb39c03b09$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b1502ddb39c03b09$var$ul = {
    bundleType: $b1502ddb39c03b09$var$tl.bundleType,
    version: $b1502ddb39c03b09$var$tl.version,
    rendererPackageName: $b1502ddb39c03b09$var$tl.rendererPackageName,
    rendererConfig: $b1502ddb39c03b09$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b1502ddb39c03b09$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $b1502ddb39c03b09$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b1502ddb39c03b09$var$tl.findFiberByHostInstance || $b1502ddb39c03b09$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b1502ddb39c03b09$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b1502ddb39c03b09$var$vl.isDisabled && $b1502ddb39c03b09$var$vl.supportsFiber) try {
        $b1502ddb39c03b09$var$kc = $b1502ddb39c03b09$var$vl.inject($b1502ddb39c03b09$var$ul), $b1502ddb39c03b09$var$lc = $b1502ddb39c03b09$var$vl;
    } catch (a) {}
}
$b1502ddb39c03b09$export$ae55be85d98224ed = $b1502ddb39c03b09$var$sl;
$b1502ddb39c03b09$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b1502ddb39c03b09$var$nl(b)) throw Error($b1502ddb39c03b09$var$p(200));
    return $b1502ddb39c03b09$var$cl(a, b, null, c);
};
$b1502ddb39c03b09$export$882461b6382ed46c = function(a, b) {
    if (!$b1502ddb39c03b09$var$nl(a)) throw Error($b1502ddb39c03b09$var$p(299));
    var c = !1, d = "", e = $b1502ddb39c03b09$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b1502ddb39c03b09$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b1502ddb39c03b09$var$uf] = b.current;
    $b1502ddb39c03b09$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b1502ddb39c03b09$var$ll(b);
};
$b1502ddb39c03b09$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b1502ddb39c03b09$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b1502ddb39c03b09$var$p(268, a));
    }
    a = $b1502ddb39c03b09$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b1502ddb39c03b09$export$cd75ccfd720a3cd4 = function(a) {
    return $b1502ddb39c03b09$var$Rk(a);
};
$b1502ddb39c03b09$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b1502ddb39c03b09$var$ol(b)) throw Error($b1502ddb39c03b09$var$p(200));
    return $b1502ddb39c03b09$var$rl(null, a, b, !0, c);
};
$b1502ddb39c03b09$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b1502ddb39c03b09$var$nl(a)) throw Error($b1502ddb39c03b09$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b1502ddb39c03b09$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b1502ddb39c03b09$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b1502ddb39c03b09$var$uf] = b.current;
    $b1502ddb39c03b09$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b1502ddb39c03b09$var$ml(b);
};
$b1502ddb39c03b09$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b1502ddb39c03b09$var$ol(b)) throw Error($b1502ddb39c03b09$var$p(200));
    return $b1502ddb39c03b09$var$rl(null, a, b, !1, c);
};
$b1502ddb39c03b09$export$502457920280e6be = function(a) {
    if (!$b1502ddb39c03b09$var$ol(a)) throw Error($b1502ddb39c03b09$var$p(40));
    return a._reactRootContainer ? ($b1502ddb39c03b09$var$Rk(function() {
        $b1502ddb39c03b09$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b1502ddb39c03b09$var$uf] = null;
        });
    }), !0) : !1;
};
$b1502ddb39c03b09$export$c78a37762a8d58e1 = $b1502ddb39c03b09$var$Qk;
$b1502ddb39c03b09$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b1502ddb39c03b09$var$ol(c)) throw Error($b1502ddb39c03b09$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b1502ddb39c03b09$var$p(38));
    return $b1502ddb39c03b09$var$rl(a, b, c, !1, d);
};
$b1502ddb39c03b09$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bE6KD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("15wph"));

});
parcelRegister("15wph", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $0caf65653c79c297$export$c4744153514ff05d; }, function (v) { return $0caf65653c79c297$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $0caf65653c79c297$export$3e506c1ccc9cc1a7; }, function (v) { return $0caf65653c79c297$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $0caf65653c79c297$export$e26fe2ed2fa76875; }, function (v) { return $0caf65653c79c297$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $0caf65653c79c297$export$502329bbf4b505b1; }, function (v) { return $0caf65653c79c297$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $0caf65653c79c297$export$6e3807111c4874c4; }, function (v) { return $0caf65653c79c297$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $0caf65653c79c297$export$c27134553091fb3a; }, function (v) { return $0caf65653c79c297$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $0caf65653c79c297$export$33ee1acdc04fd2a2; }, function (v) { return $0caf65653c79c297$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $0caf65653c79c297$export$b00a404bbd5edef2; }, function (v) { return $0caf65653c79c297$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $0caf65653c79c297$export$8352ce38b91d0c62; }, function (v) { return $0caf65653c79c297$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $0caf65653c79c297$export$d66a1c1c77bd778b; }, function (v) { return $0caf65653c79c297$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $0caf65653c79c297$export$d3dfb8e4810cb555; }, function (v) { return $0caf65653c79c297$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $0caf65653c79c297$export$839f9183b0465a69; }, function (v) { return $0caf65653c79c297$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $0caf65653c79c297$export$72fdf0e06517287b; }, function (v) { return $0caf65653c79c297$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $0caf65653c79c297$export$4b844e58a3e414b4; }, function (v) { return $0caf65653c79c297$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $0caf65653c79c297$export$816d2913ae6b83b1; }, function (v) { return $0caf65653c79c297$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $0caf65653c79c297$export$61bcfe829111a1d0; }, function (v) { return $0caf65653c79c297$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $0caf65653c79c297$export$7ee8c9beb337bc3f; }, function (v) { return $0caf65653c79c297$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $0caf65653c79c297$export$b5836b71941fa3ed; }, function (v) { return $0caf65653c79c297$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $0caf65653c79c297$export$cf845f2c119da08a; }, function (v) { return $0caf65653c79c297$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0caf65653c79c297$export$c4744153514ff05d;
var $0caf65653c79c297$export$3e506c1ccc9cc1a7;
var $0caf65653c79c297$export$e26fe2ed2fa76875;
var $0caf65653c79c297$export$502329bbf4b505b1;
var $0caf65653c79c297$export$6e3807111c4874c4;
var $0caf65653c79c297$export$c27134553091fb3a;
var $0caf65653c79c297$export$33ee1acdc04fd2a2;
var $0caf65653c79c297$export$b00a404bbd5edef2;
var $0caf65653c79c297$export$8352ce38b91d0c62;
var $0caf65653c79c297$export$d66a1c1c77bd778b;
var $0caf65653c79c297$export$d3dfb8e4810cb555;
var $0caf65653c79c297$export$839f9183b0465a69;
var $0caf65653c79c297$export$72fdf0e06517287b;
var $0caf65653c79c297$export$4b844e58a3e414b4;
var $0caf65653c79c297$export$816d2913ae6b83b1;
var $0caf65653c79c297$export$61bcfe829111a1d0;
var $0caf65653c79c297$export$7ee8c9beb337bc3f;
var $0caf65653c79c297$export$b5836b71941fa3ed;
var $0caf65653c79c297$export$cf845f2c119da08a;
"use strict";
function $0caf65653c79c297$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $0caf65653c79c297$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $0caf65653c79c297$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $0caf65653c79c297$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $0caf65653c79c297$var$g(C, c)) n < e && 0 > $0caf65653c79c297$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $0caf65653c79c297$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $0caf65653c79c297$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $0caf65653c79c297$var$l = performance;
    $0caf65653c79c297$export$c4744153514ff05d = function() {
        return $0caf65653c79c297$var$l.now();
    };
} else {
    var $0caf65653c79c297$var$p = Date, $0caf65653c79c297$var$q = $0caf65653c79c297$var$p.now();
    $0caf65653c79c297$export$c4744153514ff05d = function() {
        return $0caf65653c79c297$var$p.now() - $0caf65653c79c297$var$q;
    };
}
var $0caf65653c79c297$var$r = [], $0caf65653c79c297$var$t = [], $0caf65653c79c297$var$u = 1, $0caf65653c79c297$var$v = null, $0caf65653c79c297$var$y = 3, $0caf65653c79c297$var$z = !1, $0caf65653c79c297$var$A = !1, $0caf65653c79c297$var$B = !1, $0caf65653c79c297$var$D = "function" === typeof setTimeout ? setTimeout : null, $0caf65653c79c297$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $0caf65653c79c297$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $0caf65653c79c297$var$G(a) {
    for(var b = $0caf65653c79c297$var$h($0caf65653c79c297$var$t); null !== b;){
        if (null === b.callback) $0caf65653c79c297$var$k($0caf65653c79c297$var$t);
        else if (b.startTime <= a) $0caf65653c79c297$var$k($0caf65653c79c297$var$t), b.sortIndex = b.expirationTime, $0caf65653c79c297$var$f($0caf65653c79c297$var$r, b);
        else break;
        b = $0caf65653c79c297$var$h($0caf65653c79c297$var$t);
    }
}
function $0caf65653c79c297$var$H(a) {
    $0caf65653c79c297$var$B = !1;
    $0caf65653c79c297$var$G(a);
    if (!$0caf65653c79c297$var$A) {
        if (null !== $0caf65653c79c297$var$h($0caf65653c79c297$var$r)) $0caf65653c79c297$var$A = !0, $0caf65653c79c297$var$I($0caf65653c79c297$var$J);
        else {
            var b = $0caf65653c79c297$var$h($0caf65653c79c297$var$t);
            null !== b && $0caf65653c79c297$var$K($0caf65653c79c297$var$H, b.startTime - a);
        }
    }
}
function $0caf65653c79c297$var$J(a, b) {
    $0caf65653c79c297$var$A = !1;
    $0caf65653c79c297$var$B && ($0caf65653c79c297$var$B = !1, $0caf65653c79c297$var$E($0caf65653c79c297$var$L), $0caf65653c79c297$var$L = -1);
    $0caf65653c79c297$var$z = !0;
    var c = $0caf65653c79c297$var$y;
    try {
        $0caf65653c79c297$var$G(b);
        for($0caf65653c79c297$var$v = $0caf65653c79c297$var$h($0caf65653c79c297$var$r); null !== $0caf65653c79c297$var$v && (!($0caf65653c79c297$var$v.expirationTime > b) || a && !$0caf65653c79c297$var$M());){
            var d = $0caf65653c79c297$var$v.callback;
            if ("function" === typeof d) {
                $0caf65653c79c297$var$v.callback = null;
                $0caf65653c79c297$var$y = $0caf65653c79c297$var$v.priorityLevel;
                var e = d($0caf65653c79c297$var$v.expirationTime <= b);
                b = $0caf65653c79c297$export$c4744153514ff05d();
                "function" === typeof e ? $0caf65653c79c297$var$v.callback = e : $0caf65653c79c297$var$v === $0caf65653c79c297$var$h($0caf65653c79c297$var$r) && $0caf65653c79c297$var$k($0caf65653c79c297$var$r);
                $0caf65653c79c297$var$G(b);
            } else $0caf65653c79c297$var$k($0caf65653c79c297$var$r);
            $0caf65653c79c297$var$v = $0caf65653c79c297$var$h($0caf65653c79c297$var$r);
        }
        if (null !== $0caf65653c79c297$var$v) var w = !0;
        else {
            var m = $0caf65653c79c297$var$h($0caf65653c79c297$var$t);
            null !== m && $0caf65653c79c297$var$K($0caf65653c79c297$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $0caf65653c79c297$var$v = null, $0caf65653c79c297$var$y = c, $0caf65653c79c297$var$z = !1;
    }
}
var $0caf65653c79c297$var$N = !1, $0caf65653c79c297$var$O = null, $0caf65653c79c297$var$L = -1, $0caf65653c79c297$var$P = 5, $0caf65653c79c297$var$Q = -1;
function $0caf65653c79c297$var$M() {
    return $0caf65653c79c297$export$c4744153514ff05d() - $0caf65653c79c297$var$Q < $0caf65653c79c297$var$P ? !1 : !0;
}
function $0caf65653c79c297$var$R() {
    if (null !== $0caf65653c79c297$var$O) {
        var a = $0caf65653c79c297$export$c4744153514ff05d();
        $0caf65653c79c297$var$Q = a;
        var b = !0;
        try {
            b = $0caf65653c79c297$var$O(!0, a);
        } finally{
            b ? $0caf65653c79c297$var$S() : ($0caf65653c79c297$var$N = !1, $0caf65653c79c297$var$O = null);
        }
    } else $0caf65653c79c297$var$N = !1;
}
var $0caf65653c79c297$var$S;
if ("function" === typeof $0caf65653c79c297$var$F) $0caf65653c79c297$var$S = function S() {
    $0caf65653c79c297$var$F($0caf65653c79c297$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $0caf65653c79c297$var$T = new MessageChannel, $0caf65653c79c297$var$U = $0caf65653c79c297$var$T.port2;
    $0caf65653c79c297$var$T.port1.onmessage = $0caf65653c79c297$var$R;
    $0caf65653c79c297$var$S = function S() {
        $0caf65653c79c297$var$U.postMessage(null);
    };
} else $0caf65653c79c297$var$S = function S() {
    $0caf65653c79c297$var$D($0caf65653c79c297$var$R, 0);
};
function $0caf65653c79c297$var$I(a) {
    $0caf65653c79c297$var$O = a;
    $0caf65653c79c297$var$N || ($0caf65653c79c297$var$N = !0, $0caf65653c79c297$var$S());
}
function $0caf65653c79c297$var$K(a, b) {
    $0caf65653c79c297$var$L = $0caf65653c79c297$var$D(function() {
        a($0caf65653c79c297$export$c4744153514ff05d());
    }, b);
}
$0caf65653c79c297$export$3e506c1ccc9cc1a7 = 5;
$0caf65653c79c297$export$e26fe2ed2fa76875 = 1;
$0caf65653c79c297$export$502329bbf4b505b1 = 4;
$0caf65653c79c297$export$6e3807111c4874c4 = 3;
$0caf65653c79c297$export$c27134553091fb3a = null;
$0caf65653c79c297$export$33ee1acdc04fd2a2 = 2;
$0caf65653c79c297$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$0caf65653c79c297$export$8352ce38b91d0c62 = function() {
    $0caf65653c79c297$var$A || $0caf65653c79c297$var$z || ($0caf65653c79c297$var$A = !0, $0caf65653c79c297$var$I($0caf65653c79c297$var$J));
};
$0caf65653c79c297$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $0caf65653c79c297$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$0caf65653c79c297$export$d3dfb8e4810cb555 = function() {
    return $0caf65653c79c297$var$y;
};
$0caf65653c79c297$export$839f9183b0465a69 = function() {
    return $0caf65653c79c297$var$h($0caf65653c79c297$var$r);
};
$0caf65653c79c297$export$72fdf0e06517287b = function(a) {
    switch($0caf65653c79c297$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $0caf65653c79c297$var$y;
    }
    var c = $0caf65653c79c297$var$y;
    $0caf65653c79c297$var$y = b;
    try {
        return a();
    } finally{
        $0caf65653c79c297$var$y = c;
    }
};
$0caf65653c79c297$export$4b844e58a3e414b4 = function() {};
$0caf65653c79c297$export$816d2913ae6b83b1 = function() {};
$0caf65653c79c297$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $0caf65653c79c297$var$y;
    $0caf65653c79c297$var$y = a;
    try {
        return b();
    } finally{
        $0caf65653c79c297$var$y = c;
    }
};
$0caf65653c79c297$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $0caf65653c79c297$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $0caf65653c79c297$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $0caf65653c79c297$var$f($0caf65653c79c297$var$t, a), null === $0caf65653c79c297$var$h($0caf65653c79c297$var$r) && a === $0caf65653c79c297$var$h($0caf65653c79c297$var$t) && ($0caf65653c79c297$var$B ? ($0caf65653c79c297$var$E($0caf65653c79c297$var$L), $0caf65653c79c297$var$L = -1) : $0caf65653c79c297$var$B = !0, $0caf65653c79c297$var$K($0caf65653c79c297$var$H, c - d))) : (a.sortIndex = e, $0caf65653c79c297$var$f($0caf65653c79c297$var$r, a), $0caf65653c79c297$var$A || $0caf65653c79c297$var$z || ($0caf65653c79c297$var$A = !0, $0caf65653c79c297$var$I($0caf65653c79c297$var$J)));
    return a;
};
$0caf65653c79c297$export$b5836b71941fa3ed = $0caf65653c79c297$var$M;
$0caf65653c79c297$export$cf845f2c119da08a = function(a) {
    var b = $0caf65653c79c297$var$y;
    return function() {
        var c = $0caf65653c79c297$var$y;
        $0caf65653c79c297$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $0caf65653c79c297$var$y = c;
        }
    };
};

});



parcelRegister("dBs1W", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return Action; });
$parcel$export(module.exports, "createMemoryHistory", function () { return createMemoryHistory; });
$parcel$export(module.exports, "createPath", function () { return createPath; });
$parcel$export(module.exports, "parsePath", function () { return parsePath; });
$parcel$export(module.exports, "createBrowserHistory", function () { return createBrowserHistory; });
$parcel$export(module.exports, "createHashHistory", function () { return createHashHistory; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return invariant; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return decodePath; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return AbortedDeferredError; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return IDLE_FETCHER; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return IDLE_BLOCKER; });
$parcel$export(module.exports, "createRouter", function () { return createRouter; });
/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8ANeE = parcelRequire("8ANeE");

var $59v1D = parcelRequire("59v1D");

var $6DUu1 = parcelRequire("6DUu1");

var $6RwIG = parcelRequire("6RwIG");

var $4msX2 = parcelRequire("4msX2");

var $fTrHk = parcelRequire("fTrHk");

var $8pCJl = parcelRequire("8pCJl");

var $g3Qtd = parcelRequire("g3Qtd");

var $g83i1 = parcelRequire("g83i1");

var $fafrJ = parcelRequire("fafrJ");

var $jMsep = parcelRequire("jMsep");

var $bt19i = parcelRequire("bt19i");

var $bt19i = parcelRequire("bt19i");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $g3Qtd._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $8pCJl._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $g3Qtd._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $g3Qtd._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $fTrHk._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $fTrHk._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $59v1D._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $4msX2._)(AbortedDeferredError, Error1);
    var _super = (0, $jMsep._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $59v1D._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $fafrJ._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $59v1D._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $fTrHk._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $6RwIG._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $6DUu1._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $8ANeE._)(function() {
                    var aborted, onAbort;
                    return (0, $bt19i.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $fTrHk._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $6RwIG._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $59v1D._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, $g3Qtd._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $6RwIG._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) initialMatches = fogOfWar1.matches;
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $g3Qtd._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $8ANeE._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $8ANeE._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $6RwIG._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $fTrHk._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $6RwIG._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $8ANeE._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $8ANeE._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $6RwIG._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $6RwIG._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $fTrHk._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $6RwIG._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $6RwIG._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $8ANeE._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $fTrHk._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $8ANeE._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $8ANeE._)(function(request, redirect, isNavigation, _temp2) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $8ANeE._)(function(type, state, request, matchesToLoad, matches, fetcherKey) {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $fTrHk._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $8ANeE._)(function(state, matches, matchesToLoad, fetchersToLoad, request) {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function() {
                            var _ref = (0, $8ANeE._)(function(f) {
                                var results, result;
                                return (0, $bt19i.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, $6RwIG._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $6RwIG._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(f) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $g3Qtd._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $6RwIG._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $fTrHk._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $fTrHk._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $8ANeE._)(function(matches, pathname, signal) {
            var _loop, partialMatches, _ret;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $bt19i.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                path: pathname,
                                                matches: partialMatches,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $g3Qtd._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $bt19i.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $g83i1._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $g3Qtd._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $8ANeE._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $6RwIG._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $6RwIG._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $8ANeE._)(function(request, _temp4) {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $8ANeE._)(function(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $8ANeE._)(function(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $6RwIG._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, $6RwIG._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, $6RwIG._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $6RwIG._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $8ANeE._)(function(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $6RwIG._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $6RwIG._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $8ANeE._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
            var results, dataResults;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function() {
                                var _ref = (0, $8ANeE._)(function(match) {
                                    var result, response, _;
                                    return (0, $bt19i.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(match) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $6RwIG._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $fTrHk._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $g3Qtd._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $8ANeE._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_ref4) {
    return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
    _defaultDataStrategy = // Default implementation of `dataStrategy` which fetches all loaders in parallel
    (0, $8ANeE._)(function(_ref4) {
        var matches, matchesToLoad, results;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $6RwIG._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    });
    return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, $8ANeE._)(function(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = function() {
                            var _ref = (0, $8ANeE._)(function(handlerOverride) {
                                return (0, $bt19i.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            });
                            return function resolve(handlerOverride) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $8ANeE._)(function(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $g3Qtd._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = (0, $8ANeE._)(function() {
                            var val, e;
                            return (0, $bt19i.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            handlerOverride ? handlerOverride(function(ctx) {
                                                return actualHandler(ctx);
                                            }) : actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $fTrHk._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function _convertDataStrategyResultToDataResult() {
    _convertDataStrategyResultToDataResult = (0, $8ANeE._)(function(dataStrategyResult) {
        var result, type, data, contentType, e, _result$init2, _result$init, _result$init3, _result$init4, _result$init5, _result$init6;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            result = new ErrorResponseImpl(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
                                headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fTrHk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fTrHk._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $6RwIG._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, $6RwIG._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $6RwIG._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $g3Qtd._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $fTrHk._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function _resolveNavigationDeferredResults() {
    _resolveNavigationDeferredResults = (0, $8ANeE._)(function(matches, results, signal, currentMatches, currentLoaderData) {
        var _loop, entries, index;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, $bt19i.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, $fTrHk._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $bt19i.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function _resolveFetcherDeferredResults() {
    _resolveFetcherDeferredResults = (0, $8ANeE._)(function(matches, results, revalidatingFetchers) {
        var _loop, index;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, $bt19i.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $bt19i.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, $8ANeE._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $fTrHk._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $fTrHk._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $g3Qtd._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("8ANeE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6417e0a446e676cf$export$71511d61b312f219; });
function $6417e0a446e676cf$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $6417e0a446e676cf$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $6417e0a446e676cf$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $6417e0a446e676cf$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("59v1D", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3c05dc014d00f348$export$71511d61b312f219; });
function $3c05dc014d00f348$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6DUu1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d6232fc14783146$export$71511d61b312f219; });
function $4d6232fc14783146$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4d6232fc14783146$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4d6232fc14783146$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4d6232fc14783146$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("6RwIG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $014a14f295bb4907$export$71511d61b312f219; });
function $014a14f295bb4907$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("4msX2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $32cfac9e0183ed52$export$71511d61b312f219; });

var $84SiN = parcelRequire("84SiN");
function $32cfac9e0183ed52$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $84SiN._)(subClass, superClass);
}

});
parcelRegister("84SiN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5e18d1b4e9064299$export$71511d61b312f219; });
function $5e18d1b4e9064299$export$71511d61b312f219(o, p) {
    $5e18d1b4e9064299$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5e18d1b4e9064299$export$71511d61b312f219(o, p);
}

});


parcelRegister("fTrHk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b9217a4a22d59dcf$export$71511d61b312f219; });

var $doMXU = parcelRequire("doMXU");

var $fJ1eZ = parcelRequire("fJ1eZ");

var $4TvHF = parcelRequire("4TvHF");

var $7Nfy5 = parcelRequire("7Nfy5");
function $b9217a4a22d59dcf$export$71511d61b312f219(arr, i) {
    return (0, $doMXU._)(arr) || (0, $fJ1eZ._)(arr, i) || (0, $7Nfy5._)(arr, i) || (0, $4TvHF._)();
}

});
parcelRegister("doMXU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9c137fc2d60e442a$export$71511d61b312f219; });
function $9c137fc2d60e442a$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("fJ1eZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b72c0565a977fb90$export$71511d61b312f219; });
function $b72c0565a977fb90$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("4TvHF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3904e41eb844a944$export$71511d61b312f219; });
function $3904e41eb844a944$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("7Nfy5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5ac92ba7f0c981ff$export$71511d61b312f219; });

var $j3Soa = parcelRequire("j3Soa");
function $5ac92ba7f0c981ff$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $j3Soa._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $j3Soa._)(o, minLen);
}

});
parcelRegister("j3Soa", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de087ca2a9e58a8a$export$71511d61b312f219; });
function $de087ca2a9e58a8a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("8pCJl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $61feb395ae929da5$export$71511d61b312f219; });

var $doMXU = parcelRequire("doMXU");

var $367IJ = parcelRequire("367IJ");

var $4TvHF = parcelRequire("4TvHF");

var $7Nfy5 = parcelRequire("7Nfy5");
function $61feb395ae929da5$export$71511d61b312f219(arr) {
    return (0, $doMXU._)(arr) || (0, $367IJ._)(arr) || (0, $7Nfy5._)(arr) || (0, $4TvHF._)();
}

});
parcelRegister("367IJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2417ebbccbf379d2$export$71511d61b312f219; });
function $2417ebbccbf379d2$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("g3Qtd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bb15a0aa50a3ad05$export$71511d61b312f219; });

var $8JfAO = parcelRequire("8JfAO");

var $367IJ = parcelRequire("367IJ");

var $cimh7 = parcelRequire("cimh7");

var $7Nfy5 = parcelRequire("7Nfy5");
function $bb15a0aa50a3ad05$export$71511d61b312f219(arr) {
    return (0, $8JfAO._)(arr) || (0, $367IJ._)(arr) || (0, $7Nfy5._)(arr) || (0, $cimh7._)();
}

});
parcelRegister("8JfAO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $65ae9f18e0b5f152$export$71511d61b312f219; });

var $j3Soa = parcelRequire("j3Soa");
function $65ae9f18e0b5f152$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $j3Soa._)(arr);
}

});

parcelRegister("cimh7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8f3871d2ad621e47$export$71511d61b312f219; });
function $8f3871d2ad621e47$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fafrJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0a3c58250cbdec6$export$71511d61b312f219; });

var $aAf84 = parcelRequire("aAf84");

var $03nrE = parcelRequire("03nrE");

var $f2EX0 = parcelRequire("f2EX0");

var $84SiN = parcelRequire("84SiN");
function $b0a3c58250cbdec6$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b0a3c58250cbdec6$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $f2EX0._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $aAf84._)(Class, arguments, (0, $03nrE._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $84SiN._)(Wrapper, Class);
    };
    return $b0a3c58250cbdec6$export$71511d61b312f219(Class);
}

});
parcelRegister("aAf84", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7b49007ef843a529$export$71511d61b312f219; });

var $aMQwe = parcelRequire("aMQwe");

var $84SiN = parcelRequire("84SiN");
function $7b49007ef843a529$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $aMQwe._)()) $7b49007ef843a529$export$71511d61b312f219 = Reflect.construct;
    else $7b49007ef843a529$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $84SiN._)(instance, Class.prototype);
        return instance;
    };
    return $7b49007ef843a529$export$71511d61b312f219.apply(null, arguments);
}

});
parcelRegister("aMQwe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7da7203d7be7d806$export$71511d61b312f219; });
function $7da7203d7be7d806$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($7da7203d7be7d806$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});


parcelRegister("03nrE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $00a2779d9e3951d5$export$71511d61b312f219; });
function $00a2779d9e3951d5$export$71511d61b312f219(o) {
    $00a2779d9e3951d5$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $00a2779d9e3951d5$export$71511d61b312f219(o);
}

});

parcelRegister("f2EX0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af36cee5649e29e1$export$71511d61b312f219; });
function $af36cee5649e29e1$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("jMsep", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e6686631ef8c68aa$export$71511d61b312f219; });

var $03nrE = parcelRequire("03nrE");

var $aMQwe = parcelRequire("aMQwe");

var $gTt8x = parcelRequire("gTt8x");
function $e6686631ef8c68aa$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $aMQwe._)();
    return function _createSuperInternal() {
        var Super = (0, $03nrE._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $03nrE._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gTt8x._)(this, result);
    };
}

});
parcelRegister("gTt8x", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c4c86254875ec18a$export$71511d61b312f219; });

var $fvPrG = parcelRequire("fvPrG");

var $g83i1 = parcelRequire("g83i1");
function $c4c86254875ec18a$export$71511d61b312f219(self, call) {
    if (call && ((0, $g83i1._)(call) === "object" || typeof call === "function")) return call;
    return (0, $fvPrG._)(self);
}

});
parcelRegister("fvPrG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b4b1a848b385621f$export$71511d61b312f219; });
function $b4b1a848b385621f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("bt19i", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $138711338400fc10$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $138711338400fc10$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $g83i1 = parcelRequire("g83i1");
var $138711338400fc10$var$extendStatics = function extendStatics1(d, b) {
    $138711338400fc10$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $138711338400fc10$var$extendStatics(d, b);
};
function $138711338400fc10$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $138711338400fc10$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $138711338400fc10$export$18ce0697a983be9b = function __assign1() {
    $138711338400fc10$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $138711338400fc10$export$18ce0697a983be9b.apply(this, arguments);
};
function $138711338400fc10$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $138711338400fc10$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $138711338400fc10$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $138711338400fc10$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $138711338400fc10$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $138711338400fc10$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $g83i1._)(x)) === "symbol" ? x : "".concat(x);
}
function $138711338400fc10$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $g83i1._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $138711338400fc10$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $138711338400fc10$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $138711338400fc10$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $138711338400fc10$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $138711338400fc10$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $138711338400fc10$export$45d3717a4c69092e(o, m, p);
}
function $138711338400fc10$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $138711338400fc10$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $138711338400fc10$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($138711338400fc10$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $138711338400fc10$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $138711338400fc10$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $138711338400fc10$export$10c90e4f7922046c(v) {
    return this instanceof $138711338400fc10$export$10c90e4f7922046c ? (this.v = v, this) : new $138711338400fc10$export$10c90e4f7922046c(v);
}
function $138711338400fc10$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $138711338400fc10$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $138711338400fc10$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $138711338400fc10$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $138711338400fc10$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $138711338400fc10$export$19a8beecd37a4c45 === "function" ? $138711338400fc10$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $138711338400fc10$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $138711338400fc10$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $138711338400fc10$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $138711338400fc10$export$45d3717a4c69092e(result, mod, k);
    }
    $138711338400fc10$var$__setModuleDefault(result, mod);
    return result;
}
function $138711338400fc10$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $138711338400fc10$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $138711338400fc10$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $138711338400fc10$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $138711338400fc10$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $138711338400fc10$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $138711338400fc10$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $138711338400fc10$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $138711338400fc10$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $138711338400fc10$export$2e2bcd8739ae039 = {
    __extends: $138711338400fc10$export$a8ba968b8961cb8a,
    __assign: $138711338400fc10$export$18ce0697a983be9b,
    __rest: $138711338400fc10$export$3c9a16f847548506,
    __decorate: $138711338400fc10$export$29e00dfd3077644b,
    __param: $138711338400fc10$export$d5ad3fd78186038f,
    __esDecorate: $138711338400fc10$export$3a84e1ae4e97e9b0,
    __runInitializers: $138711338400fc10$export$d831c04e792af3d,
    __propKey: $138711338400fc10$export$6a2a36740a146cb8,
    __setFunctionName: $138711338400fc10$export$d1a06452d3489bc7,
    __metadata: $138711338400fc10$export$f1db080c865becb9,
    __awaiter: $138711338400fc10$export$1050f835b63b671e,
    __generator: $138711338400fc10$export$67ebef60e6f28a6,
    __createBinding: $138711338400fc10$export$45d3717a4c69092e,
    __exportStar: $138711338400fc10$export$f33643c0debef087,
    __values: $138711338400fc10$export$19a8beecd37a4c45,
    __read: $138711338400fc10$export$8d051b38c9118094,
    __spread: $138711338400fc10$export$afc72e2116322959,
    __spreadArrays: $138711338400fc10$export$6388937ca91ccae8,
    __spreadArray: $138711338400fc10$export$1216008129fb82ed,
    __await: $138711338400fc10$export$10c90e4f7922046c,
    __asyncGenerator: $138711338400fc10$export$e427f37a30a4de9b,
    __asyncDelegator: $138711338400fc10$export$bbd80228419bb833,
    __asyncValues: $138711338400fc10$export$e3b29a3d6162315f,
    __makeTemplateObject: $138711338400fc10$export$4fb47efe1390b86f,
    __importStar: $138711338400fc10$export$c21735bcef00d192,
    __importDefault: $138711338400fc10$export$da59b14a69baef04,
    __classPrivateFieldGet: $138711338400fc10$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $138711338400fc10$export$d40a35129aaff81f,
    __classPrivateFieldIn: $138711338400fc10$export$81fdc39f203e4e04,
    __addDisposableResource: $138711338400fc10$export$88ac25d8e944e405,
    __disposeResources: $138711338400fc10$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $138711338400fc10$export$889dfb5d17574b0b
};

});


parcelRegister("dNvVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $hgwVv = parcelRequire("hgwVv");
function $a0b89debaf1d2861$var$emptyFunction() {}
function $a0b89debaf1d2861$var$emptyFunctionWithReset() {}
$a0b89debaf1d2861$var$emptyFunctionWithReset.resetWarningCache = $a0b89debaf1d2861$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hgwVv) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a0b89debaf1d2861$var$emptyFunctionWithReset,
        resetWarningCache: $a0b89debaf1d2861$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hgwVv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c91d78cefd8560cc$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $c91d78cefd8560cc$var$ReactPropTypesSecret;

});


var $978b871a0234f592$exports = {};
"use strict";

$978b871a0234f592$exports = (parcelRequire("3hyzP"));


var $55c3e9599dcfbee0$export$882461b6382ed46c;
var $55c3e9599dcfbee0$export$757ceba2d55c277e;
"use strict";
var $e1a300cc66774841$exports = {};
"use strict";
function $e1a300cc66774841$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e1a300cc66774841$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e1a300cc66774841$var$checkDCE();

$e1a300cc66774841$exports = (parcelRequire("fdPHT"));


var $55c3e9599dcfbee0$var$i;
$55c3e9599dcfbee0$export$882461b6382ed46c = $e1a300cc66774841$exports.createRoot;
$55c3e9599dcfbee0$export$757ceba2d55c277e = $e1a300cc66774841$exports.hydrateRoot;



var $8ANeE = parcelRequire("8ANeE");
function $491a05e70049ad67$export$71511d61b312f219(value) {
    this.wrapped = value;
}


function $05d2bdbaaa72ad2b$export$71511d61b312f219(value) {
    return new (0, $491a05e70049ad67$export$71511d61b312f219)(value);
}



var $59v1D = parcelRequire("59v1D");

var $6DUu1 = parcelRequire("6DUu1");

var $03nrE = parcelRequire("03nrE");
function $1d11cddbcb9af018$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $03nrE._)(object);
        if (object === null) break;
    }
    return object;
}


function $b735c518bd78367b$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $b735c518bd78367b$export$71511d61b312f219 = Reflect.get;
    else $b735c518bd78367b$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $1d11cddbcb9af018$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $b735c518bd78367b$export$71511d61b312f219(target, property, receiver || target);
}



var $03nrE = parcelRequire("03nrE");

var $4msX2 = parcelRequire("4msX2");

var $6RwIG = parcelRequire("6RwIG");
function $8b7df3d651e6781e$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6RwIG._)(target, key, source[key]);
        });
    }
    return target;
}


function $0187e934f6ca9418$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0187e934f6ca9418$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $0187e934f6ca9418$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $25cf7171beea673d$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $e2743f9431be5140$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $25cf7171beea673d$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $fTrHk = parcelRequire("fTrHk");

var $g3Qtd = parcelRequire("g3Qtd");

function $0cd064151cb6ecce$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $491a05e70049ad67$export$71511d61b312f219);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $0cd064151cb6ecce$export$71511d61b312f219.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$0cd064151cb6ecce$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$0cd064151cb6ecce$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$0cd064151cb6ecce$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $8d539ab38e08263a$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $0cd064151cb6ecce$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}



var $jMsep = parcelRequire("jMsep");

var $bt19i = parcelRequire("bt19i");

var $bt19i = parcelRequire("bt19i");
function $fa109827480cac3d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $fa109827480cac3d$var$$9b05bcda60cc529c$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $fa109827480cac3d$export$61cc6ed0f143570b;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $fa109827480cac3d$export$dd1bc94b04021eeb;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $fa109827480cac3d$export$a09f818797e212c4;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $fa109827480cac3d$export$170f4e08cad8229d;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $fa109827480cac3d$export$2a489b3f92f4996a;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $fa109827480cac3d$export$67a6ce548ae77071;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $fa109827480cac3d$export$a48f0734ac7c2329;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $fa109827480cac3d$export$3f34ca2fef821bbd;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $fa109827480cac3d$export$86f54f62aa7a7514;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $fa109827480cac3d$export$89912e019eef22aa;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $fa109827480cac3d$export$1c8ba402144543e5;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $fa109827480cac3d$export$2ddabb89308e1a22;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $fa109827480cac3d$export$14527669107aa301;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $fa109827480cac3d$export$3f063810d7bf01bd;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $fa109827480cac3d$export$b5a4d6f439a5044d;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $fa109827480cac3d$export$b119cc7e1840e59c;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $fa109827480cac3d$export$7b85fd78dd236198;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $fa109827480cac3d$export$697c3df919c0e61a;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $fa109827480cac3d$export$e6b5ff3168b5942b;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $fa109827480cac3d$export$1d012a0dff3dab06;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $fa109827480cac3d$export$69a3209f1a06c04d;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $fa109827480cac3d$export$86c18c6347f4a8c4;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $fa109827480cac3d$export$dce9414bed0662c;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $fa109827480cac3d$export$271f7c16f175f804;
});
var $fa109827480cac3d$var$$6a9944941b4c1893$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "sum", function() {
    return $fa109827480cac3d$export$8a63f25cc62965f1;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $fa109827480cac3d$export$e1f36757ecda301d;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $fa109827480cac3d$export$8e694e1eafd55acb;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $fa109827480cac3d$export$57d7c52a66287430;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $fa109827480cac3d$export$2b4693832ca3ce16;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $fa109827480cac3d$export$5b784e078da1ce6;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $fa109827480cac3d$export$17ec9c9f4f23588c;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $fa109827480cac3d$export$595dbf49c602a1f;
});
function $fa109827480cac3d$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $fa109827480cac3d$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $fa109827480cac3d$export$8a63f25cc62965f1.apply(void 0, (0, $g3Qtd._)(data)) / data.length;
}
function $fa109827480cac3d$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $fa109827480cac3d$export$e1f36757ecda301d.apply(void 0, (0, $g3Qtd._)(data));
    var summary = $fa109827480cac3d$export$8a63f25cc62965f1.apply(void 0, (0, $g3Qtd._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $fa109827480cac3d$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($fa109827480cac3d$export$8e694e1eafd55acb(data, sample));
}
function $fa109827480cac3d$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($fa109827480cac3d$export$8a63f25cc62965f1.apply(void 0, (0, $g3Qtd._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $fa109827480cac3d$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf(".") + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
function $fa109827480cac3d$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf(".");
    if (floatOffset < 0) return length ? "".concat(text, ".").concat("0".repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $fa109827480cac3d$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes(".") ? result.padEnd(offset, "0") : result;
}
var $fa109827480cac3d$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function $6a9944941b4c1893$export$595dbf49c602a1f(value) {
        (0, $59v1D._)(this, $6a9944941b4c1893$export$595dbf49c602a1f);
        this.value = value;
    }
    (0, $6DUu1._)($6a9944941b4c1893$export$595dbf49c602a1f, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $g3Qtd._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return $6a9944941b4c1893$export$595dbf49c602a1f;
}();
function $fa109827480cac3d$export$61cc6ed0f143570b(value) {
    return !(value != null) || Number.isNaN(value);
}
function $fa109827480cac3d$export$dd1bc94b04021eeb(value) {
    return $fa109827480cac3d$export$61cc6ed0f143570b(value) || (typeof value === "object" ? !Object.keys(value).length : value === "");
}
var $fa109827480cac3d$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
function $fa109827480cac3d$export$170f4e08cad8229d(Sub, Super) {
    return Sub.prototype instanceof Super;
}
function $fa109827480cac3d$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
function $fa109827480cac3d$export$67a6ce548ae77071(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + "", undefined, {
        numeric: true
    }) > 0;
}
function $fa109827480cac3d$export$a48f0734ac7c2329(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, "xx").length;
}
function $fa109827480cac3d$export$3f34ca2fef821bbd(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? "-" : "").concat((match[1] || match[0]).toLowerCase());
    });
}
function $fa109827480cac3d$export$86f54f62aa7a7514(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
}
function $fa109827480cac3d$export$89912e019eef22aa() {
    return (Date.now() + parseInt((Math.random() + "").slice(2))).toString(36);
}
function $fa109827480cac3d$export$1c8ba402144543e5(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
}
var $fa109827480cac3d$export$2ddabb89308e1a22;
(function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
})($fa109827480cac3d$export$2ddabb89308e1a22 || ($fa109827480cac3d$export$2ddabb89308e1a22 = {}));
function $fa109827480cac3d$export$14527669107aa301(oldList, newList) {
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = newList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var _map, _item;
            (_map = map)[_item = item1] || (_map[_item] = 0);
            map[item1] += 1;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        map: map,
        group: $fa109827480cac3d$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $fTrHk._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $fa109827480cac3d$export$b5a4d6f439a5044d(data) {
    if ($fa109827480cac3d$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === "number" && length >= 0 && ~~length === length;
}
var $fa109827480cac3d$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $fa109827480cac3d$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($fa109827480cac3d$export$61cc6ed0f143570b(data)) return [];
    if ($fa109827480cac3d$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $fa109827480cac3d$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $fa109827480cac3d$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $fa109827480cac3d$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $g3Qtd._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $fa109827480cac3d$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $fa109827480cac3d$export$1d012a0dff3dab06(list, iteratee) {
    var group = $fa109827480cac3d$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $fTrHk._)(param, 2), key = _param[0], _param_ = _param[1], length = _param_.length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $fa109827480cac3d$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $g3Qtd._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $fa109827480cac3d$export$86c18c6347f4a8c4(executor) {
    return $fa109827480cac3d$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4.apply(this, arguments);
}
function $fa109827480cac3d$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4() {
    $fa109827480cac3d$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4 = (0, $8d539ab38e08263a$export$71511d61b312f219)(function(executor) {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol("done"), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $05d2bdbaaa72ad2b$export$71511d61b312f219)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$9b05bcda60cc529c$export$86c18c6347f4a8c4.apply(this, arguments);
}
function $fa109827480cac3d$export$dce9414bed0662c() {
    return $fa109827480cac3d$var$_$9b05bcda60cc529c$export$dce9414bed0662c.apply(this, arguments);
}
function $fa109827480cac3d$var$_$9b05bcda60cc529c$export$dce9414bed0662c() {
    $fa109827480cac3d$var$_$9b05bcda60cc529c$export$dce9414bed0662c = (0, $8d539ab38e08263a$export$71511d61b312f219)(function() {
        var _loop, _len, sources, _key, iterators;
        var _arguments = arguments;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $bt19i.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $05d2bdbaaa72ad2b$export$71511d61b312f219)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    for(_len = _arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
                        sources[_key] = _arguments[_key];
                    }
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $bt19i.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$9b05bcda60cc529c$export$dce9414bed0662c.apply(this, arguments);
}
var $fa109827480cac3d$export$271f7c16f175f804 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $4msX2._)($9b05bcda60cc529c$export$271f7c16f175f804, $6a9944941b4c1893$export$595dbf49c602a1f);
    var _super = (0, $jMsep._)($9b05bcda60cc529c$export$271f7c16f175f804);
    function $9b05bcda60cc529c$export$271f7c16f175f804() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $59v1D._)(this, $9b05bcda60cc529c$export$271f7c16f175f804);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $g3Qtd._)(args)));
        _this.units = [
            "",
            "K",
            "M",
            "G",
            "T",
            "P",
            "E",
            "Z",
            "Y"
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + "B"
            };
        });
        return _this;
    }
    return $9b05bcda60cc529c$export$271f7c16f175f804;
}($fa109827480cac3d$export$595dbf49c602a1f);
var $fa109827480cac3d$var$$f872d8bba1c0f79f$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $fa109827480cac3d$export$c489aa6f7fd82b1a;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $fa109827480cac3d$export$cbd942915f33be50;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $fa109827480cac3d$export$9b886f8493244014;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $fa109827480cac3d$export$e99cbb807a5bb10d;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $fa109827480cac3d$export$7a9a31a911eb9a20;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $fa109827480cac3d$export$fca4f8121099df57;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $fa109827480cac3d$export$6ce2f08d515512;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $fa109827480cac3d$export$951c8378cdfec6e6;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $fa109827480cac3d$export$1a4097b876a13bf7;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $fa109827480cac3d$export$d9bcbd5e1ff81430;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $fa109827480cac3d$export$506c8e8f8c8edda;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $fa109827480cac3d$export$3ae94a2503e890a1;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $fa109827480cac3d$export$62ad822b3a5fd9a0;
});
var $fa109827480cac3d$export$c489aa6f7fd82b1a = 1000;
var $fa109827480cac3d$export$cbd942915f33be50 = $fa109827480cac3d$export$c489aa6f7fd82b1a * 60;
var $fa109827480cac3d$export$9b886f8493244014 = $fa109827480cac3d$export$cbd942915f33be50 * 15;
var $fa109827480cac3d$export$e99cbb807a5bb10d = $fa109827480cac3d$export$9b886f8493244014 * 4;
var $fa109827480cac3d$export$7a9a31a911eb9a20 = $fa109827480cac3d$export$e99cbb807a5bb10d * 24;
var $fa109827480cac3d$export$fca4f8121099df57 = $fa109827480cac3d$export$7a9a31a911eb9a20 * 7;
var $fa109827480cac3d$export$6ce2f08d515512 = $fa109827480cac3d$export$7a9a31a911eb9a20 * 365;
var $fa109827480cac3d$export$951c8378cdfec6e6 = $fa109827480cac3d$export$6ce2f08d515512 / 12;
var $fa109827480cac3d$export$1a4097b876a13bf7 = $fa109827480cac3d$export$951c8378cdfec6e6 * 3;
var $fa109827480cac3d$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $4msX2._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, $6a9944941b4c1893$export$595dbf49c602a1f);
    var _super = (0, $jMsep._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
    function $f872d8bba1c0f79f$export$d9bcbd5e1ff81430() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $59v1D._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $g3Qtd._)(args)));
        _this.units = [
            {
                base: $fa109827480cac3d$export$c489aa6f7fd82b1a,
                name: "s"
            },
            {
                base: $fa109827480cac3d$export$cbd942915f33be50,
                name: "m"
            },
            {
                base: $fa109827480cac3d$export$e99cbb807a5bb10d,
                name: "H"
            },
            {
                base: $fa109827480cac3d$export$7a9a31a911eb9a20,
                name: "D"
            },
            {
                base: $fa109827480cac3d$export$fca4f8121099df57,
                name: "W"
            },
            {
                base: $fa109827480cac3d$export$951c8378cdfec6e6,
                name: "M"
            },
            {
                base: $fa109827480cac3d$export$6ce2f08d515512,
                name: "Y"
            }
        ];
        return _this;
    }
    (0, $6DUu1._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $b735c518bd78367b$export$71511d61b312f219)((0, $03nrE._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430;
}($fa109827480cac3d$export$595dbf49c602a1f);
function $fa109827480cac3d$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $fa109827480cac3d$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $fTrHk._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + "";
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, "0") : value).slice(-Math.max(template.length, 2));
    };
}
function $fa109827480cac3d$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "YYYY-MM-DD HH:mm:ss";
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $fa109827480cac3d$export$cbd942915f33be50);
    var _time_toJSON_split = (0, $fTrHk._)(time.toJSON().split(/\D/), 7), year = _time_toJSON_split[0], month = _time_toJSON_split[1], day = _time_toJSON_split[2], hour = _time_toJSON_split[3], minute = _time_toJSON_split[4], second = _time_toJSON_split[5], millisecond = _time_toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $fa109827480cac3d$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $fa109827480cac3d$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $fa109827480cac3d$var$$ba0e5dc395660a7c$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $fa109827480cac3d$export$27924e57e9afff7f;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $fa109827480cac3d$export$7ea17d45ecdcf634;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $fa109827480cac3d$export$bb8626e4916f587b;
});
function $fa109827480cac3d$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === "string" && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== "string" || $fa109827480cac3d$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $fa109827480cac3d$export$7ea17d45ecdcf634(raw) {
    var parsed = $fa109827480cac3d$export$27924e57e9afff7f(raw);
    if (typeof parsed !== "string") return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + "" !== parsed ? parsed : number;
}
function $fa109827480cac3d$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $fa109827480cac3d$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        var list = [];
        do {
            var value = void 0;
            if (row[0] === '"' || row[0] === "'") {
                value = $fa109827480cac3d$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
                row = row.slice(value.length + 3);
            } else {
                var index = row.indexOf(separator);
                if (index > -1) {
                    value = row.slice(0, index);
                    row = row.slice(index + 1);
                } else {
                    value = row;
                    row = "";
                }
            }
            list.push($fa109827480cac3d$export$7ea17d45ecdcf634(value.trim()));
        }while (row);
        return list;
    });
    return !header ? data : data.slice(1).map(function(row) {
        return row.reduce(function(object, item, index) {
            object[data[0][index]] = item;
            return object;
        }, {});
    });
}
var $fa109827480cac3d$var$$083124ac4b1a50a0$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $fa109827480cac3d$export$71e6483fc2b024eb;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $fa109827480cac3d$export$eb9b2aadbe449a20;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $fa109827480cac3d$export$13397a83aa5915d6;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $fa109827480cac3d$export$fd89523fba250fa4;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $fa109827480cac3d$export$504fbde693c1771c;
});
function $fa109827480cac3d$export$71e6483fc2b024eb(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
}
function $fa109827480cac3d$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_location;
        return (_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.search;
    }(), toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var list = raw.split(/\?|#/);
    var data = new URLSearchParams(list[1] || list[0]);
    return Object.fromEntries((0, $g3Qtd._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map($fa109827480cac3d$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $fa109827480cac3d$var$$083124ac4b1a50a0$var$stringify = function(value) {
    return typeof value === "string" ? value : $fa109827480cac3d$export$b5a4d6f439a5044d(value) ? $fa109827480cac3d$export$7b85fd78dd236198(value) + "" : JSON.stringify(value);
};
function $fa109827480cac3d$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $fTrHk._)(param, 2), key = _param[0], value = _param[1];
        return !$fa109827480cac3d$export$dd1bc94b04021eeb(value) && [
            key,
            $fa109827480cac3d$var$$083124ac4b1a50a0$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
function $fa109827480cac3d$export$fd89523fba250fa4(URI) {
    return $fa109827480cac3d$var$_$083124ac4b1a50a0$export$fd89523fba250fa4.apply(this, arguments);
}
function $fa109827480cac3d$var$_$083124ac4b1a50a0$export$fd89523fba250fa4() {
    $fa109827480cac3d$var$_$083124ac4b1a50a0$export$fd89523fba250fa4 = (0, $8ANeE._)(function(URI) {
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + "")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$083124ac4b1a50a0$export$fd89523fba250fa4.apply(this, arguments);
}
var $fa109827480cac3d$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $fa109827480cac3d$export$504fbde693c1771c(URI) {
    var _ref = (0, $fTrHk._)($fa109827480cac3d$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    data = base64 ? atob(data) : data;
    var aBuffer = new ArrayBuffer(data.length);
    var uBuffer = new Uint8Array(aBuffer);
    for(var i = 0; data[i]; i++)uBuffer[i] = data.charCodeAt(i);
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $fa109827480cac3d$var$$50872bf213056663$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $fa109827480cac3d$export$1b9ac4d3de3ffd2e;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$50872bf213056663$exports, "makeSHA", function() {
    return $fa109827480cac3d$export$d51f3b55e8d1aa73;
});
var $fa109827480cac3d$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $fa109827480cac3d$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $fa109827480cac3d$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "0x" + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === "object") {
    if ("msCrypto" in globalThis) {
        var $fa109827480cac3d$var$_loop = function(key) {
            var origin = $fa109827480cac3d$var$subtle[key];
            if (origin instanceof Function) $fa109827480cac3d$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-ignore
        var $fa109827480cac3d$var$_ref = globalThis.crypto = globalThis.msCrypto, $fa109827480cac3d$var$subtle = $fa109827480cac3d$var$_ref.subtle;
        for(var $fa109827480cac3d$var$key in $fa109827480cac3d$var$subtle)$fa109827480cac3d$var$_loop($fa109827480cac3d$var$key);
    }
    var $fa109827480cac3d$var$crypto1 = globalThis.crypto;
    if (!($fa109827480cac3d$var$crypto1 === null || $fa109827480cac3d$var$crypto1 === void 0 ? void 0 : $fa109827480cac3d$var$crypto1.subtle) && ($fa109827480cac3d$var$crypto1 === null || $fa109827480cac3d$var$crypto1 === void 0 ? void 0 : $fa109827480cac3d$var$crypto1["webkitSubtle"])) $fa109827480cac3d$var$crypto1.subtle = $fa109827480cac3d$var$crypto1["webkitSubtle"];
}
function $fa109827480cac3d$export$d51f3b55e8d1aa73(raw) {
    return $fa109827480cac3d$var$_$50872bf213056663$export$d51f3b55e8d1aa73.apply(this, arguments);
}
function $fa109827480cac3d$var$_$50872bf213056663$export$d51f3b55e8d1aa73() {
    $fa109827480cac3d$var$_$50872bf213056663$export$d51f3b55e8d1aa73 = (0, $8ANeE._)(function(raw) {
        var algorithm, buffer;
        var _arguments = arguments;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    algorithm = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "SHA-1";
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(buffer), function(byte) {
                            return byte.toString(16).padStart(2, "0");
                        }).join("")
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$50872bf213056663$export$d51f3b55e8d1aa73.apply(this, arguments);
}
var $fa109827480cac3d$var$$93a3089d2937b23f$exports = {};
var $fa109827480cac3d$var$$3e0a089cc13f69ad$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $fa109827480cac3d$export$2ee022bbbc550b25;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $fa109827480cac3d$export$a549dd5cef7f8327;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $fa109827480cac3d$export$8eece510bcb9c62c;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $fa109827480cac3d$export$b8a1af58c024fefd;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $fa109827480cac3d$export$a2cf0d4bb6e06de4;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $fa109827480cac3d$export$d66b332881d9723f;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $fa109827480cac3d$export$b0709844452f8b6b;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $fa109827480cac3d$export$5118471ee5d5453b;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $fa109827480cac3d$export$be4650432daa84fd;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $fa109827480cac3d$export$578e38b4a3e0b255;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $fa109827480cac3d$export$7cd14c57bbb84350;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $fa109827480cac3d$export$5100419dfae0456d;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $fa109827480cac3d$export$28d9d24a8cd0ffc2;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $fa109827480cac3d$export$3f99968195accfaf;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $fa109827480cac3d$export$eafdbaa868ea9975;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $fa109827480cac3d$export$36a0c1ca2ae264fa;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $fa109827480cac3d$export$86d7c59254d6a2c9;
});
var $fa109827480cac3d$var$$3e0a089cc13f69ad$var$templateMap = {};
function $fa109827480cac3d$export$2ee022bbbc550b25(tagName) {
    if ($fa109827480cac3d$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $fa109827480cac3d$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    var spawn = document.createElement("template");
    spawn.innerHTML = "<".concat(tagName, " />");
    return $fa109827480cac3d$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $fa109827480cac3d$export$a549dd5cef7f8327(tagName) {
    var node = $fa109827480cac3d$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? "html" : "xml";
}
function $fa109827480cac3d$export$8eece510bcb9c62c(Class) {
    return $fa109827480cac3d$export$170f4e08cad8229d(Class, HTMLElement);
}
var $fa109827480cac3d$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $fa109827480cac3d$export$b8a1af58c024fefd(Class) {
    var name = $fa109827480cac3d$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var _ref = new Class(), tagName = _ref.tagName;
    $fa109827480cac3d$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $fa109827480cac3d$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                "sizes"
            ]
        ],
        [
            HTMLIFrameElement,
            [
                "sandbox"
            ]
        ],
        [
            HTMLObjectElement,
            [
                "form"
            ]
        ],
        [
            HTMLInputElement,
            [
                "form",
                "list"
            ]
        ],
        [
            HTMLButtonElement,
            [
                "form"
            ]
        ],
        [
            HTMLSelectElement,
            [
                "form"
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                "form"
            ]
        ],
        [
            HTMLOutputElement,
            [
                "form"
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                "form"
            ]
        ]
    ];
    var template = $fa109827480cac3d$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fTrHk._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $fa109827480cac3d$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement("template");
    spawn.innerHTML = HTML;
    return (0, $g3Qtd._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
function $fa109827480cac3d$export$b0709844452f8b6b(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "");
}
function $fa109827480cac3d$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $bt19i.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $g3Qtd._)(root.childNodes);
                if (!($fa109827480cac3d$export$dd1bc94b04021eeb(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $bt19i.__values)($fa109827480cac3d$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $fa109827480cac3d$export$be4650432daa84fd(root) {
    var text = "";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fa109827480cac3d$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && parentElement.getAttribute("aria-hidden") !== "true") {
                var _parentElement_getBoundingClientRect = parentElement.getBoundingClientRect(), width = _parentElement_getBoundingClientRect.width, height = _parentElement_getBoundingClientRect.height;
                if (width && height) text += nodeValue.trim().replace(/\s+/g, " ");
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $fa109827480cac3d$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $g3Qtd._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $fa109827480cac3d$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $e2743f9431be5140$export$71511d61b312f219)(_param, [
        "alternate"
    ]);
    var style = (0, $g3Qtd._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement("link");
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? "alternate " : "") + "stylesheet";
        link.href = URI;
        document.head.append(link);
    });
}
function $fa109827480cac3d$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "    ";
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $fTrHk._)(param, 2), key = _param[0], value = _param[1];
        return typeof value !== "object" ? "".concat(padding).concat($fa109827480cac3d$export$3f34ca2fef821bbd(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($fa109827480cac3d$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join("\n");
}
function $fa109827480cac3d$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $g3Qtd._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $fa109827480cac3d$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                "meta",
                "title",
                "link",
                "script"
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $g3Qtd._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $fa109827480cac3d$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $fTrHk._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === "top") window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: "smooth",
        block: align,
        inline: justify
    });
}
function $fa109827480cac3d$export$eafdbaa868ea9975(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ""), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $fTrHk._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $g3Qtd._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, "-");
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
}
function $fa109827480cac3d$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === "visible" ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $fTrHk._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener("visibilitychange", function() {
        return change(document.visibilityState === "visible" ? last | 1 : last & 2);
    });
}
function $fa109827480cac3d$export$86d7c59254d6a2c9(form) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = form.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            var type = field.type;
            if (!name || value === "") continue;
            var box = type !== "fieldset" && field.closest("fieldset");
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case "radio":
                case "checkbox":
                    if (checked) parsedValue = defaultValue ? $fa109827480cac3d$export$7ea17d45ecdcf634(defaultValue) : true;
                    else continue;
                    break;
                case "select-multiple":
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return $fa109827480cac3d$export$7ea17d45ecdcf634(value);
                    });
                    break;
                case "fieldset":
                    parsedValue = $fa109827480cac3d$export$86d7c59254d6a2c9(field);
                    break;
                case "file":
                    parsedValue = files && Array.from(files);
                    break;
                case "date":
                case "datetime-local":
                case "month":
                case "hidden":
                case "number":
                case "range":
                case "select-one":
                    parsedValue = $fa109827480cac3d$export$7ea17d45ecdcf634(value);
            }
            if (name in data) data[name] = [].concat(data[name], parsedValue);
            else data[name] = !(parsedValue instanceof Array) || !$fa109827480cac3d$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
var $fa109827480cac3d$var$$bb23e0c794fefbef$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $fa109827480cac3d$export$e772c8ff12451969;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $fa109827480cac3d$export$57207d71b8c929c8;
});
function $fa109827480cac3d$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $fa109827480cac3d$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (0, $8ANeE._)(function() {
        var result;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!stop) return [
                        3,
                        4
                    ];
                    result = executor();
                    if (!(result instanceof Promise)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        result
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        $fa109827480cac3d$export$e772c8ff12451969(seconds)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        0
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
    return function() {
        return stop = true;
    };
}
var $fa109827480cac3d$var$$19ed8aeb7905a045$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $fa109827480cac3d$export$10b1921597150314;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $fa109827480cac3d$export$3e2b244719956741;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $fa109827480cac3d$export$1d1d2ed6b55cf67f;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $fa109827480cac3d$export$2155c0b5a4b77fb8;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $fa109827480cac3d$export$9d97473344489dfc;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $fa109827480cac3d$export$d635d04af3887bbe;
});
function $fa109827480cac3d$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $fa109827480cac3d$export$3e2b244719956741 = typeof window !== "undefined" ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener("DOMContentLoaded", done);
        window.removeEventListener("load", done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener("DOMContentLoaded", done);
    window.addEventListener("load", done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === "complete" ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $fa109827480cac3d$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + "end", end);
            element.removeEventListener(scope + "cancel", cancel);
        }
        element.addEventListener(scope + "end", end);
        element.addEventListener(scope + "cancel", cancel);
    });
}
function $fa109827480cac3d$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return _server.apply(this, arguments);
    }
    function _server() {
        _server = (0, $8ANeE._)(function(_param) {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $bt19i.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $e2743f9431be5140$export$71511d61b312f219)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        });
        return _server.apply(this, arguments);
    }
    globalThis.addEventListener("message", server);
    return function() {
        return globalThis.removeEventListener("message", server);
    };
}
function $fa109827480cac3d$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "*";
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = $fa109827480cac3d$export$89912e019eef22aa();
            function handler(_param) {
                var _param_data = _param.data, id = _param_data.id, _$data = (0, $e2743f9431be5140$export$71511d61b312f219)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener("message", handler);
            }
            globalThis.addEventListener("message", handler);
            // @ts-ignore
            target.postMessage((0, $8b7df3d651e6781e$export$71511d61b312f219)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $fa109827480cac3d$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener("statechange", function() {
                if (this.state === "installed" && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}
var $fa109827480cac3d$var$$7a08303ce13c49c5$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $fa109827480cac3d$export$1b88f6b6d432a52a;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $fa109827480cac3d$export$b70f6380221b1350;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $fa109827480cac3d$export$75d6cbe4503e149;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $fa109827480cac3d$export$b2618d51188815c2;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $fa109827480cac3d$export$490814474ddbb428;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $fa109827480cac3d$export$3ea201dffb50dfef;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $fa109827480cac3d$export$d1012c7198c6b460;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $fa109827480cac3d$export$a35a418b7b17958e;
});
var $fa109827480cac3d$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to) {
        (0, $59v1D._)(this, $7a08303ce13c49c5$export$1b88f6b6d432a52a);
        this.from = from;
        this.to = to;
    }
    (0, $6DUu1._)($7a08303ce13c49c5$export$1b88f6b6d432a52a, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? "right" : "left";
                    case YL:
                        return YD > 0 ? "forward" : "backward";
                    case ZL:
                        return ZD > 0 ? "up" : "down";
                }
            }
        }
    ]);
    return $7a08303ce13c49c5$export$1b88f6b6d432a52a;
}();
function $fa109827480cac3d$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $fa109827480cac3d$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $fa109827480cac3d$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === "animation" ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === "ms" ? 1 : 1000);
}
function $fa109827480cac3d$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $fa109827480cac3d$export$1d1d2ed6b55cf67f(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $fa109827480cac3d$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $fa109827480cac3d$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $fa109827480cac3d$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $fa109827480cac3d$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    return $fa109827480cac3d$var$_$7a08303ce13c49c5$var$fadeOut.apply(this, arguments);
}
function $fa109827480cac3d$var$_$7a08303ce13c49c5$var$fadeOut() {
    $fa109827480cac3d$var$_$7a08303ce13c49c5$var$fadeOut = (0, $8ANeE._)(function(type, element, className, remove) {
        var end;
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $fa109827480cac3d$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = "none";
                    return [
                        2
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$7a08303ce13c49c5$var$fadeOut.apply(this, arguments);
}
function $fa109827480cac3d$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return $fa109827480cac3d$var$$7a08303ce13c49c5$var$fadeIn("transition", element, className, display);
}
function $fa109827480cac3d$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "block";
    return $fa109827480cac3d$var$$7a08303ce13c49c5$var$fadeIn("animation", element, className, display);
}
function $fa109827480cac3d$export$d1012c7198c6b460(element, className, remove) {
    return $fa109827480cac3d$var$$7a08303ce13c49c5$var$fadeOut("transition", element, className, remove);
}
function $fa109827480cac3d$export$a35a418b7b17958e(element, className, remove) {
    return $fa109827480cac3d$var$$7a08303ce13c49c5$var$fadeOut("animation", element, className, remove);
}
var $fa109827480cac3d$var$$69bd9f0117925302$exports = {};
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$69bd9f0117925302$exports, "describe", function() {
    return $fa109827480cac3d$export$cd5450f3a47e3789;
});
$fa109827480cac3d$var$$parcel$export($fa109827480cac3d$var$$69bd9f0117925302$exports, "it", function() {
    return $fa109827480cac3d$export$3486a10f30cf1ee4;
});
function $fa109827480cac3d$export$cd5450f3a47e3789(title, cases) {
    return $fa109827480cac3d$var$_$69bd9f0117925302$export$cd5450f3a47e3789.apply(this, arguments);
}
function $fa109827480cac3d$var$_$69bd9f0117925302$export$cd5450f3a47e3789() {
    $fa109827480cac3d$var$_$69bd9f0117925302$export$cd5450f3a47e3789 = (0, $8ANeE._)(function(title, cases) {
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$69bd9f0117925302$export$cd5450f3a47e3789.apply(this, arguments);
}
function $fa109827480cac3d$export$3486a10f30cf1ee4(title, userCase) {
    return $fa109827480cac3d$var$_$69bd9f0117925302$export$3486a10f30cf1ee4.apply(this, arguments);
}
function $fa109827480cac3d$var$_$69bd9f0117925302$export$3486a10f30cf1ee4() {
    $fa109827480cac3d$var$_$69bd9f0117925302$export$3486a10f30cf1ee4 = (0, $8ANeE._)(function(title, userCase) {
        var secondsOut;
        var _arguments = arguments;
        function timeOut() {
            return _timeOut.apply(this, arguments);
        }
        function _timeOut() {
            _timeOut = (0, $8ANeE._)(function() {
                return (0, $bt19i.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $fa109827480cac3d$export$e772c8ff12451969(secondsOut)
                            ];
                        case 1:
                            _state.sent();
                            throw new RangeError("Timed out");
                    }
                });
            });
            return _timeOut.apply(this, arguments);
        }
        return (0, $bt19i.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    secondsOut = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
                    title = "    " + title;
                    console.time(title);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(function(status) {
                                return console.assert(status, title);
                            }),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $fa109827480cac3d$var$_$69bd9f0117925302$export$3486a10f30cf1ee4.apply(this, arguments);
}


/**
 * @desc 页面结构
 * @author
 */ 
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8ANeE = parcelRequire("8ANeE");

var $59v1D = parcelRequire("59v1D");

var $fTrHk = parcelRequire("fTrHk");

var $bt19i = parcelRequire("bt19i");

var $33gHU = parcelRequire("33gHU");


var $dBs1W = parcelRequire("dBs1W");/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $59v1D = parcelRequire("59v1D");

var $6DUu1 = parcelRequire("6DUu1");

var $4msX2 = parcelRequire("4msX2");

var $fTrHk = parcelRequire("fTrHk");

var $g3Qtd = parcelRequire("g3Qtd");

var $jMsep = parcelRequire("jMsep");

var $33gHU = parcelRequire("33gHU");

var $dBs1W = parcelRequire("dBs1W");
function $826d0dca46b64dfb$var$_extends() {
    $826d0dca46b64dfb$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $826d0dca46b64dfb$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $826d0dca46b64dfb$export$3add0d5dce533e2e = /*#__PURE__*/ $33gHU.createContext(null);
var $826d0dca46b64dfb$export$145dfa71566a64dc = /*#__PURE__*/ $33gHU.createContext(null);
var $826d0dca46b64dfb$var$AwaitContext = /*#__PURE__*/ $33gHU.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $826d0dca46b64dfb$export$26749e8557646306 = /*#__PURE__*/ $33gHU.createContext(null);
var $826d0dca46b64dfb$export$c7914228fb69b0f5 = /*#__PURE__*/ $33gHU.createContext(null);
var $826d0dca46b64dfb$export$9072aa6dd1f93057 = /*#__PURE__*/ $33gHU.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $826d0dca46b64dfb$var$RouteErrorContext = /*#__PURE__*/ $33gHU.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $826d0dca46b64dfb$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    var _React_useContext = $33gHU.useContext($826d0dca46b64dfb$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $826d0dca46b64dfb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $dBs1W.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $826d0dca46b64dfb$export$9c954a9d03d32f4a() {
    return $33gHU.useContext($826d0dca46b64dfb$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $826d0dca46b64dfb$export$45d76561a5302f2b() {
    !$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    return $33gHU.useContext($826d0dca46b64dfb$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $826d0dca46b64dfb$export$1b3f31771c5d07c() {
    return $33gHU.useContext($826d0dca46b64dfb$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $826d0dca46b64dfb$export$6c330e8992e8a295(pattern) {
    !$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    var pathname = $826d0dca46b64dfb$export$45d76561a5302f2b().pathname;
    return $33gHU.useMemo(function() {
        return (0, $dBs1W.matchPath)(pattern, (0, $dBs1W.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $826d0dca46b64dfb$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $826d0dca46b64dfb$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $33gHU.useContext($826d0dca46b64dfb$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $33gHU.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $826d0dca46b64dfb$export$9770f232ac06a008() {
    var isDataRoute = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $826d0dca46b64dfb$var$useNavigateStable() : $826d0dca46b64dfb$var$useNavigateUnstable();
}
function $826d0dca46b64dfb$var$useNavigateUnstable() {
    !$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    var dataRouterContext = $33gHU.useContext($826d0dca46b64dfb$export$3add0d5dce533e2e);
    var _React_useContext = $33gHU.useContext($826d0dca46b64dfb$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057).matches;
    var _useLocation = $826d0dca46b64dfb$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $dBs1W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = $33gHU.useRef(false);
    $826d0dca46b64dfb$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $33gHU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $dBs1W.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dBs1W.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $826d0dca46b64dfb$var$OutletContext = /*#__PURE__*/ $33gHU.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $826d0dca46b64dfb$export$4138103a3ae699cc() {
    return $33gHU.useContext($826d0dca46b64dfb$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $826d0dca46b64dfb$export$a3be3530d8e40d0b(context) {
    var outlet = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $826d0dca46b64dfb$export$99eaa27ddbbb95ef() {
    var matches = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $826d0dca46b64dfb$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $33gHU.useContext($826d0dca46b64dfb$export$26749e8557646306).future;
    var matches = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057).matches;
    var _useLocation = $826d0dca46b64dfb$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $dBs1W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $33gHU.useMemo(function() {
        return (0, $dBs1W.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $826d0dca46b64dfb$export$5d3fca4a98652595(routes, locationArg) {
    return $826d0dca46b64dfb$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $826d0dca46b64dfb$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    var navigator = $33gHU.useContext($826d0dca46b64dfb$export$26749e8557646306).navigator;
    var _React_useContext = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $826d0dca46b64dfb$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $dBs1W.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $dBs1W.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $dBs1W.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $826d0dca46b64dfb$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $dBs1W.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $dBs1W.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $826d0dca46b64dfb$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $dBs1W.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $826d0dca46b64dfb$var$DefaultErrorComponent() {
    var error = $826d0dca46b64dfb$export$ed527bf60f6e05f2();
    var message = (0, $dBs1W.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, /*#__PURE__*/ $33gHU.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $33gHU.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $33gHU.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $826d0dca46b64dfb$var$defaultErrorElement = /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$DefaultErrorComponent, null);
var $826d0dca46b64dfb$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $4msX2._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $jMsep._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $59v1D._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $6DUu1._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($33gHU.Component);
function $826d0dca46b64dfb$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $33gHU.useContext($826d0dca46b64dfb$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $826d0dca46b64dfb$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $dBs1W.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $826d0dca46b64dfb$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $826d0dca46b64dfb$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $33gHU.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $826d0dca46b64dfb$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($826d0dca46b64dfb$var$DataRouterHook || {});
var $826d0dca46b64dfb$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($826d0dca46b64dfb$var$DataRouterStateHook || {});
function $826d0dca46b64dfb$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $826d0dca46b64dfb$var$useDataRouterContext(hookName) {
    var ctx = $33gHU.useContext($826d0dca46b64dfb$export$3add0d5dce533e2e);
    !ctx && (0, $dBs1W.UNSAFE_invariant)(false);
    return ctx;
}
function $826d0dca46b64dfb$var$useDataRouterState(hookName) {
    var state = $33gHU.useContext($826d0dca46b64dfb$export$145dfa71566a64dc);
    !state && (0, $dBs1W.UNSAFE_invariant)(false);
    return state;
}
function $826d0dca46b64dfb$var$useRouteContext(hookName) {
    var route = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057);
    !route && (0, $dBs1W.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $826d0dca46b64dfb$var$useCurrentRouteId(hookName) {
    var route = $826d0dca46b64dfb$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $dBs1W.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $826d0dca46b64dfb$export$5fc8298006ad9e58() {
    return $826d0dca46b64dfb$var$useCurrentRouteId($826d0dca46b64dfb$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $826d0dca46b64dfb$export$d0fd4b7106de2769() {
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $826d0dca46b64dfb$export$600dc272ed516c15() {
    var dataRouterContext = $826d0dca46b64dfb$var$useDataRouterContext($826d0dca46b64dfb$var$DataRouterHook.UseRevalidator);
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseRevalidator);
    return $33gHU.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $826d0dca46b64dfb$export$2378eb7f5ff86053() {
    var _useDataRouterState = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $33gHU.useMemo(function() {
        return matches.map(function(m) {
            return (0, $dBs1W.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $826d0dca46b64dfb$export$1448a5050d252c4d() {
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseLoaderData);
    var routeId = $826d0dca46b64dfb$var$useCurrentRouteId($826d0dca46b64dfb$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $826d0dca46b64dfb$export$fd5d37484eab868d(routeId) {
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $826d0dca46b64dfb$export$fdc00f3f26066d5e() {
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseActionData);
    var routeId = $826d0dca46b64dfb$var$useCurrentRouteId($826d0dca46b64dfb$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $826d0dca46b64dfb$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $33gHU.useContext($826d0dca46b64dfb$var$RouteErrorContext);
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseRouteError);
    var routeId = $826d0dca46b64dfb$var$useCurrentRouteId($826d0dca46b64dfb$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $826d0dca46b64dfb$export$78a72ddb39bdd145() {
    var value = $33gHU.useContext($826d0dca46b64dfb$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $826d0dca46b64dfb$export$17f53340677d5831() {
    var value = $33gHU.useContext($826d0dca46b64dfb$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $826d0dca46b64dfb$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $826d0dca46b64dfb$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $826d0dca46b64dfb$var$useDataRouterContext($826d0dca46b64dfb$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $826d0dca46b64dfb$var$useDataRouterState($826d0dca46b64dfb$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $fTrHk._)($33gHU.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $33gHU.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $826d0dca46b64dfb$var$_extends({}, currentLocation, {
                pathname: (0, $dBs1W.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $826d0dca46b64dfb$var$_extends({}, nextLocation, {
                pathname: (0, $dBs1W.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $33gHU.useEffect(function() {
        var key = String(++$826d0dca46b64dfb$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $33gHU.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $dBs1W.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $826d0dca46b64dfb$var$useNavigateStable() {
    var router = $826d0dca46b64dfb$var$useDataRouterContext($826d0dca46b64dfb$var$DataRouterHook.UseNavigateStable).router;
    var id = $826d0dca46b64dfb$var$useCurrentRouteId($826d0dca46b64dfb$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $33gHU.useRef(false);
    $826d0dca46b64dfb$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $33gHU.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $826d0dca46b64dfb$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $826d0dca46b64dfb$var$alreadyWarned = {};
function $826d0dca46b64dfb$var$warningOnce(key, cond, message) {
    if (!cond && !$826d0dca46b64dfb$var$alreadyWarned[key]) $826d0dca46b64dfb$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $826d0dca46b64dfb$var$START_TRANSITION = "startTransition";
var $826d0dca46b64dfb$var$startTransitionImpl = $33gHU[$826d0dca46b64dfb$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $826d0dca46b64dfb$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $fTrHk._)($33gHU.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        if (v7_startTransition && $826d0dca46b64dfb$var$startTransitionImpl) $826d0dca46b64dfb$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $33gHU.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $33gHU.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $33gHU.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $33gHU.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $826d0dca46b64dfb$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $826d0dca46b64dfb$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $826d0dca46b64dfb$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $33gHU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dBs1W.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $fTrHk._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $826d0dca46b64dfb$var$startTransitionImpl ? $826d0dca46b64dfb$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $826d0dca46b64dfb$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    var _React_useContext = $33gHU.useContext($826d0dca46b64dfb$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $33gHU.useContext($826d0dca46b64dfb$export$9072aa6dd1f93057).matches;
    var _useLocation = $826d0dca46b64dfb$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $826d0dca46b64dfb$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $dBs1W.resolveTo)(to, (0, $dBs1W.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $33gHU.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $826d0dca46b64dfb$export$910ae8079b2c2852(props) {
    return $826d0dca46b64dfb$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $826d0dca46b64dfb$export$e7b0ac011bb776c6(_props) {
    (0, $dBs1W.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $826d0dca46b64dfb$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $dBs1W.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$826d0dca46b64dfb$export$9c954a9d03d32f4a() && (0, $dBs1W.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $33gHU.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $826d0dca46b64dfb$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $dBs1W.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $33gHU.useMemo(function() {
        var trailingPathname = (0, $dBs1W.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $826d0dca46b64dfb$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $826d0dca46b64dfb$export$5d3fca4a98652595($826d0dca46b64dfb$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $826d0dca46b64dfb$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$ResolveAwait, null, children));
}
var $826d0dca46b64dfb$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($826d0dca46b64dfb$var$AwaitRenderStatus || {});
var $826d0dca46b64dfb$var$neverSettledPromise = new Promise(function() {});
var $826d0dca46b64dfb$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $4msX2._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $jMsep._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $59v1D._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $6DUu1._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $826d0dca46b64dfb$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $826d0dca46b64dfb$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $826d0dca46b64dfb$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $826d0dca46b64dfb$var$AwaitRenderStatus.error : "_data" in promise ? $826d0dca46b64dfb$var$AwaitRenderStatus.success : $826d0dca46b64dfb$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $826d0dca46b64dfb$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $826d0dca46b64dfb$var$AwaitRenderStatus.error && promise._error instanceof (0, $dBs1W.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $826d0dca46b64dfb$var$neverSettledPromise;
                if (status === $826d0dca46b64dfb$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $826d0dca46b64dfb$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $826d0dca46b64dfb$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $33gHU.createElement($826d0dca46b64dfb$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($33gHU.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $826d0dca46b64dfb$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $826d0dca46b64dfb$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $826d0dca46b64dfb$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $33gHU.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $33gHU.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $g3Qtd._)(parentPath).concat([
            index
        ]);
        if (element.type === $33gHU.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $826d0dca46b64dfb$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $826d0dca46b64dfb$export$e7b0ac011bb776c6) && (0, $dBs1W.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $dBs1W.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $826d0dca46b64dfb$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $826d0dca46b64dfb$export$daf73786167a7f72(matches) {
    return $826d0dca46b64dfb$var$_renderMatches(matches);
}
function $826d0dca46b64dfb$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $33gHU.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $33gHU.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $33gHU.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $826d0dca46b64dfb$export$f30f7e456d254e83(routes, opts) {
    return (0, $dBs1W.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $826d0dca46b64dfb$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dBs1W.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $826d0dca46b64dfb$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



var $dBs1W = parcelRequire("dBs1W");
function $684185656ea9d205$var$_extends() {
    $684185656ea9d205$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $684185656ea9d205$var$_extends.apply(this, arguments);
}
function $684185656ea9d205$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $684185656ea9d205$var$defaultMethod = "get";
var $684185656ea9d205$var$defaultEncType = "application/x-www-form-urlencoded";
function $684185656ea9d205$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $684185656ea9d205$var$isButtonElement(object) {
    return $684185656ea9d205$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $684185656ea9d205$var$isFormElement(object) {
    return $684185656ea9d205$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $684185656ea9d205$var$isInputElement(object) {
    return $684185656ea9d205$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $684185656ea9d205$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $684185656ea9d205$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$684185656ea9d205$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $684185656ea9d205$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $684185656ea9d205$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $684185656ea9d205$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $684185656ea9d205$var$_formDataSupportsSubmitter = null;
function $684185656ea9d205$var$isFormDataSubmitterSupported() {
    if ($684185656ea9d205$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $684185656ea9d205$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $684185656ea9d205$var$_formDataSupportsSubmitter = true;
    }
    return $684185656ea9d205$var$_formDataSupportsSubmitter;
}
var $684185656ea9d205$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $684185656ea9d205$var$getFormEncType(encType) {
    if (encType != null && !$684185656ea9d205$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $684185656ea9d205$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($684185656ea9d205$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $dBs1W.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $684185656ea9d205$var$defaultMethod;
        encType = $684185656ea9d205$var$getFormEncType(target.getAttribute("enctype")) || $684185656ea9d205$var$defaultEncType;
        formData = new FormData(target);
    } else if ($684185656ea9d205$var$isButtonElement(target) || $684185656ea9d205$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $dBs1W.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $684185656ea9d205$var$defaultMethod;
        encType = $684185656ea9d205$var$getFormEncType(target.getAttribute("formenctype")) || $684185656ea9d205$var$getFormEncType(form.getAttribute("enctype")) || $684185656ea9d205$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$684185656ea9d205$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($684185656ea9d205$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $684185656ea9d205$var$defaultMethod;
        action = null;
        encType = $684185656ea9d205$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $684185656ea9d205$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $684185656ea9d205$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $684185656ea9d205$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $684185656ea9d205$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $684185656ea9d205$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $684185656ea9d205$export$1f3f55432a00e06d(routes, opts) {
    return (0, $dBs1W.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $684185656ea9d205$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dBs1W.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $684185656ea9d205$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $826d0dca46b64dfb$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $684185656ea9d205$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $dBs1W.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $684185656ea9d205$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dBs1W.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $684185656ea9d205$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $826d0dca46b64dfb$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $684185656ea9d205$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $684185656ea9d205$var$_extends({}, state, {
        errors: $684185656ea9d205$var$deserializeErrors(state.errors)
    });
    return state;
}
function $684185656ea9d205$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fTrHk._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $dBs1W.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $684185656ea9d205$export$7ad602f0e94e62d1 = /*#__PURE__*/ $33gHU.createContext({
    isTransitioning: false
});
var $684185656ea9d205$export$148fd98d095596d4 = /*#__PURE__*/ $33gHU.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $684185656ea9d205$var$START_TRANSITION = "startTransition";
var $684185656ea9d205$var$startTransitionImpl = $33gHU[$684185656ea9d205$var$START_TRANSITION];
var $684185656ea9d205$var$FLUSH_SYNC = "flushSync";
var $684185656ea9d205$var$flushSyncImpl = $e1a300cc66774841$exports[$684185656ea9d205$var$FLUSH_SYNC];
var $684185656ea9d205$var$USE_ID = "useId";
var $684185656ea9d205$var$useIdImpl = $33gHU[$684185656ea9d205$var$USE_ID];
function $684185656ea9d205$var$startTransitionSafe(cb) {
    if ($684185656ea9d205$var$startTransitionImpl) $684185656ea9d205$var$startTransitionImpl(cb);
    else cb();
}
function $684185656ea9d205$var$flushSyncSafe(cb) {
    if ($684185656ea9d205$var$flushSyncImpl) $684185656ea9d205$var$flushSyncImpl(cb);
    else cb();
}
var $684185656ea9d205$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $59v1D._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $684185656ea9d205$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $fTrHk._)($33gHU.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $fTrHk._)($33gHU.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $fTrHk._)($33gHU.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $fTrHk._)($33gHU.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $fTrHk._)($33gHU.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $fTrHk._)($33gHU.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $33gHU.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $33gHU.useCallback(function(cb) {
        if (v7_startTransition) $684185656ea9d205$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $33gHU.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $684185656ea9d205$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $684185656ea9d205$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $684185656ea9d205$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $684185656ea9d205$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $684185656ea9d205$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $33gHU.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $33gHU.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $684185656ea9d205$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $33gHU.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $8ANeE._)(function() {
                return (0, $bt19i.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $33gHU.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $33gHU.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $33gHU.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $33gHU.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $33gHU.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $33gHU.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $33gHU.createElement($33gHU.Fragment, null, /*#__PURE__*/ $33gHU.createElement((0, $826d0dca46b64dfb$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $33gHU.createElement((0, $826d0dca46b64dfb$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $33gHU.createElement($684185656ea9d205$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $33gHU.createElement($684185656ea9d205$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $33gHU.createElement((0, $826d0dca46b64dfb$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $33gHU.createElement($684185656ea9d205$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $684185656ea9d205$var$MemoizedDataRoutes = /*#__PURE__*/ $33gHU.memo($684185656ea9d205$var$DataRoutes);
function $684185656ea9d205$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $826d0dca46b64dfb$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $684185656ea9d205$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $33gHU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dBs1W.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $fTrHk._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $684185656ea9d205$var$startTransitionImpl ? $684185656ea9d205$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement((0, $826d0dca46b64dfb$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $684185656ea9d205$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $33gHU.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dBs1W.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $fTrHk._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $684185656ea9d205$var$startTransitionImpl ? $684185656ea9d205$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement((0, $826d0dca46b64dfb$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $684185656ea9d205$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $fTrHk._)($33gHU.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $33gHU.useCallback(function(newState) {
        v7_startTransition && $684185656ea9d205$var$startTransitionImpl ? $684185656ea9d205$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $33gHU.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $33gHU.createElement((0, $826d0dca46b64dfb$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $684185656ea9d205$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $684185656ea9d205$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $684185656ea9d205$export$a6c7ac8248d6e38a = /*#__PURE__*/ $33gHU.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = $684185656ea9d205$var$_objectWithoutPropertiesLoose(_ref7, $684185656ea9d205$var$_excluded);
    var basename = $33gHU.useContext((0, $826d0dca46b64dfb$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $684185656ea9d205$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($684185656ea9d205$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $dBs1W.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $826d0dca46b64dfb$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $684185656ea9d205$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $33gHU.createElement("a", $684185656ea9d205$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $684185656ea9d205$export$b0d92dbee9b5b60d = /*#__PURE__*/ $33gHU.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = $684185656ea9d205$var$_objectWithoutPropertiesLoose(_ref8, $684185656ea9d205$var$_excluded2);
    var path = (0, $826d0dca46b64dfb$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $826d0dca46b64dfb$export$45d76561a5302f2b)();
    var routerState = $33gHU.useContext((0, $826d0dca46b64dfb$export$145dfa71566a64dc));
    var _React_useContext = $33gHU.useContext((0, $826d0dca46b64dfb$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $684185656ea9d205$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $dBs1W.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $33gHU.createElement($684185656ea9d205$export$a6c7ac8248d6e38a, $684185656ea9d205$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $684185656ea9d205$export$a7fed597f4b8afd8 = /*#__PURE__*/ $33gHU.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $684185656ea9d205$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = $684185656ea9d205$var$_objectWithoutPropertiesLoose(_ref9, $684185656ea9d205$var$_excluded3);
    var submit = $684185656ea9d205$export$47c85c6e3a081d3();
    var formAction = $684185656ea9d205$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $33gHU.createElement("form", $684185656ea9d205$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $684185656ea9d205$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $684185656ea9d205$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $684185656ea9d205$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($684185656ea9d205$var$DataRouterHook || ($684185656ea9d205$var$DataRouterHook = {}));
var $684185656ea9d205$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($684185656ea9d205$var$DataRouterStateHook || ($684185656ea9d205$var$DataRouterStateHook = {}));
// Internal hooks
function $684185656ea9d205$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $684185656ea9d205$var$useDataRouterContext(hookName) {
    var ctx = $33gHU.useContext((0, $826d0dca46b64dfb$export$3add0d5dce533e2e));
    !ctx && (0, $dBs1W.UNSAFE_invariant)(false);
    return ctx;
}
function $684185656ea9d205$var$useDataRouterState(hookName) {
    var state = $33gHU.useContext((0, $826d0dca46b64dfb$export$145dfa71566a64dc));
    !state && (0, $dBs1W.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $684185656ea9d205$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, $826d0dca46b64dfb$export$9770f232ac06a008)();
    var location = (0, $826d0dca46b64dfb$export$45d76561a5302f2b)();
    var path = (0, $826d0dca46b64dfb$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $33gHU.useCallback(function(event) {
        if ($684185656ea9d205$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $dBs1W.createPath)(location) === (0, $dBs1W.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $684185656ea9d205$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $33gHU.useRef($684185656ea9d205$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $33gHU.useRef(false);
    var location = (0, $826d0dca46b64dfb$export$45d76561a5302f2b)();
    var searchParams = $33gHU.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $684185656ea9d205$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $826d0dca46b64dfb$export$9770f232ac06a008)();
    var setSearchParams = $33gHU.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $684185656ea9d205$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $684185656ea9d205$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $684185656ea9d205$var$fetcherId = 0;
var $684185656ea9d205$var$getUniqueFetcherId = function() {
    return "__" + String(++$684185656ea9d205$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $684185656ea9d205$export$47c85c6e3a081d3() {
    var router = $684185656ea9d205$var$useDataRouterContext($684185656ea9d205$var$DataRouterHook.UseSubmit).router;
    var basename = $33gHU.useContext((0, $826d0dca46b64dfb$export$26749e8557646306)).basename;
    var currentRouteId = (0, $826d0dca46b64dfb$export$5fc8298006ad9e58)();
    return $33gHU.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $684185656ea9d205$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $684185656ea9d205$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $684185656ea9d205$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $684185656ea9d205$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $33gHU.useContext((0, $826d0dca46b64dfb$export$26749e8557646306)).basename;
    var routeContext = $33gHU.useContext((0, $826d0dca46b64dfb$export$9072aa6dd1f93057));
    !routeContext && (0, $dBs1W.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $fTrHk._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $684185656ea9d205$var$_extends({}, (0, $826d0dca46b64dfb$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $826d0dca46b64dfb$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dBs1W.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $dBs1W.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $684185656ea9d205$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $684185656ea9d205$var$useDataRouterContext($684185656ea9d205$var$DataRouterHook.UseFetcher).router;
    var state = $684185656ea9d205$var$useDataRouterState($684185656ea9d205$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $33gHU.useContext($684185656ea9d205$export$148fd98d095596d4);
    var route = $33gHU.useContext((0, $826d0dca46b64dfb$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $dBs1W.UNSAFE_invariant)(false);
    !route && (0, $dBs1W.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $dBs1W.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $684185656ea9d205$var$useIdImpl ? $684185656ea9d205$var$useIdImpl() : "";
    var _React_useState = (0, $fTrHk._)($33gHU.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($684185656ea9d205$var$getUniqueFetcherId());
    // Registration/cleanup
    $33gHU.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $33gHU.useCallback(function(href, opts) {
        !routeId && (0, $dBs1W.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $684185656ea9d205$export$47c85c6e3a081d3();
    var submit = $33gHU.useCallback(function(target, opts) {
        submitImpl(target, $684185656ea9d205$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $33gHU.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $33gHU.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $33gHU.createElement($684185656ea9d205$export$a7fed597f4b8afd8, $684185656ea9d205$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $dBs1W.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $33gHU.useMemo(function() {
        return $684185656ea9d205$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $684185656ea9d205$export$fa996778a3a31087() {
    var state = $684185656ea9d205$var$useDataRouterState($684185656ea9d205$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $fTrHk._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $684185656ea9d205$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $684185656ea9d205$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $684185656ea9d205$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $684185656ea9d205$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $684185656ea9d205$var$useDataRouterContext($684185656ea9d205$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $684185656ea9d205$var$useDataRouterState($684185656ea9d205$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $33gHU.useContext((0, $826d0dca46b64dfb$export$26749e8557646306)).basename;
    var location = (0, $826d0dca46b64dfb$export$45d76561a5302f2b)();
    var matches = (0, $826d0dca46b64dfb$export$2378eb7f5ff86053)();
    var navigation = (0, $826d0dca46b64dfb$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $33gHU.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $684185656ea9d205$var$usePageHide($33gHU.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $684185656ea9d205$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $684185656ea9d205$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($684185656ea9d205$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $33gHU.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $684185656ea9d205$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $684185656ea9d205$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $33gHU.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($684185656ea9d205$var$_extends({}, location, {
                    pathname: (0, $dBs1W.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($684185656ea9d205$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $33gHU.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $684185656ea9d205$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $33gHU.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $684185656ea9d205$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $33gHU.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $684185656ea9d205$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $826d0dca46b64dfb$export$b273b3273281a049)(when);
    $33gHU.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $33gHU.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $684185656ea9d205$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $33gHU.useContext($684185656ea9d205$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $dBs1W.UNSAFE_invariant)(false);
    var basename = $684185656ea9d205$var$useDataRouterContext($684185656ea9d205$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $826d0dca46b64dfb$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $dBs1W.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $dBs1W.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $dBs1W.matchPath)(path.pathname, nextPath) != null || (0, $dBs1W.matchPath)(path.pathname, currentPath) != null;
}



var $59v1D = parcelRequire("59v1D");

var $6DUu1 = parcelRequire("6DUu1");

var $4msX2 = parcelRequire("4msX2");

var $jMsep = parcelRequire("jMsep");


var $33gHU = parcelRequire("33gHU");
var $85c9ba2e2697c9a8$exports = {};

$85c9ba2e2697c9a8$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "fcc-logo.4661ac00.png";


var $a121f313927ed6d9$export$d9b273488cd8ce6f;
var $a121f313927ed6d9$export$39140c7d8b0ba7b3;
var $a121f313927ed6d9$export$2ddb90ad54e5f587;
var $a121f313927ed6d9$export$fb184b623420d9be;
$a121f313927ed6d9$export$d9b273488cd8ce6f = "xADzda_Menu";
$a121f313927ed6d9$export$39140c7d8b0ba7b3 = "xADzda_Nav";
$a121f313927ed6d9$export$2ddb90ad54e5f587 = "xADzda_Panel";
$a121f313927ed6d9$export$fb184b623420d9be = "xADzda_title";


var $91d6d90f0c403b88$export$d9b273488cd8ce6f = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $4msX2._)(Menu, Component);
    var _super = (0, $jMsep._)(Menu);
    function Menu() {
        (0, $59v1D._)(this, Menu);
        return _super.apply(this, arguments);
    }
    (0, $6DUu1._)(Menu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.onscroll = function(e) {
                // let top = this.scroll().top || 0;
                // 导航条滚动到一定高度，变换导航栏的背景色和透明度
                };
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                    className: $a121f313927ed6d9$export$d9b273488cd8ce6f,
                    children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                        className: $a121f313927ed6d9$export$39140c7d8b0ba7b3,
                        children: [
                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($85c9ba2e2697c9a8$exports)))
                            }),
                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", {
                                        href: "#/events",
                                        children: "\u5386\u53F2\u6D3B\u52A8"
                                    }),
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", {
                                        href: "https://web-conf.dev/",
                                        target: "_blank",
                                        children: "\u524D\u7AEF\u5927\u4F1A"
                                    }),
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", {
                                        href: "https://web-conf.dev/#2018/Code4City/",
                                        target: "_blank",
                                        children: "code for city"
                                    }),
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", {
                                        href: "#/sponsors",
                                        children: "\u8D5E\u52A9\u5546"
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Menu;
}((0, $33gHU.Component));



var $55702225e8ae47c0$export$5c0547b091a4b556;
$55702225e8ae47c0$export$5c0547b091a4b556 = "cZbCxG_MainContent";


var $f65357a60e386bb2$export$7c6e2c02157bb7d2 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
        className: $55702225e8ae47c0$export$5c0547b091a4b556,
        children: children
    });
};







var $fTrHk = parcelRequire("fTrHk");

var $g3Qtd = parcelRequire("g3Qtd");
var $8bd163097a5514bf$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $8bd163097a5514bf$exports) {
        classNames.default = classNames;
        $8bd163097a5514bf$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $33gHU = parcelRequire("33gHU");
function $0d29b93c2530cb3f$export$71511d61b312f219() {
    $0d29b93c2530cb3f$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d29b93c2530cb3f$export$71511d61b312f219.apply(this, arguments);
}


function $9f2f3e4cb1761177$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}





var $33gHU = parcelRequire("33gHU");

"use client";
var $c964a8ba6b4dafaa$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $c964a8ba6b4dafaa$export$ff817e17bad2e091 = "xs";
var $c964a8ba6b4dafaa$var$ThemeContext = /*#__PURE__*/ $33gHU.createContext({
    prefixes: {},
    breakpoints: $c964a8ba6b4dafaa$export$666ad80b5007f835,
    minBreakpoint: $c964a8ba6b4dafaa$export$ff817e17bad2e091
});
var $c964a8ba6b4dafaa$export$b631efc24e9d5e2f = $c964a8ba6b4dafaa$var$ThemeContext.Consumer, $c964a8ba6b4dafaa$var$Provider = $c964a8ba6b4dafaa$var$ThemeContext.Provider;
function $c964a8ba6b4dafaa$var$ThemeProvider(param) {
    var _param_prefixes = param.prefixes, prefixes = _param_prefixes === void 0 ? {} : _param_prefixes, _param_breakpoints = param.breakpoints, breakpoints = _param_breakpoints === void 0 ? $c964a8ba6b4dafaa$export$666ad80b5007f835 : _param_breakpoints, _param_minBreakpoint = param.minBreakpoint, minBreakpoint = _param_minBreakpoint === void 0 ? $c964a8ba6b4dafaa$export$ff817e17bad2e091 : _param_minBreakpoint, dir = param.dir, children = param.children;
    var contextValue = (0, $33gHU.useMemo)(function() {
        return {
            prefixes: (0, $8b7df3d651e6781e$export$71511d61b312f219)({}, prefixes),
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        };
    }, [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)($c964a8ba6b4dafaa$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $c964a8ba6b4dafaa$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $33gHU.useContext)($c964a8ba6b4dafaa$var$ThemeContext).prefixes;
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $c964a8ba6b4dafaa$export$8970c8db816a5863() {
    var breakpoints = (0, $33gHU.useContext)($c964a8ba6b4dafaa$var$ThemeContext).breakpoints;
    return breakpoints;
}
function $c964a8ba6b4dafaa$export$d926d6ef38f3fd32() {
    var minBreakpoint = (0, $33gHU.useContext)($c964a8ba6b4dafaa$var$ThemeContext).minBreakpoint;
    return minBreakpoint;
}
function $c964a8ba6b4dafaa$export$35e511eefa30ac5a() {
    var dir = (0, $33gHU.useContext)($c964a8ba6b4dafaa$var$ThemeContext).dir;
    return dir === "rtl";
}
function $c964a8ba6b4dafaa$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    var prefix = opts.prefix, _opts_forwardRefAs = opts.forwardRefAs, forwardRefAs = _opts_forwardRefAs === void 0 ? isClassy ? "ref" : "innerRef" : _opts_forwardRefAs;
    var Wrapped = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
        var props = (0, $0d29b93c2530cb3f$export$71511d61b312f219)({}, (0, $9f2f3e4cb1761177$export$71511d61b312f219)(_param));
        props[forwardRefAs] = ref;
        var bsPrefix = $c964a8ba6b4dafaa$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, props), {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(".concat(Component.displayName || Component.name, ")");
    return Wrapped;
}
var $c964a8ba6b4dafaa$export$2e2bcd8739ae039 = $c964a8ba6b4dafaa$var$ThemeProvider;



"use client";
function $aa90d9fac4b169d8$export$2ed43d61a0a9f5a3(_param) {
    var as = _param.as, bsPrefix = _param.bsPrefix, className = _param.className, props = (0, $e2743f9431be5140$export$71511d61b312f219)(_param, [
        "as",
        "bsPrefix",
        "className"
    ]);
    bsPrefix = (0, $c964a8ba6b4dafaa$export$7f387860ebffb32c)(bsPrefix, "col");
    var breakpoints = (0, $c964a8ba6b4dafaa$export$8970c8db816a5863)();
    var minBreakpoint = (0, $c964a8ba6b4dafaa$export$d926d6ef38f3fd32)();
    var spans = [];
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        var ref;
        if (typeof propValue === "object" && propValue != null) ref = propValue, span = ref.span, offset = ref.offset, order = ref.order, ref;
        else span = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : "";
        if (span) spans.push(span === true ? "".concat(bsPrefix).concat(infix) : "".concat(bsPrefix).concat(infix, "-").concat(span));
        if (order != null) classes.push("order".concat(infix, "-").concat(order));
        if (offset != null) classes.push("offset".concat(infix, "-").concat(offset));
    });
    return [
        (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, props), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
                className
            ].concat((0, $g3Qtd._)(spans), (0, $g3Qtd._)(classes)))
        }),
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
var $aa90d9fac4b169d8$var$Col = /*#__PURE__*/ $33gHU.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function(props, ref) {
    var _useCol = $aa90d9fac4b169d8$export$2ed43d61a0a9f5a3(props), _useCol1 = (0, $fTrHk._)(_useCol, 2), className = _useCol1[0].className, _useCol_ = _useCol1[1], tmp = _useCol_.as, Component = tmp === void 0 ? "div" : tmp, bsPrefix = _useCol_.bsPrefix, spans = _useCol_.spans, colProps = (0, $e2743f9431be5140$export$71511d61b312f219)(_useCol[0], [
        "className"
    ]);
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, colProps), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, !spans.length && bsPrefix)
    }));
});
$aa90d9fac4b169d8$var$Col.displayName = "Col";
var $aa90d9fac4b169d8$export$2e2bcd8739ae039 = $aa90d9fac4b169d8$var$Col;






var $33gHU = parcelRequire("33gHU");


"use client";
var $efb54010aeb5074e$var$Container = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, className = _param.className, props = (0, $e2743f9431be5140$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    var prefix = (0, $c964a8ba6b4dafaa$export$7f387860ebffb32c)(bsPrefix, "container");
    var suffix = typeof fluid === "string" ? "-".concat(fluid) : "-fluid";
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
    }));
});
$efb54010aeb5074e$var$Container.displayName = "Container";
var $efb54010aeb5074e$export$2e2bcd8739ae039 = $efb54010aeb5074e$var$Container;






var $33gHU = parcelRequire("33gHU");
var $dbf9032451b6d05a$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dbf9032451b6d05a$var$ReactIs, $dbf9032451b6d05a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$dbf9032451b6d05a$exports = (parcelRequire("dNvVv"))();




"use client";
var $ec9a66476ca207ba$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($dbf9032451b6d05a$exports))).bool
};
var $ec9a66476ca207ba$var$Image = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, _param_fluid = _param.fluid, fluid = _param_fluid === void 0 ? false : _param_fluid, _param_rounded = _param.rounded, rounded = _param_rounded === void 0 ? false : _param_rounded, _param_roundedCircle = _param.roundedCircle, roundedCircle = _param_roundedCircle === void 0 ? false : _param_roundedCircle, _param_thumbnail = _param.thumbnail, thumbnail = _param_thumbnail === void 0 ? false : _param_thumbnail, props = (0, $e2743f9431be5140$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    bsPrefix = (0, $c964a8ba6b4dafaa$export$7f387860ebffb32c)(bsPrefix, "img");
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))(className, fluid && "".concat(bsPrefix, "-fluid"), rounded && "rounded", roundedCircle && "rounded-circle", thumbnail && "".concat(bsPrefix, "-thumbnail"))
    }));
});
$ec9a66476ca207ba$var$Image.displayName = "Image";
var $ec9a66476ca207ba$export$2e2bcd8739ae039 = $ec9a66476ca207ba$var$Image;





var $g3Qtd = parcelRequire("g3Qtd");


var $33gHU = parcelRequire("33gHU");


"use client";
var $02be79ff10000d06$var$Row = /*#__PURE__*/ $33gHU.forwardRef(function(_param, ref) {
    var bsPrefix = _param.bsPrefix, className = _param.className, tmp = _param.// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as, Component = tmp === void 0 ? "div" : tmp, props = (0, $e2743f9431be5140$export$71511d61b312f219)(_param, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var decoratedBsPrefix = (0, $c964a8ba6b4dafaa$export$7f387860ebffb32c)(bsPrefix, "row");
    var breakpoints = (0, $c964a8ba6b4dafaa$export$8970c8db816a5863)();
    var minBreakpoint = (0, $c964a8ba6b4dafaa$export$d926d6ef38f3fd32)();
    var sizePrefix = "".concat(decoratedBsPrefix, "-cols");
    var classes = [];
    breakpoints.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && typeof propValue === "object") cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== minBreakpoint ? "-".concat(brkPoint) : "";
        if (cols != null) classes.push("".concat(sizePrefix).concat(infix, "-").concat(cols));
    });
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)(Component, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
        ref: ref
    }, props), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports))).apply(void 0, [
            className,
            decoratedBsPrefix
        ].concat((0, $g3Qtd._)(classes)))
    }));
});
$02be79ff10000d06$var$Row.displayName = "Row";
var $02be79ff10000d06$export$2e2bcd8739ae039 = $02be79ff10000d06$var$Row;



/**
 * @desc 关于我们
 * @author
 */ 
var $2d45e4c832d37fa8$exports = {};

$2d45e4c832d37fa8$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "qr-wechat.9b54fe52.jpg";


var $747dcc3411e25fa5$exports = {};

$747dcc3411e25fa5$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "qr-qq.8aec6868.jpg";


var $3057d89942630128$exports = {};

$3057d89942630128$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "qr-weibo.43835e29.png";


var $fbb4e39571ac8bf0$exports = {};

$fbb4e39571ac8bf0$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "qr-github.093ecf25.png";


var $3844ea8b49edd5d7$export$2e2bcd8739ae039 = [
    {
        desc: "\u5B98\u65B9\u5FAE\u4FE1\u516C\u4F17\u53F7",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($2d45e4c832d37fa8$exports))),
        icon: "icon-weixin"
    },
    {
        desc: "\u5B98\u65B9QQ\u7FA4",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($747dcc3411e25fa5$exports))),
        icon: "icon-iconfonticon6"
    },
    {
        desc: "\u5B98\u65B9\u5FAE\u535A",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($3057d89942630128$exports))),
        icon: "icon-weibo"
    },
    {
        desc: "\u5B98\u65B9github",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($fbb4e39571ac8bf0$exports))),
        icon: "icon-github"
    }
];


var $99bbe9a9781932f0$export$546aaea758714416;
var $99bbe9a9781932f0$export$2081b3fbfeee58da;
var $99bbe9a9781932f0$export$534219b709288da9;
var $99bbe9a9781932f0$export$63e5e3000483ac3;
$99bbe9a9781932f0$export$546aaea758714416 = "Zq5r6G_about-container";
$99bbe9a9781932f0$export$2081b3fbfeee58da = "Zq5r6G_about-panel";
$99bbe9a9781932f0$export$534219b709288da9 = "Zq5r6G_btn";
$99bbe9a9781932f0$export$63e5e3000483ac3 = "Zq5r6G_detail-img";


var $89f6ae905faa50e6$export$c8424c4d8ba2150 = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("ul", {
        className: "list-unstyled ".concat($99bbe9a9781932f0$export$546aaea758714416),
        children: (0, $3844ea8b49edd5d7$export$2e2bcd8739ae039).map(function(param, index) {
            var img = param.img, icon = param.icon;
            return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("li", {
                className: $99bbe9a9781932f0$export$2081b3fbfeee58da,
                children: [
                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                        className: $99bbe9a9781932f0$export$63e5e3000483ac3,
                        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                            src: img
                        })
                    }),
                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("button", {
                        id: "popover".concat(index),
                        type: "button",
                        className: $99bbe9a9781932f0$export$534219b709288da9,
                        "data-placement": "top",
                        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("i", {
                            className: "iconfont ".concat(icon)
                        })
                    })
                ]
            }, img);
        })
    });
};


var $d6e945108e08abf5$export$a06f1c675e846f6f;
var $d6e945108e08abf5$export$2ddb90ad54e5f587;
var $d6e945108e08abf5$export$3421a65118e23981;
var $d6e945108e08abf5$export$a80b3bd66acc52ff;
var $d6e945108e08abf5$export$eabcd2c8791e7bf4;
var $d6e945108e08abf5$export$6adf5661dea30ec;
var $d6e945108e08abf5$export$79ffe56a765070d2;
var $d6e945108e08abf5$export$e662f3d5d816c767;
var $d6e945108e08abf5$export$120ff0929b202a6d;
var $d6e945108e08abf5$export$fb184b623420d9be;
$d6e945108e08abf5$export$a06f1c675e846f6f = "_4hk93G_Footer";
$d6e945108e08abf5$export$2ddb90ad54e5f587 = "_4hk93G_Panel";
$d6e945108e08abf5$export$3421a65118e23981 = "_4hk93G_footer-bg";
$d6e945108e08abf5$export$a80b3bd66acc52ff = "_4hk93G_info";
$d6e945108e08abf5$export$eabcd2c8791e7bf4 = "_4hk93G_left";
$d6e945108e08abf5$export$6adf5661dea30ec = "_4hk93G_left-content";
$d6e945108e08abf5$export$79ffe56a765070d2 = "_4hk93G_right";
$d6e945108e08abf5$export$e662f3d5d816c767 = "_4hk93G_right-content";
$d6e945108e08abf5$export$120ff0929b202a6d = "_4hk93G_row";
$d6e945108e08abf5$export$fb184b623420d9be = "_4hk93G_title";


var $3ad834f13fd9b8b2$export$a06f1c675e846f6f = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("footer", {
        className: $d6e945108e08abf5$export$a06f1c675e846f6f,
        children: [
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $efb54010aeb5074e$export$2e2bcd8739ae039), {
                fluid: true,
                className: $d6e945108e08abf5$export$3421a65118e23981,
                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $02be79ff10000d06$export$2e2bcd8739ae039), {
                    className: "align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            md: 6,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                className: $d6e945108e08abf5$export$6adf5661dea30ec,
                                children: [
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $ec9a66476ca207ba$export$2e2bcd8739ae039), {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($85c9ba2e2697c9a8$exports))),
                                        alt: "FCC logo",
                                        fluid: true
                                    }),
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                        children: '"\u4EBA\u4EBA\u7686\u53EF\u7F16\u7A0B"\u8425\u9020\u6709\u6E29\u5EA6\u7684\u6280\u672F\u793E\u533A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            md: 6,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                                className: $d6e945108e08abf5$export$e662f3d5d816c767,
                                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $89f6ae905faa50e6$export$c8424c4d8ba2150), {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $efb54010aeb5074e$export$2e2bcd8739ae039), {
                fluid: true,
                className: $d6e945108e08abf5$export$a80b3bd66acc52ff,
                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $02be79ff10000d06$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            md: 6,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                className: "text-md-start",
                                children: "\u7248\u6743\u6240\u6709\xa92018 FCC\u6210\u90FD\u793E\u533A\u4FDD\u7559"
                            })
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            md: 6,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                className: "text-md-end",
                                children: "FCC\u6210\u90FD\u793E\u533A"
                            })
                        })
                    ]
                })
            })
        ]
    });
};



/**
 * @desc 宗旨、理念
 * @author
 */ 
var $fd47924679424a5a$exports = {};

$fd47924679424a5a$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "banner-icon.1989a6bf.png";


var $135d3a7fa6ccd1ce$export$f316edcbf748c37b;
var $135d3a7fa6ccd1ce$export$9217ca52f16e0cac;
var $135d3a7fa6ccd1ce$export$d653589df987fd93;
var $135d3a7fa6ccd1ce$export$6647df38c3b776d8;
var $135d3a7fa6ccd1ce$export$2ddb90ad54e5f587;
var $135d3a7fa6ccd1ce$export$b112b0abbb9d23d2;
var $135d3a7fa6ccd1ce$export$da4d1a746b80f94e;
var $135d3a7fa6ccd1ce$export$4d41916950f996b8;
var $135d3a7fa6ccd1ce$export$ed1dda45d5846a36;
var $135d3a7fa6ccd1ce$export$fb184b623420d9be;
$135d3a7fa6ccd1ce$export$f316edcbf748c37b = "vURCqa_BannerContainer";
$135d3a7fa6ccd1ce$export$9217ca52f16e0cac = "vURCqa_BannerIcon";
$135d3a7fa6ccd1ce$export$d653589df987fd93 = "vURCqa_MainContainer";
$135d3a7fa6ccd1ce$export$6647df38c3b776d8 = "vURCqa_MainLink";
$135d3a7fa6ccd1ce$export$2ddb90ad54e5f587 = "vURCqa_Panel";
$135d3a7fa6ccd1ce$export$b112b0abbb9d23d2 = "vURCqa_Slogan";
$135d3a7fa6ccd1ce$export$da4d1a746b80f94e = "vURCqa_SloganContainer";
$135d3a7fa6ccd1ce$export$4d41916950f996b8 = "vURCqa_SloganContent";
$135d3a7fa6ccd1ce$export$ed1dda45d5846a36 = "vURCqa_index-slogan";
$135d3a7fa6ccd1ce$export$fb184b623420d9be = "vURCqa_title";


var $9d9305f81c4f8e17$export$b112b0abbb9d23d2 = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
        className: "".concat($135d3a7fa6ccd1ce$export$2ddb90ad54e5f587, " ").concat($135d3a7fa6ccd1ce$export$ed1dda45d5846a36),
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
            className: "".concat($135d3a7fa6ccd1ce$export$d653589df987fd93, " ").concat($135d3a7fa6ccd1ce$export$f316edcbf748c37b),
            children: [
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                    className: $135d3a7fa6ccd1ce$export$da4d1a746b80f94e,
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("blockquote", {
                            className: $135d3a7fa6ccd1ce$export$b112b0abbb9d23d2,
                            children: [
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("strong", {
                                    children: '"\u4EBA\u4EBA\u7686\u53EF\u7F16\u7A0B"'
                                }),
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("span", {
                                    children: "\u8425\u9020\u6709\u6E29\u5EA6\u7684\u6280\u672F\u793E\u533A"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                            className: $135d3a7fa6ccd1ce$export$4d41916950f996b8,
                            children: "\u7ACB\u5373\u524D\u5F80\u7EBF\u4E0A\u5B66\u4E60\u5E73\u53F0"
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                            className: $135d3a7fa6ccd1ce$export$6647df38c3b776d8,
                            children: [
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", {
                                    href: "https://www.freecodecamp.org/chinese/",
                                    target: "_blank",
                                    children: "\u4E2D\u6587\u7248"
                                }),
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("a", {
                                    href: "https://www.freecodecamp.org/",
                                    target: "_blank",
                                    children: "English version"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                    className: $135d3a7fa6ccd1ce$export$9217ca52f16e0cac,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fd47924679424a5a$exports)))
                })
            ]
        })
    });
};


/**
 * @desc 社区介绍板块
 * @author
 */ 

var $218738b4fafa4935$export$526f4382efd7a17b;
var $218738b4fafa4935$export$2ddb90ad54e5f587;
var $218738b4fafa4935$export$fbf0aa84f3ee7d2a;
var $218738b4fafa4935$export$a0a5a7f280ecd616;
var $218738b4fafa4935$export$819df0953b32b8b3;
var $218738b4fafa4935$export$120ff0929b202a6d;
var $218738b4fafa4935$export$fb184b623420d9be;
$218738b4fafa4935$export$526f4382efd7a17b = "mPtzWW_ImagePanel";
$218738b4fafa4935$export$2ddb90ad54e5f587 = "mPtzWW_Panel";
$218738b4fafa4935$export$fbf0aa84f3ee7d2a = "mPtzWW_index-info";
$218738b4fafa4935$export$a0a5a7f280ecd616 = "mPtzWW_info-panel";
$218738b4fafa4935$export$819df0953b32b8b3 = "mPtzWW_info-row";
$218738b4fafa4935$export$120ff0929b202a6d = "mPtzWW_row";
$218738b4fafa4935$export$fb184b623420d9be = "mPtzWW_title";


var $599c6732a16b7928$exports = {};

$599c6732a16b7928$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "info1.954408a1.png";


var $c0e23f89c2808627$var$info1 = new URL($599c6732a16b7928$exports) + "";
var $1279c9b52e6b9958$exports = {};

$1279c9b52e6b9958$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "info2.815b0047.png";


var $c0e23f89c2808627$var$info2 = new URL($1279c9b52e6b9958$exports) + "";
var $c0e23f89c2808627$export$c4868e4a24d48fad = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
        className: "".concat($218738b4fafa4935$export$2ddb90ad54e5f587, " ").concat($218738b4fafa4935$export$fbf0aa84f3ee7d2a),
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
            className: $218738b4fafa4935$export$819df0953b32b8b3,
            children: [
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $02be79ff10000d06$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            xs: 12,
                            md: 5,
                            className: $218738b4fafa4935$export$526f4382efd7a17b,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                                src: $c0e23f89c2808627$var$info2,
                                alt: "Info 2"
                            })
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            xs: 12,
                            md: 7,
                            className: $218738b4fafa4935$export$a0a5a7f280ecd616,
                            children: [
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("h3", {
                                    className: $218738b4fafa4935$export$fb184b623420d9be,
                                    children: "freeCodeCamp \u662F\u4EC0\u4E48\uFF1F"
                                }),
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                    children: "freeCodeCamp(\u7B80\u79F0FCC)\xa0 \u662F\u7531\u7F8E\u56FD\u7684 Quincy Larson \u53D1\u8D77\u7684\u5F00\u6E90\u9879\u76EE\uFF0C\u622A\u6B622018.02.03\uFF0C\u5728 Github \u4E0A\u83B7\u5F9729+\u4E07Star(\u6392\u540D\u7B2C\u4E00)\u3002\u6709\u957F\u8FBE 1600 \u5C0F\u65F6\u7684\u8BFE\u7A0B\uFF0C \u5E76\u4E14\u662F\u57FA\u4E8E\u6D4F\u89C8\u5668\u3001\u8BFE\u7A0B\u514D\u8D39\u3001\u8BC1\u4E66\u514D\u8D39\u3001\u7ED3\u5408\u4E86\u6E38\u620F\u5316\u95EF\u5173\u7684\u4E50\u8DA3\u3002FCC\u662F\u4E00\u4E2A\u5728160\u591A\u4E2A\u56FD\u5BB6\u548C2000\u591A\u4E2A\u57CE\u5E02\u7684\u62E5\u6709\u4E0E100w +\u5F00\u53D1\u8005\u7684\u793E\u533A\u3002"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $02be79ff10000d06$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            xs: 12,
                            md: 8,
                            className: $218738b4fafa4935$export$a0a5a7f280ecd616,
                            children: [
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("h3", {
                                    className: $218738b4fafa4935$export$fb184b623420d9be,
                                    children: "FCC\u6210\u90FD\u793E\u533A"
                                }),
                                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                    children: "FCC \u6210\u90FD\u793E\u533A, \u6210\u7ACB\u4E8E2016\u5E746\u6708\uFF0C\u662F\u4E00\u4E2A\u975E\u8425\u5229\u6027\u7684\u516C\u76CA\u6027\u6280\u672F\u793E\u533A\uFF0C\u662F\u7531\u4E00\u7FA4\u70ED\u8840\u6709\u5FD7\u9752\u5E74\u7231\u597D\u8005\uFF0C\u5229\u7528\u4E2A\u4EBA\u4E1A\u4F59\u4F11\u606F\u65F6\u95F4\u7EC4\u5EFA\u800C\u6210\u7684\u6280\u672F\u793E\u533A\uFF0C\u76EE\u7684\u662F\u4E3A\u4E86\u642D\u5EFA\u4E00\u4E2A\u53CB\u597D\u7684\u4EA4\u6D41\u3001\u5B66\u4E60\u3001\u4E92\u52A9\u7684\u793E\u533A\uFF0C\u5E2E\u52A9\u6210\u90FD\u5E02\u4F17\u591A\u7684\u5F00\u53D1\u8005\uFF0C\u6280\u672F\u7231\u597D\u8005\u63D0\u5347\u4E2A\u4EBA\u6280\u672F\u80FD\u529B\u3002\u793E\u533A\u81F4\u529B\u4E8E\u505A\u897F\u5357\u5730\u533A\u9996\u4E2A\u6709\u6E29\u5EA6\u4E0E\u60C5\u6000\u7684\u6280\u672F\u793E\u533A\uFF0C\u9F13\u52B1\u4EBA\u4EBA\u7686\u53EF\u7F16\u7A0B\u5B9E\u73B0\u4E2A\u4EBA\u68A6\u60F3\u3002"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                            xs: 12,
                            md: 4,
                            className: $218738b4fafa4935$export$526f4382efd7a17b,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                                src: $c0e23f89c2808627$var$info1,
                                alt: "Info 1"
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/**
 * @desc 大事件记录、展示板块
 * @author
 */ 
var $59v1D = parcelRequire("59v1D");

var $6DUu1 = parcelRequire("6DUu1");

var $4msX2 = parcelRequire("4msX2");

var $jMsep = parcelRequire("jMsep");


var $33gHU = parcelRequire("33gHU");
/**
 * Swiper React 11.1.14
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 12, 2024
 */ 
var $6RwIG = parcelRequire("6RwIG");



var $fTrHk = parcelRequire("fTrHk");

var $33gHU = parcelRequire("33gHU");

var $59v1D = parcelRequire("59v1D");

var $6DUu1 = parcelRequire("6DUu1");

var $6RwIG = parcelRequire("6RwIG");



var $fTrHk = parcelRequire("fTrHk");

var $g3Qtd = parcelRequire("g3Qtd");
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $37568870cc180284$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $37568870cc180284$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($37568870cc180284$var$isObject(src[key]) && $37568870cc180284$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $37568870cc180284$var$extend(target[key], src[key]);
    });
}
var $37568870cc180284$var$ssrDocument = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $37568870cc180284$export$39b482c5e57630a8() {
    var doc = typeof document !== "undefined" ? document : {};
    $37568870cc180284$var$extend(doc, $37568870cc180284$var$ssrDocument);
    return doc;
}
var $37568870cc180284$var$ssrWindow = {
    document: $37568870cc180284$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $37568870cc180284$export$407448d2b89b1813() {
    var win = typeof window !== "undefined" ? window : {};
    $37568870cc180284$var$extend(win, $37568870cc180284$var$ssrWindow);
    return win;
}



var $6RwIG = parcelRequire("6RwIG");

var $g3Qtd = parcelRequire("g3Qtd");

function $f1851ae8473f6f1e$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter(function(c) {
        return !!c.trim();
    });
}
function $f1851ae8473f6f1e$export$d141bba7fdc215a3(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $f1851ae8473f6f1e$export$4368d992c4eafac0() {
    return Date.now();
}
function $f1851ae8473f6f1e$var$getComputedStyle(el) {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $f1851ae8473f6f1e$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = "x";
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $f1851ae8473f6f1e$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
            return a.replace(",", ".");
        }).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $f1851ae8473f6f1e$export$882b5998b3b9117c(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $f1851ae8473f6f1e$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $f1851ae8473f6f1e$export$efccba1c4a2ef57b() {
    var _arguments = arguments, _loop = function(i) {
        var nextSource = i < 0 || _arguments.length <= i ? undefined : _arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$f1851ae8473f6f1e$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($f1851ae8473f6f1e$export$882b5998b3b9117c(to[nextKey]) && $f1851ae8473f6f1e$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f1851ae8473f6f1e$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$f1851ae8473f6f1e$export$882b5998b3b9117c(to[nextKey]) && $f1851ae8473f6f1e$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f1851ae8473f6f1e$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    };
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var i = 1; i < arguments.length; i += 1)_loop(i);
    return to;
}
function $f1851ae8473f6f1e$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $f1851ae8473f6f1e$export$625550452a3fa3ec(_ref) {
    var swiper = _ref.swiper, targetPosition = _ref.targetPosition, side = _ref.side;
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? "next" : "prev";
    var isOutOfBound = function(current, target) {
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, $6RwIG._)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo((0, $6RwIG._)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $f1851ae8473f6f1e$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $f1851ae8473f6f1e$export$f1e1789686576879(element, selector) {
    var _children;
    if (selector === void 0) selector = "";
    var children = (0, $g3Qtd._)(element.children);
    if (element instanceof HTMLSlotElement) (_children = children).push.apply(_children, (0, $g3Qtd._)(element.assignedElements()));
    if (!selector) return children;
    return children.filter(function(el) {
        return el.matches(selector);
    });
}
function $f1851ae8473f6f1e$export$90a7f3efeed30595(el, parent) {
    var isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        var children = (0, $g3Qtd._)(parent.assignedElements());
        return children.includes(el);
    }
    return isChild;
}
function $f1851ae8473f6f1e$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $f1851ae8473f6f1e$export$db3b6bfb95261072(tag, classes) {
    var _el_classList;
    if (classes === void 0) classes = [];
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, $g3Qtd._)(Array.isArray(classes) ? classes : $f1851ae8473f6f1e$export$23f2a1d2818174ef(classes)));
    return el;
}
function $f1851ae8473f6f1e$export$8b22cf2602fb60ce(el) {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var document1 = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var box = el.getBoundingClientRect();
    var body = document1.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    var scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $f1851ae8473f6f1e$export$43caf9889c228507(el, selector) {
    var prevEls = [];
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $f1851ae8473f6f1e$export$9e5f44173e64f162(el, selector) {
    var nextEls = [];
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $f1851ae8473f6f1e$export$ffb5f4729a158638(el, prop) {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $f1851ae8473f6f1e$export$dda1d9f60106f0e9(el) {
    var child = el;
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $f1851ae8473f6f1e$export$407448d2b89b1813(el, selector) {
    var parents = []; // eslint-disable-line
    var parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $f1851ae8473f6f1e$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $f1851ae8473f6f1e$export$2d1720544b23b823(el, size, includeMargins) {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $f1851ae8473f6f1e$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter(function(e) {
        return !!e;
    });
}
function $f1851ae8473f6f1e$export$ae1af26003f05816(swiper) {
    return function(v) {
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


var $94e807446e39d4b4$var$support;
function $94e807446e39d4b4$var$calcSupport() {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var document1 = (0, $37568870cc180284$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $94e807446e39d4b4$var$getSupport() {
    if (!$94e807446e39d4b4$var$support) $94e807446e39d4b4$var$support = $94e807446e39d4b4$var$calcSupport();
    return $94e807446e39d4b4$var$support;
}
var $94e807446e39d4b4$var$deviceCached;
function $94e807446e39d4b4$var$calcDevice(_temp) {
    var userAgent = (_temp === void 0 ? {} : _temp).userAgent;
    var support = $94e807446e39d4b4$var$getSupport();
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var platform = window1.navigator.platform;
    var ua = userAgent || window1.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window1.screen.width;
    var screenHeight = window1.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === "Win32";
    var macos = platform === "MacIntel";
    // iPadOs 13 fix
    var iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $94e807446e39d4b4$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$94e807446e39d4b4$var$deviceCached) $94e807446e39d4b4$var$deviceCached = $94e807446e39d4b4$var$calcDevice(overrides);
    return $94e807446e39d4b4$var$deviceCached;
}
var $94e807446e39d4b4$var$browser;
function $94e807446e39d4b4$var$calcBrowser() {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var device = $94e807446e39d4b4$var$getDevice();
    var needPerspectiveFix = false;
    function isSafari() {
        var ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        var ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            var _ua_split__split__split_map = (0, $fTrHk._)(ua.split("Version/")[1].split(" ")[0].split(".").map(function(num) {
                return Number(num);
            }), 2), major = _ua_split__split__split_map[0], minor = _ua_split__split__split_map[1];
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    var isSafariBrowser = isSafari();
    var need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $94e807446e39d4b4$var$getBrowser() {
    if (!$94e807446e39d4b4$var$browser) $94e807446e39d4b4$var$browser = $94e807446e39d4b4$var$calcBrowser();
    return $94e807446e39d4b4$var$browser;
}
function $94e807446e39d4b4$var$Resize(_ref) {
    var swiper = _ref.swiper, on = _ref.on, emit = _ref.emit;
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window1.requestAnimationFrame(function() {
                var width = swiper.width, height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function(_ref2) {
                    var contentBoxSize = _ref2.contentBoxSize, contentRect = _ref2.contentRect, target = _ref2.target;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", function() {
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", function() {
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $94e807446e39d4b4$var$Observer(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var observers = [];
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var attach = function attach(target, options) {
        if (options === void 0) options = {};
        var ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, $f1851ae8473f6f1e$export$407448d2b89b1813)(swiper.hostEl);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $94e807446e39d4b4$var$eventsEmitter = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        events.split(" ").forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach(function(event) {
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $g3Qtd._)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $94e807446e39d4b4$var$updateSize() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(el, "padding-left") || 0, 10) - parseInt((0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(el, "padding-top") || 0, 10) - parseInt((0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $94e807446e39d4b4$var$updateSlides() {
    var swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, ".".concat(swiper.params.slideClass, ", swiper-slide"));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $f1851ae8473f6f1e$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $f1851ae8473f6f1e$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = void 0;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = "";
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $f1851ae8473f6f1e$export$2d1720544b23b823)(slide, "width", true) : (0, $f1851ae8473f6f1e$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, "width");
                var paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                var paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                var marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                var marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i2 = 0; i2 < groups; i2 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i3 = 0; i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i3 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = "".concat(spaceBetween, "px");
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        var offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize1 + offsetSize < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1 - offsetSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $f1851ae8473f6f1e$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "".concat(-snapGrid[0], "px"));
        (0, $f1851ae8473f6f1e$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $94e807446e39d4b4$var$updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = "".concat(newHeight, "px");
}
function $94e807446e39d4b4$var$updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    // eslint-disable-next-line
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
var $94e807446e39d4b4$var$toggleSlideClasses$1 = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $94e807446e39d4b4$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $94e807446e39d4b4$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $94e807446e39d4b4$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $94e807446e39d4b4$var$updateProgress(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd, progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
var $94e807446e39d4b4$var$toggleSlideClasses = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $94e807446e39d4b4$var$updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var getFilteredSlide = function(selector) {
        return (0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass).concat(selector, ", swiper-slide").concat(selector))[0];
    };
    var activeSlide;
    var prevSlide;
    var nextSlide;
    if (isVirtual) {
        if (params.loop) {
            var slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(slideIndex, '"]'));
        } else activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(activeIndex, '"]'));
    } else if (gridEnabled) {
        activeSlide = slides.filter(function(slideEl) {
            return slideEl.column === activeIndex;
        })[0];
        nextSlide = slides.filter(function(slideEl) {
            return slideEl.column === activeIndex + 1;
        })[0];
        prevSlide = slides.filter(function(slideEl) {
            return slideEl.column === activeIndex - 1;
        })[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $f1851ae8473f6f1e$export$9e5f44173e64f162)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $f1851ae8473f6f1e$export$43caf9889c228507)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
            params.loop;
        }
    }
    slides.forEach(function(slideEl) {
        $94e807446e39d4b4$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $94e807446e39d4b4$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $94e807446e39d4b4$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
var $94e807446e39d4b4$var$processLazyPreloader = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var slideSelector = function() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(".".concat(swiper.params.lazyPreloaderClass));
            else // init later
            requestAnimationFrame(function() {
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(".".concat(swiper.params.lazyPreloaderClass));
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
var $94e807446e39d4b4$var$unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
var $94e807446e39d4b4$var$preload = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, $g3Qtd._)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (preloadColumns.includes(slideEl.column)) $94e807446e39d4b4$var$unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $94e807446e39d4b4$var$unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) $94e807446e39d4b4$var$unlazy(swiper, i1);
    }
};
function $94e807446e39d4b4$var$getActiveIndexByTranslate(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $94e807446e39d4b4$var$updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $94e807446e39d4b4$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    var realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        var firstSlideInColumn = swiper.slides.filter(function(slideEl) {
            return slideEl.column === activeIndex;
        })[0];
        var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        var slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $94e807446e39d4b4$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $94e807446e39d4b4$var$updateClickedSlide(el, path) {
    var swiper = this;
    var params = swiper.params;
    var slide = el.closest(".".concat(params.slideClass, ", swiper-slide"));
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) (0, $g3Qtd._)(path.slice(path.indexOf(el) + 1, path.length)).forEach(function(pathEl) {
        if (!slide && pathEl.matches && pathEl.matches(".".concat(params.slideClass, ", swiper-slide"))) slide = pathEl;
    });
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $94e807446e39d4b4$var$update = {
    updateSize: $94e807446e39d4b4$var$updateSize,
    updateSlides: $94e807446e39d4b4$var$updateSlides,
    updateAutoHeight: $94e807446e39d4b4$var$updateAutoHeight,
    updateSlidesOffset: $94e807446e39d4b4$var$updateSlidesOffset,
    updateSlidesProgress: $94e807446e39d4b4$var$updateSlidesProgress,
    updateProgress: $94e807446e39d4b4$var$updateProgress,
    updateSlidesClasses: $94e807446e39d4b4$var$updateSlidesClasses,
    updateActiveIndex: $94e807446e39d4b4$var$updateActiveIndex,
    updateClickedSlide: $94e807446e39d4b4$var$updateClickedSlide
};
function $94e807446e39d4b4$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $f1851ae8473f6f1e$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $94e807446e39d4b4$var$setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)");
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $94e807446e39d4b4$var$minTranslate() {
    return -this.snapGrid[0];
}
function $94e807446e39d4b4$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $94e807446e39d4b4$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var _$minTranslate = swiper.minTranslate();
    var _$maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > _$minTranslate) newTranslate = _$minTranslate;
    else if (translateBounds && translate < _$maxTranslate) newTranslate = _$maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $f1851ae8473f6f1e$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $6RwIG._)(_obj, isH ? "left" : "top", -newTranslate), (0, $6RwIG._)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $94e807446e39d4b4$var$translate = {
    getTranslate: $94e807446e39d4b4$var$getSwiperTranslate,
    setTranslate: $94e807446e39d4b4$var$setTranslate,
    minTranslate: $94e807446e39d4b4$var$minTranslate,
    maxTranslate: $94e807446e39d4b4$var$maxTranslate,
    translateTo: $94e807446e39d4b4$var$translateTo
};
function $94e807446e39d4b4$var$setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = "".concat(duration, "ms");
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? "0ms" : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $94e807446e39d4b4$var$transitionEmit(_ref) {
    var swiper = _ref.swiper, runCallbacks = _ref.runCallbacks, direction = _ref.direction, step = _ref.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === "next") swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}
function $94e807446e39d4b4$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $94e807446e39d4b4$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $94e807446e39d4b4$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $94e807446e39d4b4$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $94e807446e39d4b4$var$transition = {
    setTransition: $94e807446e39d4b4$var$setTransition,
    transitionStart: $94e807446e39d4b4$var$transitionStart,
    transitionEnd: $94e807446e39d4b4$var$transitionEnd
};
function $94e807446e39d4b4$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // initial virtual
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $f1851ae8473f6f1e$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $6RwIG._)(_obj, isH ? "left" : "top", t), (0, $6RwIG._)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $94e807446e39d4b4$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    var newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            var targetSlideIndex;
            if (gridEnabled) {
                var slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex;
                })[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            var centeredSlides = swiper.params.centeredSlides;
            var slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            var needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                var direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                var slideIndex1 = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex1;
                })[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(function() {
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $94e807446e39d4b4$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(function() {
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $94e807446e39d4b4$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(function() {
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $94e807446e39d4b4$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $94e807446e39d4b4$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $94e807446e39d4b4$var$slideToClickedSlide() {
    var swiper = this;
    if (swiper.destroyed) return;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    var slideSelector = swiper.isElement ? "swiper-slide" : ".".concat(params.slideClass);
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
                (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
            (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $94e807446e39d4b4$var$slide = {
    slideTo: $94e807446e39d4b4$var$slideTo,
    slideToLoop: $94e807446e39d4b4$var$slideToLoop,
    slideNext: $94e807446e39d4b4$var$slideNext,
    slidePrev: $94e807446e39d4b4$var$slidePrev,
    slideReset: $94e807446e39d4b4$var$slideReset,
    slideToClosest: $94e807446e39d4b4$var$slideToClosest,
    slideToClickedSlide: $94e807446e39d4b4$var$slideToClickedSlide
};
function $94e807446e39d4b4$var$loopCreate(slideRealIndex) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    var initSlides = function() {
        var slides = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
        slides.forEach(function(el, index) {
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    var addBlankSlides = function(amountOfSlides) {
        for(var i = 0; i < amountOfSlides; i += 1){
            var slideEl = swiper.isElement ? (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f1851ae8473f6f1e$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd1 = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd1);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f1851ae8473f6f1e$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $94e807446e39d4b4$var$loopFix(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, slideRealIndex = _ref.slideRealIndex, _ref_slideTo = _ref.slideTo, _$slideTo = _ref_slideTo === void 0 ? true : _ref_slideTo, direction = _ref.direction, _$setTranslate = _ref.setTranslate, activeSlideIndex = _ref.activeSlideIndex, byController = _ref.byController, byMousewheel = _ref.byMousewheel;
    var swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    var centeredSlides = params.centeredSlides;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (_$slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    var slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    var loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, $f1851ae8473f6f1e$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $f1851ae8473f6f1e$export$3b14a55fb2447963)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter(function(el) {
        return el.classList.contains(params.slideActiveClass);
    })[0]);
    else activeIndex = activeSlideIndex;
    var isNext = direction === "next" || !direction;
    var isPrev = direction === "prev" || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    var activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    var activeColIndexWithShift = activeColIndex + (centeredSlides && typeof _$setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            var index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                var colIndexToPrepend = cols - index - 1;
                for(var i1 = slides.length - 1; i1 >= 0; i1 -= 1)if (slides[i1].column === colIndexToPrepend) prependSlidesIndexes.push(i1);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        var _loop = function(i2) {
            var index = i2 - Math.floor(i2 / cols) * cols;
            if (gridEnabled) slides.forEach(function(slide, slideIndex) {
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        };
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(var i2 = 0; i2 < slidesAppended; i2 += 1)_loop(i2);
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach(function(slide, slideIndex) {
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (_$slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (_$setTranslate) {
                var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff1;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff1;
                    }
                }
            } else {
                var shift1 = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift1, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: _$setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix((0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, loopParams), {
                slideTo: c.params.slidesPerView === params.slidesPerView ? _$slideTo : false
            }));
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix((0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, loopParams), {
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? _$slideTo : false
        }));
    }
    swiper.emit("loopFix");
}
function $94e807446e39d4b4$var$loopDestroy() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $94e807446e39d4b4$var$loop = {
    loopCreate: $94e807446e39d4b4$var$loopCreate,
    loopFix: $94e807446e39d4b4$var$loopFix,
    loopDestroy: $94e807446e39d4b4$var$loopDestroy
};
function $94e807446e39d4b4$var$setGrabCursor(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
function $94e807446e39d4b4$var$unsetGrabCursor() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
var $94e807446e39d4b4$var$grabCursor = {
    setGrabCursor: $94e807446e39d4b4$var$setGrabCursor,
    unsetGrabCursor: $94e807446e39d4b4$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $94e807446e39d4b4$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $37568870cc180284$export$39b482c5e57630a8)() || el === (0, $37568870cc180284$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $94e807446e39d4b4$var$preventEdgeSwipe(swiper, event, startX) {
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var params = swiper.params;
    var edgeSwipeDetection = params.edgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $94e807446e39d4b4$var$onTouchStart(event) {
    var swiper = this;
    var document1 = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $94e807446e39d4b4$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!(0, $f1851ae8473f6f1e$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    var eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $94e807446e39d4b4$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$94e807446e39d4b4$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === "mouse" || e.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $94e807446e39d4b4$var$onTouchMove(event) {
    var document1 = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        var id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    var targetTouch;
    if (e.type === "touchmove") {
        targetTouch = (0, $g3Qtd._)(e.changedTouches).filter(function(t) {
            return t.identifier === data.touchId;
        })[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== "mouse") document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    var isLoop = swiper.params.loop && !params.cssMode;
    var allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    var loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $94e807446e39d4b4$var$onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var targetTouch;
    var isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = (0, $g3Qtd._)(e.changedTouches).filter(function(t) {
            return t.identifier === data.touchId;
        })[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        var proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)();
    (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}
function $94e807446e39d4b4$var$onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $94e807446e39d4b4$var$onClick(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $94e807446e39d4b4$var$onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $94e807446e39d4b4$var$onLoad(e) {
    var swiper = this;
    $94e807446e39d4b4$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $94e807446e39d4b4$var$onDocumentTouchStart() {
    var swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
var $94e807446e39d4b4$var$events = function(swiper, method) {
    var document1 = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    var swiperMethod = method;
    if (!el || typeof el === "string") return;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $94e807446e39d4b4$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $94e807446e39d4b4$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $94e807446e39d4b4$var$attachEvents() {
    var swiper = this;
    var params = swiper.params;
    swiper.onTouchStart = $94e807446e39d4b4$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $94e807446e39d4b4$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $94e807446e39d4b4$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $94e807446e39d4b4$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $94e807446e39d4b4$var$onScroll.bind(swiper);
    swiper.onClick = $94e807446e39d4b4$var$onClick.bind(swiper);
    swiper.onLoad = $94e807446e39d4b4$var$onLoad.bind(swiper);
    $94e807446e39d4b4$var$events(swiper, "on");
}
function $94e807446e39d4b4$var$detachEvents() {
    var swiper = this;
    $94e807446e39d4b4$var$events(swiper, "off");
}
var $94e807446e39d4b4$var$events$1 = {
    attachEvents: $94e807446e39d4b4$var$attachEvents,
    detachEvents: $94e807446e39d4b4$var$detachEvents
};
var $94e807446e39d4b4$var$isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $94e807446e39d4b4$var$setBreakpoint() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $94e807446e39d4b4$var$isGridEnabled(swiper, params);
    var isMultiRow = $94e807446e39d4b4$var$isGridEnabled(swiper, breakpointParams);
    var wasGrabCursor = swiper.params.grabCursor;
    var isGrabCursor = breakpointParams.grabCursor;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(prop) {
        if (typeof breakpointParams[prop] === "undefined") return;
        var wasModuleEnabled = params[prop] && params[prop].enabled;
        var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    var wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    var hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $94e807446e39d4b4$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    var breakpoint = false;
    var window1 = (0, $37568870cc180284$export$407448d2b89b1813)();
    var currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === "window") {
            if (window1.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $94e807446e39d4b4$var$breakpoints = {
    setBreakpoint: $94e807446e39d4b4$var$setBreakpoint,
    getBreakpoint: $94e807446e39d4b4$var$getBreakpoint
};
function $94e807446e39d4b4$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === "object") Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $94e807446e39d4b4$var$addClasses() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // prettier-ignore
    var suffixes = $94e807446e39d4b4$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $g3Qtd._)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, $g3Qtd._)(classNames));
    swiper.emitContainerClasses();
}
function $94e807446e39d4b4$var$removeClasses() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    if (!el || typeof el === "string") return;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, $g3Qtd._)(classNames));
    swiper.emitContainerClasses();
}
var $94e807446e39d4b4$var$classes = {
    addClasses: $94e807446e39d4b4$var$addClasses,
    removeClasses: $94e807446e39d4b4$var$removeClasses
};
function $94e807446e39d4b4$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $94e807446e39d4b4$var$checkOverflow$1 = {
    checkOverflow: $94e807446e39d4b4$var$checkOverflow
};
var $94e807446e39d4b4$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $94e807446e39d4b4$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ var $94e807446e39d4b4$var$prototypes = {
    eventsEmitter: $94e807446e39d4b4$var$eventsEmitter,
    update: $94e807446e39d4b4$var$update,
    translate: $94e807446e39d4b4$var$translate,
    transition: $94e807446e39d4b4$var$transition,
    slide: $94e807446e39d4b4$var$slide,
    loop: $94e807446e39d4b4$var$loop,
    grabCursor: $94e807446e39d4b4$var$grabCursor,
    events: $94e807446e39d4b4$var$events$1,
    breakpoints: $94e807446e39d4b4$var$breakpoints,
    checkOverflow: $94e807446e39d4b4$var$checkOverflow$1,
    classes: $94e807446e39d4b4$var$classes
};
var $94e807446e39d4b4$var$extendedDefaults = {};
var $94e807446e39d4b4$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        var _swiper_modules;
        (0, $59v1D._)(this, Swiper);
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else ref = (0, $fTrHk._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        var document1 = (0, $37568870cc180284$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document1.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $94e807446e39d4b4$var$getSupport();
        swiper.device = $94e807446e39d4b4$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $94e807446e39d4b4$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $g3Qtd._)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, $g3Qtd._)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: $94e807446e39d4b4$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)({}, $94e807446e39d4b4$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)({}, swiperParams, $94e807446e39d4b4$var$extendedDefaults, params);
        swiper.originalParams = (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function() {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    (0, $6DUu1._)(Swiper, [
        {
            key: "getDirectionLabel",
            value: function getDirectionLabel(property) {
                if (this.isHorizontal()) return property;
                // prettier-ignore
                return ({
                    "width": "height",
                    "margin-top": "margin-left",
                    "margin-bottom ": "margin-right",
                    "margin-left": "margin-top",
                    "margin-right": "margin-bottom",
                    "padding-left": "padding-top",
                    "padding-right": "padding-bottom",
                    "marginRight": "marginBottom"
                })[property];
            }
        },
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
                var firstSlideIndex = (0, $f1851ae8473f6f1e$export$dda1d9f60106f0e9)(slides[0]);
                return (0, $f1851ae8473f6f1e$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") * 1 === index;
                })[0]);
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var swiper = this;
                var slidesEl = swiper.slidesEl, params = swiper.params;
                swiper.slides = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
            }
        },
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit("enable");
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit("disable");
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit("_containerClasses", cls.join(" "));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                if (swiper.destroyed) return "";
                return slideEl.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(" ");
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.forEach(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit("_slideClass", slideEl, classNames);
                });
                swiper.emit("_slideClasses", updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic(view, exact) {
                if (view === void 0) view = "current";
                if (exact === void 0) exact = false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (typeof params.slidesPerView === "number") return params.slidesPerView;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += Math.ceil(slides[i].swiperSlideSize);
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === "current") for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                (0, $g3Qtd._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) $94e807446e39d4b4$var$processLazyPreloader(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                        translated = swiper.slideTo(slides.length - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection, needUpdate) {
                if (needUpdate === void 0) needUpdate = true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
                swiper.el.classList.remove("".concat(swiper.params.containerModifierClass).concat(currentDirection));
                swiper.el.classList.add("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === "vertical") slideEl.style.width = "";
                    else slideEl.style.height = "";
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
                swiper.rtl = direction === "rtl";
                swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "rtl";
                } else {
                    swiper.el.classList.remove("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "ltr";
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // Find el
                var el = element || swiper.params.el;
                if (typeof el === "string") el = document.querySelector(el);
                if (!el) return false;
                el.swiper = swiper;
                if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || "").trim().split(" ").join("."));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, $f1851ae8473f6f1e$export$f1e1789686576879)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, $f1851ae8473f6f1e$export$f1e1789686576879)(el, ".".concat(swiper.params.slideClass)).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
                    hostEl: swiper.isElement ? el.parentNode.host : el,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === "rtl" || (0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(el, "direction") === "rtl",
                    rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(el, "direction") === "rtl"),
                    wrongRTL: (0, $f1851ae8473f6f1e$export$ffb5f4729a158638)(wrapperEl, "display") === "-webkit-box"
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var _lazyElements;
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit("beforeInit");
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                // Attach events
                swiper.attachEvents();
                var lazyElements = (0, $g3Qtd._)(swiper.el.querySelectorAll('[loading="lazy"]'));
                if (swiper.isElement) (_lazyElements = lazyElements).push.apply(_lazyElements, (0, $g3Qtd._)(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
                lazyElements.forEach(function(imageEl) {
                    if (imageEl.complete) $94e807446e39d4b4$var$processLazyPreloader(swiper, imageEl);
                    else imageEl.addEventListener("load", function(e) {
                        $94e807446e39d4b4$var$processLazyPreloader(swiper, e.target);
                    });
                });
                $94e807446e39d4b4$var$preload(swiper);
                // Init Flag
                swiper.initialized = true;
                $94e807446e39d4b4$var$preload(swiper);
                // Emit
                swiper.emit("init");
                swiper.emit("afterInit");
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy(deleteInstance, cleanStyles) {
                if (deleteInstance === void 0) deleteInstance = true;
                if (cleanStyles === void 0) cleanStyles = true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
                swiper.emit("beforeDestroy");
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    if (el && typeof el !== "string") el.removeAttribute("style");
                    if (wrapperEl) wrapperEl.removeAttribute("style");
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute("style");
                        slideEl.removeAttribute("data-swiper-slide-index");
                    });
                }
                swiper.emit("destroy");
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    if (swiper.el && typeof swiper.el !== "string") swiper.el.swiper = null;
                    (0, $f1851ae8473f6f1e$export$d141bba7fdc215a3)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $f1851ae8473f6f1e$export$efccba1c4a2ef57b)($94e807446e39d4b4$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $94e807446e39d4b4$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return $94e807446e39d4b4$export$4368d992c4eafac0;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($94e807446e39d4b4$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($94e807446e39d4b4$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $94e807446e39d4b4$export$25ce5a424b770e84.prototype[protoMethod] = $94e807446e39d4b4$var$prototypes[prototypeGroup][protoMethod];
    });
});
$94e807446e39d4b4$export$25ce5a424b770e84.use([
    $94e807446e39d4b4$var$Resize,
    $94e807446e39d4b4$var$Observer
]);


/* underscore in name -> watch for changes */ var $57170384bf1bf533$export$ffb5f4729a158638 = [
    "eventsPrefix",
    "injectStyles",
    "injectStylesUrls",
    "modules",
    "init",
    "_direction",
    "oneWayMovement",
    "swiperElementNodeName",
    "touchEventsTarget",
    "initialSlide",
    "_speed",
    "cssMode",
    "updateOnWindowResize",
    "resizeObserver",
    "nested",
    "focusableElements",
    "_enabled",
    "_width",
    "_height",
    "preventInteractionOnTransition",
    "userAgent",
    "url",
    "_edgeSwipeDetection",
    "_edgeSwipeThreshold",
    "_freeMode",
    "_autoHeight",
    "setWrapperSize",
    "virtualTranslate",
    "_effect",
    "breakpoints",
    "breakpointsBase",
    "_spaceBetween",
    "_slidesPerView",
    "maxBackfaceHiddenSlides",
    "_grid",
    "_slidesPerGroup",
    "_slidesPerGroupSkip",
    "_slidesPerGroupAuto",
    "_centeredSlides",
    "_centeredSlidesBounds",
    "_slidesOffsetBefore",
    "_slidesOffsetAfter",
    "normalizeSlideIndex",
    "_centerInsufficientSlides",
    "_watchOverflow",
    "roundLengths",
    "touchRatio",
    "touchAngle",
    "simulateTouch",
    "_shortSwipes",
    "_longSwipes",
    "longSwipesRatio",
    "longSwipesMs",
    "_followFinger",
    "allowTouchMove",
    "_threshold",
    "touchMoveStopPropagation",
    "touchStartPreventDefault",
    "touchStartForcePreventDefault",
    "touchReleaseOnEdges",
    "uniqueNavElements",
    "_resistance",
    "_resistanceRatio",
    "_watchSlidesProgress",
    "_grabCursor",
    "preventClicks",
    "preventClicksPropagation",
    "_slideToClickedSlide",
    "_loop",
    "loopAdditionalSlides",
    "loopAddBlankSlides",
    "loopPreventsSliding",
    "_rewind",
    "_allowSlidePrev",
    "_allowSlideNext",
    "_swipeHandler",
    "_noSwiping",
    "noSwipingClass",
    "noSwipingSelector",
    "passiveListeners",
    "containerModifierClass",
    "slideClass",
    "slideActiveClass",
    "slideVisibleClass",
    "slideFullyVisibleClass",
    "slideNextClass",
    "slidePrevClass",
    "slideBlankClass",
    "wrapperClass",
    "lazyPreloaderClass",
    "lazyPreloadPrevNext",
    "runCallbacksOnInit",
    "observer",
    "observeParents",
    "observeSlideChildren",
    // modules
    "a11y",
    "_autoplay",
    "_controller",
    "coverflowEffect",
    "cubeEffect",
    "fadeEffect",
    "flipEffect",
    "creativeEffect",
    "cardsEffect",
    "hashNavigation",
    "history",
    "keyboard",
    "mousewheel",
    "_navigation",
    "_pagination",
    "parallax",
    "_scrollbar",
    "_thumbs",
    "virtual",
    "zoom",
    "control"
];
function $57170384bf1bf533$export$23f2a1d2818174ef(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object" && !o.__swiper__;
}
function $57170384bf1bf533$export$f1e1789686576879(target, src) {
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(src).filter(function(key) {
        return noExtend.indexOf(key) < 0;
    }).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($57170384bf1bf533$export$23f2a1d2818174ef(src[key]) && $57170384bf1bf533$export$23f2a1d2818174ef(target[key]) && Object.keys(src[key]).length > 0) {
            if (src[key].__swiper__) target[key] = src[key];
            else $57170384bf1bf533$export$f1e1789686576879(target[key], src[key]);
        } else target[key] = src[key];
    });
}
function $57170384bf1bf533$export$7ccc53e8f1e7dfc5(params) {
    if (params === void 0) params = {};
    return params.navigation && typeof params.navigation.nextEl === "undefined" && typeof params.navigation.prevEl === "undefined";
}
function $57170384bf1bf533$export$407448d2b89b1813(params) {
    if (params === void 0) params = {};
    return params.pagination && typeof params.pagination.el === "undefined";
}
function $57170384bf1bf533$export$8b22cf2602fb60ce(params) {
    if (params === void 0) params = {};
    return params.scrollbar && typeof params.scrollbar.el === "undefined";
}
function $57170384bf1bf533$export$4368d992c4eafac0(classNames) {
    if (classNames === void 0) classNames = "";
    var classes = classNames.split(" ").map(function(c) {
        return c.trim();
    }).filter(function(c) {
        return !!c;
    });
    var unique = [];
    classes.forEach(function(c) {
        if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(" ");
}
function $57170384bf1bf533$export$db3b6bfb95261072(attrName) {
    if (attrName === void 0) attrName = "";
    return attrName.replace(/-[a-z]/g, function(l) {
        return l.toUpperCase().replace("-", "");
    });
}
function $57170384bf1bf533$export$efccba1c4a2ef57b(className) {
    if (className === void 0) className = "";
    if (!className) return "swiper-wrapper";
    if (!className.includes("swiper-wrapper")) return "swiper-wrapper ".concat(className);
    return className;
}
function $57170384bf1bf533$export$3b14a55fb2447963(_ref) {
    var swiper = _ref.swiper, slides = _ref.slides, passedParams = _ref.passedParams, changedParams = _ref.changedParams, nextEl = _ref.nextEl, prevEl = _ref.prevEl, scrollbarEl = _ref.scrollbarEl, paginationEl = _ref.paginationEl;
    var updateParams = changedParams.filter(function(key) {
        return key !== "children" && key !== "direction" && key !== "wrapperClass";
    });
    var currentParams = swiper.params, pagination = swiper.pagination, navigation = swiper.navigation, scrollbar = swiper.scrollbar, virtual = swiper.virtual, thumbs = swiper.thumbs;
    var needThumbsInit;
    var needControllerInit;
    var needPaginationInit;
    var needScrollbarInit;
    var needNavigationInit;
    var loopNeedDestroy;
    var loopNeedEnable;
    var loopNeedReloop;
    if (changedParams.includes("thumbs") && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) needThumbsInit = true;
    if (changedParams.includes("controller") && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) needControllerInit = true;
    if (changedParams.includes("pagination") && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) needPaginationInit = true;
    if (changedParams.includes("scrollbar") && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) needScrollbarInit = true;
    if (changedParams.includes("navigation") && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) needNavigationInit = true;
    var destroyModule = function(mod) {
        if (!swiper[mod]) return;
        swiper[mod].destroy();
        if (mod === "navigation") {
            if (swiper.isElement) {
                swiper[mod].prevEl.remove();
                swiper[mod].nextEl.remove();
            }
            currentParams[mod].prevEl = undefined;
            currentParams[mod].nextEl = undefined;
            swiper[mod].prevEl = undefined;
            swiper[mod].nextEl = undefined;
        } else {
            if (swiper.isElement) swiper[mod].el.remove();
            currentParams[mod].el = undefined;
            swiper[mod].el = undefined;
        }
    };
    if (changedParams.includes("loop") && swiper.isElement) {
        if (currentParams.loop && !passedParams.loop) loopNeedDestroy = true;
        else if (!currentParams.loop && passedParams.loop) loopNeedEnable = true;
        else loopNeedReloop = true;
    }
    updateParams.forEach(function(key) {
        if ($57170384bf1bf533$export$23f2a1d2818174ef(currentParams[key]) && $57170384bf1bf533$export$23f2a1d2818174ef(passedParams[key])) {
            Object.assign(currentParams[key], passedParams[key]);
            if ((key === "navigation" || key === "pagination" || key === "scrollbar") && "enabled" in passedParams[key] && !passedParams[key].enabled) destroyModule(key);
        } else {
            var newValue = passedParams[key];
            if ((newValue === true || newValue === false) && (key === "navigation" || key === "pagination" || key === "scrollbar")) {
                if (newValue === false) destroyModule(key);
            } else currentParams[key] = passedParams[key];
        }
    });
    if (updateParams.includes("controller") && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) swiper.controller.control = currentParams.controller.control;
    if (changedParams.includes("children") && slides && virtual && currentParams.virtual.enabled) {
        virtual.slides = slides;
        virtual.update(true);
    } else if (changedParams.includes("virtual") && virtual && currentParams.virtual.enabled) {
        if (slides) virtual.slides = slides;
        virtual.update(true);
    }
    if (changedParams.includes("children") && slides && currentParams.loop) loopNeedReloop = true;
    if (needThumbsInit) {
        var initialized = thumbs.init();
        if (initialized) thumbs.update(true);
    }
    if (needControllerInit) swiper.controller.control = currentParams.controller.control;
    if (needPaginationInit) {
        if (swiper.isElement && (!paginationEl || typeof paginationEl === "string")) {
            paginationEl = document.createElement("div");
            paginationEl.classList.add("swiper-pagination");
            paginationEl.part.add("pagination");
            swiper.el.appendChild(paginationEl);
        }
        if (paginationEl) currentParams.pagination.el = paginationEl;
        pagination.init();
        pagination.render();
        pagination.update();
    }
    if (needScrollbarInit) {
        if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === "string")) {
            scrollbarEl = document.createElement("div");
            scrollbarEl.classList.add("swiper-scrollbar");
            scrollbarEl.part.add("scrollbar");
            swiper.el.appendChild(scrollbarEl);
        }
        if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
        scrollbar.init();
        scrollbar.updateSize();
        scrollbar.setTranslate();
    }
    if (needNavigationInit) {
        if (swiper.isElement) {
            if (!nextEl || typeof nextEl === "string") {
                nextEl = document.createElement("div");
                nextEl.classList.add("swiper-button-next");
                nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
                nextEl.part.add("button-next");
                swiper.el.appendChild(nextEl);
            }
            if (!prevEl || typeof prevEl === "string") {
                prevEl = document.createElement("div");
                prevEl.classList.add("swiper-button-prev");
                prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
                prevEl.part.add("button-prev");
                swiper.el.appendChild(prevEl);
            }
        }
        if (nextEl) currentParams.navigation.nextEl = nextEl;
        if (prevEl) currentParams.navigation.prevEl = prevEl;
        navigation.init();
        navigation.update();
    }
    if (changedParams.includes("allowSlideNext")) swiper.allowSlideNext = passedParams.allowSlideNext;
    if (changedParams.includes("allowSlidePrev")) swiper.allowSlidePrev = passedParams.allowSlidePrev;
    if (changedParams.includes("direction")) swiper.changeDirection(passedParams.direction, false);
    if (loopNeedDestroy || loopNeedReloop) swiper.loopDestroy();
    if (loopNeedEnable || loopNeedReloop) swiper.loopCreate();
    swiper.update();
}



function $5227fbc8a624a908$export$39b482c5e57630a8(obj, splitEvents) {
    if (obj === void 0) obj = {};
    if (splitEvents === void 0) splitEvents = true;
    var params = {
        on: {}
    };
    var events = {};
    var passedParams = {};
    (0, $57170384bf1bf533$export$f1e1789686576879)(params, (0, $94e807446e39d4b4$export$4368d992c4eafac0));
    params._emitClasses = true;
    params.init = false;
    var rest = {};
    var allowedParams = (0, $57170384bf1bf533$export$ffb5f4729a158638).map(function(key) {
        return key.replace(/_/, "");
    });
    var plainObj = Object.assign({}, obj);
    Object.keys(plainObj).forEach(function(key) {
        if (typeof obj[key] === "undefined") return;
        if (allowedParams.indexOf(key) >= 0) {
            if ((0, $57170384bf1bf533$export$23f2a1d2818174ef)(obj[key])) {
                params[key] = {};
                passedParams[key] = {};
                (0, $57170384bf1bf533$export$f1e1789686576879)(params[key], obj[key]);
                (0, $57170384bf1bf533$export$f1e1789686576879)(passedParams[key], obj[key]);
            } else {
                params[key] = obj[key];
                passedParams[key] = obj[key];
            }
        } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === "function") {
            if (splitEvents) events["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
            else params.on["".concat(key[2].toLowerCase()).concat(key.substr(3))] = obj[key];
        } else rest[key] = obj[key];
    });
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(key) {
        if (params[key] === true) params[key] = {};
        if (params[key] === false) delete params[key];
    });
    return {
        params: params,
        passedParams: passedParams,
        rest: rest,
        events: events
    };
}
function $5227fbc8a624a908$export$953cecd6e717a553(_ref, swiperParams) {
    var el = _ref.el, nextEl = _ref.nextEl, prevEl = _ref.prevEl, paginationEl = _ref.paginationEl, scrollbarEl = _ref.scrollbarEl, swiper = _ref.swiper;
    if ((0, $57170384bf1bf533$export$7ccc53e8f1e7dfc5)(swiperParams) && nextEl && prevEl) {
        swiper.params.navigation.nextEl = nextEl;
        swiper.originalParams.navigation.nextEl = nextEl;
        swiper.params.navigation.prevEl = prevEl;
        swiper.originalParams.navigation.prevEl = prevEl;
    }
    if ((0, $57170384bf1bf533$export$407448d2b89b1813)(swiperParams) && paginationEl) {
        swiper.params.pagination.el = paginationEl;
        swiper.originalParams.pagination.el = paginationEl;
    }
    if ((0, $57170384bf1bf533$export$8b22cf2602fb60ce)(swiperParams) && scrollbarEl) {
        swiper.params.scrollbar.el = scrollbarEl;
        swiper.originalParams.scrollbar.el = scrollbarEl;
    }
    swiper.init(el);
}
function $5227fbc8a624a908$export$407448d2b89b1813(swiperParams, oldParams, children, oldChildren, getKey) {
    var keys = [];
    if (!oldParams) return keys;
    var addKey = function(key) {
        if (keys.indexOf(key) < 0) keys.push(key);
    };
    if (children && oldChildren) {
        var oldChildrenKeys = oldChildren.map(getKey);
        var childrenKeys = children.map(getKey);
        if (oldChildrenKeys.join("") !== childrenKeys.join("")) addKey("children");
        if (oldChildren.length !== children.length) addKey("children");
    }
    var watchParams = (0, $57170384bf1bf533$export$ffb5f4729a158638).filter(function(key) {
        return key[0] === "_";
    }).map(function(key) {
        return key.replace(/_/, "");
    });
    watchParams.forEach(function(key) {
        if (key in swiperParams && key in oldParams) {
            if ((0, $57170384bf1bf533$export$23f2a1d2818174ef)(swiperParams[key]) && (0, $57170384bf1bf533$export$23f2a1d2818174ef)(oldParams[key])) {
                var newKeys = Object.keys(swiperParams[key]);
                var oldKeys = Object.keys(oldParams[key]);
                if (newKeys.length !== oldKeys.length) addKey(key);
                else {
                    newKeys.forEach(function(newKey) {
                        if (swiperParams[key][newKey] !== oldParams[key][newKey]) addKey(key);
                    });
                    oldKeys.forEach(function(oldKey) {
                        if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
                    });
                }
            } else if (swiperParams[key] !== oldParams[key]) addKey(key);
        }
    });
    return keys;
}
var $5227fbc8a624a908$export$3b14a55fb2447963 = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) swiper.parallax.setTranslate();
};



function $04583d40f52ed51d$var$_extends() {
    $04583d40f52ed51d$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04583d40f52ed51d$var$_extends.apply(this, arguments);
}
function $04583d40f52ed51d$var$isChildSwiperSlide(child) {
    return child.type && child.type.displayName && child.type.displayName.includes("SwiperSlide");
}
function $04583d40f52ed51d$var$processChildren(c) {
    var slides = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Children.toArray(c).forEach(function(child) {
        if ($04583d40f52ed51d$var$isChildSwiperSlide(child)) slides.push(child);
        else if (child.props && child.props.children) $04583d40f52ed51d$var$processChildren(child.props.children).forEach(function(slide) {
            return slides.push(slide);
        });
    });
    return slides;
}
function $04583d40f52ed51d$var$getChildren(c) {
    var slides = [];
    var slots = {
        "container-start": [],
        "container-end": [],
        "wrapper-start": [],
        "wrapper-end": []
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Children.toArray(c).forEach(function(child) {
        if ($04583d40f52ed51d$var$isChildSwiperSlide(child)) slides.push(child);
        else if (child.props && child.props.slot && slots[child.props.slot]) slots[child.props.slot].push(child);
        else if (child.props && child.props.children) {
            var foundSlides = $04583d40f52ed51d$var$processChildren(child.props.children);
            if (foundSlides.length > 0) foundSlides.forEach(function(slide) {
                return slides.push(slide);
            });
            else slots["container-end"].push(child);
        } else slots["container-end"].push(child);
    });
    return {
        slides: slides,
        slots: slots
    };
}
function $04583d40f52ed51d$var$renderVirtual(swiper, slides, virtualData) {
    if (!virtualData) return null;
    var getSlideIndex = function(index) {
        var slideIndex = index;
        if (index < 0) slideIndex = slides.length + index;
        else if (slideIndex >= slides.length) // eslint-disable-next-line
        slideIndex = slideIndex - slides.length;
        return slideIndex;
    };
    var style = swiper.isHorizontal() ? (0, $6RwIG._)({}, swiper.rtlTranslate ? "right" : "left", "".concat(virtualData.offset, "px")) : {
        top: "".concat(virtualData.offset, "px")
    };
    var from = virtualData.from, to = virtualData.to;
    var loopFrom = swiper.params.loop ? -slides.length : 0;
    var loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
    var slidesToRender = [];
    for(var i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) slidesToRender.push(slides[getSlideIndex(i)]);
    return slidesToRender.map(function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).cloneElement(child, {
            swiper: swiper,
            style: style,
            key: child.props.virtualIndex || child.key || "slide-".concat(index)
        });
    });
}
function $04583d40f52ed51d$var$useIsomorphicLayoutEffect(callback, deps) {
    // eslint-disable-next-line
    if (typeof window === "undefined") return (0, $33gHU.useEffect)(callback, deps);
    return (0, $33gHU.useLayoutEffect)(callback, deps);
}
var $04583d40f52ed51d$var$SwiperSlideContext = /*#__PURE__*/ (0, $33gHU.createContext)(null);
var $04583d40f52ed51d$export$e17ab8f22f9ee1f5 = function() {
    return (0, $33gHU.useContext)($04583d40f52ed51d$var$SwiperSlideContext);
};
var $04583d40f52ed51d$var$SwiperContext = /*#__PURE__*/ (0, $33gHU.createContext)(null);
var $04583d40f52ed51d$export$28a6094880e3e9fd = function() {
    return (0, $33gHU.useContext)($04583d40f52ed51d$var$SwiperContext);
};
var $04583d40f52ed51d$export$6b3850921bc5a414 = /*#__PURE__*/ (0, $33gHU.forwardRef)(function(_temp, externalElRef) {
    var _ref = _temp === void 0 ? {} : _temp, className = _ref.className, tmp = _ref.tag, Tag = tmp === void 0 ? "div" : tmp, tmp1 = _ref.wrapperTag, WrapperTag = tmp1 === void 0 ? "div" : tmp1, children = _ref.children, onSwiper = _ref.onSwiper, rest = (0, $e2743f9431be5140$export$71511d61b312f219)(_ref, [
        "className",
        "tag",
        "wrapperTag",
        "children",
        "onSwiper"
    ]);
    var eventsAssigned = false;
    var _useState = (0, $fTrHk._)((0, $33gHU.useState)("swiper"), 2), containerClasses = _useState[0], setContainerClasses = _useState[1];
    var _useState1 = (0, $fTrHk._)((0, $33gHU.useState)(null), 2), virtualData = _useState1[0], setVirtualData = _useState1[1];
    var _useState2 = (0, $fTrHk._)((0, $33gHU.useState)(false), 2), breakpointChanged = _useState2[0], setBreakpointChanged = _useState2[1];
    var initializedRef = (0, $33gHU.useRef)(false);
    var swiperElRef = (0, $33gHU.useRef)(null);
    var swiperRef = (0, $33gHU.useRef)(null);
    var oldPassedParamsRef = (0, $33gHU.useRef)(null);
    var oldSlides = (0, $33gHU.useRef)(null);
    var nextElRef = (0, $33gHU.useRef)(null);
    var prevElRef = (0, $33gHU.useRef)(null);
    var paginationElRef = (0, $33gHU.useRef)(null);
    var scrollbarElRef = (0, $33gHU.useRef)(null);
    var _getParams = (0, $5227fbc8a624a908$export$39b482c5e57630a8)(rest), swiperParams = _getParams.params, passedParams = _getParams.passedParams, restProps = _getParams.rest, events = _getParams.events;
    var _getChildren = $04583d40f52ed51d$var$getChildren(children), slides = _getChildren.slides, slots = _getChildren.slots;
    var onBeforeBreakpoint = function() {
        setBreakpointChanged(!breakpointChanged);
    };
    Object.assign(swiperParams.on, {
        _containerClasses: function(swiper, classes) {
            setContainerClasses(classes);
        }
    });
    var initSwiper = function() {
        // init swiper
        Object.assign(swiperParams.on, events);
        eventsAssigned = true;
        var passParams = (0, $8b7df3d651e6781e$export$71511d61b312f219)({}, swiperParams);
        delete passParams.wrapperClass;
        swiperRef.current = new (0, $94e807446e39d4b4$export$25ce5a424b770e84)(passParams);
        if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
            swiperRef.current.virtual.slides = slides;
            var extendWith = {
                cache: false,
                slides: slides,
                renderExternal: setVirtualData,
                renderExternalUpdate: false
            };
            (0, $57170384bf1bf533$export$f1e1789686576879)(swiperRef.current.params.virtual, extendWith);
            (0, $57170384bf1bf533$export$f1e1789686576879)(swiperRef.current.originalParams.virtual, extendWith);
        }
    };
    if (!swiperElRef.current) initSwiper();
    // Listen for breakpoints change
    if (swiperRef.current) swiperRef.current.on("_beforeBreakpoint", onBeforeBreakpoint);
    var attachEvents = function() {
        if (eventsAssigned || !events || !swiperRef.current) return;
        Object.keys(events).forEach(function(eventName) {
            swiperRef.current.on(eventName, events[eventName]);
        });
    };
    var detachEvents = function() {
        if (!events || !swiperRef.current) return;
        Object.keys(events).forEach(function(eventName) {
            swiperRef.current.off(eventName, events[eventName]);
        });
    };
    (0, $33gHU.useEffect)(function() {
        return function() {
            if (swiperRef.current) swiperRef.current.off("_beforeBreakpoint", onBeforeBreakpoint);
        };
    });
    // set initialized flag
    (0, $33gHU.useEffect)(function() {
        if (!initializedRef.current && swiperRef.current) {
            swiperRef.current.emitSlidesClasses();
            initializedRef.current = true;
        }
    });
    // mount swiper
    $04583d40f52ed51d$var$useIsomorphicLayoutEffect(function() {
        if (externalElRef) externalElRef.current = swiperElRef.current;
        if (!swiperElRef.current) return;
        if (swiperRef.current.destroyed) initSwiper();
        (0, $5227fbc8a624a908$export$953cecd6e717a553)({
            el: swiperElRef.current,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            paginationEl: paginationElRef.current,
            scrollbarEl: scrollbarElRef.current,
            swiper: swiperRef.current
        }, swiperParams);
        if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
        // eslint-disable-next-line
        return function() {
            if (swiperRef.current && !swiperRef.current.destroyed) swiperRef.current.destroy(true, false);
        };
    }, []);
    // watch for params change
    $04583d40f52ed51d$var$useIsomorphicLayoutEffect(function() {
        attachEvents();
        var changedParams = (0, $5227fbc8a624a908$export$407448d2b89b1813)(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, function(c) {
            return c.key;
        });
        oldPassedParamsRef.current = passedParams;
        oldSlides.current = slides;
        if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) (0, $57170384bf1bf533$export$3b14a55fb2447963)({
            swiper: swiperRef.current,
            slides: slides,
            passedParams: passedParams,
            changedParams: changedParams,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            scrollbarEl: scrollbarElRef.current,
            paginationEl: paginationElRef.current
        });
        return function() {
            detachEvents();
        };
    });
    // update on virtual update
    $04583d40f52ed51d$var$useIsomorphicLayoutEffect(function() {
        (0, $5227fbc8a624a908$export$3b14a55fb2447963)(swiperRef.current);
    }, [
        virtualData
    ]);
    // bypass swiper instance to slides
    function renderSlides() {
        if (swiperParams.virtual) return $04583d40f52ed51d$var$renderVirtual(swiperRef.current, slides, virtualData);
        return slides.map(function(child, index) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).cloneElement(child, {
                swiper: swiperRef.current,
                swiperSlideIndex: index
            });
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement(Tag, $04583d40f52ed51d$var$_extends({
        ref: swiperElRef,
        className: (0, $57170384bf1bf533$export$4368d992c4eafac0)("".concat(containerClasses).concat(className ? " ".concat(className) : ""))
    }, restProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($04583d40f52ed51d$var$SwiperContext.Provider, {
        value: swiperRef.current
    }, slots["container-start"], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement(WrapperTag, {
        className: (0, $57170384bf1bf533$export$efccba1c4a2ef57b)(swiperParams.wrapperClass)
    }, slots["wrapper-start"], renderSlides(), slots["wrapper-end"]), (0, $57170384bf1bf533$export$7ccc53e8f1e7dfc5)(swiperParams) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        ref: prevElRef,
        className: "swiper-button-prev"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        ref: nextElRef,
        className: "swiper-button-next"
    })), (0, $57170384bf1bf533$export$8b22cf2602fb60ce)(swiperParams) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        ref: scrollbarElRef,
        className: "swiper-scrollbar"
    }), (0, $57170384bf1bf533$export$407448d2b89b1813)(swiperParams) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        ref: paginationElRef,
        className: "swiper-pagination"
    }), slots["container-end"]));
});
$04583d40f52ed51d$export$6b3850921bc5a414.displayName = "Swiper";
var $04583d40f52ed51d$export$5c2bcc76ee716566 = /*#__PURE__*/ (0, $33gHU.forwardRef)(function(_temp, externalRef) {
    var _ref = _temp === void 0 ? {} : _temp, tmp = _ref.tag, Tag = tmp === void 0 ? "div" : tmp, children = _ref.children, _ref_className = _ref.className, className = _ref_className === void 0 ? "" : _ref_className, swiper = _ref.swiper, zoom = _ref.zoom, lazy = _ref.lazy, virtualIndex = _ref.virtualIndex, swiperSlideIndex = _ref.swiperSlideIndex, rest = (0, $e2743f9431be5140$export$71511d61b312f219)(_ref, [
        "tag",
        "children",
        "className",
        "swiper",
        "zoom",
        "lazy",
        "virtualIndex",
        "swiperSlideIndex"
    ]);
    var slideElRef = (0, $33gHU.useRef)(null);
    var _useState = (0, $fTrHk._)((0, $33gHU.useState)("swiper-slide"), 2), slideClasses = _useState[0], setSlideClasses = _useState[1];
    var _useState1 = (0, $fTrHk._)((0, $33gHU.useState)(false), 2), lazyLoaded = _useState1[0], setLazyLoaded = _useState1[1];
    function updateClasses(_s, el, classNames) {
        if (el === slideElRef.current) setSlideClasses(classNames);
    }
    $04583d40f52ed51d$var$useIsomorphicLayoutEffect(function() {
        if (typeof swiperSlideIndex !== "undefined") slideElRef.current.swiperSlideIndex = swiperSlideIndex;
        if (externalRef) externalRef.current = slideElRef.current;
        if (!slideElRef.current || !swiper) return;
        if (swiper.destroyed) {
            if (slideClasses !== "swiper-slide") setSlideClasses("swiper-slide");
            return;
        }
        swiper.on("_slideClass", updateClasses);
        // eslint-disable-next-line
        return function() {
            if (!swiper) return;
            swiper.off("_slideClass", updateClasses);
        };
    });
    $04583d40f52ed51d$var$useIsomorphicLayoutEffect(function() {
        if (swiper && slideElRef.current && !swiper.destroyed) setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }, [
        swiper
    ]);
    var slideData = {
        isActive: slideClasses.indexOf("swiper-slide-active") >= 0,
        isVisible: slideClasses.indexOf("swiper-slide-visible") >= 0,
        isPrev: slideClasses.indexOf("swiper-slide-prev") >= 0,
        isNext: slideClasses.indexOf("swiper-slide-next") >= 0
    };
    var renderChildren = function() {
        return typeof children === "function" ? children(slideData) : children;
    };
    var onLoad = function() {
        setLazyLoaded(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement(Tag, $04583d40f52ed51d$var$_extends({
        ref: slideElRef,
        className: (0, $57170384bf1bf533$export$4368d992c4eafac0)("".concat(slideClasses).concat(className ? " ".concat(className) : "")),
        "data-swiper-slide-index": virtualIndex,
        onLoad: onLoad
    }, rest), zoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($04583d40f52ed51d$var$SwiperSlideContext.Provider, {
        value: slideData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof zoom === "number" ? zoom : undefined
    }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        className: "swiper-lazy-preloader"
    }))), !zoom && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement($04583d40f52ed51d$var$SwiperSlideContext.Provider, {
        value: slideData
    }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createElement("div", {
        className: "swiper-lazy-preloader"
    })));
});
$04583d40f52ed51d$export$5c2bcc76ee716566.displayName = "SwiperSlide";



var $g3Qtd = parcelRequire("g3Qtd");


function $aea4f6437cace9d8$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    var tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        var slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides, isLoop = _swiper_params.loop, initialSlide = _swiper_params.initialSlide;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        var from = activeIndex - slidesBefore;
        var to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach(function(slideEl) {
                slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        var getSlideIndex = function(index) {
            var slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter(function(el) {
            return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
        }).forEach(function(slideEl) {
            slideEl.remove();
        });
        else {
            var _loop = function(i) {
                if (i < from || i > to) {
                    var slideIndex = getSlideIndex(i);
                    swiper.slides.filter(function(el) {
                        return el.matches(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(slideIndex, '"], swiper-slide[data-swiper-slide-index="').concat(slideIndex, '"]'));
                    }).forEach(function(slideEl) {
                        slideEl.remove();
                    });
                }
            };
            for(var i = previousFrom; i <= previousTo; i += 1)_loop(i);
        }
        var loopFrom = isLoop ? -slides.length : 0;
        var loopTo = isLoop ? slides.length * 2 : slides.length;
        for(var i1 = loopFrom; i1 < loopTo; i1 += 1)if (i1 >= from && i1 <= to) {
            var slideIndex = getSlideIndex(i1);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i1 > previousTo) appendIndexes.push(slideIndex);
                if (i1 < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(var i2 = prependIndexes.length - 1; i2 >= 0; i2 -= 1){
            var index = prependIndexes[i2];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort(function(a, b) {
                return b - a;
            });
            prependIndexes.forEach(function(index) {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $f1851ae8473f6f1e$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach(function(slideEl) {
            slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var cachedEl = cache[cachedIndex];
                var cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach(function(key) {
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach(function(key) {
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", function() {
        if (!swiper.params.virtual.enabled) return;
        var domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            var slides = (0, $g3Qtd._)(swiper.slidesEl.children).filter(function(el) {
                return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
            });
            if (slides && slides.length) {
                swiper.virtual.slides = (0, $g3Qtd._)(slides);
                domSlidesAssigned = true;
                slides.forEach(function(slideEl, slideIndex) {
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on("init update resize", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $f1851ae8473f6f1e$export$2408f22a0fab9ae5)(swiper.wrapperEl, "--swiper-virtual-size", "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $02cc5c44e3a90982$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var window = (0, $37568870cc180284$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $f1851ae8473f6f1e$export$407448d2b89b1813)(swiper.el, ".".concat(swiper.params.slideClass, ", swiper-slide")).length > 0 && (0, $f1851ae8473f6f1e$export$407448d2b89b1813)(swiper.el, ".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var el = swiper.el;
            var swiperWidth = el.clientWidth;
            var swiperHeight = el.clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = (0, $f1851ae8473f6f1e$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $32ded400a4e8526f$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var window = (0, $37568870cc180284$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(".".concat(swiper.params.mousewheel.noMousewheelClass))) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        var targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent1.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
                        if (swiper.destroyed || !swiper.params) return;
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $g3Qtd = parcelRequire("g3Qtd");

function $5379b1a8a06e839e$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(swiper.el, ".".concat(checkProps[key]))[0];
            if (!element) {
                element = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $de90517a238f79bf$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        var res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = (0, $g3Qtd._)(document.querySelectorAll(el));
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        var params = swiper.params.navigation;
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            if (subEl) {
                var _subEl_classList;
                (_subEl_classList = subEl.classList)[disabled ? "add" : "remove"].apply(_subEl_classList, (0, $g3Qtd._)(params.disabledClass.split(" ")));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $5379b1a8a06e839e$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        var nextEl = getEl(params.nextEl);
        var prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(prevEl);
        var initButton = function(el, dir) {
            var _el_classList;
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) (_el_classList = el.classList).add.apply(_el_classList, (0, $g3Qtd._)(params.lockClass.split(" ")));
        };
        nextEl.forEach(function(el) {
            return initButton(el, "next");
        });
        prevEl.forEach(function(el) {
            return initButton(el, "prev");
        });
    }
    function destroy() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(prevEl);
        var destroyButton = function(el, dir) {
            var _el_classList;
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $g3Qtd._)(swiper.params.navigation.disabledClass.split(" ")));
        };
        nextEl.forEach(function(el) {
            return destroyButton(el, "next");
        });
        prevEl.forEach(function(el) {
            return destroyButton(el, "prev");
        });
    }
    on("init", function() {
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", function() {
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        (0, $g3Qtd._)(nextEl).concat((0, $g3Qtd._)(prevEl)).filter(function(el) {
            return !!el;
        }).forEach(function(el) {
            return el.classList.add(swiper.params.navigation.lockClass);
        });
    });
    on("click", function(_s, e) {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(prevEl);
        var targetEl = e.target;
        var targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            var path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find(function(pathEl) {
                return nextEl.includes(pathEl) || prevEl.includes(pathEl);
            });
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            (0, $g3Qtd._)(nextEl).concat((0, $g3Qtd._)(prevEl)).filter(function(el) {
                return !!el;
            }).forEach(function(el) {
                return el.classList.toggle(swiper.params.navigation.hiddenClass);
            });
        }
    });
    var enable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $g3Qtd._)(swiper.params.navigation.navigationDisabledClass.split(" ")));
        init();
        update();
    };
    var disable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $g3Qtd._)(swiper.params.navigation.navigationDisabledClass.split(" ")));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $g3Qtd = parcelRequire("g3Qtd");
function $9eab12d7dfaea8f5$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return ".".concat(classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, "."));
}




function $6d242430f04388d6$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical"),
            paginationDisabledClass: "".concat(pfx, "-disabled")
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        if (!bulletEl) return;
        bulletEl = bulletEl["".concat(position === "prev" ? "previous" : "next", "ElementSibling")];
        if (bulletEl) {
            bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position));
            bulletEl = bulletEl["".concat(position === "prev" ? "previous" : "next", "ElementSibling")];
            if (bulletEl) bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return "next";
        else if (nextIndex === prevIndex - 1) return "previous";
        return;
    }
    function onBulletClick(e) {
        var bulletEl = e.target.closest((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        var index = (0, $f1851ae8473f6f1e$export$dda1d9f60106f0e9)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            var moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === "next") swiper.slideNext();
            else if (moveDirection === "previous") swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        // Current/Total
        var current;
        var previousIndex;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $f1851ae8473f6f1e$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach(function(subEl) {
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = "".concat(bulletSize * (params.dynamicMainBullets + 4), "px");
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach(function(bulletEl) {
                var _bulletEl_classList;
                var classesToRemove = (0, $g3Qtd._)([
                    "",
                    "-next",
                    "-next-next",
                    "-prev",
                    "-prev-prev",
                    "-main"
                ].map(function(suffix) {
                    return "".concat(params.bulletActiveClass).concat(suffix);
                })).map(function(s) {
                    return typeof s === "string" && s.includes(" ") ? s.split(" ") : s;
                }).flat();
                (_bulletEl_classList = bulletEl.classList).remove.apply(_bulletEl_classList, (0, $g3Qtd._)(classesToRemove));
            });
            if (el.length > 1) bullets.forEach(function(bullet) {
                var _bullet_classList;
                var bulletIndex = (0, $f1851ae8473f6f1e$export$dda1d9f60106f0e9)(bullet);
                if (bulletIndex === current) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $g3Qtd._)(params.bulletActiveClass.split(" ")));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    var _bullet_classList1;
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) (_bullet_classList1 = bullet.classList).add.apply(_bullet_classList1, (0, $g3Qtd._)("".concat(params.bulletActiveClass, "-main").split(" ")));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                var _bullet_classList;
                var bullet = bullets[current];
                if (bullet) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $g3Qtd._)(params.bulletActiveClass.split(" ")));
                if (swiper.isElement) bullets.forEach(function(bulletEl, bulletIndex) {
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    var _bullets_i_classList;
                    var firstDisplayedBullet = bullets[firstIndex];
                    var lastDisplayedBullet = bullets[lastIndex];
                    for(var i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) (_bullets_i_classList = bullets[i].classList).add.apply(_bullets_i_classList, (0, $g3Qtd._)("".concat(params.bulletActiveClass, "-main").split(" ")));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.forEach(function(bullet) {
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = "".concat(bulletsOffset, "px");
                });
            }
        }
        el.forEach(function(subEl, subElIndex) {
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(params.currentClass)).forEach(function(fractionEl) {
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(params.totalClass)).forEach(function(totalEl) {
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                var progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                var scale = (current + 1) / total;
                var scaleX = 1;
                var scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach(function(progressEl) {
                    progressEl.style.transform = "translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")");
                    progressEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        var el = swiper.pagination.el;
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += "<".concat(params.bulletElement, " ").concat(swiper.isElement ? 'part="bullet"' : "", ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + " / " + '<span class="'.concat(params.totalClass, '"></span>');
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
        }
        swiper.pagination.bullets = [];
        el.forEach(function(subEl) {
            var _swiper_pagination_bullets;
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") (_swiper_pagination_bullets = swiper.pagination.bullets).push.apply(_swiper_pagination_bullets, (0, $g3Qtd._)(subEl.querySelectorAll((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(params.bulletClass))));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $5379b1a8a06e839e$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = (0, $g3Qtd._)(document.querySelectorAll(params.el));
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = (0, $g3Qtd._)(swiper.el.querySelectorAll(params.el));
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter(function(subEl) {
                if ((0, $f1851ae8473f6f1e$export$407448d2b89b1813)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            var _subEl_classList;
            if (params.type === "bullets" && params.clickable) (_subEl_classList = subEl.classList).add.apply(_subEl_classList, (0, $g3Qtd._)((params.clickableClass || "").split(" ")));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add("".concat(params.modifierClass).concat(params.type, "-dynamic"));
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        var _subEl_classList;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    var _subEl_classList;
                    (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $g3Qtd._)((params.clickableClass || "").split(" ")));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function(subEl) {
            return (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $g3Qtd._)(params.bulletActiveClass.split(" ")));
        });
    }
    on("changeDirection", function() {
        if (!swiper.pagination || !swiper.pagination.el) return;
        var params = swiper.params.pagination;
        var el = swiper.pagination.el;
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", function() {
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", function() {
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", function() {
        update();
    });
    on("snapGridLengthChange", function() {
        render();
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                return subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass);
            });
        }
    });
    on("lock unlock", function() {
        update();
    });
    on("click", function(_s, e) {
        var targetEl = e.target;
        var el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach(function(subEl) {
                return subEl.classList.toggle(swiper.params.pagination.hiddenClass);
            });
        }
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                return subEl.classList.remove(swiper.params.pagination.paginationDisabledClass);
            });
        }
        init();
        render();
        update();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
            el.forEach(function(subEl) {
                return subEl.classList.add(swiper.params.pagination.paginationDisabledClass);
            });
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $g3Qtd = parcelRequire("g3Qtd");




function $de53f52630ee199f$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        var params = swiper.params.scrollbar;
        var progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = "translate3d(".concat(newPos, "px, 0, 0)");
            dragEl.style.width = "".concat(newSize, "px");
        } else {
            dragEl.style.transform = "translate3d(0px, ".concat(newPos, "px, 0)");
            dragEl.style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = "".concat(duration, "ms");
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = "".concat(dragSize, "px");
        else dragEl.style.height = "".concat(dragSize, "px");
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var el = scrollbar.el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $f1851ae8473f6f1e$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        var scrollbar = swiper.scrollbar, params = swiper.params;
        var el = scrollbar.el;
        if (!el) return;
        var target = el;
        var activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        var _el_classList;
        var scrollbar = swiper.scrollbar, swiperEl = swiper.el;
        swiper.params.scrollbar = (0, $5379b1a8a06e839e$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        var dragEl;
        if (el) {
            dragEl = el.querySelector((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) (_el_classList = el.classList)[swiper.enabled ? "remove" : "add"].apply(_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass)));
    }
    function destroy() {
        var _el_classList;
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList).remove.apply(_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass)));
        disableDraggable();
    }
    on("changeDirection", function() {
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", function() {
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", function() {
        updateSize();
    });
    on("setTranslate", function() {
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        setTransition(duration);
    });
    on("enable disable", function() {
        var _el_classList;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList)[swiper.enabled ? "remove" : "add"].apply(_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass)));
    });
    on("destroy", function() {
        destroy();
    });
    var enable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).remove.apply(_swiper_scrollbar_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        init();
        updateSize();
        setTranslate();
    };
    var disable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).add.apply(_swiper_scrollbar_el_classList, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass)));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



var $g3Qtd = parcelRequire("g3Qtd");

function $7a387e0246bb9d45$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var rtlFactor = rtl ? -1 : 1;
        var p = el.getAttribute("data-swiper-parallax") || "0";
        var x = el.getAttribute("data-swiper-parallax-x");
        var y = el.getAttribute("data-swiper-parallax-y");
        var scale = el.getAttribute("data-swiper-parallax-scale");
        var opacity = el.getAttribute("data-swiper-parallax-opacity");
        var rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf("%") >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        var transform = "translate3d(".concat(x, ", ").concat(y, ", 0px)");
        if (typeof scale !== "undefined" && scale !== null) {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += " scale(".concat(currentScale, ")");
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            var currentRotate = rotate * progress * -1;
            transform += " rotate(".concat(currentRotate, "deg)");
        }
        el.style.transform = transform;
    };
    var setTranslate = function() {
        var _elements;
        var el = swiper.el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid, isElement = swiper.isElement;
        var elements = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, $g3Qtd._)((0, $f1851ae8473f6f1e$export$f1e1789686576879)(swiper.hostEl, elementsSelector)));
        elements.forEach(function(subEl) {
            setTransform(subEl, progress);
        });
        slides.forEach(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll("".concat(elementsSelector, ", [data-swiper-parallax-rotate]")).forEach(function(subEl) {
                setTransform(subEl, slideProgress);
            });
        });
    };
    var setTransition = function setTransition(duration) {
        var _elements;
        if (duration === void 0) duration = swiper.params.speed;
        var el = swiper.el, hostEl = swiper.hostEl;
        var elements = (0, $g3Qtd._)(el.querySelectorAll(elementsSelector));
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, $g3Qtd._)(hostEl.querySelectorAll(elementsSelector)));
        elements.forEach(function(parallaxEl) {
            var parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = "".concat(parallaxDuration, "ms");
        });
    };
    on("beforeInit", function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $fTrHk = parcelRequire("fTrHk");

var $g3Qtd = parcelRequire("g3Qtd");


function $42cd78caf29b143a$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var window = (0, $37568870cc180284$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var fakeGestureTouched;
    var fakeGestureMoved;
    var evCache = [];
    var gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.imageEl;
                var slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        var x1 = evCache[0].pageX;
        var y1 = evCache[0].pageY;
        var x2 = evCache[1].pageX;
        var y2 = evCache[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    }
    function getMaxRatio() {
        var params = swiper.params.zoom;
        var maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            var imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        var box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    }
    function eventWithinSlide(e) {
        var slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter(function(slideEl) {
            return slideEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        var selector = ".".concat(swiper.params.zoom.containerClass);
        if (e.target.matches(selector)) return true;
        if ((0, $g3Qtd._)(swiper.hostEl.querySelectorAll(selector)).filter(function(containerEl) {
            return containerEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f1851ae8473f6f1e$export$407448d2b89b1813)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            var _getScaleOrigin = (0, $fTrHk._)(getScaleOrigin(), 2), originX = _getScaleOrigin[0], originY = _getScaleOrigin[1];
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    var allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(function() {
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        var event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $f1851ae8473f6f1e$export$35e795649ee09318)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $f1851ae8473f6f1e$export$35e795649ee09318)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        var touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        var scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        var originX = gesture.originX, originY = gesture.originY;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTouchEnd() {
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = "".concat(momentumDuration, "ms");
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    }
    function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove("".concat(swiper.params.zoom.zoomedSlideClass));
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f1851ae8473f6f1e$export$407448d2b89b1813)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        var forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        var maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $f1851ae8473f6f1e$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $f1851ae8473f6f1e$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)");
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    }
    function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f1851ae8473f6f1e$export$f1e1789686576879)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f1851ae8473f6f1e$export$407448d2b89b1813)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        var passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(eventName) {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(eventName) {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", function() {
        disable();
    });
    on("touchStart", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $g3Qtd = parcelRequire("g3Qtd");

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $7713c6a263a8adee$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $f1851ae8473f6f1e$export$7ccc53e8f1e7dfc5)(function() {
                    c.updateAutoHeight();
                });
                (0, $f1851ae8473f6f1e$export$342063e11d6c3cad)(c.wrapperEl, function() {
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", function() {
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            var controlElements = typeof swiper.params.controller.control === "string" ? (0, $g3Qtd._)(document.querySelectorAll(swiper.params.controller.control)) : [
                swiper.params.controller.control
            ];
            controlElements.forEach(function(controlElement) {
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    var eventName = "".concat(swiper.params.eventsPrefix, "init");
                    var onControllerSwiper = function(e) {
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", function() {
        removeSpline();
    });
    on("resize", function() {
        removeSpline();
    });
    on("observerUpdate", function() {
        removeSpline();
    });
    on("setTranslate", function(_s, translate, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", function(_s, duration, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $7e5edb7d7f82b72b$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    var liveRegion = null;
    var preventFocusHandler;
    var focusTargetSlideEl;
    var visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            var prevEls = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(swiper.navigation.prevEl);
            var nextEls = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach(function(bulletEl) {
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $f1851ae8473f6f1e$export$dda1d9f60106f0e9)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $9eab12d7dfaea8f5$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    var initNavEl = function(el, wrapperId, message) {
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    var handlePointerDown = function(e) {
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    var handlePointerUp = function() {
        preventFocusHandler = false;
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    var onVisibilityChange = function(e) {
        visibilityChangedTimestamp = new Date().getTime();
    };
    var handleFocus = function(e) {
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        var slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        var isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        var isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(function() {
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    var initSlides = function() {
        var params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        var slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach(function(slideEl, index) {
            var slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    var init = function() {
        var params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        var containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        var wrapperEl = swiper.wrapperEl;
        var wrapperId = params.id || wrapperEl.getAttribute("id") || "swiper-wrapper-".concat(getRandomNumber(16));
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        var _$_ref = swiper.navigation ? swiper.navigation : {}, nextEl = _$_ref.nextEl, prevEl = _$_ref.prevEl;
        nextEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.nextSlideMessage);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.prevSlideMessage);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        var _$_ref = swiper.navigation ? swiper.navigation : {}, nextEl = _$_ref.nextEl, prevEl = _$_ref.prevEl;
        nextEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return el.removeEventListener("keydown", onEnterOrSpaceKey);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return el.removeEventListener("keydown", onEnterOrSpaceKey);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, $f1851ae8473f6f1e$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("focus", handleFocus, true);
            swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
            swiper.el.removeEventListener("pointerup", handlePointerUp, true);
        }
    }
    on("beforeInit", function() {
        liveRegion = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", function() {
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function() {
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $dc5fe417d111dbff$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    var getPathValues = function(urlOverride) {
        var window = (0, $37568870cc180284$export$407448d2b89b1813)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, $37568870cc180284$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(index, '"]')) : swiper.slides[index];
        var value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = "".concat(root, "/").concat(key ? "".concat(key, "/") : "").concat(value);
        } else if (!location.pathname.includes(key)) value = "".concat(key ? "".concat(key, "/") : "").concat(value);
        if (swiper.params.history.keepQuery) value += location.search;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides[i];
            var slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                var index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    var init = function() {
        var window = (0, $37568870cc180284$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, $37568870cc180284$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", function() {
        if (swiper.params.history.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $d27fbcc7cda93be2$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, emit = _ref.emit, on = _ref.on;
    var initialized = false;
    var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
    var window = (0, $37568870cc180284$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex: function(_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    var slideWithHash = swiper.slides.filter(function(slideEl) {
                        return slideEl.getAttribute("data-hash") === hash;
                    })[0];
                    if (!slideWithHash) return 0;
                    var index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $f1851ae8473f6f1e$export$f1e1789686576879)(swiper.slidesEl, ".".concat(swiper.params.slideClass, '[data-hash="').concat(hash, '"], swiper-slide[data-hash="').concat(hash, '"]'))[0]);
            }
        }
    });
    var onHashChange = function() {
        emit("hashChange");
        var newHash = document.location.hash.replace("#", "");
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#".concat(activeSlideHash) || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            var index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHash();
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $4e14d5f5cae05a68$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit, params = _ref.params;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    var timeout;
    var raf;
    var autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayTimeLeft;
    var autoplayStartTime = new Date().getTime();
    var wasPaused;
    var isTouched;
    var pausedByTouch;
    var touchStartTimeout;
    var slideChanged;
    var pausedByInteraction;
    var pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    var calcTimeLeft = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        var timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(function() {
            calcTimeLeft();
        });
    };
    var getSlideDelay = function() {
        var activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter(function(slideEl) {
            return slideEl.classList.contains("swiper-slide-active");
        })[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        var currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    var run = function(delayForce) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        var delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        var currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        var speed = swiper.params.speed;
        var proceed = function() {
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(function() {
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                proceed();
            }, delay);
        } else requestAnimationFrame(function() {
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    var start = function() {
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    var stop = function() {
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    var pause = function(internal, reset) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        var proceed = function() {
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        var delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    var resume = function() {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    var onVisibilityChange = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    var onPointerEnter = function(e) {
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    var onPointerLeave = function(e) {
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    var attachMouseEvents = function() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    var detachMouseEvents = function() {
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("pointerenter", onPointerEnter);
            swiper.el.removeEventListener("pointerleave", onPointerLeave);
        }
    };
    var attachDocumentEvents = function() {
        var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    var detachDocumentEvents = function() {
        var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", function() {
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", function() {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", function() {
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", function() {
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", function(_s, speed, internal) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(function() {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", function() {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $548fb0b111aefd7f$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $f1851ae8473f6f1e$export$882b5998b3b9117c)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(function(slideEl) {
            return slideEl.classList.remove(thumbActiveClass);
        });
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)(0, $f1851ae8473f6f1e$export$f1e1789686576879)(thumbsSwiper.slidesEl, '[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).forEach(function(slideEl) {
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)if (thumbsSwiper.slides[swiper.realIndex + i1]) thumbsSwiper.slides[swiper.realIndex + i1].classList.add(thumbActiveClass);
        }
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                var newThumbsSlide = thumbsSwiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") === "".concat(swiper.realIndex);
                })[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            var document = (0, $37568870cc180284$export$39b482c5e57630a8)();
            var getThumbsElementAndInit = function() {
                var thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    var eventName = "".concat(swiper.params.eventsPrefix, "init");
                    var onThumbsSwiper = function(e) {
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            var watchForThumbsToAppear = function() {
                if (swiper.destroyed) return;
                var thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", function() {
        update();
    });
    on("setTransition", function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $3a65d712b1820dd6$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, emit = _ref.emit, once = _ref.once;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        var translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        var data = swiper.touchEventsData, touches = swiper.touches;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        var currentPos = _ref2.currentPos;
        if (swiper.params.cssMode) return;
        var params = swiper.params, wrapperEl = swiper.wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData;
        // Time diff
        var touchEndTime = (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $f1851ae8473f6f1e$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $f1851ae8473f6f1e$export$342063e11d6c3cad)(wrapperEl, function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        (0, $f1851ae8473f6f1e$export$342063e11d6c3cad)(wrapperEl, function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $f1851ae8473f6f1e$export$342063e11d6c3cad)(wrapperEl, function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}



var $g3Qtd = parcelRequire("g3Qtd");
function $8c0c8eb29f0aebc9$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var wasMultiRow;
    var getSpaceBetween = function() {
        var spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    var initSlides = function(slides) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    var unsetSlides = function() {
        if (swiper.slides) swiper.slides.forEach(function(slide) {
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    var updateSlide = function(i, slide, slides) {
        var slidesPerGroup = swiper.params.slidesPerGroup;
        var spaceBetween = getSpaceBetween();
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === "row" && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = "calc((100% - ".concat((rows - 1) * spaceBetween, "px) / ").concat(rows, ")");
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : "";
        slide.swiperSlideGridSet = true;
    };
    var updateWrapperSize = function(slideSize, snapGrid) {
        var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var spaceBetween = getSpaceBetween();
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
        if (centeredSlides) {
            var _snapGrid;
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, $g3Qtd._)(newSlidesGrid));
        }
    };
    var onInit = function() {
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    var onUpdate = function() {
        var params = swiper.params, el = swiper.el;
        var isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add("".concat(params.containerModifierClass, "grid"));
            if (params.grid.fill === "column") el.classList.add("".concat(params.containerModifierClass, "grid-column"));
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $e749a01e3b8421a2$var$appendSlide(slides) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var appendElement = function(slideEl) {
        if (typeof slideEl === "string") {
            var tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $e749a01e3b8421a2$var$prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    var prependElement = function(slideEl) {
        if (typeof slideEl === "string") {
            var tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $e749a01e3b8421a2$var$addSlide(index, slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) slidesEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)slidesEl.append(slidesBuffer[i2]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $e749a01e3b8421a2$var$removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $e749a01e3b8421a2$var$removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $e749a01e3b8421a2$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper;
    Object.assign(swiper, {
        appendSlide: $e749a01e3b8421a2$var$appendSlide.bind(swiper),
        prependSlide: $e749a01e3b8421a2$var$prependSlide.bind(swiper),
        addSlide: $e749a01e3b8421a2$var$addSlide.bind(swiper),
        removeSlide: $e749a01e3b8421a2$var$removeSlide.bind(swiper),
        removeAllSlides: $e749a01e3b8421a2$var$removeAllSlides.bind(swiper)
    });
}


function $878b5e2c576bed51$export$f1e1789686576879(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective, recreateShadows = params.recreateShadows, getEffectParams = params.getEffectParams;
    on("beforeInit", function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", function() {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach(function(slideEl) {
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                    return shadowEl.remove();
                });
            });
            // create new one
            recreateShadows();
        }
    });
    var requireUpdateOnVirtual;
    on("virtualUpdate", function() {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(function() {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $c8f193725a442a4b$export$f1e1789686576879(effectParams, slideEl) {
    var transformEl = (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $9cf909c6bbeb30b3$export$f1e1789686576879(_ref) {
    var swiper = _ref.swiper, duration = _ref.duration, transformElements = _ref.transformElements, allSlides = _ref.allSlides;
    var activeIndex = swiper.activeIndex;
    var getSlide = function(el) {
        if (!el.parentElement) {
            // assume shadow root
            var slide = swiper.slides.filter(function(slideEl) {
                return slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode;
            })[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter(function(transformEl) {
            var el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach(function(el) {
            (0, $f1851ae8473f6f1e$export$342063e11d6c3cad)(el, function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $056fbe3c0338e0b8$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = swiper.slides[i];
            var offset = slideEl.swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            var targetEl = (0, $c8f193725a442a4b$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)");
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
        });
        (0, $9cf909c6bbeb30b3$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $878b5e2c576bed51$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




function $facd5835bb452700$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var createSlideShadows = function(slideEl, progress, isHorizontal) {
        var shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        var shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", "swiper-slide-shadow-cube swiper-slide-shadow-".concat(isHorizontal ? "left" : "top").split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", "swiper-slide-shadow-cube swiper-slide-shadow-".concat(isHorizontal ? "right" : "bottom").split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // create new ones
        var isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach(function(slideEl) {
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    var setTranslate = function() {
        var el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var r = (0, $f1851ae8473f6f1e$export$ae1af26003f05816)(swiper);
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = "".concat(swiperWidth, "px");
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(r(isHorizontal ? 0 : -slideAngle), "deg) rotateY(").concat(r(isHorizontal ? slideAngle : 0), "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = "50% 50% -".concat(swiperSize / 2, "px");
        wrapperEl.style["-webkit-transform-origin"] = "50% 50% -".concat(swiperSize / 2, "px");
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = "translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(89.99deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                cubeShadowEl.style.transform = "scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-89.99deg)");
            }
        }
        var zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = "translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(r(swiper.isHorizontal() ? 0 : wrapperRotate), "deg) rotateY(").concat(r(swiper.isHorizontal() ? -wrapperRotate : 0), "deg)");
        wrapperEl.style.setProperty("--swiper-cube-translate-z", "".concat(zFactor, "px"));
    };
    var setTransition = function(duration) {
        var el = swiper.el, slides = swiper.slides;
        slides.forEach(function(slideEl) {
            slideEl.style.transitionDuration = "".concat(duration, "ms");
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(subEl) {
                subEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            var shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = "".concat(duration, "ms");
        }
    };
    (0, $878b5e2c576bed51$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.cubeEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}



function $9292b8ec9deaa039$export$db3b6bfb95261072(suffix, slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : "").concat(suffix ? " swiper-slide-shadow-".concat(suffix) : "");
    var shadowContainer = (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
    var shadowEl = shadowContainer.querySelector(".".concat(shadowClass.split(" ").join(".")));
    if (!shadowEl) {
        shadowEl = (0, $f1851ae8473f6f1e$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $3d154c825313b9ba$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    var createSlideShadows = function(slideEl, progress) {
        var shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        var shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $9292b8ec9deaa039$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $9292b8ec9deaa039$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach(function(slideEl) {
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        var rotateFix = (0, $f1851ae8473f6f1e$export$ae1af26003f05816)(swiper);
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var offset = slideEl.swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateFix(rotateX), "deg) rotateY(").concat(rotateFix(rotateY), "deg)");
            var targetEl = (0, $c8f193725a442a4b$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $9cf909c6bbeb30b3$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $878b5e2c576bed51$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.flipEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}






function $fb5174d6f4cfdad6$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        var r = (0, $f1851ae8473f6f1e$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var slideEl = slides[i];
            var slideSize = slidesSizesGrid[i];
            var slideOffset = slideEl.swiperSlideOffset;
            var centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            var offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(r(rotateX), "deg) rotateY(").concat(r(rotateY), "deg) scale(").concat(scale, ")");
            var targetEl = (0, $c8f193725a442a4b$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                var shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $9292b8ec9deaa039$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $9292b8ec9deaa039$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
    };
    (0, $878b5e2c576bed51$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}







function $07b77cc65c1288a0$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === "string") return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            var offset = slideEl.swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            });
            // set rotates
            r.forEach(function(value, index) {
                var val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(", ");
            var rotateString = "rotateX(".concat(rotateFix(r[0]), "deg) rotateY(").concat(rotateFix(r[1]), "deg) rotateZ(").concat(rotateFix(r[2]), "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString);
            // Set shadows
            if (custom && data.shadow || !custom) {
                var shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $9292b8ec9deaa039$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var targetEl = (0, $c8f193725a442a4b$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        };
        var slides = swiper.slides, wrapperEl = swiper.wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        var rotateFix = (0, $f1851ae8473f6f1e$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = "translateX(calc(50% - ".concat(margin, "px))");
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $9cf909c6bbeb30b3$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $878b5e2c576bed51$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}







function $5b27ab69ba5938db$export$2e2bcd8739ae039(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = "translateX(".concat(swiper.minTranslate(), "px)");
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -params.perSlideRotate * progress;
            var tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            var slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            var isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px ").concat(rtl ? "-" : "+", " (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            tX = "calc(".concat(tX, "px ").concat(rtl ? "-" : "+", " (-").concat(tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            /* eslint-disable */ var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(params.rotate ? rtl ? -rotate : rotate : 0, "deg)\n        scale(").concat(scaleString, ")\n      ");
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                var shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $9292b8ec9deaa039$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var targetEl = (0, $c8f193725a442a4b$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $f1851ae8473f6f1e$export$39b482c5e57630a8)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $9cf909c6bbeb30b3$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $878b5e2c576bed51$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




var $20abc66ae0b27dec$exports = {};

$20abc66ae0b27dec$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "a.a12ee820.png";


var $26cd02a34d59d95b$exports = {};

$26cd02a34d59d95b$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "b.70afaab6.png";


var $b4ecbcaca1d0d64e$exports = {};

$b4ecbcaca1d0d64e$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "c.6842c356.png";


var $c15ebd2819bb1882$exports = {};

$c15ebd2819bb1882$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "d.40b300f8.png";


var $37aad785b3e4690f$export$4bf9923669ad6c63 = [
    {
        url: new URL($20abc66ae0b27dec$exports),
        title: "2017\u6210\u90FDWeb\u524D\u7AEF\u5927\u4F1A"
    },
    {
        url: new URL($26cd02a34d59d95b$exports),
        title: "2018\u65B0\u8000\u676F code for city \u9ED1\u5BA2\u677E\u5927\u8D5B"
    },
    {
        url: new URL($b4ecbcaca1d0d64e$exports),
        title: "2017\u524D\u7AEF\u5927\u4F1A\u82B1\u7D6E"
    },
    {
        url: new URL($c15ebd2819bb1882$exports),
        title: "FCC\u6210\u90FD\u793E\u533A\u65E5\u5E38"
    }
];



var $ed163310560d1e2a$export$ada873a34909da65 = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, $4msX2._)(Events, Component);
    var _super = (0, $jMsep._)(Events);
    function Events() {
        (0, $59v1D._)(this, Events);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setMarginLeft = function() {
            var _document_querySelector;
            var bodyWidth = document.body.clientWidth, panelWidth = ((_document_querySelector = document.querySelector("#index-events")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.clientWidth) || 0;
            var contentEvents = document.querySelector(".content-events");
            if (contentEvents) contentEvents.style.marginRight = "".concat((panelWidth - bodyWidth) / 2, "px");
        };
        return _this;
    }
    (0, $6DUu1._)(Events, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setMarginLeft();
                window.addEventListener("resize", this.setMarginLeft);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.setMarginLeft);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                    className: "Panel index-events",
                    children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                        className: "MainContainer",
                        id: "index-events",
                        children: [
                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                className: "TitleRow",
                                children: [
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                        className: "title-panel",
                                        children: [
                                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("strong", {
                                                children: "\u793E\u533A\u5927\u4E8B\u4EF6"
                                            }),
                                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                                className: "preloader",
                                                children: [
                                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("span", {}),
                                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("span", {}),
                                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("span", {}),
                                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("span", {})
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                        className: "title-panel-bg",
                                        children: [
                                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                                children: "Big"
                                            }),
                                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                                children: "even"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                                className: "content-events",
                                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                                    className: "events-slider",
                                    children: [
                                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("i", {
                                            id: "swiper-button-prev",
                                            className: "iconfont icon-jiantou1-copy-copy-copy"
                                        }),
                                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("i", {
                                            id: "swiper-button-next",
                                            className: "iconfont icon-jiantou1-copy"
                                        }),
                                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $04583d40f52ed51d$export$6b3850921bc5a414), {
                                            className: "swiper-container",
                                            modules: [
                                                (0, $de90517a238f79bf$export$2e2bcd8739ae039),
                                                (0, $4e14d5f5cae05a68$export$2e2bcd8739ae039)
                                            ],
                                            grabCursor: true,
                                            slidesPerView: 3,
                                            centeredSlides: false,
                                            slidesPerGroup: 1,
                                            spaceBetween: 65,
                                            loop: true,
                                            autoplay: {
                                                delay: 3000,
                                                disableOnInteraction: false
                                            },
                                            navigation: {
                                                nextEl: "#swiper-button-next",
                                                prevEl: "#swiper-button-prev"
                                            },
                                            children: (0, $37aad785b3e4690f$export$4bf9923669ad6c63).map(function(param) {
                                                var title = param.title, url = param.url;
                                                return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $04583d40f52ed51d$export$5c2bcc76ee716566), {
                                                    className: "event-panel",
                                                    children: [
                                                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                                                            src: url + "",
                                                            alt: title
                                                        }),
                                                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("p", {
                                                            className: "text-white",
                                                            children: title
                                                        })
                                                    ]
                                                }, url + "");
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Events;
}((0, $33gHU.Component));


/**
 * @desc 社区组织者板块
 * @author
 */ 



var $33gHU = parcelRequire("33gHU");
var $05202a95809fe9f3$export$100ad4af8c8d544f;
var $05202a95809fe9f3$export$da7f422cc1e28947;
var $05202a95809fe9f3$export$b92be0eb0322c3af;
var $05202a95809fe9f3$export$b77c95dbff56e254;
var $05202a95809fe9f3$export$fb184b623420d9be;
$05202a95809fe9f3$export$100ad4af8c8d544f = "Cmu5pa_members";
$05202a95809fe9f3$export$da7f422cc1e28947 = "Cmu5pa_members-block";
$05202a95809fe9f3$export$b92be0eb0322c3af = "Cmu5pa_members-list";
$05202a95809fe9f3$export$b77c95dbff56e254 = "Cmu5pa_sub-title";
$05202a95809fe9f3$export$fb184b623420d9be = "Cmu5pa_title";



var $6RwIG = parcelRequire("6RwIG");


var $cb0bd36af064cb0b$export$af6694465029dab3;
var $cb0bd36af064cb0b$export$5f243868198ee679;
var $cb0bd36af064cb0b$export$a7db06668cad9adb;
var $cb0bd36af064cb0b$export$e28abb855b6e85e9;
var $cb0bd36af064cb0b$export$32963a15ef390f7f;
var $cb0bd36af064cb0b$export$96b22254c25c876a;
var $cb0bd36af064cb0b$export$a8ff84c12d48cfa6;
var $cb0bd36af064cb0b$export$d596ff69a111f6f2;
var $cb0bd36af064cb0b$export$d62495e1ba7ee965;
var $cb0bd36af064cb0b$export$cafc46a9962c7699;
$cb0bd36af064cb0b$export$af6694465029dab3 = "dVc8Va_GithubLink";
$cb0bd36af064cb0b$export$5f243868198ee679 = "dVc8Va_card-img-top";
$cb0bd36af064cb0b$export$a7db06668cad9adb = "dVc8Va_content";
$cb0bd36af064cb0b$export$e28abb855b6e85e9 = "dVc8Va_img-block";
$cb0bd36af064cb0b$export$32963a15ef390f7f = "dVc8Va_last-item";
$cb0bd36af064cb0b$export$96b22254c25c876a = "dVc8Va_member-item";
$cb0bd36af064cb0b$export$a8ff84c12d48cfa6 = "dVc8Va_name";
$cb0bd36af064cb0b$export$d596ff69a111f6f2 = "dVc8Va_responsibility";
$cb0bd36af064cb0b$export$d62495e1ba7ee965 = "dVc8Va_text-over";
$cb0bd36af064cb0b$export$cafc46a9962c7699 = "dVc8Va_user-icon";


var $83f8e8b1c19b0450$export$60332b2344f7fe41 = function(param) {
    var url = param.url, img = param.img, name = param.name, responsibility = param.responsibility, urlType = param.urlType, index = param.index;
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))($cb0bd36af064cb0b$export$96b22254c25c876a, (0, $6RwIG._)({}, $cb0bd36af064cb0b$export$32963a15ef390f7f, index % 5 === 4)),
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                    className: $cb0bd36af064cb0b$export$e28abb855b6e85e9,
                    children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                        className: $cb0bd36af064cb0b$export$5f243868198ee679,
                        src: img,
                        alt: "\u5934\u50CF"
                    })
                }),
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
                    className: $cb0bd36af064cb0b$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                            className: "".concat($cb0bd36af064cb0b$export$a8ff84c12d48cfa6, " ").concat($cb0bd36af064cb0b$export$d62495e1ba7ee965),
                            children: name
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                            className: "".concat($cb0bd36af064cb0b$export$d596ff69a111f6f2, " ").concat($cb0bd36af064cb0b$export$d62495e1ba7ee965),
                            title: responsibility,
                            children: responsibility
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                            className: $cb0bd36af064cb0b$export$d62495e1ba7ee965,
                            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("a", {
                                className: $cb0bd36af064cb0b$export$af6694465029dab3,
                                title: url,
                                href: url,
                                target: "_blank",
                                children: [
                                    urlType === "user" && /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                                        className: $cb0bd36af064cb0b$export$cafc46a9962c7699,
                                        src: img,
                                        alt: "\u5934\u50CF"
                                    }),
                                    urlType !== "none" && /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("i", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8bd163097a5514bf$exports)))("iconfont", urlType)
                                    }),
                                    url
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


var $f1a7ee6246a348d0$exports = {};

$f1a7ee6246a348d0$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "ccb-min.1243fc24.jpg";


var $0a2e65425e32c17d$exports = {};

$0a2e65425e32c17d$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "Ak-min.37f36a80.jpg";


var $6f264cc6e63a810b$exports = {};

$6f264cc6e63a810b$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "glowd-min.7c709901.jpg";


var $de7c6ac8b41b4260$exports = {};

$de7c6ac8b41b4260$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "Dean-min.8f3ac48c.jpg";


var $a5f9e520f7b5be46$exports = {};

$a5f9e520f7b5be46$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "caiting-min.64c69471.jpeg";


var $36bbfcb4a4acbe14$exports = {};

$36bbfcb4a4acbe14$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "Helen-min.63225d0b.jpg";


var $f0534144ab68b2b4$exports = {};

$f0534144ab68b2b4$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "janeZhen-min.e2e7ecd1.jpg";


var $da45f5484b740487$exports = {};

$da45f5484b740487$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "lanhao-min.fc9425e7.jpg";


var $2d0b368872104fde$exports = {};

$2d0b368872104fde$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "liunanbing-min.b2176dcb.jpg";


var $29a3700da7f11564$exports = {};

$29a3700da7f11564$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "qianyu-min.60ff98ad.jpg";


var $574c3fc6d2cfcc5a$exports = {};

$574c3fc6d2cfcc5a$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "qingsong-min.c0767d75.jpg";


var $bdb81b270eba06bb$exports = {};

$bdb81b270eba06bb$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "shiyao-min.91fcc421.jpg";


var $52bb69e8b1c66d95$exports = {};

$52bb69e8b1c66d95$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "Too-min.08a0ed86.jpg";


var $dfbf66a2c0db604b$exports = {};

$dfbf66a2c0db604b$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "wangbo-min.56f72d73.jpg";


var $8d5eef63b5347d11$exports = {};

$8d5eef63b5347d11$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "wangjie-min.7459719a.jpg";


var $a5f3a134cc6ad7f8$exports = {};

$a5f3a134cc6ad7f8$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "xiaoshan-min.b85bdc4b.jpg";


var $7ade2e517452d221$exports = {};

$7ade2e517452d221$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "yuqi-min.c03388af.jpg";


//用户链接类型
var $da6a55327149f50d$var$URL_TYPE_CLASS = {
    github: "icon-github",
    lofter: "icon-LOFTER"
};
var $da6a55327149f50d$export$600c496b83aabea2 = [
    {
        name: "\u59DC\u59DC\u59DC",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($f0534144ab68b2b4$exports))),
        responsibility: "\u793E\u533A\u8D1F\u8D23\u4EBA",
        url: "https://github.com/jiangyuzhen",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "AK",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($0a2e65425e32c17d$exports))),
        responsibility: "\u6D3B\u52A8\u90E8",
        url: "",
        urlType: "none"
    },
    {
        name: "\u8881\u6C11\u6210",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($de7c6ac8b41b4260$exports))),
        responsibility: "\u6587\u6848\u4E0E\u5468\u8FB9",
        url: "https://github.com/jiangyuzhen",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "Nanbing",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($2d0b368872104fde$exports))),
        responsibility: "\u534F\u52A9\u8FD0\u8425",
        url: "http://nanbing.me/",
        urlType: "user"
    },
    {
        name: "Helen",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($36bbfcb4a4acbe14$exports))),
        responsibility: "\u6D3B\u52A8\u90E8",
        url: "https://github.com/TingYinHelen",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "\u521D\u4E00",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($dfbf66a2c0db604b$exports))),
        responsibility: "\u8BBE\u8BA1",
        url: "http://918930.lofter.com",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.lofter
    },
    {
        name: "\u84DD\u6D69",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($da45f5484b740487$exports))),
        responsibility: "\u540E\u5907\u5F00\u53D1\u4EBA\u5458",
        url: "http://www.lanhao.name",
        urlType: "user"
    },
    {
        name: "glowd",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($6f264cc6e63a810b$exports))),
        responsibility: "\u540E\u5907\u5F00\u53D1\u4EBA\u5458",
        url: "https://github.com/Glowdable",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "\u4E66\u9999\u58A8\u5251",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($7ade2e517452d221$exports))),
        responsibility: "\u540E\u5907\u5F00\u53D1\u4EBA\u5458",
        url: "https://github.com/demongodYY",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "\u8521\u5A77",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($a5f9e520f7b5be46$exports))),
        responsibility: "\u6D3B\u52A8\u7B56\u5212",
        url: "",
        urlType: "none"
    },
    {
        name: "\u6C34\u6B4C",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($bdb81b270eba06bb$exports))),
        responsibility: "JavaScript \u5168\u6808\u5F00\u53D1\u8BB2\u5E08",
        url: "https://tech-query.me/",
        urlType: "user"
    },
    {
        name: "\u4F55\u9752\u677E",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($574c3fc6d2cfcc5a$exports))),
        responsibility: "FCC\u6210\u90FD\u793E\u533A\u5546\u52A1\u5408\u4F5C",
        url: "https://github.com/Heqingsong",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "\u9648\u5C0F\u5C71",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($a5f3a134cc6ad7f8$exports))),
        responsibility: "\u6D3B\u52A8\u7B56\u5212\u6267\u884C",
        url: "https://github.com/HillChen3",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "TOO",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($52bb69e8b1c66d95$exports))),
        responsibility: "\u6280\u672F\u652F\u6301",
        url: "http://fctoo.com",
        urlType: "user"
    },
    {
        name: "\u9648\u707F\u51B0",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($f1a7ee6246a348d0$exports))),
        responsibility: "\u6280\u672F\u652F\u6301",
        url: "https://github.com/CanbingChen",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "\u5029\u7389",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($29a3700da7f11564$exports))),
        responsibility: "\u6587\u6848",
        url: "https://github.com/Lmagic16",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    },
    {
        name: "\u738B\u6770",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($8d5eef63b5347d11$exports))),
        responsibility: "\u6280\u672F\u652F\u6301",
        url: "https://github.com/acherie",
        urlType: $da6a55327149f50d$var$URL_TYPE_CLASS.github
    }
];


var $465cbbcc86964252$export$934777d8c7d5b61 = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
        className: $05202a95809fe9f3$export$da7f422cc1e28947,
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)("div", {
            className: $05202a95809fe9f3$export$100ad4af8c8d544f,
            children: [
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("h2", {
                    className: $05202a95809fe9f3$export$fb184b623420d9be,
                    children: "\u7EC4\u7EC7\u8005\u98CE\u91C7\u5C55"
                }),
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("h3", {
                    className: $05202a95809fe9f3$export$b77c95dbff56e254,
                    children: "Community members"
                }),
                /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("div", {
                    className: $05202a95809fe9f3$export$b92be0eb0322c3af,
                    children: (0, $da6a55327149f50d$export$600c496b83aabea2).map(function(item, index) {
                        return /*#__PURE__*/ (0, $33gHU.createElement)((0, $83f8e8b1c19b0450$export$60332b2344f7fe41), (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, item), {
                            index: index,
                            key: item.name
                        }));
                    })
                })
            ]
        })
    });
};


var $6bd010c06d68f9a5$export$cf17b003b6192af3 = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $9d9305f81c4f8e17$export$b112b0abbb9d23d2), {}),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $c0e23f89c2808627$export$c4868e4a24d48fad), {}),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $ed163310560d1e2a$export$ada873a34909da65), {}),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $465cbbcc86964252$export$934777d8c7d5b61), {})
        ]
    });
};


/**
 * @desc 历史活动页面
 * @author
 */ 


var $fTrHk = parcelRequire("fTrHk");



var $6RwIG = parcelRequire("6RwIG");



var $fTrHk = parcelRequire("fTrHk");


var $33gHU = parcelRequire("33gHU");

var $d198ac116a0e36eb$exports = {};
// shim for using process in browser
var $d198ac116a0e36eb$var$process = $d198ac116a0e36eb$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d198ac116a0e36eb$var$cachedSetTimeout;
var $d198ac116a0e36eb$var$cachedClearTimeout;
function $d198ac116a0e36eb$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d198ac116a0e36eb$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d198ac116a0e36eb$var$cachedSetTimeout = setTimeout;
        else $d198ac116a0e36eb$var$cachedSetTimeout = $d198ac116a0e36eb$var$defaultSetTimout;
    } catch (e) {
        $d198ac116a0e36eb$var$cachedSetTimeout = $d198ac116a0e36eb$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d198ac116a0e36eb$var$cachedClearTimeout = clearTimeout;
        else $d198ac116a0e36eb$var$cachedClearTimeout = $d198ac116a0e36eb$var$defaultClearTimeout;
    } catch (e) {
        $d198ac116a0e36eb$var$cachedClearTimeout = $d198ac116a0e36eb$var$defaultClearTimeout;
    }
})();
function $d198ac116a0e36eb$var$runTimeout(fun) {
    if ($d198ac116a0e36eb$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d198ac116a0e36eb$var$cachedSetTimeout === $d198ac116a0e36eb$var$defaultSetTimout || !$d198ac116a0e36eb$var$cachedSetTimeout) && setTimeout) {
        $d198ac116a0e36eb$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d198ac116a0e36eb$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d198ac116a0e36eb$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d198ac116a0e36eb$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d198ac116a0e36eb$var$runClearTimeout(marker) {
    if ($d198ac116a0e36eb$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d198ac116a0e36eb$var$cachedClearTimeout === $d198ac116a0e36eb$var$defaultClearTimeout || !$d198ac116a0e36eb$var$cachedClearTimeout) && clearTimeout) {
        $d198ac116a0e36eb$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d198ac116a0e36eb$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d198ac116a0e36eb$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d198ac116a0e36eb$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d198ac116a0e36eb$var$queue = [];
var $d198ac116a0e36eb$var$draining = false;
var $d198ac116a0e36eb$var$currentQueue;
var $d198ac116a0e36eb$var$queueIndex = -1;
function $d198ac116a0e36eb$var$cleanUpNextTick() {
    if (!$d198ac116a0e36eb$var$draining || !$d198ac116a0e36eb$var$currentQueue) return;
    $d198ac116a0e36eb$var$draining = false;
    if ($d198ac116a0e36eb$var$currentQueue.length) $d198ac116a0e36eb$var$queue = $d198ac116a0e36eb$var$currentQueue.concat($d198ac116a0e36eb$var$queue);
    else $d198ac116a0e36eb$var$queueIndex = -1;
    if ($d198ac116a0e36eb$var$queue.length) $d198ac116a0e36eb$var$drainQueue();
}
function $d198ac116a0e36eb$var$drainQueue() {
    if ($d198ac116a0e36eb$var$draining) return;
    var timeout = $d198ac116a0e36eb$var$runTimeout($d198ac116a0e36eb$var$cleanUpNextTick);
    $d198ac116a0e36eb$var$draining = true;
    var len = $d198ac116a0e36eb$var$queue.length;
    while(len){
        $d198ac116a0e36eb$var$currentQueue = $d198ac116a0e36eb$var$queue;
        $d198ac116a0e36eb$var$queue = [];
        while(++$d198ac116a0e36eb$var$queueIndex < len)if ($d198ac116a0e36eb$var$currentQueue) $d198ac116a0e36eb$var$currentQueue[$d198ac116a0e36eb$var$queueIndex].run();
        $d198ac116a0e36eb$var$queueIndex = -1;
        len = $d198ac116a0e36eb$var$queue.length;
    }
    $d198ac116a0e36eb$var$currentQueue = null;
    $d198ac116a0e36eb$var$draining = false;
    $d198ac116a0e36eb$var$runClearTimeout(timeout);
}
$d198ac116a0e36eb$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d198ac116a0e36eb$var$queue.push(new $d198ac116a0e36eb$var$Item(fun, args));
    if ($d198ac116a0e36eb$var$queue.length === 1 && !$d198ac116a0e36eb$var$draining) $d198ac116a0e36eb$var$runTimeout($d198ac116a0e36eb$var$drainQueue);
};
// v8 likes predictible objects
function $d198ac116a0e36eb$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d198ac116a0e36eb$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d198ac116a0e36eb$var$process.title = "browser";
$d198ac116a0e36eb$var$process.browser = true;
$d198ac116a0e36eb$var$process.env = {};
$d198ac116a0e36eb$var$process.argv = [];
$d198ac116a0e36eb$var$process.version = ""; // empty string to avoid regexp issues
$d198ac116a0e36eb$var$process.versions = {};
function $d198ac116a0e36eb$var$noop() {}
$d198ac116a0e36eb$var$process.on = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.addListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.once = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.off = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.removeListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.removeAllListeners = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.emit = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.prependListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.prependOnceListener = $d198ac116a0e36eb$var$noop;
$d198ac116a0e36eb$var$process.listeners = function(name) {
    return [];
};
$d198ac116a0e36eb$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d198ac116a0e36eb$var$process.cwd = function() {
    return "/";
};
$d198ac116a0e36eb$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d198ac116a0e36eb$var$process.umask = function() {
    return 0;
};


"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
function $36ad047dac3e028c$var$v(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $36ad047dac3e028c$var$y = {
    exports: {}
}, $36ad047dac3e028c$var$w = {}, $36ad047dac3e028c$var$b = {
    exports: {}
}, $36ad047dac3e028c$var$x = {};
function $36ad047dac3e028c$var$C() {
    var e = {
        "align-content": !1,
        "align-items": !1,
        "align-self": !1,
        "alignment-adjust": !1,
        "alignment-baseline": !1,
        all: !1,
        "anchor-point": !1,
        animation: !1,
        "animation-delay": !1,
        "animation-direction": !1,
        "animation-duration": !1,
        "animation-fill-mode": !1,
        "animation-iteration-count": !1,
        "animation-name": !1,
        "animation-play-state": !1,
        "animation-timing-function": !1,
        azimuth: !1,
        "backface-visibility": !1,
        background: !0,
        "background-attachment": !0,
        "background-clip": !0,
        "background-color": !0,
        "background-image": !0,
        "background-origin": !0,
        "background-position": !0,
        "background-repeat": !0,
        "background-size": !0,
        "baseline-shift": !1,
        binding: !1,
        bleed: !1,
        "bookmark-label": !1,
        "bookmark-level": !1,
        "bookmark-state": !1,
        border: !0,
        "border-bottom": !0,
        "border-bottom-color": !0,
        "border-bottom-left-radius": !0,
        "border-bottom-right-radius": !0,
        "border-bottom-style": !0,
        "border-bottom-width": !0,
        "border-collapse": !0,
        "border-color": !0,
        "border-image": !0,
        "border-image-outset": !0,
        "border-image-repeat": !0,
        "border-image-slice": !0,
        "border-image-source": !0,
        "border-image-width": !0,
        "border-left": !0,
        "border-left-color": !0,
        "border-left-style": !0,
        "border-left-width": !0,
        "border-radius": !0,
        "border-right": !0,
        "border-right-color": !0,
        "border-right-style": !0,
        "border-right-width": !0,
        "border-spacing": !0,
        "border-style": !0,
        "border-top": !0,
        "border-top-color": !0,
        "border-top-left-radius": !0,
        "border-top-right-radius": !0,
        "border-top-style": !0,
        "border-top-width": !0,
        "border-width": !0,
        bottom: !1,
        "box-decoration-break": !0,
        "box-shadow": !0,
        "box-sizing": !0,
        "box-snap": !0,
        "box-suppress": !0,
        "break-after": !0,
        "break-before": !0,
        "break-inside": !0,
        "caption-side": !1,
        chains: !1,
        clear: !0,
        clip: !1,
        "clip-path": !1,
        "clip-rule": !1,
        color: !0,
        "color-interpolation-filters": !0,
        "column-count": !1,
        "column-fill": !1,
        "column-gap": !1,
        "column-rule": !1,
        "column-rule-color": !1,
        "column-rule-style": !1,
        "column-rule-width": !1,
        "column-span": !1,
        "column-width": !1,
        columns: !1,
        contain: !1,
        content: !1,
        "counter-increment": !1,
        "counter-reset": !1,
        "counter-set": !1,
        crop: !1,
        cue: !1,
        "cue-after": !1,
        "cue-before": !1,
        cursor: !1,
        direction: !1,
        display: !0,
        "display-inside": !0,
        "display-list": !0,
        "display-outside": !0,
        "dominant-baseline": !1,
        elevation: !1,
        "empty-cells": !1,
        filter: !1,
        flex: !1,
        "flex-basis": !1,
        "flex-direction": !1,
        "flex-flow": !1,
        "flex-grow": !1,
        "flex-shrink": !1,
        "flex-wrap": !1,
        float: !1,
        "float-offset": !1,
        "flood-color": !1,
        "flood-opacity": !1,
        "flow-from": !1,
        "flow-into": !1,
        font: !0,
        "font-family": !0,
        "font-feature-settings": !0,
        "font-kerning": !0,
        "font-language-override": !0,
        "font-size": !0,
        "font-size-adjust": !0,
        "font-stretch": !0,
        "font-style": !0,
        "font-synthesis": !0,
        "font-variant": !0,
        "font-variant-alternates": !0,
        "font-variant-caps": !0,
        "font-variant-east-asian": !0,
        "font-variant-ligatures": !0,
        "font-variant-numeric": !0,
        "font-variant-position": !0,
        "font-weight": !0,
        grid: !1,
        "grid-area": !1,
        "grid-auto-columns": !1,
        "grid-auto-flow": !1,
        "grid-auto-rows": !1,
        "grid-column": !1,
        "grid-column-end": !1,
        "grid-column-start": !1,
        "grid-row": !1,
        "grid-row-end": !1,
        "grid-row-start": !1,
        "grid-template": !1,
        "grid-template-areas": !1,
        "grid-template-columns": !1,
        "grid-template-rows": !1,
        "hanging-punctuation": !1,
        height: !0,
        hyphens: !1,
        icon: !1,
        "image-orientation": !1,
        "image-resolution": !1,
        "ime-mode": !1,
        "initial-letters": !1,
        "inline-box-align": !1,
        "justify-content": !1,
        "justify-items": !1,
        "justify-self": !1,
        left: !1,
        "letter-spacing": !0,
        "lighting-color": !0,
        "line-box-contain": !1,
        "line-break": !1,
        "line-grid": !1,
        "line-height": !1,
        "line-snap": !1,
        "line-stacking": !1,
        "line-stacking-ruby": !1,
        "line-stacking-shift": !1,
        "line-stacking-strategy": !1,
        "list-style": !0,
        "list-style-image": !0,
        "list-style-position": !0,
        "list-style-type": !0,
        margin: !0,
        "margin-bottom": !0,
        "margin-left": !0,
        "margin-right": !0,
        "margin-top": !0,
        "marker-offset": !1,
        "marker-side": !1,
        marks: !1,
        mask: !1,
        "mask-box": !1,
        "mask-box-outset": !1,
        "mask-box-repeat": !1,
        "mask-box-slice": !1,
        "mask-box-source": !1,
        "mask-box-width": !1,
        "mask-clip": !1,
        "mask-image": !1,
        "mask-origin": !1,
        "mask-position": !1,
        "mask-repeat": !1,
        "mask-size": !1,
        "mask-source-type": !1,
        "mask-type": !1,
        "max-height": !0,
        "max-lines": !1,
        "max-width": !0,
        "min-height": !0,
        "min-width": !0,
        "move-to": !1,
        "nav-down": !1,
        "nav-index": !1,
        "nav-left": !1,
        "nav-right": !1,
        "nav-up": !1,
        "object-fit": !1,
        "object-position": !1,
        opacity: !1,
        order: !1,
        orphans: !1,
        outline: !1,
        "outline-color": !1,
        "outline-offset": !1,
        "outline-style": !1,
        "outline-width": !1,
        overflow: !1,
        "overflow-wrap": !1,
        "overflow-x": !1,
        "overflow-y": !1,
        padding: !0,
        "padding-bottom": !0,
        "padding-left": !0,
        "padding-right": !0,
        "padding-top": !0,
        page: !1,
        "page-break-after": !1,
        "page-break-before": !1,
        "page-break-inside": !1,
        "page-policy": !1,
        pause: !1,
        "pause-after": !1,
        "pause-before": !1,
        perspective: !1,
        "perspective-origin": !1,
        pitch: !1,
        "pitch-range": !1,
        "play-during": !1,
        position: !1,
        "presentation-level": !1,
        quotes: !1,
        "region-fragment": !1,
        resize: !1,
        rest: !1,
        "rest-after": !1,
        "rest-before": !1,
        richness: !1,
        right: !1,
        rotation: !1,
        "rotation-point": !1,
        "ruby-align": !1,
        "ruby-merge": !1,
        "ruby-position": !1,
        "shape-image-threshold": !1,
        "shape-outside": !1,
        "shape-margin": !1,
        size: !1,
        speak: !1,
        "speak-as": !1,
        "speak-header": !1,
        "speak-numeral": !1,
        "speak-punctuation": !1,
        "speech-rate": !1,
        stress: !1,
        "string-set": !1,
        "tab-size": !1,
        "table-layout": !1,
        "text-align": !0,
        "text-align-last": !0,
        "text-combine-upright": !0,
        "text-decoration": !0,
        "text-decoration-color": !0,
        "text-decoration-line": !0,
        "text-decoration-skip": !0,
        "text-decoration-style": !0,
        "text-emphasis": !0,
        "text-emphasis-color": !0,
        "text-emphasis-position": !0,
        "text-emphasis-style": !0,
        "text-height": !0,
        "text-indent": !0,
        "text-justify": !0,
        "text-orientation": !0,
        "text-overflow": !0,
        "text-shadow": !0,
        "text-space-collapse": !0,
        "text-transform": !0,
        "text-underline-position": !0,
        "text-wrap": !0,
        top: !1,
        transform: !1,
        "transform-origin": !1,
        "transform-style": !1,
        transition: !1,
        "transition-delay": !1,
        "transition-duration": !1,
        "transition-property": !1,
        "transition-timing-function": !1,
        "unicode-bidi": !1,
        "vertical-align": !1,
        visibility: !1,
        "voice-balance": !1,
        "voice-duration": !1,
        "voice-family": !1,
        "voice-pitch": !1,
        "voice-range": !1,
        "voice-rate": !1,
        "voice-stress": !1,
        "voice-volume": !1,
        volume: !1,
        "white-space": !1,
        widows: !1,
        width: !0,
        "will-change": !1,
        "word-break": !0,
        "word-spacing": !0,
        "word-wrap": !0,
        "wrap-flow": !1,
        "wrap-through": !1,
        "writing-mode": !1,
        "z-index": !1
    };
    return e;
}
var $36ad047dac3e028c$var$k = /javascript\s*\:/gim;
$36ad047dac3e028c$var$x.whiteList = $36ad047dac3e028c$var$C(), $36ad047dac3e028c$var$x.getDefaultWhiteList = $36ad047dac3e028c$var$C, $36ad047dac3e028c$var$x.onAttr = function(e, t, n) {}, $36ad047dac3e028c$var$x.onIgnoreAttr = function(e, t, n) {}, $36ad047dac3e028c$var$x.safeAttrValue = function(e, t) {
    return $36ad047dac3e028c$var$k.test(t) ? "" : t;
};
var $36ad047dac3e028c$var$S = {
    indexOf: function indexOf(e, t) {
        var n, _$i;
        if (Array.prototype.indexOf) return e.indexOf(t);
        for(n = 0, _$i = e.length; n < _$i; n++)if (e[n] === t) return n;
        return -1;
    },
    forEach: function forEach(e, t, n) {
        var _$i, r;
        if (Array.prototype.forEach) return e.forEach(t, n);
        for(_$i = 0, r = e.length; _$i < r; _$i++)t.call(n, e[_$i], _$i, e);
    },
    trim: function trim(e) {
        return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
    },
    trimRight: function trimRight(e) {
        return String.prototype.trimRight ? e.trimRight() : e.replace(/(\s*$)/g, "");
    }
}, $36ad047dac3e028c$var$T = $36ad047dac3e028c$var$S;
var $36ad047dac3e028c$var$$ = function $(e, t) {
    ";" !== (e = $36ad047dac3e028c$var$T.trimRight(e))[e.length - 1] && (e += ";");
    var n = e.length, _$i = !1, r = 0, o = 0, a = "";
    function s() {
        if (!_$i) {
            var n = $36ad047dac3e028c$var$T.trim(e.slice(r, o)), _$s = n.indexOf(":");
            if (-1 !== _$s) {
                var l = $36ad047dac3e028c$var$T.trim(n.slice(0, _$s)), _$c = $36ad047dac3e028c$var$T.trim(n.slice(_$s + 1));
                if (l) {
                    var d = t(r, a.length, l, _$c, n);
                    d && (a += d + "; ");
                }
            }
        }
        r = o + 1;
    }
    for(; o < n; o++){
        var l = e[o];
        if ("/" === l && "*" === e[o + 1]) {
            var _$c = e.indexOf("*/", o + 2);
            if (-1 === _$c) break;
            r = (o = _$c + 1) + 1, _$i = !1;
        } else "(" === l ? _$i = !0 : ")" === l ? _$i = !1 : ";" === l ? _$i || s() : "\n" === l && s();
    }
    return $36ad047dac3e028c$var$T.trim(a);
}, $36ad047dac3e028c$var$I = $36ad047dac3e028c$var$x, $36ad047dac3e028c$var$A = $36ad047dac3e028c$var$$;
function $36ad047dac3e028c$var$N(e) {
    return null == e;
}
function $36ad047dac3e028c$var$L(e) {
    (e = function(e) {
        var t = {};
        for(var n in e)t[n] = e[n];
        return t;
    }(e || {})).whiteList = e.whiteList || $36ad047dac3e028c$var$I.whiteList, e.onAttr = e.onAttr || $36ad047dac3e028c$var$I.onAttr, e.onIgnoreAttr = e.onIgnoreAttr || $36ad047dac3e028c$var$I.onIgnoreAttr, e.safeAttrValue = e.safeAttrValue || $36ad047dac3e028c$var$I.safeAttrValue, this.options = e;
}
$36ad047dac3e028c$var$L.prototype.process = function(e) {
    if (!(e = (e = e || "").toString())) return "";
    var t = this.options, n = t.whiteList, _$i = t.onAttr, r = t.onIgnoreAttr, o = t.safeAttrValue, a = $36ad047dac3e028c$var$A(e, function(e, t, a, s, l) {
        var _$c = n[a], d = !1;
        if (!0 === _$c ? d = _$c : "function" == typeof _$c ? d = _$c(s) : _$c instanceof RegExp && (d = _$c.test(s)), !0 !== d && (d = !1), s = o(a, s)) {
            var u, h = {
                position: t,
                sourcePosition: e,
                source: l,
                isWhite: d
            };
            return d ? $36ad047dac3e028c$var$N(u = _$i(a, s, h)) ? a + ":" + s : u : $36ad047dac3e028c$var$N(u = r(a, s, h)) ? void 0 : u;
        }
    });
    return a;
};
var $36ad047dac3e028c$var$O = $36ad047dac3e028c$var$L;
!function(e, t) {
    var n = $36ad047dac3e028c$var$x, _$i = $36ad047dac3e028c$var$O;
    for(var r in (t = e.exports = function t(e, t) {
        return new _$i(t).process(e);
    }).FilterCSS = _$i, n)t[r] = n[r];
    "undefined" != typeof window && (window.filterCSS = e.exports);
}($36ad047dac3e028c$var$b, $36ad047dac3e028c$var$b.exports);
var $36ad047dac3e028c$var$M = $36ad047dac3e028c$var$b.exports, $36ad047dac3e028c$var$D = {
    indexOf: function indexOf(e, t) {
        var n, _$i;
        if (Array.prototype.indexOf) return e.indexOf(t);
        for(n = 0, _$i = e.length; n < _$i; n++)if (e[n] === t) return n;
        return -1;
    },
    forEach: function forEach(e, t, n) {
        var _$i, r;
        if (Array.prototype.forEach) return e.forEach(t, n);
        for(_$i = 0, r = e.length; _$i < r; _$i++)t.call(n, e[_$i], _$i, e);
    },
    trim: function trim(e) {
        return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
    },
    spaceIndex: function spaceIndex(e) {
        var t = /\s|\n|\t/.exec(e);
        return t ? t.index : -1;
    }
}, $36ad047dac3e028c$var$E = $36ad047dac3e028c$var$M.FilterCSS, $36ad047dac3e028c$var$R = $36ad047dac3e028c$var$M.getDefaultWhiteList, $36ad047dac3e028c$var$H = $36ad047dac3e028c$var$D;
function $36ad047dac3e028c$var$P() {
    return {
        a: [
            "target",
            "href",
            "title"
        ],
        abbr: [
            "title"
        ],
        address: [],
        area: [
            "shape",
            "coords",
            "href",
            "alt"
        ],
        article: [],
        aside: [],
        audio: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "preload",
            "src"
        ],
        b: [],
        bdi: [
            "dir"
        ],
        bdo: [
            "dir"
        ],
        big: [],
        blockquote: [
            "cite"
        ],
        br: [],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: [
            "align",
            "valign",
            "span",
            "width"
        ],
        colgroup: [
            "align",
            "valign",
            "span",
            "width"
        ],
        dd: [],
        del: [
            "datetime"
        ],
        details: [
            "open"
        ],
        div: [],
        dl: [],
        dt: [],
        em: [],
        figcaption: [],
        figure: [],
        font: [
            "color",
            "size",
            "face"
        ],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: [],
        i: [],
        img: [
            "src",
            "alt",
            "title",
            "width",
            "height",
            "loading"
        ],
        ins: [
            "datetime"
        ],
        kbd: [],
        li: [],
        mark: [],
        nav: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: [],
        sub: [],
        summary: [],
        sup: [],
        strong: [],
        strike: [],
        table: [
            "width",
            "border",
            "align",
            "valign"
        ],
        tbody: [
            "align",
            "valign"
        ],
        td: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        tfoot: [
            "align",
            "valign"
        ],
        th: [
            "width",
            "rowspan",
            "colspan",
            "align",
            "valign"
        ],
        thead: [
            "align",
            "valign"
        ],
        tr: [
            "rowspan",
            "align",
            "valign"
        ],
        tt: [],
        u: [],
        ul: [],
        video: [
            "autoplay",
            "controls",
            "crossorigin",
            "loop",
            "muted",
            "playsinline",
            "poster",
            "preload",
            "src",
            "height",
            "width"
        ]
    };
}
var $36ad047dac3e028c$var$j = new $36ad047dac3e028c$var$E;
function $36ad047dac3e028c$var$z(e) {
    return e.replace($36ad047dac3e028c$var$_, "&lt;").replace($36ad047dac3e028c$var$W, "&gt;");
}
var $36ad047dac3e028c$var$_ = /</g, $36ad047dac3e028c$var$W = />/g, $36ad047dac3e028c$var$B = /"/g, $36ad047dac3e028c$var$F = /&quot;/g, $36ad047dac3e028c$var$V = /&#([a-zA-Z0-9]*);?/gim, $36ad047dac3e028c$var$G = /&colon;?/gim, $36ad047dac3e028c$var$q = /&newline;?/gim, $36ad047dac3e028c$var$Y = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi, $36ad047dac3e028c$var$U = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi, $36ad047dac3e028c$var$Z = /u\s*r\s*l\s*\(.*/gi;
function $36ad047dac3e028c$var$X(e) {
    return e.replace($36ad047dac3e028c$var$B, "&quot;");
}
function $36ad047dac3e028c$var$J(e) {
    return e.replace($36ad047dac3e028c$var$F, '"');
}
function $36ad047dac3e028c$var$K(e) {
    return e.replace($36ad047dac3e028c$var$V, function(e, t) {
        return "x" === t[0] || "X" === t[0] ? String.fromCharCode(parseInt(t.substr(1), 16)) : String.fromCharCode(parseInt(t, 10));
    });
}
function $36ad047dac3e028c$var$Q(e) {
    return e.replace($36ad047dac3e028c$var$G, ":").replace($36ad047dac3e028c$var$q, " ");
}
function $36ad047dac3e028c$var$ee(e) {
    for(var t = "", n = 0, _$i = e.length; n < _$i; n++)t += e.charCodeAt(n) < 32 ? " " : e.charAt(n);
    return $36ad047dac3e028c$var$H.trim(t);
}
function $36ad047dac3e028c$var$te(e) {
    return e = $36ad047dac3e028c$var$ee(e = $36ad047dac3e028c$var$Q(e = $36ad047dac3e028c$var$K(e = $36ad047dac3e028c$var$J(e))));
}
function $36ad047dac3e028c$var$ne(e) {
    return e = $36ad047dac3e028c$var$z(e = $36ad047dac3e028c$var$X(e));
}
$36ad047dac3e028c$var$w.whiteList = {
    a: [
        "target",
        "href",
        "title"
    ],
    abbr: [
        "title"
    ],
    address: [],
    area: [
        "shape",
        "coords",
        "href",
        "alt"
    ],
    article: [],
    aside: [],
    audio: [
        "autoplay",
        "controls",
        "crossorigin",
        "loop",
        "muted",
        "preload",
        "src"
    ],
    b: [],
    bdi: [
        "dir"
    ],
    bdo: [
        "dir"
    ],
    big: [],
    blockquote: [
        "cite"
    ],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: [
        "align",
        "valign",
        "span",
        "width"
    ],
    colgroup: [
        "align",
        "valign",
        "span",
        "width"
    ],
    dd: [],
    del: [
        "datetime"
    ],
    details: [
        "open"
    ],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: [
        "color",
        "size",
        "face"
    ],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: [
        "src",
        "alt",
        "title",
        "width",
        "height",
        "loading"
    ],
    ins: [
        "datetime"
    ],
    kbd: [],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: [
        "width",
        "border",
        "align",
        "valign"
    ],
    tbody: [
        "align",
        "valign"
    ],
    td: [
        "width",
        "rowspan",
        "colspan",
        "align",
        "valign"
    ],
    tfoot: [
        "align",
        "valign"
    ],
    th: [
        "width",
        "rowspan",
        "colspan",
        "align",
        "valign"
    ],
    thead: [
        "align",
        "valign"
    ],
    tr: [
        "rowspan",
        "align",
        "valign"
    ],
    tt: [],
    u: [],
    ul: [],
    video: [
        "autoplay",
        "controls",
        "crossorigin",
        "loop",
        "muted",
        "playsinline",
        "poster",
        "preload",
        "src",
        "height",
        "width"
    ]
}, $36ad047dac3e028c$var$w.getDefaultWhiteList = $36ad047dac3e028c$var$P, $36ad047dac3e028c$var$w.onTag = function(e, t, n) {}, $36ad047dac3e028c$var$w.onIgnoreTag = function(e, t, n) {}, $36ad047dac3e028c$var$w.onTagAttr = function(e, t, n) {}, $36ad047dac3e028c$var$w.onIgnoreTagAttr = function(e, t, n) {}, $36ad047dac3e028c$var$w.safeAttrValue = function(e, t, n, i) {
    if (n = $36ad047dac3e028c$var$te(n), "href" === t || "src" === t) {
        if ("#" === (n = $36ad047dac3e028c$var$H.trim(n))) return "#";
        if ("http://" !== n.substr(0, 7) && "https://" !== n.substr(0, 8) && "mailto:" !== n.substr(0, 7) && "tel:" !== n.substr(0, 4) && "data:image/" !== n.substr(0, 11) && "ftp://" !== n.substr(0, 6) && "./" !== n.substr(0, 2) && "../" !== n.substr(0, 3) && "#" !== n[0] && "/" !== n[0]) return "";
    } else if ("background" === t) {
        if ($36ad047dac3e028c$var$Y.lastIndex = 0, $36ad047dac3e028c$var$Y.test(n)) return "";
    } else if ("style" === t) {
        if ($36ad047dac3e028c$var$U.lastIndex = 0, $36ad047dac3e028c$var$U.test(n)) return "";
        if ($36ad047dac3e028c$var$Z.lastIndex = 0, $36ad047dac3e028c$var$Z.test(n) && ($36ad047dac3e028c$var$Y.lastIndex = 0, $36ad047dac3e028c$var$Y.test(n))) return "";
        !1 !== i && (n = (i = i || $36ad047dac3e028c$var$j).process(n));
    }
    return n = $36ad047dac3e028c$var$ne(n);
}, $36ad047dac3e028c$var$w.escapeHtml = $36ad047dac3e028c$var$z, $36ad047dac3e028c$var$w.escapeQuote = $36ad047dac3e028c$var$X, $36ad047dac3e028c$var$w.unescapeQuote = $36ad047dac3e028c$var$J, $36ad047dac3e028c$var$w.escapeHtmlEntities = $36ad047dac3e028c$var$K, $36ad047dac3e028c$var$w.escapeDangerHtml5Entities = $36ad047dac3e028c$var$Q, $36ad047dac3e028c$var$w.clearNonPrintableCharacter = $36ad047dac3e028c$var$ee, $36ad047dac3e028c$var$w.friendlyAttrValue = $36ad047dac3e028c$var$te, $36ad047dac3e028c$var$w.escapeAttrValue = $36ad047dac3e028c$var$ne, $36ad047dac3e028c$var$w.onIgnoreTagStripAll = function() {
    return "";
}, $36ad047dac3e028c$var$w.StripTagBody = function(e, t) {
    "function" != typeof t && (t = function t() {});
    var n = !Array.isArray(e), _$i = [], r = !1;
    return {
        onIgnoreTag: function onIgnoreTag(o, a, s) {
            if (function(t) {
                return !!n || -1 !== $36ad047dac3e028c$var$H.indexOf(e, t);
            }(o)) {
                if (s.isClosing) {
                    var l = "[/removed]", _$c = s.position + 10;
                    return _$i.push([
                        !1 !== r ? r : s.position,
                        _$c
                    ]), r = !1, l;
                }
                return r || (r = s.position), "[removed]";
            }
            return t(o, a, s);
        },
        remove: function remove(e) {
            var _$t = "", n = 0;
            return $36ad047dac3e028c$var$H.forEach(_$i, function(i) {
                _$t += e.slice(n, i[0]), n = i[1];
            }), _$t += e.slice(n);
        }
    };
}, $36ad047dac3e028c$var$w.stripCommentTag = function(e) {
    for(var t = "", n = 0; n < e.length;){
        var _$i = e.indexOf("<!--", n);
        if (-1 === _$i) {
            t += e.slice(n);
            break;
        }
        t += e.slice(n, _$i);
        var r = e.indexOf("-->", _$i);
        if (-1 === r) break;
        n = r + 3;
    }
    return t;
}, $36ad047dac3e028c$var$w.stripBlankChar = function(e) {
    var t = e.split("");
    return t = t.filter(function(e) {
        var t = e.charCodeAt(0);
        return 127 !== t && (!(t <= 31) || 10 === t || 13 === t);
    }), t.join("");
}, $36ad047dac3e028c$var$w.attributeWrapSign = '"', $36ad047dac3e028c$var$w.cssFilter = $36ad047dac3e028c$var$j, $36ad047dac3e028c$var$w.getDefaultCSSWhiteList = $36ad047dac3e028c$var$R;
var $36ad047dac3e028c$var$ie = {}, $36ad047dac3e028c$var$re = $36ad047dac3e028c$var$D;
function $36ad047dac3e028c$var$oe(e) {
    var t, n = $36ad047dac3e028c$var$re.spaceIndex(e);
    return t = -1 === n ? e.slice(1, -1) : e.slice(1, n + 1), "/" === (t = $36ad047dac3e028c$var$re.trim(t).toLowerCase()).slice(0, 1) && (t = t.slice(1)), "/" === t.slice(-1) && (t = t.slice(0, -1)), t;
}
function $36ad047dac3e028c$var$ae(e) {
    return "</" === e.slice(0, 2);
}
var $36ad047dac3e028c$var$se = /[^a-zA-Z0-9\\_:.-]/gim;
function $36ad047dac3e028c$var$le(e, t) {
    for(; t < e.length; t++){
        var n = e[t];
        if (" " !== n) return "=" === n ? t : -1;
    }
}
function $36ad047dac3e028c$var$ce(e, t) {
    for(; t < e.length; t++){
        var n = e[t];
        if (" " !== n) return "'" === n || '"' === n ? t : -1;
    }
}
function $36ad047dac3e028c$var$de(e, t) {
    for(; t > 0; t--){
        var n = e[t];
        if (" " !== n) return "=" === n ? t : -1;
    }
}
function $36ad047dac3e028c$var$ue(e) {
    return function(e) {
        return '"' === e[0] && '"' === e[e.length - 1] || "'" === e[0] && "'" === e[e.length - 1];
    }(e) ? e.substr(1, e.length - 2) : e;
}
$36ad047dac3e028c$var$ie.parseTag = function(e, t, n) {
    var _$i = "", r = 0, o = !1, a = !1, s = 0, l = e.length, _$c = "", d = "";
    e: for(s = 0; s < l; s++){
        var u = e.charAt(s);
        if (!1 === o) {
            if ("<" === u) {
                o = s;
                continue;
            }
        } else if (!1 === a) {
            if ("<" === u) {
                _$i += n(e.slice(r, s)), o = s, r = s;
                continue;
            }
            if (">" === u || s === l - 1) {
                _$i += n(e.slice(r, o)), _$c = $36ad047dac3e028c$var$oe(d = e.slice(o, s + 1)), _$i += t(o, _$i.length, _$c, d, $36ad047dac3e028c$var$ae(d)), r = s + 1, o = !1;
                continue;
            }
            if ('"' === u || "'" === u) for(var h = 1, _$p = e.charAt(s - h); "" === _$p.trim() || "=" === _$p;){
                if ("=" === _$p) {
                    a = u;
                    continue e;
                }
                _$p = e.charAt(s - ++h);
            }
        } else if (u === a) {
            a = !1;
            continue;
        }
    }
    return r < l && (_$i += n(e.substr(r))), _$i;
}, $36ad047dac3e028c$var$ie.parseAttr = function(e, t) {
    var n = 0, _$i = 0, r = [], o = !1, a = e.length;
    function s(e, n) {
        if (!((e = (e = $36ad047dac3e028c$var$re.trim(e)).replace($36ad047dac3e028c$var$se, "").toLowerCase()).length < 1)) {
            var _$i = t(e, n || "");
            _$i && r.push(_$i);
        }
    }
    for(var l = 0; l < a; l++){
        var _$c, d = e.charAt(l);
        if (!1 !== o || "=" !== d) {
            if (!1 === o || l !== _$i) {
                if (/\s|\n|\t/.test(d)) {
                    if (e = e.replace(/\s|\n|\t/g, " "), !1 === o) {
                        if (-1 === (_$c = $36ad047dac3e028c$var$le(e, l))) {
                            s($36ad047dac3e028c$var$re.trim(e.slice(n, l))), o = !1, n = l + 1;
                            continue;
                        }
                        l = _$c - 1;
                        continue;
                    }
                    if (-1 === (_$c = $36ad047dac3e028c$var$de(e, l - 1))) {
                        s(o, $36ad047dac3e028c$var$ue($36ad047dac3e028c$var$re.trim(e.slice(n, l)))), o = !1, n = l + 1;
                        continue;
                    }
                }
            } else {
                if (-1 === (_$c = e.indexOf(d, l + 1))) break;
                s(o, $36ad047dac3e028c$var$re.trim(e.slice(_$i + 1, _$c))), o = !1, n = (l = _$c) + 1;
            }
        } else o = e.slice(n, l), n = l + 1, _$i = '"' === e.charAt(n) || "'" === e.charAt(n) ? n : $36ad047dac3e028c$var$ce(e, l + 1);
    }
    return n < e.length && (!1 === o ? s(e.slice(n)) : s(o, $36ad047dac3e028c$var$ue($36ad047dac3e028c$var$re.trim(e.slice(n))))), $36ad047dac3e028c$var$re.trim(r.join(" "));
};
var $36ad047dac3e028c$var$he = $36ad047dac3e028c$var$M.FilterCSS, $36ad047dac3e028c$var$pe = $36ad047dac3e028c$var$w, $36ad047dac3e028c$var$me = $36ad047dac3e028c$var$ie, $36ad047dac3e028c$var$fe = $36ad047dac3e028c$var$me.parseTag, $36ad047dac3e028c$var$ge = $36ad047dac3e028c$var$me.parseAttr, $36ad047dac3e028c$var$ve = $36ad047dac3e028c$var$D;
function $36ad047dac3e028c$var$ye(e) {
    return null == e;
}
function $36ad047dac3e028c$var$we(e) {
    (e = function(e) {
        var t = {};
        for(var n in e)t[n] = e[n];
        return t;
    }(e || {})).stripIgnoreTag && (e.onIgnoreTag, e.onIgnoreTag = $36ad047dac3e028c$var$pe.onIgnoreTagStripAll), e.whiteList || e.allowList ? e.whiteList = function(e) {
        var t = {};
        for(var n in e)Array.isArray(e[n]) ? t[n.toLowerCase()] = e[n].map(function(e) {
            return e.toLowerCase();
        }) : t[n.toLowerCase()] = e[n];
        return t;
    }(e.whiteList || e.allowList) : e.whiteList = $36ad047dac3e028c$var$pe.whiteList, this.attributeWrapSign = !0 === e.singleQuotedAttributeValue ? "'" : $36ad047dac3e028c$var$pe.attributeWrapSign, e.onTag = e.onTag || $36ad047dac3e028c$var$pe.onTag, e.onTagAttr = e.onTagAttr || $36ad047dac3e028c$var$pe.onTagAttr, e.onIgnoreTag = e.onIgnoreTag || $36ad047dac3e028c$var$pe.onIgnoreTag, e.onIgnoreTagAttr = e.onIgnoreTagAttr || $36ad047dac3e028c$var$pe.onIgnoreTagAttr, e.safeAttrValue = e.safeAttrValue || $36ad047dac3e028c$var$pe.safeAttrValue, e.escapeHtml = e.escapeHtml || $36ad047dac3e028c$var$pe.escapeHtml, this.options = e, !1 === e.css ? this.cssFilter = !1 : (e.css = e.css || {}, this.cssFilter = new $36ad047dac3e028c$var$he(e.css));
}
$36ad047dac3e028c$var$we.prototype.process = function(e) {
    if (!(e = (e = e || "").toString())) return "";
    var t = this, n = t.options, _$i = n.whiteList, r = n.onTag, o = n.onIgnoreTag, a = n.onTagAttr, s = n.onIgnoreTagAttr, l = n.safeAttrValue, _$c = n.escapeHtml, d = t.attributeWrapSign, u = t.cssFilter;
    n.stripBlankChar && (e = $36ad047dac3e028c$var$pe.stripBlankChar(e)), n.allowCommentTag || (e = $36ad047dac3e028c$var$pe.stripCommentTag(e));
    var h = !1;
    n.stripIgnoreTagBody && (h = $36ad047dac3e028c$var$pe.StripTagBody(n.stripIgnoreTagBody, o), o = h.onIgnoreTag);
    var _$p = $36ad047dac3e028c$var$fe(e, function(e, t, n, h, p) {
        var _$m = {
            sourcePosition: e,
            position: t,
            isClosing: p,
            isWhite: Object.prototype.hasOwnProperty.call(_$i, n)
        }, f = r(n, h, _$m);
        if (!$36ad047dac3e028c$var$ye(f)) return f;
        if (_$m.isWhite) {
            if (_$m.isClosing) return "</" + n + ">";
            var g = function(e) {
                var _$t = $36ad047dac3e028c$var$ve.spaceIndex(e);
                if (-1 === _$t) return {
                    html: "",
                    closing: "/" === e[e.length - 2]
                };
                var _$n = "/" === (e = $36ad047dac3e028c$var$ve.trim(e.slice(_$t + 1, -1)))[e.length - 1];
                return _$n && (e = $36ad047dac3e028c$var$ve.trim(e.slice(0, -1))), {
                    html: e,
                    closing: _$n
                };
            }(h), _$v = _$i[n], y = $36ad047dac3e028c$var$ge(g.html, function(e, t) {
                var _$i = -1 !== $36ad047dac3e028c$var$ve.indexOf(_$v, e), r = a(n, e, t, _$i);
                return $36ad047dac3e028c$var$ye(r) ? _$i ? (t = l(n, e, t, u)) ? e + "=" + d + t + d : e : $36ad047dac3e028c$var$ye(r = s(n, e, t, _$i)) ? void 0 : r : r;
            });
            return h = "<" + n, y && (h += " " + y), g.closing && (h += " /"), h += ">";
        }
        return $36ad047dac3e028c$var$ye(f = o(n, h, _$m)) ? _$c(h) : f;
    }, _$c);
    return h && (_$p = h.remove(_$p)), _$p;
};
var $36ad047dac3e028c$var$be = $36ad047dac3e028c$var$we;
!function(e, t) {
    var n = $36ad047dac3e028c$var$w, _$i = $36ad047dac3e028c$var$ie, r = $36ad047dac3e028c$var$be;
    function o(e, t) {
        return new r(t).process(e);
    }
    (t = e.exports = o).filterXSS = o, t.FilterXSS = r, function() {
        for(var _$e in n)t[_$e] = n[_$e];
        for(var r in _$i)t[r] = _$i[r];
    }(), "undefined" != typeof window && (window.filterXSS = e.exports), "undefined" != typeof self && "undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope && (self.filterXSS = e.exports);
}($36ad047dac3e028c$var$y, $36ad047dac3e028c$var$y.exports);
var $36ad047dac3e028c$var$xe = $36ad047dac3e028c$var$v($36ad047dac3e028c$var$y.exports);
var $36ad047dac3e028c$var$Ce = {
    cardBgColor: "#ffffff",
    cardDetailsBackGround: "#ffffff",
    cardDetailsColor: "#000",
    cardMediaBgColor: "#f5f5f5",
    cardSubtitleColor: "#000",
    cardTitleColor: "#007FFF",
    detailsColor: "#000",
    iconBackgroundColor: "#007FFF",
    nestedCardBgColor: "#f5f5f5",
    nestedCardDetailsBackGround: "#f5f5f5",
    nestedCardDetailsColor: "#000",
    nestedCardSubtitleColor: "#000",
    nestedCardTitleColor: "#000",
    primary: "#007FFF",
    secondary: "#ffdf00",
    titleColor: "#007FFF",
    titleColorActive: "#007FFF",
    toolbarBgColor: "#f5f5f5",
    toolbarBtnBgColor: "#fff",
    toolbarTextColor: "#000"
}, $36ad047dac3e028c$var$ke = {
    cardBgColor: "#191919",
    cardDetailsBackGround: "#191919",
    cardDetailsColor: "#ffff0f",
    cardMediaBgColor: "#2f2f2f",
    cardSubtitleColor: "#ffffff",
    cardTitleColor: "#007FFF",
    detailsColor: "#ffffff",
    iconBackgroundColor: "#007FFF",
    nestedCardBgColor: "#333333",
    nestedCardDetailsBackGround: "#333333",
    nestedCardDetailsColor: "#ffffff",
    nestedCardSubtitleColor: "#ffffff",
    nestedCardTitleColor: "#ffffff",
    primary: "#007FFF",
    secondary: "#ffdf00",
    titleColor: "#007FFF",
    titleColorActive: "#007FFF",
    toolbarBgColor: "#555",
    toolbarBtnBgColor: "#222",
    toolbarTextColor: "#ffffff"
}, $36ad047dac3e028c$var$Se = function(e, t) {
    return "rgba(".concat(parseInt(e.slice(1, 3), 16), ", ").concat(parseInt(e.slice(3, 5), 16), ", ").concat(parseInt(e.slice(5, 7), 16), ", ").concat(t, ")");
}, $36ad047dac3e028c$var$Te = function(e) {
    return "HORIZONTAL" === e || "VERTICAL" === e ? "reveal" : "VERTICAL_ALTERNATING" === e ? "slide_from_sides" : "reveal";
}, $36ad047dac3e028c$var$$e = function() {
    var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var t = "";
    var n = new Uint32Array(7);
    window.crypto.getRandomValues(n);
    for(var _$i = 0; _$i < n.length; _$i++)t += e[n[_$i] % 62];
    return t;
};
var $36ad047dac3e028c$var$Ie = {
    exports: {}
};
$36ad047dac3e028c$var$Ie.exports = function() {
    var e = 1e3, t = 6e4, n = 36e5, _$i = "millisecond", r = "second", o = "minute", a = "hour", s = "day", l = "week", _$c = "month", d = "quarter", u = "year", h = "date", _$p = "Invalid Date", _$m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, f = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(e) {
            var t = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = e % 100;
            return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
        }
    }, _$v = function v(e, t, n) {
        var _$i = String(e);
        return !_$i || _$i.length >= t ? e : "" + Array(t + 1 - _$i.length).join(n) + e;
    }, y = {
        s: _$v,
        z: function z(e) {
            var t = -e.utcOffset(), n = Math.abs(t), _$i = Math.floor(n / 60), r = n % 60;
            return (t <= 0 ? "+" : "-") + _$v(_$i, 2, "0") + ":" + _$v(r, 2, "0");
        },
        m: function e(t, n) {
            if (t.date() < n.date()) return -e(n, t);
            var _$i = 12 * (n.year() - t.year()) + (n.month() - t.month()), r = t.clone().add(_$i, _$c), o = n - r < 0, a = t.clone().add(_$i + (o ? -1 : 1), _$c);
            return +(-(_$i + (n - r) / (o ? r - a : a - r)) || 0);
        },
        a: function a(e) {
            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
        },
        p: function p(e) {
            return ({
                M: _$c,
                y: u,
                w: l,
                d: s,
                D: h,
                h: a,
                m: o,
                s: r,
                ms: _$i,
                Q: d
            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
        },
        u: function u(e) {
            return void 0 === e;
        }
    }, w = "en", b = {};
    b[w] = g;
    var x = "$isDayjsObject", _$C = function C(e) {
        return e instanceof $ || !(!e || !e[x]);
    }, k = function e(t, n, i) {
        var r;
        if (!t) return w;
        if ("string" == typeof t) {
            var o = t.toLowerCase();
            b[o] && (r = o), n && (b[o] = n, r = o);
            var a = t.split("-");
            if (!r && a.length > 1) return e(a[0]);
        } else {
            var s = t.name;
            b[s] = t, r = s;
        }
        return !i && r && (w = r), r || !i && w;
    }, S = function S(e, t) {
        if (_$C(e)) return e.clone();
        var n = "object" == typeof t ? t : {};
        return n.date = e, n.args = arguments, new $(n);
    }, T = y;
    T.l = k, T.i = _$C, T.w = function(e, t) {
        return S(e, {
            locale: t.$L,
            utc: t.$u,
            x: t.$x,
            $offset: t.$offset
        });
    };
    var $ = function() {
        function g(e) {
            this.$L = k(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
        }
        var _$v = g.prototype;
        return _$v.parse = function(e) {
            this.$d = function(e) {
                var t = e.date, n = e.utc;
                if (null === t) return new Date(NaN);
                if (T.u(t)) return new Date;
                if (t instanceof Date) return new Date(t);
                if ("string" == typeof t && !/Z$/i.test(t)) {
                    var _$i = t.match(_$m);
                    if (_$i) {
                        var r = _$i[2] - 1 || 0, o = (_$i[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(_$i[1], r, _$i[3] || 1, _$i[4] || 0, _$i[5] || 0, _$i[6] || 0, o)) : new Date(_$i[1], r, _$i[3] || 1, _$i[4] || 0, _$i[5] || 0, _$i[6] || 0, o);
                    }
                }
                return new Date(t);
            }(e), this.init();
        }, _$v.init = function() {
            var e = this.$d;
            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
        }, _$v.$utils = function() {
            return T;
        }, _$v.isValid = function() {
            return !(this.$d.toString() === _$p);
        }, _$v.isSame = function(e, t) {
            var n = S(e);
            return this.startOf(t) <= n && n <= this.endOf(t);
        }, _$v.isAfter = function(e, t) {
            return S(e) < this.startOf(t);
        }, _$v.isBefore = function(e, t) {
            return this.endOf(t) < S(e);
        }, _$v.$g = function(e, t, n) {
            return T.u(e) ? this[t] : this.set(n, e);
        }, _$v.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, _$v.valueOf = function() {
            return this.$d.getTime();
        }, _$v.startOf = function(e, t) {
            var n = this, _$i = !!T.u(t) || t, d = T.p(e), _$p = function p(e, t) {
                var r = T.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
                return _$i ? r : r.endOf(s);
            }, _$m = function m(e, t) {
                return T.w(n.toDate()[e].apply(n.toDate("s"), (_$i ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(t)), n);
            }, f = this.$W, _$g = this.$M, _$v = this.$D, y = "set" + (this.$u ? "UTC" : "");
            switch(d){
                case u:
                    return _$i ? _$p(1, 0) : _$p(31, 11);
                case _$c:
                    return _$i ? _$p(1, _$g) : _$p(0, _$g + 1);
                case l:
                    var w = this.$locale().weekStart || 0, b = (f < w ? f + 7 : f) - w;
                    return _$p(_$i ? _$v - b : _$v + (6 - b), _$g);
                case s:
                case h:
                    return _$m(y + "Hours", 0);
                case a:
                    return _$m(y + "Minutes", 1);
                case o:
                    return _$m(y + "Seconds", 2);
                case r:
                    return _$m(y + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, _$v.endOf = function(e) {
            return this.startOf(e, !1);
        }, _$v.$set = function(e, t) {
            var n, l = T.p(e), d = "set" + (this.$u ? "UTC" : ""), _$p = (n = {}, n[s] = d + "Date", n[h] = d + "Date", n[_$c] = d + "Month", n[u] = d + "FullYear", n[a] = d + "Hours", n[o] = d + "Minutes", n[r] = d + "Seconds", n[_$i] = d + "Milliseconds", n)[l], _$m = l === s ? this.$D + (t - this.$W) : t;
            if (l === _$c || l === u) {
                var f = this.clone().set(h, 1);
                f.$d[_$p](_$m), f.init(), this.$d = f.set(h, Math.min(this.$D, f.daysInMonth())).$d;
            } else _$p && this.$d[_$p](_$m);
            return this.init(), this;
        }, _$v.set = function(e, t) {
            return this.clone().$set(e, t);
        }, _$v.get = function(e) {
            return this[T.p(e)]();
        }, _$v.add = function(i, d) {
            var h, _$p = this;
            i = Number(i);
            var _$m = T.p(d), f = function f(e) {
                var t = S(_$p);
                return T.w(t.date(t.date() + Math.round(e * i)), _$p);
            };
            if (_$m === _$c) return this.set(_$c, this.$M + i);
            if (_$m === u) return this.set(u, this.$y + i);
            if (_$m === s) return f(1);
            if (_$m === l) return f(7);
            var _$g = (h = {}, h[o] = t, h[a] = n, h[r] = e, h)[_$m] || 1, _$v = this.$d.getTime() + i * _$g;
            return T.w(_$v, this);
        }, _$v.subtract = function(e, t) {
            return this.add(-1 * e, t);
        }, _$v.format = function(e) {
            var t = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || _$p;
            var _$i = e || "YYYY-MM-DDTHH:mm:ssZ", r = T.z(this), o = this.$H, a = this.$m, s = this.$M, l = n.weekdays, _$c = n.months, d = n.meridiem, u = function u(e, n, r, o) {
                return e && (e[n] || e(t, _$i)) || r[n].slice(0, o);
            }, h = function h(e) {
                return T.s(o % 12 || 12, e, "0");
            }, _$m = d || function(e, t, n) {
                var _$i = e < 12 ? "AM" : "PM";
                return n ? _$i.toLowerCase() : _$i;
            };
            return _$i.replace(f, function(e, i) {
                return i || function(e) {
                    switch(e){
                        case "YY":
                            return String(t.$y).slice(-2);
                        case "YYYY":
                            return T.s(t.$y, 4, "0");
                        case "M":
                            return s + 1;
                        case "MM":
                            return T.s(s + 1, 2, "0");
                        case "MMM":
                            return u(n.monthsShort, s, _$c, 3);
                        case "MMMM":
                            return u(_$c, s);
                        case "D":
                            return t.$D;
                        case "DD":
                            return T.s(t.$D, 2, "0");
                        case "d":
                            return String(t.$W);
                        case "dd":
                            return u(n.weekdaysMin, t.$W, l, 2);
                        case "ddd":
                            return u(n.weekdaysShort, t.$W, l, 3);
                        case "dddd":
                            return l[t.$W];
                        case "H":
                            return String(o);
                        case "HH":
                            return T.s(o, 2, "0");
                        case "h":
                            return h(1);
                        case "hh":
                            return h(2);
                        case "a":
                            return _$m(o, a, !0);
                        case "A":
                            return _$m(o, a, !1);
                        case "m":
                            return String(a);
                        case "mm":
                            return T.s(a, 2, "0");
                        case "s":
                            return String(t.$s);
                        case "ss":
                            return T.s(t.$s, 2, "0");
                        case "SSS":
                            return T.s(t.$ms, 3, "0");
                        case "Z":
                            return r;
                    }
                    return null;
                }(e) || r.replace(":", "");
            });
        }, _$v.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, _$v.diff = function(i, h, p) {
            var _$m, f = this, _$g = T.p(h), _$v = S(i), y = (_$v.utcOffset() - this.utcOffset()) * t, w = this - _$v, b = function b() {
                return T.m(f, _$v);
            };
            switch(_$g){
                case u:
                    _$m = b() / 12;
                    break;
                case _$c:
                    _$m = b();
                    break;
                case d:
                    _$m = b() / 3;
                    break;
                case l:
                    _$m = (w - y) / 6048e5;
                    break;
                case s:
                    _$m = (w - y) / 864e5;
                    break;
                case a:
                    _$m = w / n;
                    break;
                case o:
                    _$m = w / t;
                    break;
                case r:
                    _$m = w / e;
                    break;
                default:
                    _$m = w;
            }
            return p ? _$m : T.a(_$m);
        }, _$v.daysInMonth = function() {
            return this.endOf(_$c).$D;
        }, _$v.$locale = function() {
            return b[this.$L];
        }, _$v.locale = function(e, t) {
            if (!e) return this.$L;
            var n = this.clone(), _$i = k(e, t, !0);
            return _$i && (n.$L = _$i), n;
        }, _$v.clone = function() {
            return T.w(this.$d, this);
        }, _$v.toDate = function() {
            return new Date(this.valueOf());
        }, _$v.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, _$v.toISOString = function() {
            return this.$d.toISOString();
        }, _$v.toString = function() {
            return this.$d.toUTCString();
        }, g;
    }(), I = $.prototype;
    return S.prototype = I, [
        [
            "$ms",
            _$i
        ],
        [
            "$s",
            r
        ],
        [
            "$m",
            o
        ],
        [
            "$H",
            a
        ],
        [
            "$W",
            s
        ],
        [
            "$M",
            _$c
        ],
        [
            "$y",
            u
        ],
        [
            "$D",
            h
        ]
    ].forEach(function(e) {
        I[e[1]] = function(t) {
            return this.$g(t, e[0], e[1]);
        };
    }), S.extend = function(e, t) {
        return e.$i || (e(t, $, S), e.$i = !0), S;
    }, S.locale = k, S.isDayjs = _$C, S.unix = function(e) {
        return S(1e3 * e);
    }, S.en = b[w], S.Ls = b, S.p = {}, S;
}();
var $36ad047dac3e028c$var$Ae = $36ad047dac3e028c$var$v($36ad047dac3e028c$var$Ie.exports);
var $36ad047dac3e028c$var$Ne = function(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    var _s = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), _$i = _s[0], _$c = _s[1], d = (0, $33gHU.useRef)(window.matchMedia(e)), u = (0, $33gHU.useCallback)(function() {
        return _$c(d.current.matches);
    }, [
        d
    ]), h = function(e, t, n) {
        var _$i = this, _$s = (0, $33gHU.useRef)(null), _$l = (0, $33gHU.useRef)(0), _$c = (0, $33gHU.useRef)(null), d = (0, $33gHU.useRef)([]), u = (0, $33gHU.useRef)(), h = (0, $33gHU.useRef)(), _$p = (0, $33gHU.useRef)(e), _$m = (0, $33gHU.useRef)(!0);
        _$p.current = e;
        var f = "undefined" != typeof window, g = !t && 0 !== t && f;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        t = +t || 0;
        var _$v = !!(n = n || {}).leading, y = !("trailing" in n) || !!n.trailing, w = "maxWait" in n, b = "debounceOnServer" in n && !!n.debounceOnServer, x = w ? Math.max(+n.maxWait || 0, t) : null;
        (0, $33gHU.useEffect)(function() {
            return _$m.current = !0, function() {
                _$m.current = !1;
            };
        }, []);
        var _$C = (0, $33gHU.useMemo)(function() {
            var _$e = function e(e) {
                var _$t = d.current, _$n = u.current;
                return d.current = u.current = null, _$l.current = e, h.current = _$p.current.apply(_$n, _$t);
            }, _$n = function n(e, t) {
                g && cancelAnimationFrame(_$c.current), _$c.current = g ? requestAnimationFrame(e) : setTimeout(e, t);
            }, _$r = function r(e) {
                if (!_$m.current) return !1;
                var _$n = e - _$s.current;
                return !_$s.current || _$n >= t || _$n < 0 || w && e - _$l.current >= x;
            }, _$o = function o(t) {
                return _$c.current = null, y && d.current ? _$e(t) : (d.current = u.current = null, h.current);
            }, _$a = function e() {
                var _$i = Date.now();
                if (_$r(_$i)) return _$o(_$i);
                if (_$m.current) {
                    var _$a = t - (_$i - _$s.current), _$c = w ? Math.min(_$a, x - (_$i - _$l.current)) : _$a;
                    _$n(e, _$c);
                }
            }, _$C = function C() {
                if (f || b) {
                    var _$o = Date.now(), _$p = _$r(_$o);
                    if (d.current = [].slice.call(arguments), u.current = _$i, _$s.current = _$o, _$p) {
                        if (!_$c.current && _$m.current) return _$l.current = _$s.current, _$n(_$a, t), _$v ? _$e(_$s.current) : h.current;
                        if (w) return _$n(_$a, t), _$e(_$s.current);
                    }
                    return _$c.current || _$n(_$a, t), h.current;
                }
            };
            return _$C.cancel = function() {
                _$c.current && (g ? cancelAnimationFrame(_$c.current) : clearTimeout(_$c.current)), _$l.current = 0, d.current = _$s.current = u.current = _$c.current = null;
            }, _$C.isPending = function() {
                return !!_$c.current;
            }, _$C.flush = function() {
                return _$c.current ? _$o(Date.now()) : h.current;
            }, _$C;
        }, [
            _$v,
            w,
            t,
            x,
            y,
            g,
            f,
            b
        ]);
        return _$C;
    }(function() {
        var _$e = d.current.matches;
        _$e !== _$i && _$c(_$e);
    }, 100);
    return (0, $33gHU.useEffect)(function() {
        var _$e = d.current;
        if (!n || !_$e) return;
        var _$t = _$e.matches;
        return _$t !== _$i && _$c(_$t), _$e.addEventListener("change", u), window.addEventListener("resize", h), function() {
            _$e.removeEventListener("change", u), window.removeEventListener("resize", h);
        };
    }, [
        e,
        n,
        d
    ]), (0, $33gHU.useEffect)(function() {
        _$i && t && t();
    }, [
        _$i,
        t
    ]), _$i;
}, $36ad047dac3e028c$var$Le = (0, $33gHU.createContext)({}), $36ad047dac3e028c$var$Oe = function(t) {
    var tmp = t.cardHeight, n = tmp === void 0 ? 200 : tmp, tmp1 = t.cardLess, _$i = tmp1 === void 0 ? !1 : tmp1, r = t.flipLayout, tmp2 = t.items, o = tmp2 === void 0 ? [] : tmp2, _$c = t.theme, d = t.buttonTexts, u = t.classNames, tmp3 = t.mode, h = tmp3 === void 0 ? "VERTICAL_ALTERNATING" : tmp3, _$p = t.fontSizes, _$m = t.textOverlay, f = t.darkMode, g = t.slideShow, _$v = t.onThemeChange, y = t.mediaSettings, tmp4 = t.mediaHeight, w = tmp4 === void 0 ? 200 : tmp4, tmp5 = t.contentDetailsHeight, b = tmp5 === void 0 ? 10 : tmp5, x = t.showAllCardsHorizontal, tmp6 = t.textDensity, _$C = tmp6 === void 0 ? "HIGH" : tmp6, tmp7 = t.responsiveBreakPoint, k = tmp7 === void 0 ? 1024 : tmp7, S = t.enableBreakPoint, _s = (0, $fTrHk._)((0, $33gHU.useState)(f), 2), T = _s[0], $ = _s[1], _s1 = (0, $fTrHk._)((0, $33gHU.useState)(x || !1), 2), I = _s1[0], A = _s1[1], _s2 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), N = _s2[0], _$L = _s2[1], _s3 = (0, $fTrHk._)((0, $33gHU.useState)(_$C), 2), O = _s3[0], M = _s3[1], D = (0, $33gHU.useMemo)(function() {
        return Math.max(b || 0 + w || 0, n);
    }, []), E = (0, $33gHU.useMemo)(function() {
        var _$e = Math.round(.75 * D);
        return b > D ? Math.min(b, _$e) : Math.max(b, _$e);
    }, [
        D
    ]), R = (0, $33gHU.useCallback)(function() {
        $(!T), null == _$v || _$v();
    }, [
        T
    ]), H = (0, $33gHU.useCallback)(function(e) {
        A(e);
    }, [
        I
    ]), _$P = (0, $33gHU.useCallback)(function(e) {
        M(e);
    }, [
        O
    ]);
    $36ad047dac3e028c$var$Ne("(max-width: ".concat(k - 1, "px)"), function() {
        return _$L(!0);
    }, S), $36ad047dac3e028c$var$Ne("(min-width: ".concat(k, "px)"), function() {
        return _$L(!1);
    }, S);
    var j = (0, $33gHU.useMemo)(function() {
        var _$e;
        return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
            borderLessCards: !1,
            cardHeight: D,
            cardLess: !1,
            disableAutoScrollOnClick: !!t.disableInteraction,
            disableClickOnCircle: !!t.disableInteraction,
            disableInteraction: !1,
            disableTimelinePoint: !!t.disableInteraction,
            disableToolbar: !1,
            enableBreakPoint: !0,
            enableDarkToggle: !1,
            enableLayoutSwitch: !0,
            enableQuickJump: !0,
            focusActiveItemOnLoad: !1,
            highlightCardsOnHover: !1,
            lineWidth: 3,
            mediaHeight: 200,
            nestedCardHeight: 150,
            parseDetailsAsHTML: !1,
            scrollable: {
                scrollbar: !1
            },
            showProgressOnSlideshow: g,
            slideItemDuration: 2e3,
            slideShowType: $36ad047dac3e028c$var$Te(h),
            textOverlay: !1,
            timelinePointDimension: 16,
            timelinePointShape: "circle",
            titleDateFormat: "MMM DD, YYYY",
            toolbarPosition: "top",
            uniqueId: "react-chrono",
            useReadMore: !0
        }, t), {
            activeItemIndex: r ? (null == o ? void 0 : o.length) - 1 : 0,
            buttonTexts: (0, $8b7df3d651e6781e$export$71511d61b312f219)({
                changeDensity: "Change density",
                changeDensityOptions: {
                    high: {
                        helpText: "Show more items at once",
                        text: "High"
                    },
                    low: {
                        helpText: "Show fewer items at once",
                        text: "Low"
                    }
                },
                changeLayout: "Change layout",
                changeLayoutOptions: {
                    alternating: {
                        helpText: "Show cards in a vertical layout with alternating fashion",
                        text: "Alternating"
                    },
                    horizontal: {
                        helpText: "Show cards in a horizontal layout",
                        text: "Horizontal"
                    },
                    horizontal_all: {
                        helpText: "Show all cards in a horizontal layout",
                        text: "Show all cards"
                    },
                    vertical: {
                        helpText: "Show cards in a vertical layout",
                        text: "Vertical"
                    }
                },
                dark: "Switch to Dark Mode",
                first: "Go to First",
                jumpTo: "Jump to",
                last: "Go to Last",
                light: "Switch to Light Mode",
                next: "Next",
                play: "Play Slideshow",
                previous: "Previous",
                stop: "Stop Slideshow"
            }, d),
            cardHeight: _$i ? n || 80 : n,
            classNames: (0, $8b7df3d651e6781e$export$71511d61b312f219)({
                card: "rc-card",
                cardMedia: "rc-card-media",
                cardSubTitle: "rc-card-subtitle",
                cardText: "rc-card-text",
                cardTitle: "rc-card-title",
                controls: "rc-controls",
                title: "rc-title"
            }, u),
            contentDetailsHeight: E,
            darkMode: T,
            fontSizes: (0, $8b7df3d651e6781e$export$71511d61b312f219)({
                cardSubtitle: "0.85rem",
                cardText: "1rem",
                cardTitle: "1rem",
                title: "1rem"
            }, _$p),
            isMobile: N,
            mediaSettings: (0, $8b7df3d651e6781e$export$71511d61b312f219)({
                align: "VERTICAL" !== h || _$m ? "center" : "left",
                imageFit: "cover"
            }, y),
            showAllCardsHorizontal: I,
            textDensity: O,
            theme: (0, $8b7df3d651e6781e$export$71511d61b312f219)({}, (_$e = T, _$e ? $36ad047dac3e028c$var$ke : $36ad047dac3e028c$var$Ce), _$c),
            toggleDarkMode: R,
            updateHorizontalAllCards: H,
            updateTextContentDensity: _$P
        });
    }, [
        E,
        D,
        T,
        R,
        H,
        O,
        N
    ]), _$z = (0, $33gHU.useMemo)(function() {
        return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, j), {
            darkMode: T,
            toggleDarkMode: R,
            updateHorizontalAllCards: H
        });
    }, [
        j,
        T
    ]), _ = t.children;
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Le.Provider, {
        value: _$z,
        children: _
    });
};
var $36ad047dac3e028c$var$Me, $36ad047dac3e028c$var$De = {
    exports: {}
};
$36ad047dac3e028c$var$Me = $36ad047dac3e028c$var$De, function() {
    var e = {}.hasOwnProperty;
    function t() {
        for(var e = "", _$t = 0; _$t < arguments.length; _$t++){
            var r = arguments[_$t];
            r && (e = i(e, n(r)));
        }
        return e;
    }
    function n(n) {
        if ("string" == typeof n || "number" == typeof n) return n;
        if ("object" != typeof n) return "";
        if (Array.isArray(n)) return t.apply(null, n);
        if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]")) return n.toString();
        var r = "";
        for(var o in n)e.call(n, o) && n[o] && (r = i(r, o));
        return r;
    }
    function i(e, t) {
        return t ? e ? e + " " + t : e + t : e;
    }
    $36ad047dac3e028c$var$Me.exports ? (t.default = t, $36ad047dac3e028c$var$Me.exports = t) : window.classNames = t;
}();
var $36ad047dac3e028c$var$Ee = $36ad047dac3e028c$var$v($36ad047dac3e028c$var$De.exports);
var $36ad047dac3e028c$var$Re = function Re1() {
    return $36ad047dac3e028c$var$Re = Object.assign || function(e) {
        for(var t, n = 1, _$i = arguments.length; n < _$i; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $36ad047dac3e028c$var$Re.apply(this, arguments);
};
function $36ad047dac3e028c$var$He(e, t, n) {
    if (n || 2 === arguments.length) for(var _$i, r = 0, o = t.length; r < o; r++)!_$i && r in t || (_$i || (_$i = Array.prototype.slice.call(t, 0, r)), _$i[r] = t[r]);
    return e.concat(_$i || Array.prototype.slice.call(t));
}
function $36ad047dac3e028c$var$Pe(e) {
    var t = Object.create(null);
    return function(n) {
        return void 0 === t[n] && (t[n] = e(n)), t[n];
    };
}
"function" == typeof SuppressedError && SuppressedError;
var $36ad047dac3e028c$var$je = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, $36ad047dac3e028c$var$ze = $36ad047dac3e028c$var$Pe(function(e) {
    return $36ad047dac3e028c$var$je.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
}), $36ad047dac3e028c$var$_e = "-ms-", $36ad047dac3e028c$var$We = "-moz-", $36ad047dac3e028c$var$Be = "-webkit-", $36ad047dac3e028c$var$Fe = "comm", $36ad047dac3e028c$var$Ve = "rule", $36ad047dac3e028c$var$Ge = "decl", $36ad047dac3e028c$var$qe = "@import", $36ad047dac3e028c$var$Ye = "@keyframes", $36ad047dac3e028c$var$Ue = "@layer", $36ad047dac3e028c$var$Ze = Math.abs, $36ad047dac3e028c$var$Xe = String.fromCharCode, $36ad047dac3e028c$var$Je = Object.assign;
function $36ad047dac3e028c$var$Ke(e) {
    return e.trim();
}
function $36ad047dac3e028c$var$Qe(e, t) {
    return (e = t.exec(e)) ? e[0] : e;
}
function $36ad047dac3e028c$var$et(e, t, n) {
    return e.replace(t, n);
}
function $36ad047dac3e028c$var$tt(e, t, n) {
    return e.indexOf(t, n);
}
function $36ad047dac3e028c$var$nt(e, t) {
    return 0 | e.charCodeAt(t);
}
function $36ad047dac3e028c$var$it(e, t, n) {
    return e.slice(t, n);
}
function $36ad047dac3e028c$var$rt(e) {
    return e.length;
}
function $36ad047dac3e028c$var$ot(e) {
    return e.length;
}
function $36ad047dac3e028c$var$at(e, t) {
    return t.push(e), e;
}
function $36ad047dac3e028c$var$st(e, t) {
    return e.filter(function(e) {
        return !$36ad047dac3e028c$var$Qe(e, t);
    });
}
var $36ad047dac3e028c$var$lt = 1, $36ad047dac3e028c$var$ct = 1, $36ad047dac3e028c$var$dt = 0, $36ad047dac3e028c$var$ut = 0, $36ad047dac3e028c$var$ht = 0, $36ad047dac3e028c$var$pt = "";
function $36ad047dac3e028c$var$mt(e, t, n, i, r, o, a, s) {
    return {
        value: e,
        root: t,
        parent: n,
        type: i,
        props: r,
        children: o,
        line: $36ad047dac3e028c$var$lt,
        column: $36ad047dac3e028c$var$ct,
        length: a,
        return: "",
        siblings: s
    };
}
function $36ad047dac3e028c$var$ft(e, t) {
    return $36ad047dac3e028c$var$Je($36ad047dac3e028c$var$mt("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, t);
}
function $36ad047dac3e028c$var$gt(e) {
    for(; e.root;)e = $36ad047dac3e028c$var$ft(e.root, {
        children: [
            e
        ]
    });
    $36ad047dac3e028c$var$at(e, e.siblings);
}
function $36ad047dac3e028c$var$vt() {
    return $36ad047dac3e028c$var$ht = $36ad047dac3e028c$var$ut > 0 ? $36ad047dac3e028c$var$nt($36ad047dac3e028c$var$pt, --$36ad047dac3e028c$var$ut) : 0, $36ad047dac3e028c$var$ct--, 10 === $36ad047dac3e028c$var$ht && ($36ad047dac3e028c$var$ct = 1, $36ad047dac3e028c$var$lt--), $36ad047dac3e028c$var$ht;
}
function $36ad047dac3e028c$var$yt() {
    return $36ad047dac3e028c$var$ht = $36ad047dac3e028c$var$ut < $36ad047dac3e028c$var$dt ? $36ad047dac3e028c$var$nt($36ad047dac3e028c$var$pt, $36ad047dac3e028c$var$ut++) : 0, $36ad047dac3e028c$var$ct++, 10 === $36ad047dac3e028c$var$ht && ($36ad047dac3e028c$var$ct = 1, $36ad047dac3e028c$var$lt++), $36ad047dac3e028c$var$ht;
}
function $36ad047dac3e028c$var$wt() {
    return $36ad047dac3e028c$var$nt($36ad047dac3e028c$var$pt, $36ad047dac3e028c$var$ut);
}
function $36ad047dac3e028c$var$bt() {
    return $36ad047dac3e028c$var$ut;
}
function $36ad047dac3e028c$var$xt(e, t) {
    return $36ad047dac3e028c$var$it($36ad047dac3e028c$var$pt, e, t);
}
function $36ad047dac3e028c$var$Ct(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $36ad047dac3e028c$var$kt(e) {
    return $36ad047dac3e028c$var$Ke($36ad047dac3e028c$var$xt($36ad047dac3e028c$var$ut - 1, $36ad047dac3e028c$var$$t(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
}
function $36ad047dac3e028c$var$St(e) {
    for(; ($36ad047dac3e028c$var$ht = $36ad047dac3e028c$var$wt()) && $36ad047dac3e028c$var$ht < 33;)$36ad047dac3e028c$var$yt();
    return $36ad047dac3e028c$var$Ct(e) > 2 || $36ad047dac3e028c$var$Ct($36ad047dac3e028c$var$ht) > 3 ? "" : " ";
}
function $36ad047dac3e028c$var$Tt(e, t) {
    for(; --t && $36ad047dac3e028c$var$yt() && !($36ad047dac3e028c$var$ht < 48 || $36ad047dac3e028c$var$ht > 102 || $36ad047dac3e028c$var$ht > 57 && $36ad047dac3e028c$var$ht < 65 || $36ad047dac3e028c$var$ht > 70 && $36ad047dac3e028c$var$ht < 97););
    return $36ad047dac3e028c$var$xt(e, $36ad047dac3e028c$var$bt() + (t < 6 && 32 == $36ad047dac3e028c$var$wt() && 32 == $36ad047dac3e028c$var$yt()));
}
function $36ad047dac3e028c$var$$t(e) {
    for(; $36ad047dac3e028c$var$yt();)switch($36ad047dac3e028c$var$ht){
        case e:
            return $36ad047dac3e028c$var$ut;
        case 34:
        case 39:
            34 !== e && 39 !== e && $36ad047dac3e028c$var$$t($36ad047dac3e028c$var$ht);
            break;
        case 40:
            41 === e && $36ad047dac3e028c$var$$t(e);
            break;
        case 92:
            $36ad047dac3e028c$var$yt();
    }
    return $36ad047dac3e028c$var$ut;
}
function $36ad047dac3e028c$var$It(e, t) {
    for(; $36ad047dac3e028c$var$yt() && e + $36ad047dac3e028c$var$ht !== 57 && (e + $36ad047dac3e028c$var$ht !== 84 || 47 !== $36ad047dac3e028c$var$wt()););
    return "/*" + $36ad047dac3e028c$var$xt(t, $36ad047dac3e028c$var$ut - 1) + "*" + $36ad047dac3e028c$var$Xe(47 === e ? e : $36ad047dac3e028c$var$yt());
}
function $36ad047dac3e028c$var$At(e) {
    for(; !$36ad047dac3e028c$var$Ct($36ad047dac3e028c$var$wt());)$36ad047dac3e028c$var$yt();
    return $36ad047dac3e028c$var$xt(e, $36ad047dac3e028c$var$ut);
}
function $36ad047dac3e028c$var$Nt(e) {
    return function(e) {
        return $36ad047dac3e028c$var$pt = "", e;
    }($36ad047dac3e028c$var$Lt("", null, null, null, [
        ""
    ], e = function(e) {
        return $36ad047dac3e028c$var$lt = $36ad047dac3e028c$var$ct = 1, $36ad047dac3e028c$var$dt = $36ad047dac3e028c$var$rt($36ad047dac3e028c$var$pt = e), $36ad047dac3e028c$var$ut = 0, [];
    }(e), 0, [
        0
    ], e));
}
function $36ad047dac3e028c$var$Lt(e, t, n, i, r, o, a, s, l) {
    for(var _$c = 0, d = 0, u = a, h = 0, _$p = 0, _$m = 0, f = 1, g = 1, _$v = 1, y = 0, w = "", b = r, x = o, _$C = i, k = w; g;)switch(_$m = y, y = $36ad047dac3e028c$var$yt()){
        case 40:
            if (108 != _$m && 58 == $36ad047dac3e028c$var$nt(k, u - 1)) {
                -1 != $36ad047dac3e028c$var$tt(k += $36ad047dac3e028c$var$et($36ad047dac3e028c$var$kt(y), "&", "&\f"), "&\f", $36ad047dac3e028c$var$Ze(_$c ? s[_$c - 1] : 0)) && (_$v = -1);
                break;
            }
        case 34:
        case 39:
        case 91:
            k += $36ad047dac3e028c$var$kt(y);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            k += $36ad047dac3e028c$var$St(_$m);
            break;
        case 92:
            k += $36ad047dac3e028c$var$Tt($36ad047dac3e028c$var$bt() - 1, 7);
            continue;
        case 47:
            switch($36ad047dac3e028c$var$wt()){
                case 42:
                case 47:
                    $36ad047dac3e028c$var$at($36ad047dac3e028c$var$Mt($36ad047dac3e028c$var$It($36ad047dac3e028c$var$yt(), $36ad047dac3e028c$var$bt()), t, n, l), l);
                    break;
                default:
                    k += "/";
            }
            break;
        case 123 * f:
            s[_$c++] = $36ad047dac3e028c$var$rt(k) * _$v;
        case 125 * f:
        case 59:
        case 0:
            switch(y){
                case 0:
                case 125:
                    g = 0;
                case 59 + d:
                    -1 == _$v && (k = $36ad047dac3e028c$var$et(k, /\f/g, "")), _$p > 0 && $36ad047dac3e028c$var$rt(k) - u && $36ad047dac3e028c$var$at(_$p > 32 ? $36ad047dac3e028c$var$Dt(k + ";", i, n, u - 1, l) : $36ad047dac3e028c$var$Dt($36ad047dac3e028c$var$et(k, " ", "") + ";", i, n, u - 2, l), l);
                    break;
                case 59:
                    k += ";";
                default:
                    if ($36ad047dac3e028c$var$at(_$C = $36ad047dac3e028c$var$Ot(k, t, n, _$c, d, r, s, w, b = [], x = [], u, o), o), 123 === y) {
                        if (0 === d) $36ad047dac3e028c$var$Lt(k, t, _$C, _$C, b, o, u, s, x);
                        else switch(99 === h && 110 === $36ad047dac3e028c$var$nt(k, 3) ? 100 : h){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ad047dac3e028c$var$Lt(e, _$C, _$C, i && $36ad047dac3e028c$var$at($36ad047dac3e028c$var$Ot(e, _$C, _$C, 0, 0, r, s, w, r, b = [], u, x), x), r, x, u, s, i ? b : x);
                                break;
                            default:
                                $36ad047dac3e028c$var$Lt(k, _$C, _$C, _$C, [
                                    ""
                                ], x, 0, s, x);
                        }
                    }
            }
            _$c = d = _$p = 0, f = _$v = 1, w = k = "", u = a;
            break;
        case 58:
            u = 1 + $36ad047dac3e028c$var$rt(k), _$p = _$m;
        default:
            if (f < 1) {
                if (123 == y) --f;
                else if (125 == y && 0 == f++ && 125 == $36ad047dac3e028c$var$vt()) continue;
            }
            switch(k += $36ad047dac3e028c$var$Xe(y), y * f){
                case 38:
                    _$v = d > 0 ? 1 : (k += "\f", -1);
                    break;
                case 44:
                    s[_$c++] = ($36ad047dac3e028c$var$rt(k) - 1) * _$v, _$v = 1;
                    break;
                case 64:
                    45 === $36ad047dac3e028c$var$wt() && (k += $36ad047dac3e028c$var$kt($36ad047dac3e028c$var$yt())), h = $36ad047dac3e028c$var$wt(), d = u = $36ad047dac3e028c$var$rt(w = k += $36ad047dac3e028c$var$At($36ad047dac3e028c$var$bt())), y++;
                    break;
                case 45:
                    45 === _$m && 2 == $36ad047dac3e028c$var$rt(k) && (f = 0);
            }
    }
    return o;
}
function $36ad047dac3e028c$var$Ot(e, t, n, i, r, o, a, s, l, c, d, u) {
    for(var h = r - 1, _$p = 0 === r ? o : [
        ""
    ], _$m = $36ad047dac3e028c$var$ot(_$p), f = 0, g = 0, _$v = 0; f < i; ++f)for(var y = 0, w = $36ad047dac3e028c$var$it(e, h + 1, h = $36ad047dac3e028c$var$Ze(g = a[f])), b = e; y < _$m; ++y)(b = $36ad047dac3e028c$var$Ke(g > 0 ? _$p[y] + " " + w : $36ad047dac3e028c$var$et(w, /&\f/g, _$p[y]))) && (l[_$v++] = b);
    return $36ad047dac3e028c$var$mt(e, t, n, 0 === r ? $36ad047dac3e028c$var$Ve : s, l, c, d, u);
}
function $36ad047dac3e028c$var$Mt(e, t, n, i) {
    return $36ad047dac3e028c$var$mt(e, t, n, $36ad047dac3e028c$var$Fe, $36ad047dac3e028c$var$Xe($36ad047dac3e028c$var$ht), $36ad047dac3e028c$var$it(e, 2, -2), 0, i);
}
function $36ad047dac3e028c$var$Dt(e, t, n, i, r) {
    return $36ad047dac3e028c$var$mt(e, t, n, $36ad047dac3e028c$var$Ge, $36ad047dac3e028c$var$it(e, 0, i), $36ad047dac3e028c$var$it(e, i + 1, -1), i, r);
}
function $36ad047dac3e028c$var$Et(e, t, n) {
    switch(function(e, t) {
        return 45 ^ $36ad047dac3e028c$var$nt(e, 0) ? (((t << 2 ^ $36ad047dac3e028c$var$nt(e, 0)) << 2 ^ $36ad047dac3e028c$var$nt(e, 1)) << 2 ^ $36ad047dac3e028c$var$nt(e, 2)) << 2 ^ $36ad047dac3e028c$var$nt(e, 3) : 0;
    }(e, t)){
        case 5103:
            return $36ad047dac3e028c$var$Be + "print-" + e + e;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $36ad047dac3e028c$var$Be + e + e;
        case 4789:
            return $36ad047dac3e028c$var$We + e + e;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$We + e + $36ad047dac3e028c$var$_e + e + e;
        case 5936:
            switch($36ad047dac3e028c$var$nt(e, t + 11)){
                case 114:
                    return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
                case 108:
                    return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
                case 45:
                    return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
            }
        case 6828:
        case 4268:
        case 2903:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + e + e;
        case 6165:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + "flex-" + e + e;
        case 5187:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$et(e, /(\w+).+(:[^]+)/, $36ad047dac3e028c$var$Be + "box-$1$2" + $36ad047dac3e028c$var$_e + "flex-$1$2") + e;
        case 5443:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + "flex-item-" + $36ad047dac3e028c$var$et(e, /flex-|-self/g, "") + ($36ad047dac3e028c$var$Qe(e, /flex-|baseline/) ? "" : $36ad047dac3e028c$var$_e + "grid-row-" + $36ad047dac3e028c$var$et(e, /flex-|-self/g, "")) + e;
        case 4675:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + "flex-line-pack" + $36ad047dac3e028c$var$et(e, /align-content|flex-|-self/g, "") + e;
        case 5548:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, "shrink", "negative") + e;
        case 5292:
            return $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, "basis", "preferred-size") + e;
        case 6060:
            return $36ad047dac3e028c$var$Be + "box-" + $36ad047dac3e028c$var$et(e, "-grow", "") + $36ad047dac3e028c$var$Be + e + $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, "grow", "positive") + e;
        case 4554:
            return $36ad047dac3e028c$var$Be + $36ad047dac3e028c$var$et(e, /([^-])(transform)/g, "$1" + $36ad047dac3e028c$var$Be + "$2") + e;
        case 6187:
            return $36ad047dac3e028c$var$et($36ad047dac3e028c$var$et($36ad047dac3e028c$var$et(e, /(zoom-|grab)/, $36ad047dac3e028c$var$Be + "$1"), /(image-set)/, $36ad047dac3e028c$var$Be + "$1"), e, "") + e;
        case 5495:
        case 3959:
            return $36ad047dac3e028c$var$et(e, /(image-set\([^]*)/, $36ad047dac3e028c$var$Be + "$1$`$1");
        case 4968:
            return $36ad047dac3e028c$var$et($36ad047dac3e028c$var$et(e, /(.+:)(flex-)?(.*)/, $36ad047dac3e028c$var$Be + "box-pack:$3" + $36ad047dac3e028c$var$_e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $36ad047dac3e028c$var$Be + e + e;
        case 4200:
            if (!$36ad047dac3e028c$var$Qe(e, /flex-|baseline/)) return $36ad047dac3e028c$var$_e + "grid-column-align" + $36ad047dac3e028c$var$it(e, t) + e;
            break;
        case 2592:
        case 3360:
            return $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, "template-", "") + e;
        case 4384:
        case 3616:
            return n && n.some(function(e, n) {
                return t = n, $36ad047dac3e028c$var$Qe(e.props, /grid-\w+-end/);
            }) ? ~$36ad047dac3e028c$var$tt(e + (n = n[t].value), "span", 0) ? e : $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, "-start", "") + e + $36ad047dac3e028c$var$_e + "grid-row-span:" + (~$36ad047dac3e028c$var$tt(n, "span", 0) ? $36ad047dac3e028c$var$Qe(n, /\d+/) : +$36ad047dac3e028c$var$Qe(n, /\d+/) - +$36ad047dac3e028c$var$Qe(e, /\d+/)) + ";" : $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et(e, "-start", "") + e;
        case 4896:
        case 4128:
            return n && n.some(function(e) {
                return $36ad047dac3e028c$var$Qe(e.props, /grid-\w+-start/);
            }) ? e : $36ad047dac3e028c$var$_e + $36ad047dac3e028c$var$et($36ad047dac3e028c$var$et(e, "-end", "-span"), "span ", "") + e;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $36ad047dac3e028c$var$et(e, /(.+)-inline(.+)/, $36ad047dac3e028c$var$Be + "$1$2") + e;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($36ad047dac3e028c$var$rt(e) - 1 - t > 6) switch($36ad047dac3e028c$var$nt(e, t + 1)){
                case 109:
                    if (45 !== $36ad047dac3e028c$var$nt(e, t + 4)) break;
                case 102:
                    return $36ad047dac3e028c$var$et(e, /(.+:)(.+)-([^]+)/, "$1" + $36ad047dac3e028c$var$Be + "$2-$3$1" + $36ad047dac3e028c$var$We + (108 == $36ad047dac3e028c$var$nt(e, t + 3) ? "$3" : "$2-$3")) + e;
                case 115:
                    return ~$36ad047dac3e028c$var$tt(e, "stretch", 0) ? $36ad047dac3e028c$var$Et($36ad047dac3e028c$var$et(e, "stretch", "fill-available"), t, n) + e : e;
            }
            break;
        case 5152:
        case 5920:
            return $36ad047dac3e028c$var$et(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(t, n, i, r, o, a, s) {
                return $36ad047dac3e028c$var$_e + n + ":" + i + s + (r ? $36ad047dac3e028c$var$_e + n + "-span:" + (o ? a : +a - +i) + s : "") + e;
            });
        case 4949:
            if (121 === $36ad047dac3e028c$var$nt(e, t + 6)) return $36ad047dac3e028c$var$et(e, ":", ":" + $36ad047dac3e028c$var$Be) + e;
            break;
        case 6444:
            switch($36ad047dac3e028c$var$nt(e, 45 === $36ad047dac3e028c$var$nt(e, 14) ? 18 : 11)){
                case 120:
                    return $36ad047dac3e028c$var$et(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $36ad047dac3e028c$var$Be + (45 === $36ad047dac3e028c$var$nt(e, 14) ? "inline-" : "") + "box$3$1" + $36ad047dac3e028c$var$Be + "$2$3$1" + $36ad047dac3e028c$var$_e + "$2box$3") + e;
                case 100:
                    return $36ad047dac3e028c$var$et(e, ":", ":" + $36ad047dac3e028c$var$_e) + e;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $36ad047dac3e028c$var$et(e, "scroll-", "scroll-snap-") + e;
    }
    return e;
}
function $36ad047dac3e028c$var$Rt(e, t) {
    for(var n = "", _$i = 0; _$i < e.length; _$i++)n += t(e[_$i], _$i, e, t) || "";
    return n;
}
function $36ad047dac3e028c$var$Ht(e, t, n, i) {
    switch(e.type){
        case $36ad047dac3e028c$var$Ue:
            if (e.children.length) break;
        case $36ad047dac3e028c$var$qe:
        case $36ad047dac3e028c$var$Ge:
            return e.return = e.return || e.value;
        case $36ad047dac3e028c$var$Fe:
            return "";
        case $36ad047dac3e028c$var$Ye:
            return e.return = e.value + "{" + $36ad047dac3e028c$var$Rt(e.children, i) + "}";
        case $36ad047dac3e028c$var$Ve:
            if (!$36ad047dac3e028c$var$rt(e.value = e.props.join(","))) return "";
    }
    return $36ad047dac3e028c$var$rt(n = $36ad047dac3e028c$var$Rt(e.children, i)) ? e.return = e.value + "{" + n + "}" : "";
}
function $36ad047dac3e028c$var$Pt(e, t, n, i) {
    if (e.length > -1 && !e.return) switch(e.type){
        case $36ad047dac3e028c$var$Ge:
            return void (e.return = $36ad047dac3e028c$var$Et(e.value, e.length, n));
        case $36ad047dac3e028c$var$Ye:
            return $36ad047dac3e028c$var$Rt([
                $36ad047dac3e028c$var$ft(e, {
                    value: $36ad047dac3e028c$var$et(e.value, "@", "@" + $36ad047dac3e028c$var$Be)
                })
            ], i);
        case $36ad047dac3e028c$var$Ve:
            if (e.length) return function(e, t) {
                return e.map(t).join("");
            }(n = e.props, function(t) {
                switch($36ad047dac3e028c$var$Qe(t, i = /(::plac\w+|:read-\w+)/)){
                    case ":read-only":
                    case ":read-write":
                        $36ad047dac3e028c$var$gt($36ad047dac3e028c$var$ft(e, {
                            props: [
                                $36ad047dac3e028c$var$et(t, /:(read-\w+)/, ":" + $36ad047dac3e028c$var$We + "$1")
                            ]
                        })), $36ad047dac3e028c$var$gt($36ad047dac3e028c$var$ft(e, {
                            props: [
                                t
                            ]
                        })), $36ad047dac3e028c$var$Je(e, {
                            props: $36ad047dac3e028c$var$st(n, i)
                        });
                        break;
                    case "::placeholder":
                        $36ad047dac3e028c$var$gt($36ad047dac3e028c$var$ft(e, {
                            props: [
                                $36ad047dac3e028c$var$et(t, /:(plac\w+)/, ":" + $36ad047dac3e028c$var$Be + "input-$1")
                            ]
                        })), $36ad047dac3e028c$var$gt($36ad047dac3e028c$var$ft(e, {
                            props: [
                                $36ad047dac3e028c$var$et(t, /:(plac\w+)/, ":" + $36ad047dac3e028c$var$We + "$1")
                            ]
                        })), $36ad047dac3e028c$var$gt($36ad047dac3e028c$var$ft(e, {
                            props: [
                                $36ad047dac3e028c$var$et(t, /:(plac\w+)/, $36ad047dac3e028c$var$_e + "input-$1")
                            ]
                        })), $36ad047dac3e028c$var$gt($36ad047dac3e028c$var$ft(e, {
                            props: [
                                t
                            ]
                        })), $36ad047dac3e028c$var$Je(e, {
                            props: $36ad047dac3e028c$var$st(n, i)
                        });
                }
                return "";
            });
    }
}
var $36ad047dac3e028c$var$jt = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
}, $36ad047dac3e028c$var$zt = ("undefined" != typeof $d198ac116a0e36eb$exports && void 0 !== $d198ac116a0e36eb$exports.env && undefined, "data-styled"), $36ad047dac3e028c$var$_t = "active", $36ad047dac3e028c$var$Wt = "data-styled-version", $36ad047dac3e028c$var$Bt = "6.1.8", $36ad047dac3e028c$var$Ft = "/*!sc*/\n", $36ad047dac3e028c$var$Vt = "undefined" != typeof window && "HTMLElement" in window, $36ad047dac3e028c$var$Gt = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $d198ac116a0e36eb$exports && $d198ac116a0e36eb$exports.env, "undefined" != typeof $d198ac116a0e36eb$exports && $d198ac116a0e36eb$exports.env, false)), $36ad047dac3e028c$var$qt = /invalid hook call/i, $36ad047dac3e028c$var$Yt = new Set, $36ad047dac3e028c$var$Ut = function Ut(e, t) {
    var n, _$i, o, a, e1;
}, $36ad047dac3e028c$var$Zt = Object.freeze([]), $36ad047dac3e028c$var$Xt = Object.freeze({});
var $36ad047dac3e028c$var$Jt = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $36ad047dac3e028c$var$Kt = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $36ad047dac3e028c$var$Qt = /(^-|-$)/g;
function $36ad047dac3e028c$var$en(e) {
    return e.replace($36ad047dac3e028c$var$Kt, "-").replace($36ad047dac3e028c$var$Qt, "");
}
var $36ad047dac3e028c$var$tn = /(a)(d)/gi, $36ad047dac3e028c$var$nn = 52, $36ad047dac3e028c$var$rn = function rn(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $36ad047dac3e028c$var$on(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $36ad047dac3e028c$var$nn; t = t / $36ad047dac3e028c$var$nn | 0)n = $36ad047dac3e028c$var$rn(t % $36ad047dac3e028c$var$nn) + n;
    return ($36ad047dac3e028c$var$rn(t % $36ad047dac3e028c$var$nn) + n).replace($36ad047dac3e028c$var$tn, "$1-$2");
}
var $36ad047dac3e028c$var$an, $36ad047dac3e028c$var$sn = function sn(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $36ad047dac3e028c$var$ln = function ln(e) {
    return $36ad047dac3e028c$var$sn(5381, e);
};
function $36ad047dac3e028c$var$cn(e) {
    return $36ad047dac3e028c$var$on($36ad047dac3e028c$var$ln(e) >>> 0);
}
function $36ad047dac3e028c$var$dn(e) {
    return "string" == typeof e && true;
}
var $36ad047dac3e028c$var$un = "function" == typeof Symbol && Symbol.for, $36ad047dac3e028c$var$hn = $36ad047dac3e028c$var$un ? Symbol.for("react.memo") : 60115, $36ad047dac3e028c$var$pn = $36ad047dac3e028c$var$un ? Symbol.for("react.forward_ref") : 60112, $36ad047dac3e028c$var$mn = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $36ad047dac3e028c$var$fn = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $36ad047dac3e028c$var$gn = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $36ad047dac3e028c$var$vn = (($36ad047dac3e028c$var$an = {})[$36ad047dac3e028c$var$pn] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $36ad047dac3e028c$var$an[$36ad047dac3e028c$var$hn] = $36ad047dac3e028c$var$gn, $36ad047dac3e028c$var$an);
function $36ad047dac3e028c$var$yn(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $36ad047dac3e028c$var$hn ? $36ad047dac3e028c$var$gn : "$$typeof" in e ? $36ad047dac3e028c$var$vn[e.$$typeof] : $36ad047dac3e028c$var$mn;
}
var $36ad047dac3e028c$var$wn = Object.defineProperty, $36ad047dac3e028c$var$bn = Object.getOwnPropertyNames, $36ad047dac3e028c$var$xn = Object.getOwnPropertySymbols, $36ad047dac3e028c$var$Cn = Object.getOwnPropertyDescriptor, $36ad047dac3e028c$var$kn = Object.getPrototypeOf, $36ad047dac3e028c$var$Sn = Object.prototype;
function $36ad047dac3e028c$var$Tn(e, t, n) {
    if ("string" != typeof t) {
        if ($36ad047dac3e028c$var$Sn) {
            var _$i = $36ad047dac3e028c$var$kn(t);
            _$i && _$i !== $36ad047dac3e028c$var$Sn && $36ad047dac3e028c$var$Tn(e, _$i, n);
        }
        var r = $36ad047dac3e028c$var$bn(t);
        $36ad047dac3e028c$var$xn && (r = r.concat($36ad047dac3e028c$var$xn(t)));
        for(var o = $36ad047dac3e028c$var$yn(e), a = $36ad047dac3e028c$var$yn(t), s = 0; s < r.length; ++s){
            var l = r[s];
            if (!(l in $36ad047dac3e028c$var$fn || n && n[l] || a && l in a || o && l in o)) {
                var _$c = $36ad047dac3e028c$var$Cn(t, l);
                try {
                    $36ad047dac3e028c$var$wn(e, l, _$c);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $36ad047dac3e028c$var$$n(e) {
    return "function" == typeof e;
}
function $36ad047dac3e028c$var$In(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $36ad047dac3e028c$var$An(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $36ad047dac3e028c$var$Nn(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], _$i = 1; _$i < e.length; _$i++)n += t ? t + e[_$i] : e[_$i];
    return n;
}
function $36ad047dac3e028c$var$Ln(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $36ad047dac3e028c$var$On(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$36ad047dac3e028c$var$Ln(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var _$i = 0; _$i < t.length; _$i++)e[_$i] = $36ad047dac3e028c$var$On(e[_$i], t[_$i]);
    else if ($36ad047dac3e028c$var$Ln(t)) for(var _$i in t)e[_$i] = $36ad047dac3e028c$var$On(e[_$i], t[_$i]);
    return e;
}
function $36ad047dac3e028c$var$Mn(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $36ad047dac3e028c$var$Dn = {};
function $36ad047dac3e028c$var$En() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], _$i = [], r = 1, o = e.length; r < o; r += 1)_$i.push(e[r]);
    return _$i.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $36ad047dac3e028c$var$Rn(e) {
    for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(t.length > 0 ? " Args: ".concat(t.join(", ")) : ""));
}
var $36ad047dac3e028c$var$Hn = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$i = n.length, r = _$i; e >= r;)if ((r <<= 1) < 0) throw $36ad047dac3e028c$var$Rn(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var o = _$i; o < r; o++)this.groupSizes[o] = 0;
        }
        for(var a = this.indexOfGroup(e + 1), s = (o = 0, t.length); o < s; o++)this.tag.insertRule(a, t[o]) && (this.groupSizes[e]++, a++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$i = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < _$i; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$i = this.indexOfGroup(e), r = _$i + n, o = _$i; o < r; o++)t += "".concat(this.tag.getRule(o)).concat($36ad047dac3e028c$var$Ft);
        return t;
    }, e;
}(), $36ad047dac3e028c$var$Pn = new Map, $36ad047dac3e028c$var$jn = new Map, $36ad047dac3e028c$var$zn = 1, $36ad047dac3e028c$var$_n = function _n(e) {
    if ($36ad047dac3e028c$var$Pn.has(e)) return $36ad047dac3e028c$var$Pn.get(e);
    for(; $36ad047dac3e028c$var$jn.has($36ad047dac3e028c$var$zn);)$36ad047dac3e028c$var$zn++;
    var t = $36ad047dac3e028c$var$zn++;
    return $36ad047dac3e028c$var$Pn.set(e, t), $36ad047dac3e028c$var$jn.set(t, e), t;
}, $36ad047dac3e028c$var$Wn = function Wn(e, t) {
    $36ad047dac3e028c$var$zn = t + 1, $36ad047dac3e028c$var$Pn.set(e, t), $36ad047dac3e028c$var$jn.set(t, e);
}, $36ad047dac3e028c$var$Bn = "style[".concat($36ad047dac3e028c$var$zt, "][").concat($36ad047dac3e028c$var$Wt, '="').concat($36ad047dac3e028c$var$Bt, '"]'), $36ad047dac3e028c$var$Fn = new RegExp("^".concat($36ad047dac3e028c$var$zt, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $36ad047dac3e028c$var$Vn = function Vn(e, t, n) {
    for(var _$i, r = n.split(","), o = 0, a = r.length; o < a; o++)(_$i = r[o]) && e.registerName(t, _$i);
}, $36ad047dac3e028c$var$Gn = function Gn(e, t) {
    for(var n, _$i = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($36ad047dac3e028c$var$Ft), r = [], o = 0, a = _$i.length; o < a; o++){
        var s = _$i[o].trim();
        if (s) {
            var l = s.match($36ad047dac3e028c$var$Fn);
            if (l) {
                var _$c = 0 | parseInt(l[1], 10), d = l[2];
                0 !== _$c && ($36ad047dac3e028c$var$Wn(d, _$c), $36ad047dac3e028c$var$Vn(e, d, l[3]), e.getTag().insertRules(_$c, r)), r.length = 0;
            } else r.push(s);
        }
    }
};
var $36ad047dac3e028c$var$qn = function qn(e) {
    var t = document.head, n = e || t, _$i = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($36ad047dac3e028c$var$zt, "]")));
        return t[t.length - 1];
    }(n), o = void 0 !== r ? r.nextSibling : null;
    _$i.setAttribute($36ad047dac3e028c$var$zt, $36ad047dac3e028c$var$_t), _$i.setAttribute($36ad047dac3e028c$var$Wt, $36ad047dac3e028c$var$Bt);
    var a = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
    return a && _$i.setAttribute("nonce", a), n.insertBefore(_$i, o), _$i;
}, $36ad047dac3e028c$var$Yn = function() {
    function e(e) {
        this.element = $36ad047dac3e028c$var$qn(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$i = t.length; n < _$i; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $36ad047dac3e028c$var$Rn(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $36ad047dac3e028c$var$Un = function() {
    function e(e) {
        this.element = $36ad047dac3e028c$var$qn(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $36ad047dac3e028c$var$Zn = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $36ad047dac3e028c$var$Xn = $36ad047dac3e028c$var$Vt, $36ad047dac3e028c$var$Jn = {
    isServer: !$36ad047dac3e028c$var$Vt,
    useCSSOMInjection: !$36ad047dac3e028c$var$Gt
}, $36ad047dac3e028c$var$Kn = function() {
    function e(e, t, n) {
        void 0 === e && (e = $36ad047dac3e028c$var$Xt), void 0 === t && (t = {});
        var _$i = this;
        this.options = $36ad047dac3e028c$var$Re($36ad047dac3e028c$var$Re({}, $36ad047dac3e028c$var$Jn), e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $36ad047dac3e028c$var$Vt && $36ad047dac3e028c$var$Xn && ($36ad047dac3e028c$var$Xn = !1, function(e) {
            for(var _$t = document.querySelectorAll($36ad047dac3e028c$var$Bn), _$n = 0, _$i = _$t.length; _$n < _$i; _$n++){
                var r = _$t[_$n];
                r && r.getAttribute($36ad047dac3e028c$var$zt) !== $36ad047dac3e028c$var$_t && ($36ad047dac3e028c$var$Gn(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $36ad047dac3e028c$var$Mn(this, function() {
            return function(e) {
                for(var _$t = e.getTag(), _$n = _$t.length, _$i = "", r = function r(n) {
                    var r = function(e) {
                        return $36ad047dac3e028c$var$jn.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var o = e.names.get(r), a = _$t.getGroup(n);
                    if (void 0 === o || 0 === a.length) return "continue";
                    var s = "".concat($36ad047dac3e028c$var$zt, ".g").concat(n, '[id="').concat(r, '"]'), l = "";
                    void 0 !== o && o.forEach(function(e) {
                        e.length > 0 && (l += "".concat(e, ","));
                    }), _$i += "".concat(a).concat(s, '{content:"').concat(l, '"}').concat($36ad047dac3e028c$var$Ft);
                }, o = 0; o < _$n; o++)r(o);
                return _$i;
            }(_$i);
        });
    }
    return e.registerId = function(e) {
        return $36ad047dac3e028c$var$_n(e);
    }, e.prototype.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($36ad047dac3e028c$var$Re($36ad047dac3e028c$var$Re({}, this.options), t), this.gs, n && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var _$e;
        return this.tag || (this.tag = (_$e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $36ad047dac3e028c$var$Zn(n) : t ? new $36ad047dac3e028c$var$Yn(n) : new $36ad047dac3e028c$var$Un(n);
        }(this.options), new $36ad047dac3e028c$var$Hn(_$e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($36ad047dac3e028c$var$_n(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($36ad047dac3e028c$var$_n(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($36ad047dac3e028c$var$_n(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $36ad047dac3e028c$var$Qn = /&/g, $36ad047dac3e028c$var$ei = /^\s*\/\/.*$/gm;
function $36ad047dac3e028c$var$ti(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $36ad047dac3e028c$var$ti(e.children, t)), e;
    });
}
var $36ad047dac3e028c$var$ni = new $36ad047dac3e028c$var$Kn, $36ad047dac3e028c$var$ii = function(e) {
    var t, n, _$i, r = void 0 === e ? $36ad047dac3e028c$var$Xt : e, o = r.options, a = void 0 === o ? $36ad047dac3e028c$var$Xt : o, s = r.plugins, l = void 0 === s ? $36ad047dac3e028c$var$Zt : s, _$c = function c(e, i, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, d = l.slice();
    d.push(function(e) {
        e.type === $36ad047dac3e028c$var$Ve && e.value.includes("&") && (e.props[0] = e.props[0].replace($36ad047dac3e028c$var$Qn, n).replace(_$i, _$c));
    }), a.prefix && d.push($36ad047dac3e028c$var$Pt), d.push($36ad047dac3e028c$var$Ht);
    var u = function u(e, r, o, s) {
        void 0 === r && (r = ""), void 0 === o && (o = ""), void 0 === s && (s = "&"), t = s, n = r, _$i = new RegExp("\\".concat(n, "\\b"), "g");
        var l = e.replace($36ad047dac3e028c$var$ei, ""), _$c = $36ad047dac3e028c$var$Nt(o || r ? "".concat(o, " ").concat(r, " { ").concat(l, " }") : l);
        a.namespace && (_$c = $36ad047dac3e028c$var$ti(_$c, a.namespace));
        var u, h = [];
        return $36ad047dac3e028c$var$Rt(_$c, function(e) {
            var t = $36ad047dac3e028c$var$ot(e);
            return function(n, i, r, o) {
                for(var a = "", _$s = 0; _$s < t; _$s++)a += e[_$s](n, i, r, o) || "";
                return a;
            };
        }(d.concat((u = function u(e) {
            return h.push(e);
        }, function(e) {
            e.root || (e = e.return) && u(e);
        })))), h;
    };
    return u.hash = l.length ? l.reduce(function(e, t) {
        return t.name || $36ad047dac3e028c$var$Rn(15), $36ad047dac3e028c$var$sn(e, t.name);
    }, 5381).toString() : "", u;
}(), $36ad047dac3e028c$var$ri = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $36ad047dac3e028c$var$ni,
    stylis: $36ad047dac3e028c$var$ii
});
function $36ad047dac3e028c$var$oi() {
    return (0, $33gHU.useContext)($36ad047dac3e028c$var$ri);
}
$36ad047dac3e028c$var$ri.Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext(void 0);
var $36ad047dac3e028c$var$ai = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $36ad047dac3e028c$var$ii);
            var _$i = n.name + t.hash;
            e.hasNameForId(n.id, _$i) || e.insertRules(n.id, _$i, t(n.rules, _$i, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $36ad047dac3e028c$var$Mn(this, function() {
            throw $36ad047dac3e028c$var$Rn(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $36ad047dac3e028c$var$ii), this.name + e.hash;
    }, e;
}(), $36ad047dac3e028c$var$si = function si(e) {
    return e >= "A" && e <= "Z";
};
function $36ad047dac3e028c$var$li(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var _$i = e[n];
        if (1 === n && "-" === _$i && "-" === e[0]) return e;
        $36ad047dac3e028c$var$si(_$i) ? t += "-" + _$i.toLowerCase() : t += _$i;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $36ad047dac3e028c$var$ci = function ci(e) {
    return null == e || !1 === e || "" === e;
}, $36ad047dac3e028c$var$di = function di1(e) {
    var t, n, _$i = [];
    for(var r in e){
        var o = e[r];
        e.hasOwnProperty(r) && !$36ad047dac3e028c$var$ci(o) && (Array.isArray(o) && o.isCss || $36ad047dac3e028c$var$$n(o) ? _$i.push("".concat($36ad047dac3e028c$var$li(r), ":"), o, ";") : $36ad047dac3e028c$var$Ln(o) ? _$i.push.apply(_$i, $36ad047dac3e028c$var$He($36ad047dac3e028c$var$He([
            "".concat(r, " {")
        ], $36ad047dac3e028c$var$di(o), !1), [
            "}"
        ], !1)) : _$i.push("".concat($36ad047dac3e028c$var$li(r), ": ").concat((t = r, null == (n = o) || "boolean" == typeof n || "" === n ? "" : "number" != typeof n || 0 === n || t in $36ad047dac3e028c$var$jt || t.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
    }
    return _$i;
};
function $36ad047dac3e028c$var$ui(e, t, n, i) {
    if ($36ad047dac3e028c$var$ci(e)) return [];
    if ($36ad047dac3e028c$var$In(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($36ad047dac3e028c$var$$n(e)) {
        if (!$36ad047dac3e028c$var$$n(o = e) || o.prototype && o.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $36ad047dac3e028c$var$ui(r, t, n, i);
    }
    var o;
    return e instanceof $36ad047dac3e028c$var$ai ? n ? (e.inject(n, i), [
        e.getName(i)
    ]) : [
        e
    ] : $36ad047dac3e028c$var$Ln(e) ? $36ad047dac3e028c$var$di(e) : Array.isArray(e) ? Array.prototype.concat.apply($36ad047dac3e028c$var$Zt, e.map(function(e) {
        return $36ad047dac3e028c$var$ui(e, t, n, i);
    })) : [
        e.toString()
    ];
}
var $36ad047dac3e028c$var$hi = $36ad047dac3e028c$var$ln($36ad047dac3e028c$var$Bt), $36ad047dac3e028c$var$pi = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && function(e) {
            for(var _$t = 0; _$t < e.length; _$t += 1){
                var _$n = e[_$t];
                if ($36ad047dac3e028c$var$$n(_$n) && !$36ad047dac3e028c$var$In(_$n)) return !1;
            }
            return !0;
        }(e), this.componentId = t, this.baseHash = $36ad047dac3e028c$var$sn($36ad047dac3e028c$var$hi, t), this.baseStyle = n, $36ad047dac3e028c$var$Kn.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$i = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) _$i = $36ad047dac3e028c$var$An(_$i, this.staticRulesId);
            else {
                var r = $36ad047dac3e028c$var$Nn($36ad047dac3e028c$var$ui(this.rules, e, t, n)), o = $36ad047dac3e028c$var$on($36ad047dac3e028c$var$sn(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, o)) {
                    var a = n(r, ".".concat(o), void 0, this.componentId);
                    t.insertRules(this.componentId, o, a);
                }
                _$i = $36ad047dac3e028c$var$An(_$i, o), this.staticRulesId = o;
            }
        } else {
            for(var s = $36ad047dac3e028c$var$sn(this.baseHash, n.hash), l = "", _$c = 0; _$c < this.rules.length; _$c++){
                var d = this.rules[_$c];
                if ("string" == typeof d) l += d;
                else if (d) {
                    var u = $36ad047dac3e028c$var$Nn($36ad047dac3e028c$var$ui(d, e, t, n));
                    s = $36ad047dac3e028c$var$sn(s, u + _$c), l += u;
                }
            }
            if (l) {
                var h = $36ad047dac3e028c$var$on(s >>> 0);
                t.hasNameForId(this.componentId, h) || t.insertRules(this.componentId, h, n(l, ".".concat(h), void 0, this.componentId)), _$i = $36ad047dac3e028c$var$An(_$i, h);
            }
        }
        return _$i;
    }, e;
}(), $36ad047dac3e028c$var$mi = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).createContext(void 0);
$36ad047dac3e028c$var$mi.Consumer;
var $36ad047dac3e028c$var$fi = {}, $36ad047dac3e028c$var$gi = new Set;
function $36ad047dac3e028c$var$vi(e, t, n) {
    var r = $36ad047dac3e028c$var$In(e), o = e, a = !$36ad047dac3e028c$var$dn(e), s = t.attrs, l = void 0 === s ? $36ad047dac3e028c$var$Zt : s, _$c = t.componentId, h = void 0 === _$c ? function(e, t) {
        var _$n = "string" != typeof e ? "sc" : $36ad047dac3e028c$var$en(e);
        $36ad047dac3e028c$var$fi[_$n] = ($36ad047dac3e028c$var$fi[_$n] || 0) + 1;
        var _$i = "".concat(_$n, "-").concat($36ad047dac3e028c$var$cn($36ad047dac3e028c$var$Bt + _$n + $36ad047dac3e028c$var$fi[_$n]));
        return t ? "".concat(t, "-").concat(_$i) : _$i;
    }(t.displayName, t.parentComponentId) : _$c, _$p = t.displayName, _$m = void 0 === _$p ? function(e) {
        return $36ad047dac3e028c$var$dn(e) ? "styled.".concat(e) : "Styled(".concat(function(e) {
            return (0, e.displayName) || e.name || "Component";
        }(e), ")");
    }(e) : _$p, f = t.displayName && t.componentId ? "".concat($36ad047dac3e028c$var$en(t.displayName), "-").concat(t.componentId) : t.componentId || h, g = r && o.attrs ? o.attrs.concat(l).filter(Boolean) : l, _$v = t.shouldForwardProp;
    if (r && o.shouldForwardProp) {
        var y = o.shouldForwardProp;
        if (t.shouldForwardProp) {
            var w = t.shouldForwardProp;
            _$v = function v(e, t) {
                return y(e, t) && w(e, t);
            };
        } else _$v = y;
    }
    var b = new $36ad047dac3e028c$var$pi(n, f, r ? o.componentStyle : void 0);
    function x(e, t) {
        return function(e, t, n) {
            var r = e.attrs, o = e.componentStyle, a = e.defaultProps, s = e.foldedComponentIds, l = e.styledComponentId, _$c = e.target, h = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).useContext($36ad047dac3e028c$var$mi), _$p = $36ad047dac3e028c$var$oi(), _$m = e.shouldForwardProp || _$p.shouldForwardProp;
            var f = function(e, t, n) {
                return void 0 === n && (n = $36ad047dac3e028c$var$Xt), e.theme !== n.theme && e.theme || t || n.theme;
            }(t, h, a) || $36ad047dac3e028c$var$Xt, g = function(e, t, n) {
                for(var _$i, r = $36ad047dac3e028c$var$Re($36ad047dac3e028c$var$Re({}, t), {
                    className: void 0,
                    theme: n
                }), o = 0; o < e.length; o += 1){
                    var a = $36ad047dac3e028c$var$$n(_$i = e[o]) ? _$i(r) : _$i;
                    for(var s in a)r[s] = "className" === s ? $36ad047dac3e028c$var$An(r[s], a[s]) : "style" === s ? $36ad047dac3e028c$var$Re($36ad047dac3e028c$var$Re({}, r[s]), a[s]) : a[s];
                }
                return t.className && (r.className = $36ad047dac3e028c$var$An(r.className, t.className)), r;
            }(r, t, f), _$v = g.as || _$c, y = {};
            for(var w in g)void 0 === g[w] || "$" === w[0] || "as" === w || "theme" === w && g.theme === f || ("forwardedAs" === w ? y.as = g.forwardedAs : _$m && !_$m(w, _$v) || (y[w] = g[w], _$m));
            var b = function(e, t) {
                var _$n = $36ad047dac3e028c$var$oi(), _$i = e.generateAndInjectStyles(t, _$n.styleSheet, _$n.stylis);
                return _$i;
            }(o, g);
            var _$x = $36ad047dac3e028c$var$An(s, l);
            return b && (_$x += " " + b), g.className && (_$x += " " + g.className), y[$36ad047dac3e028c$var$dn(_$v) && !$36ad047dac3e028c$var$Jt.has(_$v) ? "class" : "className"] = _$x, y.ref = n, (0, $33gHU.createElement)(_$v, y);
        }(_$C, e, t);
    }
    x.displayName = _$m;
    var _$C = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).forwardRef(x);
    return _$C.attrs = g, _$C.componentStyle = b, _$C.displayName = _$m, _$C.shouldForwardProp = _$v, _$C.foldedComponentIds = r ? $36ad047dac3e028c$var$An(o.foldedComponentIds, o.styledComponentId) : "", _$C.styledComponentId = f, _$C.target = r ? o.target : e, Object.defineProperty(_$C, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(e) {
            this._foldedDefaultProps = r ? function(e) {
                for(var _$t = [], _$n = 1; _$n < arguments.length; _$n++)_$t[_$n - 1] = arguments[_$n];
                for(var _$i = 0, r = _$t; _$i < r.length; _$i++)$36ad047dac3e028c$var$On(e, r[_$i], !0);
                return e;
            }({}, o.defaultProps, e) : e;
        }
    }), $36ad047dac3e028c$var$Mn(_$C, function() {
        return ".".concat(_$C.styledComponentId);
    }), a && $36ad047dac3e028c$var$Tn(_$C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), _$C;
}
function $36ad047dac3e028c$var$yi(e, t) {
    for(var n = [
        e[0]
    ], _$i = 0, r = t.length; _$i < r; _$i += 1)n.push(t[_$i], e[_$i + 1]);
    return n;
}
var $36ad047dac3e028c$var$wi = function wi(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $36ad047dac3e028c$var$bi(e) {
    for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
    if ($36ad047dac3e028c$var$$n(e) || $36ad047dac3e028c$var$Ln(e)) return $36ad047dac3e028c$var$wi($36ad047dac3e028c$var$ui($36ad047dac3e028c$var$yi($36ad047dac3e028c$var$Zt, $36ad047dac3e028c$var$He([
        e
    ], t, !0))));
    var _$i = e;
    return 0 === t.length && 1 === _$i.length && "string" == typeof _$i[0] ? $36ad047dac3e028c$var$ui(_$i) : $36ad047dac3e028c$var$wi($36ad047dac3e028c$var$ui($36ad047dac3e028c$var$yi(_$i, t)));
}
function $36ad047dac3e028c$var$xi(e, t, n) {
    if (void 0 === n && (n = $36ad047dac3e028c$var$Xt), !t) throw $36ad047dac3e028c$var$Rn(1, t);
    var _$i = function i(_i) {
        for(var r = [], o = 1; o < arguments.length; o++)r[o - 1] = arguments[o];
        return e(t, n, $36ad047dac3e028c$var$bi.apply(void 0, $36ad047dac3e028c$var$He([
            _i
        ], r, !1)));
    };
    return _$i.attrs = function(i) {
        return $36ad047dac3e028c$var$xi(e, t, $36ad047dac3e028c$var$Re($36ad047dac3e028c$var$Re({}, n), {
            attrs: Array.prototype.concat(n.attrs, i).filter(Boolean)
        }));
    }, _$i.withConfig = function(i) {
        return $36ad047dac3e028c$var$xi(e, t, $36ad047dac3e028c$var$Re($36ad047dac3e028c$var$Re({}, n), i));
    }, _$i;
}
var $36ad047dac3e028c$var$Ci = function Ci(e) {
    return $36ad047dac3e028c$var$xi($36ad047dac3e028c$var$vi, e);
}, $36ad047dac3e028c$var$ki = $36ad047dac3e028c$var$Ci;
function $36ad047dac3e028c$var$Si(e) {
    for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
    var _$i = $36ad047dac3e028c$var$Nn($36ad047dac3e028c$var$bi.apply(void 0, $36ad047dac3e028c$var$He([
        e
    ], t, !1))), r = $36ad047dac3e028c$var$cn(_$i);
    return new $36ad047dac3e028c$var$ai(r, _$i);
}
$36ad047dac3e028c$var$Jt.forEach(function(e) {
    $36ad047dac3e028c$var$ki[e] = $36ad047dac3e028c$var$Ci(e);
});
var $36ad047dac3e028c$var$Ti = "__sc-".concat($36ad047dac3e028c$var$zt, "__");
var $36ad047dac3e028c$var$$i = $36ad047dac3e028c$var$bi([
    "scrollbar-color:",
    " default;scrollbar-width:thin;&::-webkit-scrollbar{width:0.3em;}&::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,0.2);}&::-webkit-scrollbar-thumb{background-color:",
    ";outline:1px solid ",
    ";}"
], function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}), $36ad047dac3e028c$var$Ii = $36ad047dac3e028c$var$bi([
    "&::after{content:'';position:absolute;bottom:0;left:0;width:100%;height:2rem;background:linear-gradient( 0deg,var(--rc-gradient-color) 0%,rgba(255,255,255,0) 100% );}"
]), $36ad047dac3e028c$var$Ai = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "MediaWrapper",
    componentId: "sc-1yk7mm5-0"
})([
    "align-items:flex-start;align-self:center;background:",
    ";border-radius:4px;flex-direction:row;height:",
    ";padding:0.5em;position:relative;text-align:",
    ";width:calc(100% - 1em);",
    ";",
    ""
], function(e) {
    var t;
    return e.$textOverlay ? "none" : null === (t = e.theme) || void 0 === t ? void 0 : t.cardMediaBgColor;
}, function(e) {
    return e.$textOverlay ? "calc(100% - 1em)" : "0";
}, function(e) {
    return e.align;
}, function(e) {
    return e.$cardHeight ? "min-height: ".concat(e.$cardHeight, "px;") : "";
}, function(e) {
    return "HORIZONTAL" === e.mode || "left" === e.dir ? "\n        justify-content: flex-start;\n      " : "\n        justify-content: flex-end;\n      ";
}), $36ad047dac3e028c$var$Ni = $36ad047dac3e028c$var$ki.img.withConfig({
    displayName: "CardImage",
    componentId: "sc-1yk7mm5-1"
})([
    "flex:4;justify-self:center;margin-left:auto;margin-right:auto;height:100%;width:100%;object-fit:",
    ";object-position:center;visibility:",
    ";border-radius:",
    ";"
], function(e) {
    return e.fit || "cover";
}, function(e) {
    return e.$visible ? "visible" : "hidden";
}, function(e) {
    return e.$enableBorderRadius ? "6px" : "0";
}), $36ad047dac3e028c$var$Li = $36ad047dac3e028c$var$ki.video.withConfig({
    displayName: "CardVideo",
    componentId: "sc-1yk7mm5-2"
})([
    "max-width:100%;max-height:100%;margin-left:auto;margin-right:auto;"
]), $36ad047dac3e028c$var$Oi = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "MediaDetailsWrapper",
    componentId: "sc-1yk7mm5-3"
})([
    "bottom:0;left:0;right:0;margin-right:auto;width:",
    ";display:flex;flex-direction:column;flex:1;overflow:hidden;",
    " position:",
    ";",
    " ",
    " --rc-gradient-color:",
    ";",
    ""
], function(e) {
    switch(e.mode){
        case "HORIZONTAL":
        case "VERTICAL":
        case "VERTICAL_ALTERNATING":
            return "calc(90% - 0rem)";
    }
}, function(e) {
    return e.$textInMedia && e.$expandFull ? $36ad047dac3e028c$var$bi([
        "height:100%;width:100%;border:0;"
    ]) : e.$showText ? e.$textInMedia && e.$expandable ? $36ad047dac3e028c$var$bi([
        "box-shadow:0 0 10px 0 rgba(0,0,0,0.2);border-radius:10px;height:50%;"
    ]) : void 0 : $36ad047dac3e028c$var$bi([
        "height:15%;box-shadow:0 0 10px 0 rgba(0,0,0,0.2);border-radius:10px;"
    ]);
}, function(e) {
    return e.$absolutePosition ? "absolute" : "relative";
}, function(e) {
    var t, n;
    return e.$absolutePosition ? "\n    left: 50%;\n    bottom: ".concat(e.$expandFull ? "0%" : " 5%", ";\n    transform: translateX(-50%);\n    background: ").concat(e.$showText ? null === (t = e.theme) || void 0 === t ? void 0 : t.cardDetailsBackGround : null === (n = e.theme) || void 0 === n ? void 0 : n.cardBgColor, ";\n    // backdrop-filter: blur(1px);\n    padding: 0.25rem;\n    ").concat(e.$showText ? "overflow: auto;" : "overflow: hidden;", "\n    transition: height 0.25s ease-out, width 0.25s ease-out, bottom 0.25s ease-out, background 0.25s ease-out;\n  ") : "";
}, function(param) {
    var e = param.$borderLessCard;
    return e ? "border-radius: 6px; box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);" : "";
}, function(e) {
    return e.$gradientColor;
}, function(e) {
    return e.$gradientColor ? $36ad047dac3e028c$var$Ii : null;
}), $36ad047dac3e028c$var$Mi = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "ErrorMessage",
    componentId: "sc-1yk7mm5-4"
})([
    "color:#a3a3a3;left:50%;position:absolute;text-align:center;top:50%;transform:translateY(-50%) translateX(-50%);"
]), $36ad047dac3e028c$var$Di = $36ad047dac3e028c$var$ki.iframe.withConfig({
    displayName: "IFrameVideo",
    componentId: "sc-1yk7mm5-5"
})([
    "position:relative;height:100%;width:100%;"
]), $36ad047dac3e028c$var$Ei = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "DetailsTextWrapper",
    componentId: "sc-1yk7mm5-6"
})([
    "align-self:center;display:flex;transition:height 0.5s ease;width:calc(100%);background:",
    ";color:",
    ";padding:0.5rem;border-bottom-left-radius:8px;border-bottom-right-radius:8px;position:relative;align-items:flex-start;justify-content:center;",
    " ",
    " ",
    " ",
    ""
], function(e) {
    return e.background;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.cardDetailsColor;
}, $36ad047dac3e028c$var$$i, function(e) {
    return e.$expandFull ? "\n        overflow: auto;\n      " : "\n        overflow: hidden;\n      ";
}, function(e) {
    return e.$show ? "\n    height: 100%;" : "\n    height: 0;\n  ";
}, function(e) {
    return !e.$expandFull && $36ad047dac3e028c$var$Ii;
}), $36ad047dac3e028c$var$Ri = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "CardMediaHeader",
    componentId: "sc-1yk7mm5-7"
})([
    "padding:0.5rem 0 0.5rem 0.5rem;display:flex;align-items:center;justify-content:center;"
]), $36ad047dac3e028c$var$Hi = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-1yk7mm5-8"
})([
    "width:100%;height:100%;overflow:hidden;border-radius:6px;"
]), $36ad047dac3e028c$var$Pi = (0, $33gHU.memo)(function(param) {
    var t = param.theme, n = param.show, _$i = param.expand, r = param.textOverlay, o = param.text, s = param.height, _$c = param.onRender;
    var d = (0, $33gHU.useCallback)(function(e) {
        e && (null == _$c || _$c(e.clientHeight));
    }, []), u = o, h = (0, $33gHU.useMemo)(function() {
        var _$e = (null == t ? void 0 : t.cardDetailsBackGround) || "";
        return _$e ? $36ad047dac3e028c$var$Se(_$e, .8) : _$e;
    }, [
        null == t ? void 0 : t.cardDetailsBackGround
    ]);
    return r ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ei, {
        ref: d,
        $expandFull: _$i,
        theme: t,
        $show: n,
        background: h,
        children: (0, $978b871a0234f592$exports.jsx)(u, {})
    }) : null;
}, function(e, t) {
    return e.height === t.height && e.show === t.show && e.expand === t.expand && JSON.stringify(e.theme) === JSON.stringify(t.theme);
});
$36ad047dac3e028c$var$Pi.displayName = "Details Text";
var $36ad047dac3e028c$var$ji = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M6 18h12v2H6zm5-14v8.586L6.707 8.293 5.293 9.707 12 16.414l6.707-6.707-1.414-1.414L13 12.586V4z"
        })
    });
}, $36ad047dac3e028c$var$zi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M20 6 9 17l-5-5"
        })
    });
}, $36ad047dac3e028c$var$_i = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });
}, $36ad047dac3e028c$var$Wi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevron-left",
        children: (0, $978b871a0234f592$exports.jsx)("polyline", {
            points: "15 18 9 12 15 6"
        })
    });
}, $36ad047dac3e028c$var$Bi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevron-right",
        children: (0, $978b871a0234f592$exports.jsx)("polyline", {
            points: "9 18 15 12 9 6"
        })
    });
};
function $36ad047dac3e028c$var$Fi() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "prefix__feather prefix__feather-x",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M18 6L6 18M6 6l12 12"
        })
    });
}
var $36ad047dac3e028c$var$Vi = function(t) {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "currentColor",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M19 3H5c-1.103 0-2 .897-2 2v4h18V5c0-1.103-.897-2-2-2zM3 19c0 1.103.897 2 2 2h8V11H3v8zm12 2h4c1.103 0 2-.897 2-2v-8h-6v10z"
        })
    });
}, $36ad047dac3e028c$var$Gi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-maximize-2",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
        })
    });
}, $36ad047dac3e028c$var$qi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"
        })
    });
}, $36ad047dac3e028c$var$Yi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M5 12h14"
        })
    });
}, $36ad047dac3e028c$var$Ui = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        viewBox: "0 0 24 24",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
        })
    });
}, $36ad047dac3e028c$var$Zi = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M12 5v14M5 12h14"
        })
    });
}, $36ad047dac3e028c$var$Xi = function() {
    return (0, $978b871a0234f592$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        viewBox: "0 0 24 24",
        children: [
            (0, $978b871a0234f592$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10
            }),
            (0, $978b871a0234f592$exports.jsx)("path", {
                d: "M9 9h6v6H9z"
            })
        ]
    });
}, $36ad047dac3e028c$var$Ji = function() {
    return (0, $978b871a0234f592$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-sun",
        children: [
            (0, $978b871a0234f592$exports.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 5
            }),
            (0, $978b871a0234f592$exports.jsx)("path", {
                d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
            })
        ]
    });
}, $36ad047dac3e028c$var$Ki = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: (0, $978b871a0234f592$exports.jsx)("path", {
            d: "M9 16h2v4h2V6h2v14h2V6h3V4H9c-3.309 0-6 2.691-6 6s2.691 6 6 6zM9 6h2v8H9c-2.206 0-4-1.794-4-4s1.794-4 4-4z"
        })
    });
}, $36ad047dac3e028c$var$Qi = $36ad047dac3e028c$var$bi([
    "align-items:center;background:none;border-radius:50%;border:none;cursor:pointer;display:flex;height:1.5rem;justify-content:center;padding:0;width:1.5rem;margin:0 0.25rem;background:",
    ";color:#fff;svg{width:70%;height:70%;}"
], function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}), $36ad047dac3e028c$var$er = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "ExpandButton",
    componentId: "sc-14xzasw-0"
})([
    "",
    ""
], $36ad047dac3e028c$var$Qi), $36ad047dac3e028c$var$tr = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "ShowHideTextButton",
    componentId: "sc-14xzasw-1"
})([
    "",
    ""
], $36ad047dac3e028c$var$Qi), $36ad047dac3e028c$var$nr = $36ad047dac3e028c$var$ki.ul.withConfig({
    displayName: "ButtonWrapper",
    componentId: "sc-14xzasw-2"
})([
    "display:flex;flex-direction:row;justify-content:flex-end;list-style:none;margin:0;padding:0;margin-left:auto;"
]), $36ad047dac3e028c$var$ir = (0, $33gHU.memo)(function(param) {
    var t = param.theme, n = param.expanded, _$i = param.onExpand, r = param.textOverlay;
    var o = (0, $33gHU.useMemo)(function() {
        return n ? "Minimize" : "Maximize";
    }, [
        n
    ]);
    return r ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$er, {
        onPointerDown: _$i,
        onKeyDown: function(e) {
            return "Enter" === e.key && (null == _$i ? void 0 : _$i(e));
        },
        theme: t,
        "aria-expanded": n,
        tabIndex: 0,
        "aria-label": o,
        title: o,
        children: (0, $978b871a0234f592$exports.jsx)(n ? $36ad047dac3e028c$var$qi : $36ad047dac3e028c$var$Gi, {})
    }) : null;
}, function(e, t) {
    return e.expanded === t.expanded;
});
$36ad047dac3e028c$var$ir.displayName = "Expand Button";
var $36ad047dac3e028c$var$rr = (0, $33gHU.memo)(function(param) {
    var t = param.textOverlay, n = param.onToggle, _$i = param.theme, r = param.show;
    var o = (0, $33gHU.useMemo)(function() {
        return r ? "Hide Text" : "Show Text";
    }, [
        r
    ]);
    return t ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$tr, {
        onPointerDown: n,
        theme: _$i,
        tabIndex: 0,
        onKeyDown: function(e) {
            return "Enter" === e.key && (null == n ? void 0 : n(e));
        },
        "aria-label": o,
        title: o,
        children: (0, $978b871a0234f592$exports.jsx)(r ? $36ad047dac3e028c$var$Yi : $36ad047dac3e028c$var$Zi, {})
    }) : null;
});
$36ad047dac3e028c$var$rr.displayName = "Show Hide Text Button";
var $36ad047dac3e028c$var$or = $36ad047dac3e028c$var$Si([
    "0%{opacity:0;transform:scale(0.95);}100%{opacity:1;transform:scale(1);}"
]), $36ad047dac3e028c$var$ar = $36ad047dac3e028c$var$Si([
    "0%{opacity:0;transform:translateY(-50%);}100%{opacity:1;transform:translateY(0);}"
]), $36ad047dac3e028c$var$sr = $36ad047dac3e028c$var$Si([
    "0%{opacity:0;transform:translateX(-50%);}100%{opacity:1;transform:translateX(0);}"
]), $36ad047dac3e028c$var$lr = $36ad047dac3e028c$var$Si([
    "0%{opacity:0;transform:translateX(50%);}100%{opacity:1;transform:translateX(0);}"
]), $36ad047dac3e028c$var$cr = $36ad047dac3e028c$var$ki.section.withConfig({
    displayName: "TimelineItemContentWrapper",
    componentId: "sc-d7qjm1-0"
})([
    "align-items:flex-start;background:",
    ";border-radius:8px;display:flex;position:absolute;",
    ";flex-direction:column;justify-content:flex-start;line-height:1.5em;margin:",
    ";max-width:",
    "px;",
    " ",
    ";position:relative;text-align:left;width:98%;z-index:0;",
    " ",
    " height:",
    ";&:focus{outline:1px solid ",
    ";}",
    " ",
    ""
], function(e) {
    return e.theme.cardBgColor;
}, function(param) {
    var e = param.borderLessCards;
    return e ? "none" : "filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.3))";
}, function(e) {
    return "HORIZONTAL" === e.mode ? "0 auto" : "";
}, function(e) {
    return e.$maxWidth;
}, function(param) {
    var e = param.$textDensity, t = param.$customContent, n = param.$minHeight;
    return $36ad047dac3e028c$var$bi([
        "",
        ";"
    ], "HIGH" === e ? "".concat(t ? "height" : "min-height", ": ").concat(n, "px") : "");
}, function(e) {
    return e.$textOverlay ? "min-height: ".concat(e.$minHeight, "px") : "";
}, function(e) {
    return e.$highlight ? $36ad047dac3e028c$var$bi([
        "&:hover{filter:drop-shadow(0 0 5px rgba(0,0,0,0.3)) brightness(1.05);&::before{content:'';height:100%;left:0;position:absolute;top:0;width:100%;z-index:-1;border:2px solid ",
        ";border-radius:4px;}}"
    ], e.theme.primary) : $36ad047dac3e028c$var$bi([
        ""
    ]);
}, function(e) {
    return e.$isNested ? $36ad047dac3e028c$var$bi([
        "background:",
        ";box-shadow:0 0 5px 2px rgba(0,0,0,0.1);"
    ], e.theme.nestedCardBgColor) : $36ad047dac3e028c$var$bi([
        ""
    ]);
}, function(e) {
    return e.$textOverlay ? "0" : "";
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    if (e.$slideShowActive && e.$active) return "slide_in" === e.$slideShowType ? $36ad047dac3e028c$var$bi([
        "animation:",
        " 0.5s ease-in-out;"
    ], $36ad047dac3e028c$var$ar) : "slide_from_sides" === e.$slideShowType && "left" === e.$branchDir ? $36ad047dac3e028c$var$bi([
        "animation:",
        " 0.5s ease-in-out;"
    ], $36ad047dac3e028c$var$sr) : "slide_from_sides" === e.$slideShowType && "right" === e.$branchDir ? $36ad047dac3e028c$var$bi([
        "animation:",
        " 0.5s ease-in-out;"
    ], $36ad047dac3e028c$var$lr) : $36ad047dac3e028c$var$bi([
        "animation:",
        " 0.5s ease-in-out;"
    ], $36ad047dac3e028c$var$or);
}, function(e) {
    return e.$slideShowActive && e.$active ? $36ad047dac3e028c$var$bi([
        "opacity:1;animation-timing-function:ease-in-out;animation-duration:0.5s;"
    ]) : e.$slideShowActive && !e.$active ? $36ad047dac3e028c$var$bi([
        "opacity:0;"
    ]) : void 0;
}), $36ad047dac3e028c$var$dr = $36ad047dac3e028c$var$ki.header.withConfig({
    displayName: "TimelineCardHeader",
    componentId: "sc-d7qjm1-1"
})([
    "width:100%;padding:0.5rem;"
]), $36ad047dac3e028c$var$ur = $36ad047dac3e028c$var$ki.h2.withConfig({
    displayName: "CardSubTitle",
    componentId: "sc-d7qjm1-2"
})([
    "color:",
    ";font-size:",
    ";font-weight:600;margin:0;text-align:left;width:97%;padding:",
    ";"
], function(e) {
    return e.theme.cardSubtitleColor;
}, function(e) {
    return e.$fontSize;
}, function(e) {
    return e.$padding ? "0.5rem 0 0.5rem 0.5rem;" : "";
}), $36ad047dac3e028c$var$hr = $36ad047dac3e028c$var$ki.h1.withConfig({
    displayName: "CardTitle",
    componentId: "sc-d7qjm1-3"
})([
    "color:",
    ";font-size:",
    ";font-weight:600;margin:0.25rem 0 0.5rem 0;text-align:left;width:95%;padding:",
    " &.active{color:",
    ";}"
], function(e) {
    return e.theme.cardTitleColor;
}, function(e) {
    return e.$fontSize;
}, function(e) {
    return e.$padding ? "0.2rem 0 0.25rem 0.5rem;" : "";
}, function(e) {
    return e.theme.primary;
}), $36ad047dac3e028c$var$pr = $36ad047dac3e028c$var$ki.a.withConfig({
    displayName: "CardTitleAnchor",
    componentId: "sc-d7qjm1-4"
})([
    "color:inherit;&:active{color:inherit;}"
]), $36ad047dac3e028c$var$mr = $36ad047dac3e028c$var$ki.p.withConfig({
    displayName: "TimelineContentDetails",
    componentId: "sc-d7qjm1-5"
})([
    "font-size:0.85rem;font-weight:400;margin:0;width:100%;color:",
    ";"
], function(e) {
    return e.theme.cardDetailsColor;
}), $36ad047dac3e028c$var$fr = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "TimelineSubContent",
    componentId: "sc-d7qjm1-6"
})([
    "margin-bottom:0.5rem;display:block;font-size:",
    ";color:",
    ";"
], function(e) {
    return e.fontSize;
}, function(e) {
    return e.theme.cardDetailsColor;
}), $36ad047dac3e028c$var$gr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineContentDetailsWrapper",
    componentId: "sc-d7qjm1-7"
})([
    "align-items:center;display:flex;flex-direction:column;margin:0 auto;margin-top:0.5em;margin-bottom:0.5em;position:relative;",
    " ",
    " overflow-x:hidden;overflow-y:auto;scrollbar-color:",
    " default;scrollbar-width:thin;transition:max-height 0.25s ease-in-out;width:",
    ";padding:0.25rem 0.25rem;",
    " $",
    " &::-webkit-scrollbar{width:0.3em;}&::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,0.2);}&::-webkit-scrollbar-thumb{background-color:",
    ";outline:1px solid ",
    ";}&.show-less{scrollbar-width:none;&::-webkit-scrollbar{width:0;}overflow:hidden;}--rc-gradient-color:",
    ";",
    ""
], function(param) {
    var e = param.$useReadMore, t = param.$customContent, n = param.$showMore, tmp = param.height, _$i = tmp === void 0 ? 0 : tmp, r = param.$textOverlay;
    return !e || t || n || r ? "height: 100%" : "max-height: ".concat(_$i, "px;");
}, function(param) {
    var tmp = param.$cardHeight, e = tmp === void 0 ? 0 : tmp, tmp1 = param.$contentHeight, t = tmp1 === void 0 ? 0 : tmp1, tmp2 = param.height, n = tmp2 === void 0 ? 0 : tmp2, _$i = param.$showMore, r = param.$textOverlay;
    return _$i && !r ? "max-height: ".concat((e || 0) + (t || 0) - n, "px;") : "";
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    return e.$borderLess ? "calc(100% - 0.5rem)" : "calc(95% - 0.5rem)";
}, function(e) {
    return e.$customContent ? "height: 100%;" : "";
}, function(param) {
    var tmp = param.height, e = tmp === void 0 ? 0 : tmp, tmp1 = param.$cardHeight, t = tmp1 === void 0 ? 0 : tmp1, tmp2 = param.$contentHeight, n = tmp2 === void 0 ? 0 : tmp2, _$i = param.$showMore, r = param.$useReadMore;
    return _$i && r && t ? $36ad047dac3e028c$var$bi([
        "animation:",
        " 0.25s ease-in-out;"
    ], $36ad047dac3e028c$var$Si([
        "0%{max-height:",
        "px;}100%{max-height:",
        "px;}"
    ], e, t + n - e)) : "";
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    return e.$gradientColor;
}, $36ad047dac3e028c$var$Ii), $36ad047dac3e028c$var$vr = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "ShowMore",
    componentId: "sc-d7qjm1-8"
})([
    "align-items:center;align-self:flex-end;border-radius:4px;cursor:pointer;display:",
    ";font-size:0.75rem;justify-self:flex-end;margin-bottom:0.5em;margin-left:0.5em;margin-right:0.5em;margin-top:auto;padding:0.25em;color:",
    ";border:0;background:none;&:hover{text-decoration:underline;}"
], function(e) {
    return "true" === e.show ? "flex" : "none";
}, function(e) {
    return e.theme.primary;
}), $36ad047dac3e028c$var$yr = $36ad047dac3e028c$var$ki.progress.withConfig({
    displayName: "SlideShowProgressBar",
    componentId: "sc-d7qjm1-9"
})([
    "background:",
    ";bottom:-0.75em;display:block;height:4px;left:50%;transform:translateX(-50%);position:absolute;border-radius:2px;gggg border:0;",
    " ",
    " svg{position:absolute;left:0;top:0;width:100%;}"
], function(e) {
    return e.color;
}, function(e) {
    if (e.$paused) return $36ad047dac3e028c$var$bi([
        "left:50%;transform:translateX(-50%);"
    ]);
}, function(e) {
    return !e.$paused && e.$startWidth && e.$startWidth > 0 ? $36ad047dac3e028c$var$bi([
        "animation:",
        " ",
        "ms ease-in;animation-play-state:running;"
    ], $36ad047dac3e028c$var$Si([
        "0%{width:",
        "px;}100%{width:",
        "px;}"
    ], e.$startWidth, 0), e.$duration) : $36ad047dac3e028c$var$bi([
        "animation-play-state:paused;width:",
        "px;"
    ], e.$startWidth);
}), $36ad047dac3e028c$var$wr = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "ChevronIconWrapper",
    componentId: "sc-d7qjm1-10"
})([
    "align-items:center;display:flex;height:1.25em;justify-content:center;margin-left:0.2em;margin-top:0.2em;width:1.25em;",
    ";svg{height:100%;width:100%;}"
], function(e) {
    return "false" === e.collapsed ? "\n      transform: rotate(90deg);\n  " : "transform: rotate(-90deg)";
}), $36ad047dac3e028c$var$br = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "TriangleIconWrapper",
    componentId: "sc-d7qjm1-11"
})([
    "display:flex;align-items:center;justify-content:center;width:1.5rem;height:1.5rem;position:absolute;top:calc(50%);background:",
    ";transform:translateY(-50%) rotate(225deg);z-index:-1;& svg{width:100%;height:100%;fill:#fff;}",
    ";"
], function(e) {
    return e.theme.cardBgColor;
}, function(e) {
    return "left" === e.dir ? "right: ".concat(e.offset, "px;") : "left: ".concat(e.offset, "px;");
}), $36ad047dac3e028c$var$xr = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).memo(function(param) {
    var t = param.content, n = param.color, _$i = param.dir, r = param.theme, o = param.fontSize, a = param.classString, s = param.padding;
    return t ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ur, {
        style: {
            color: n
        },
        dir: _$i,
        theme: r,
        $fontSize: o,
        className: $36ad047dac3e028c$var$Ee("card-sub-title", a),
        $padding: s,
        children: t
    }) : null;
}, function(e, t) {
    var n, _$i;
    return (null === (n = e.theme) || void 0 === n ? void 0 : n.cardSubtitleColor) === (null === (_$i = t.theme) || void 0 === _$i ? void 0 : _$i.cardSubtitleColor);
});
$36ad047dac3e028c$var$xr.displayName = "Timeline Content";
var $36ad047dac3e028c$var$Cr = function(param) {
    var t = param.title, n = param.url, _$i = param.theme, r = param.color, o = param.dir, a = param.active, tmp = param.fontSize, s = tmp === void 0 ? "1rem" : tmp, tmp1 = param.classString, l = tmp1 === void 0 ? "" : tmp1, tmp2 = param.padding, _$c = tmp2 === void 0 ? !1 : tmp2;
    return t ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$hr, {
        className: $36ad047dac3e028c$var$Ee(a ? "active" : "", (0, $6RwIG._)({}, l, !0)),
        theme: _$i,
        style: {
            color: r
        },
        dir: o,
        $fontSize: s,
        "data-class": l,
        $padding: _$c,
        children: n ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$pr, {
            href: n,
            target: "_blank",
            rel: "noreferrer",
            children: t
        }) : t
    }) : null;
};
$36ad047dac3e028c$var$Cr.displayName = "Timeline Title";
var $36ad047dac3e028c$var$kr = function(param) {
    var _$i = param.active, _$c = param.id, d = param.onMediaStateChange, u = param.title, _$m = param.content, f = param.media, g = param.slideshowActive, _$v = param.url, y = param.detailsText, w = param.showProgressBar, b = param.remainInterval, x = param.startWidth, _$C = param.paused, k = param.triangleDir, S = param.resuming, T = param.progressRef;
    var $ = (0, $33gHU.useRef)(null), _s = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), I = _s[0], A = _s[1], N = (0, $33gHU.useRef)(null), _s1 = (0, $fTrHk._)((0, $33gHU.useState)(0), 2), _$L = _s1[0], O = _s1[1], _s2 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), M = _s2[0], D = _s2[1], _s3 = (0, $fTrHk._)((0, $33gHU.useState)(!0), 2), E = _s3[0], R = _s3[1], _s4 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), H = _s4[0], _$P = _s4[1], _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), j = _h.mode, _$z = _h.fontSizes, _ = _h.classNames, W = _h.mediaHeight, B = _h.borderLessCards, F = _h.textOverlay, V = _h.theme, G = _h.cardHeight, q = _h.mediaSettings;
    (0, $33gHU.useEffect)(function() {
        $ && (_$i ? $.current && $.current.play() : $.current && $.current.pause());
    }, [
        _$i
    ]);
    var Y = (0, $33gHU.useCallback)(function() {
        _$P(!0);
    }, []), U = (0, $33gHU.useCallback)(function() {
        A(!0), d({
            id: _$c,
            paused: !1,
            playing: !1
        });
    }, [
        d,
        _$c
    ]), Z = (0, $33gHU.memo)(function(param) {
        var _$t = param.message;
        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Mi, {
            children: _$t
        });
    }), _$X = (0, $33gHU.useMemo)(function() {
        return /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/.test(f.source.url);
    }, []), _$J = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Di, {
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: !0,
            src: "".concat(f.source.url).concat(_$i ? "?autoplay=1&enablejsapi=1" : "?enablejsapi=1"),
            title: f.name
        });
    }, [
        _$i
    ]), _$K = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Li, {
            controls: !0,
            autoPlay: _$i,
            ref: $,
            onLoadedData: Y,
            onPlay: function() {
                return d({
                    id: _$c,
                    paused: !1,
                    playing: !0
                });
            },
            onPause: function() {
                return d({
                    id: _$c,
                    paused: !0,
                    playing: !1
                });
            },
            onEnded: function() {
                return d({
                    id: _$c,
                    paused: !1,
                    playing: !1
                });
            },
            onError: U,
            children: (0, $978b871a0234f592$exports.jsx)("source", {
                src: f.source.url
            })
        });
    }, [
        _$i
    ]), _$Q = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ni, {
            src: f.source.url,
            mode: j,
            onLoad: Y,
            onError: U,
            $visible: H,
            alt: f.name,
            loading: "lazy",
            $enableBorderRadius: B,
            fit: null == q ? void 0 : q.imageFit
        });
    }, [
        H,
        B
    ]);
    Z.displayName = "Error Message";
    var _$ee = (0, $33gHU.useCallback)(function(e) {
        e && O(e);
    }, []), _$te = (0, $33gHU.useCallback)(function(e) {
        D(function(e) {
            return !e;
        }), R(!0);
    }, []), _$ne = (0, $33gHU.useCallback)(function(e) {
        D(!1), R(function(e) {
            return !e;
        });
    }, []), ie = (0, $33gHU.useMemo)(function() {
        return ("VERTICAL" === j || "VERTICAL_ALTERNATING" === j) && F;
    }, []), re = (0, $33gHU.useMemo)(function() {
        return E && !!y;
    }, [
        E,
        y
    ]), oe = (0, $33gHU.useMemo)(function() {
        return u || _$m || y;
    }, [
        u,
        _$m,
        y
    ]), ae = (0, $33gHU.useMemo)(function() {
        return F && !!y;
    }, [
        _$m,
        y
    ]), se = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Se((null == V ? void 0 : V.cardDetailsBackGround) || "", .8);
    }, [
        null == V ? void 0 : V.cardDetailsBackGround
    ]), le = (0, $33gHU.useMemo)(function() {
        return !M && E && F;
    }, [
        M,
        E
    ]), ce = (0, $33gHU.useMemo)(function() {
        return F ? G : W;
    }, []), de = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Oi, {
            mode: j,
            $absolutePosition: F,
            $textInMedia: F,
            ref: N,
            theme: V,
            $expandFull: M,
            $showText: E,
            $expandable: ae,
            $gradientColor: le ? se : null,
            children: [
                (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Ri, {
                    children: [
                        (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Cr, {
                            title: u,
                            theme: V,
                            active: _$i,
                            url: _$v,
                            fontSize: null == _$z ? void 0 : _$z.cardTitle,
                            classString: null == _ ? void 0 : _.cardTitle
                        }),
                        ae ? (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$nr, {
                            children: [
                                (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$rr, {
                                    onToggle: _$ne,
                                    show: E,
                                    textOverlay: !0,
                                    theme: V
                                }),
                                (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ir, {
                                    theme: V,
                                    expanded: M,
                                    onExpand: _$te,
                                    textOverlay: !0
                                })
                            ]
                        }) : null
                    ]
                }),
                E && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$xr, {
                    content: _$m,
                    fontSize: null == _$z ? void 0 : _$z.cardSubtitle,
                    classString: null == _ ? void 0 : _.cardSubTitle,
                    padding: !0,
                    theme: V
                }),
                re ? (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
                    children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Pi, {
                        theme: V,
                        show: E,
                        expand: M,
                        text: y,
                        onRender: _$ee,
                        textOverlay: F
                    })
                }) : null
            ]
        });
    }, [
        E,
        M,
        re,
        se,
        u,
        JSON.stringify(V)
    ]), ue = (0, $33gHU.useMemo)(function() {
        return w && F;
    }, [
        w,
        F
    ]);
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Ai, {
                theme: V,
                $active: _$i,
                mode: j,
                $slideShowActive: g,
                className: $36ad047dac3e028c$var$Ee("card-media-wrapper", null == _ ? void 0 : _.cardMedia),
                $cardHeight: ce,
                align: null == q ? void 0 : q.align,
                $textOverlay: F,
                children: [
                    "VIDEO" === f.type && !_$X && (I ? (0, $978b871a0234f592$exports.jsx)(Z, {
                        message: "Failed to load the video"
                    }) : _$K),
                    "VIDEO" === f.type && _$X && _$J,
                    "IMAGE" === f.type && (I ? (0, $978b871a0234f592$exports.jsx)(Z, {
                        message: "Failed to load the image."
                    }) : (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Hi, {
                        height: W,
                        children: _$Q
                    })),
                    ue ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$yr, {
                        color: null == V ? void 0 : V.primary,
                        $duration: b,
                        $paused: _$C,
                        ref: T,
                        $startWidth: x,
                        $resuming: S
                    }) : null,
                    ie ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$br, {
                        dir: k,
                        theme: V,
                        offset: -15,
                        role: "img"
                    }) : null
                ]
            }),
            oe ? de : null
        ]
    });
};
$36ad047dac3e028c$var$kr.displayName = "Card Media";
var $36ad047dac3e028c$var$Sr = function(param) {
    var _$i = param.showProgressBar, r = param.onExpand, o = param.triangleDir, s = param.showMore, _$c = param.textContentIsLarge, d = param.showReadMore, u = param.remainInterval, _$p = param.paused, _$m = param.startWidth, f = param.canShow, g = param.progressRef, _$v = param.isNested, y = param.isResuming;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), w = _h.mode, b = _h.theme, x = (0, $33gHU.useMemo)(function() {
        return !_$v && [
            "VERTICAL",
            "VERTICAL_ALTERNATING"
        ].some(function(e) {
            return e === w;
        });
    }, [
        w,
        _$v
    ]), _$C = (0, $33gHU.useCallback)(function(e) {
        e.stopPropagation(), e.preventDefault(), r();
    }, [
        r
    ]), k = (0, $33gHU.useMemo)(function() {
        return d && _$c;
    }, [
        d,
        _$c
    ]);
    return (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
        children: [
            k ? (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$vr, {
                className: "show-more",
                onPointerDown: _$C,
                onKeyUp: function(e) {
                    "Enter" === e.key && r();
                },
                show: f ? "true" : "false",
                theme: b,
                tabIndex: 0,
                children: [
                    (0, $978b871a0234f592$exports.jsx)("span", {
                        children: s ? "read less" : "read more"
                    }),
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$wr, {
                        collapsed: s ? "true" : "false",
                        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Bi, {})
                    })
                ]
            }) : null,
            _$i && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$yr, {
                color: null == b ? void 0 : b.primary,
                $duration: u,
                $paused: _$p,
                ref: g,
                $startWidth: _$m,
                $resuming: y
            }),
            x && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$br, {
                dir: o,
                theme: b,
                offset: -8
            })
        ]
    });
}, $36ad047dac3e028c$var$Tr = (0, $33gHU.memo)(function(param) {
    var n = param.title, _$i = param.url, r = param.media, o = param.content, s = param.cardTitle;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), l = _h.fontSizes, _$c = _h.classNames, d = _h.theme, u = _h.isMobile, _$p = (0, $33gHU.useMemo)(function() {
        return !r;
    }, [
        r
    ]);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$dr, {
        children: [
            u ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$hr, {
                $fontSize: "1.2rem",
                theme: d,
                children: s
            }) : null,
            _$p ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Cr, {
                title: n,
                theme: d,
                url: _$i,
                fontSize: null == l ? void 0 : l.cardTitle,
                classString: null == _$c ? void 0 : _$c.cardTitle
            }) : null,
            _$p ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$xr, {
                content: o,
                theme: d,
                fontSize: null == l ? void 0 : l.cardSubtitle,
                classString: null == _$c ? void 0 : _$c.cardSubTitle
            }) : null
        ]
    });
});
$36ad047dac3e028c$var$Tr.displayName = "ContentHeader";
var $36ad047dac3e028c$var$$r = function(param) {
    var t = param.timelineContent, n = param.theme, _$i = param.detailedText, r = param.showMore;
    var o = (0, $33gHU.forwardRef)(function(o, s) {
        var l = Array.isArray(_$i), _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), _$c = _h.fontSizes, d = _h.classNames, u = _h.parseDetailsAsHTML, _$p = _h.textDensity;
        return function() {
            if (t) return (0, $978b871a0234f592$exports.jsx)("div", {
                ref: s,
                children: t
            });
            {
                var t1 = null;
                t1 = l ? function(param) {
                    var t = param.fontSizes, n = param.parseDetailsAsHTML, _$i = param.theme, r = param.detailedText, o = param.cardTextClassName;
                    return r.map(function(r, a) {
                        var _$s = n ? {
                            dangerouslySetInnerHTML: {
                                __html: $36ad047dac3e028c$var$xe(r)
                            }
                        } : null;
                        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$fr, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
                            fontSize: null == t ? void 0 : t.cardText,
                            className: o,
                            theme: _$i
                        }, _$s), {
                            children: n ? null : r
                        }), a);
                    });
                }({
                    cardTextClassName: null == d ? void 0 : d.cardText,
                    detailedText: _$i,
                    fontSizes: _$c,
                    parseDetailsAsHTML: u,
                    theme: n
                }) : u ? $36ad047dac3e028c$var$xe(_$i) : _$i;
                var o = u && !l ? {
                    dangerouslySetInnerHTML: {
                        __html: $36ad047dac3e028c$var$xe(t1)
                    }
                } : {}, _$h = (0, $33gHU.useMemo)(function() {
                    return u && !l || "LOW" === _$p;
                }, [
                    l,
                    _$p
                ]);
                return t1 ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$mr, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
                    className: r ? "active" : "",
                    ref: s,
                    theme: n
                }, o), {
                    children: _$h ? null : t1
                })) : null;
            }
        }();
    });
    return o.displayName = "Text Or Content", o;
}, $36ad047dac3e028c$var$Ir = (0, $33gHU.forwardRef)(function(t, i) {
    var r = t.showMore, o = t.cardActualHeight, a = t.detailsHeight, s = t.gradientColor, l = t.customContent, _$c = t.timelineContent, d = t.detailedText, u = t.contentDetailsClass, _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), _$p = _h.useReadMore, _$m = _h.borderLessCards, f = _h.contentDetailsHeight, g = _h.textOverlay, _$v = _h.theme, y = $36ad047dac3e028c$var$$r({
        detailedText: d,
        showMore: r,
        theme: _$v,
        timelineContent: _$c
    });
    return (0, $978b871a0234f592$exports.jsx)((0, $978b871a0234f592$exports.Fragment), {
        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$gr, {
            "aria-expanded": r,
            className: u,
            $customContent: !!l,
            ref: i,
            theme: _$v,
            $useReadMore: _$p,
            $borderLess: _$m,
            $showMore: r,
            $cardHeight: g ? null : o,
            $contentHeight: a,
            height: f,
            $textOverlay: g,
            $gradientColor: s,
            children: l || (0, $978b871a0234f592$exports.jsx)(y, {
                detailedText: d,
                showMore: r,
                theme: _$v,
                timelineContent: _$c
            })
        })
    });
});
$36ad047dac3e028c$var$Ir.displayName = "Details Text";
var $36ad047dac3e028c$var$Ar = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).memo(function(param) {
    var n = param.active, _$i = param.content, _$c = param.detailedText, d = param.id, u = param.media, _$p = param.onShowMore, _$m = param.slideShowActive, f = param.onElapsed, g = param.theme, _$v = param.onClick, y = param.customContent, w = param.hasFocus, b = param.flip, x = param.branchDir, _$C = param.url, k = param.timelineContent, S = param.items, T = param.isNested, $ = param.nestedCardHeight, I = param.title, A = param.cardTitle;
    var _s = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), N = _s[0], _$L = _s[1], O = (0, $33gHU.useRef)(null), M = (0, $33gHU.useRef)(null), D = (0, $33gHU.useRef)(null), E = (0, $33gHU.useRef)(0), R = (0, $33gHU.useRef)(!0), _s1 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), H = _s1[0], _$P = _s1[1], _s2 = (0, $fTrHk._)((0, $33gHU.useState)(0), 2), j = _s2[0], _$z = _s2[1], _s3 = (0, $fTrHk._)((0, $33gHU.useState)(0), 2), _ = _s3[0], W = _s3[1], _s4 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), B = _s4[0], F = _s4[1], _s5 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), V = _s5[0], G = _s5[1], _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), q = _h.mode, Y = _h.cardHeight, tmp = _h.slideItemDuration, U = tmp === void 0 ? 2e3 : tmp, Z = _h.useReadMore, _$X = _h.cardWidth, _$J = _h.borderLessCards, _$K = _h.disableAutoScrollOnClick, _$Q = _h.classNames, _$ee = _h.textOverlay, _$te = _h.slideShowType, _$ne = _h.showProgressOnSlideshow, ie = _h.disableInteraction, re = _h.highlightCardsOnHover, oe = _h.textDensity, _ref = function(e, t, n, i, a, c) {
        var d = (0, $33gHU.useRef)(), u = (0, $33gHU.useRef)(0), _s = (0, $fTrHk._)((0, $33gHU.useState)(0), 2), _$h = _s[0], _$p = _s[1], _s1 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), _$m = _s1[0], f = _s1[1], g = (0, $33gHU.useRef)(0), _s2 = (0, $fTrHk._)((0, $33gHU.useState)(0), 2), _$v = _s2[0], y = _s2[1], w = (0, $33gHU.useCallback)(function(e) {
            i && (y(e), d.current = new Date, f(!1), u.current = window.setTimeout(function() {
                window.clearTimeout(u.current), f(!0), _$p(0), y(i), a && (null == c || c(a));
            }, e));
        }, []), b = (0, $33gHU.useCallback)(function() {
            if (t && n) {
                if (window.clearTimeout(u.current), f(!0), d.current) {
                    var _$e = +new Date - +d.current;
                    g.current = _$e;
                }
                e.current && _$p(e.current.clientWidth);
            }
        }, [
            t,
            n
        ]), x = (0, $33gHU.useCallback)(function() {
            if (t && n) {
                if (!i) return;
                var _$e = i - g.current;
                f(!1), _$e > 0 && w(_$e);
            }
        }, [
            t,
            n,
            i
        ]);
        return (0, $33gHU.useEffect)(function() {
            u.current && !n && window.clearTimeout(u.current);
        }, [
            n
        ]), {
            paused: _$m,
            remainInterval: _$v,
            setStartWidth: _$p,
            setupTimer: w,
            startWidth: _$h,
            tryPause: b,
            tryResume: x
        };
    }(D, n, _$m, U, d, f), ae = _ref.paused, se = _ref.remainInterval, le = _ref.startWidth, ce = _ref.tryPause, de = _ref.tryResume, ue = _ref.setupTimer, he = _ref.setStartWidth, pe = (0, $33gHU.useMemo)(function() {
        return n && _$m && _$ne;
    }, [
        n,
        _$m
    ]), me = (0, $33gHU.useMemo)(function() {
        return !!_$c;
    }, [
        _$c
    ]);
    (0, $33gHU.useEffect)(function() {
        var _$e = O.current;
        _$e && (_$e.scrollTop = 0);
    }, [
        N
    ]), (0, $33gHU.useEffect)(function() {
        n && F(!0);
    }, [
        n
    ]);
    var fe = (0, $33gHU.useCallback)(function(e) {
        if (null === e) return;
        var _$t = O.current;
        if (!_$t) return;
        var n = _$t.scrollHeight, _$i = _$t.offsetTop;
        E.current = e.clientWidth, he(E.current), _$z(n), W(_$t.offsetHeight), _$P(n + _$i > e.clientHeight);
    }, [
        O,
        oe
    ]);
    (0, $33gHU.useEffect)(function() {
        U && (n && _$m && (he(E.current), ue(U)), n && w && M.current && M.current.focus(), _$m || F(!1));
    }, [
        n,
        _$m
    ]), (0, $33gHU.useEffect)(function() {
        w && n && M.current && M.current.focus();
    }, [
        w,
        n
    ]), (0, $33gHU.useEffect)(function() {
        ae || R.current || G(!0);
    }, [
        ae,
        le
    ]), (0, $33gHU.useEffect)(function() {
        R.current = !1;
    }, []);
    var ge = (0, $33gHU.useMemo)(function() {
        return Z && _$c && !y && "HIGH" === oe;
    }, [
        oe
    ]), ve = (0, $33gHU.useCallback)(function(e) {
        _$m && (e.playing ? ce() : e.paused && ae && d && f && f(d));
    }, [
        ae,
        _$m
    ]), ye = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee(n ? "timeline-card-content active" : "timeline-card-content ", null == _$Q ? void 0 : _$Q.card);
    }, [
        n
    ]), _$we = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee(N || y || !Z ? "card-description" : "show-less card-description", null == _$Q ? void 0 : _$Q.cardText);
    }, [
        N,
        y
    ]), be = (0, $33gHU.useMemo)(function() {
        return _$ee && u ? Y : T ? $ : Y;
    }, []), xe = (0, $33gHU.useCallback)(function() {
        (n && ae || !_$m) && (_$L(!N), _$p());
    }, [
        n,
        ae,
        _$m,
        N
    ]), Ce = (0, $33gHU.useMemo)(function() {
        return b ? "right" === x ? "left" : "right" : x;
    }, [
        x,
        b
    ]), ke = (0, $33gHU.useMemo)(function() {
        var _$e = T ? null == g ? void 0 : g.nestedCardDetailsBackGround : null == g ? void 0 : g.cardBgColor;
        return !N && H ? $36ad047dac3e028c$var$Se(_$e || "#ffffff", .8) : null;
    }, [
        H,
        N,
        null == g ? void 0 : g.cardDetailsBackGround,
        T
    ]), Te = (0, $33gHU.useMemo)(function() {
        return !(_$ee || null != S && S.length || "HIGH" !== oe);
    }, [
        null == S ? void 0 : S.length,
        oe
    ]), $e = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$$r({
            detailedText: _$c,
            showMore: N,
            theme: g,
            timelineContent: k
        });
    }, [
        N,
        k,
        g,
        _$c
    ]), Ie = (0, $33gHU.useMemo)(function() {
        if (!T && !ie) return {
            onPointerDown: function(e) {
                e.stopPropagation(), !_$m && _$v && d && !_$K && _$v(d);
            },
            onPointerEnter: ce,
            onPointerLeave: de
        };
    }, []), Ae = (0, $33gHU.useMemo)(function() {
        return !Te && "HIGH" === oe;
    }, [
        Te,
        oe
    ]);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$cr, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
        className: ye,
        $minHeight: be,
        $maxWidth: _$X,
        mode: q,
        $noMedia: !u
    }, Ie), {
        ref: fe,
        tabIndex: T ? -1 : 0,
        theme: g,
        $borderLessCards: _$J,
        $textOverlay: _$ee,
        $active: B,
        $slideShowType: _$te,
        $slideShowActive: _$m,
        $branchDir: x,
        $isNested: T,
        $highlight: re,
        $customContent: !!y,
        $textDensity: oe,
        children: [
            I && !_$ee ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Tr, {
                title: I,
                theme: g,
                url: _$C,
                media: u,
                content: _$i,
                cardTitle: A
            }) : null,
            u && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$kr, {
                active: n,
                cardHeight: Y,
                content: _$i,
                hideMedia: N,
                id: d,
                media: u,
                onMediaStateChange: ve,
                slideshowActive: _$m,
                theme: g,
                title: I,
                url: _$C,
                startWidth: le,
                detailsText: $e,
                paused: ae,
                remainInterval: se,
                showProgressBar: pe,
                triangleDir: Ce,
                resuming: V,
                progressRef: D
            }),
            Te && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ir, {
                showMore: N,
                gradientColor: ke,
                detailedText: _$c,
                customContent: y,
                timelineContent: k,
                contentDetailsClass: _$we,
                cardActualHeight: j,
                detailsHeight: _,
                ref: O
            }),
            Ae && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$qo, {
                items: S,
                mode: "VERTICAL",
                nestedCardHeight: $,
                isChild: !0
            }),
            (!_$ee || !u) && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Sr, {
                theme: g,
                progressRef: D,
                startWidth: le,
                textContentIsLarge: H,
                remainInterval: se,
                paused: ae,
                triangleDir: Ce,
                showProgressBar: pe,
                showReadMore: ge,
                onExpand: xe,
                canShow: me,
                showMore: N,
                isNested: T,
                isResuming: V
            })
        ]
    }));
});
$36ad047dac3e028c$var$Ar.displayName = "TimelineCardContent";
var $36ad047dac3e028c$var$Nr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-13izrht-0"
})([
    "border-radius:0.2rem;font-size:",
    ";font-weight:600;overflow:hidden;padding:0.25rem;visibility:",
    ";text-align:",
    ";color:",
    ";&.active{background:",
    ";color:",
    ";}"
], function(e) {
    return e.$fontSize ? e.$fontSize : "1rem";
}, function(e) {
    return e.$hide ? "hidden" : "visible";
}, function(e) {
    return e.align ? e.align : "";
}, function(e) {
    return e.theme ? e.theme.titleColor : "";
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.secondary;
}, function(e) {
    var t, n, _$i;
    return null !== (t = e.theme) && void 0 !== t && t.titleColorActive ? null === (n = e.theme) || void 0 === n ? void 0 : n.titleColorActive : null === (_$i = e.theme) || void 0 === _$i ? void 0 : _$i.primary;
}), $36ad047dac3e028c$var$Lr = function(param) {
    var t = param.title, n = param.active, _$i = param.theme, r = param.align, o = param.classString;
    var s = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee("timeline-item-title", n ? "active" : "", o);
    }, [
        n,
        o
    ]), _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), l = _h.fontSizes;
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Nr, {
        className: s,
        theme: _$i,
        $hide: !t,
        align: r,
        $fontSize: null == l ? void 0 : l.title,
        children: t
    });
}, $36ad047dac3e028c$var$Or = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-18iuiou-0"
})([
    "align-items:center;border:1px solid transparent;display:flex;justify-content:center;position:relative;width:100%;height:100%;&.vertical{justify-content:flex-start;}"
]);
$36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Item",
    componentId: "sc-18iuiou-1"
})([
    ""
]);
var $36ad047dac3e028c$var$Mr = $36ad047dac3e028c$var$Si([
    "from{opacity:0;}to{opacity:1;}"
]), $36ad047dac3e028c$var$Dr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "ShapeWrapper",
    componentId: "sc-18iuiou-2"
})([
    "align-items:center;display:flex;flex-direction:column;justify-content:center;width:5em;"
]), $36ad047dac3e028c$var$Er = function(e) {
    return "circle" === e.$timelinePointShape ? "border-radius: 50%;" : "square" === e.$timelinePointShape ? "border-radius: 2px;" : "diamond" === e.$timelinePointShape ? "border-radius: 0;" : void 0;
}, $36ad047dac3e028c$var$Rr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Shape",
    componentId: "sc-18iuiou-3"
})([
    "",
    " cursor:pointer;height:",
    "px;width:",
    "px;transform:",
    ";&.active{&.using-icon{}&:not(.using-icon){transform:",
    ";}&::after{",
    " content:'';display:block;height:",
    "px;width:",
    "px;left:50%;position:absolute;top:50%;transform:translateY(-50%) translateX(-50%);z-index:-1;}}&:not(.using-icon){background:",
    ";&.active{background:",
    ";border:",
    "px solid ",
    ";}&.in-active{}}&.using-icon{background:",
    ";display:flex;align-items:center;justify-content:center;img{max-width:90%;max-height:90%;}}"
], $36ad047dac3e028c$var$Er, function(e) {
    return e.dimension;
}, function(e) {
    return e.dimension;
}, function(e) {
    return "diamond" === e.$timelinePointShape ? "rotate(45deg)" : "";
}, function(e) {
    return "diamond" === e.$timelinePointShape ? "rotate(45deg)" : "";
}, $36ad047dac3e028c$var$Er, function(e) {
    return e.dimension ? Math.round(.75 * e.dimension) : 20;
}, function(e) {
    return e.dimension ? Math.round(.75 * e.dimension) : 20;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.secondary;
}, function(e) {
    return e.dimension ? Math.round(.2 * e.dimension) : "3";
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
}, function(e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.iconBackgroundColor;
}), $36ad047dac3e028c$var$Hr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineTitleContainer",
    componentId: "sc-18iuiou-4"
})([
    "display:flex;align-items:center;justify-content:flex-start;&.vertical{margin-bottom:1em;}&.horizontal{position:absolute;top:0;}"
]), $36ad047dac3e028c$var$Pr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineContentContainer",
    componentId: "sc-18iuiou-5"
})([
    "align-items:flex-start;animation:",
    " 0.25s ease-in;outline:2px solid ",
    ";margin:1rem;&.horizontal{min-width:",
    "px;}&.vertical{width:calc(100% - 5em);margin-left:auto;flex-direction:column;}"
], $36ad047dac3e028c$var$Mr, function(e) {
    var t;
    return e.$highlight && e.$active ? null === (t = e.theme) || void 0 === t ? void 0 : t.primary : "transparent";
}, function(e) {
    return e.$cardWidth;
}), $36ad047dac3e028c$var$jr = function(param) {
    var n = param.active, _$i = param.autoScroll, s = param.cardDetailedText, _$c = param.cardSubtitle, d = param.cardTitle, u = param.url, _$p = param.id, _$m = param.media, f = param.onClick, _$v = param.onElapsed, y = param.slideShowRunning, w = param.title, b = param.wrapperId, x = param.customContent, _$C = param.hasFocus, k = param.iconChild, S = param.timelineContent, T = param.cardWidth, $ = param.isNested, I = param.nestedCardHeight, A = param.items;
    var N = (0, $33gHU.useRef)(null), _$L = (0, $33gHU.useRef)(null), O = (0, $33gHU.useRef)(null), _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), M = _h.mode, D = _h.cardPositionHorizontal, E = _h.timelinePointDimension, R = _h.disableClickOnCircle, H = _h.cardLess, _$P = _h.showAllCardsHorizontal, j = _h.classNames, _$z = _h.theme, _ = _h.timelinePointShape, W = _h.disableInteraction;
    (0, $33gHU.useEffect)(function() {
        if (n) {
            var _$e = N.current, _$t = _$L.current;
            if (_$e && _$t) {
                var n1 = _$e.offsetLeft, _$r = _$t.offsetLeft;
                null == _$i || _$i({
                    pointOffset: n1 + _$r,
                    pointWidth: _$e.clientWidth
                });
            }
        }
    }, [
        n,
        _$i,
        M
    ]);
    var B = (0, $33gHU.useCallback)(function() {}, []), F = (0, $33gHU.useMemo)(function() {
        return null == M ? void 0 : M.toLowerCase();
    }, [
        M
    ]), V = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee("timeline-horz-card-wrapper", F, "TOP" === D ? "bottom" : "top", _$P ? "show-all" : "");
    }, [
        M,
        D
    ]), G = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee(F, D);
    }, []), q = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee("timeline-circle", {
            "using-icon": !!k
        }, F, n ? "active" : "in-active");
    }, [
        n
    ]), Y = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Pr, {
            className: V,
            ref: O,
            id: "timeline-card-".concat(_$p),
            theme: _$z,
            $active: n && !W,
            $highlight: _$P,
            tabIndex: 0,
            $cardWidth: T,
            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ar, {
                content: _$c,
                active: n,
                title: d,
                url: u,
                detailedText: s,
                onShowMore: B,
                theme: _$z,
                slideShowActive: y,
                media: _$m,
                onElapsed: _$v,
                id: _$p,
                customContent: x,
                hasFocus: _$C,
                onClick: f,
                timelineContent: S,
                isNested: $,
                nestedCardHeight: I,
                items: A
            })
        });
    }, [
        n,
        y,
        JSON.stringify(_$z)
    ]), U = (0, $33gHU.useMemo)(function() {
        return n && !H || _$P;
    }, [
        n,
        H,
        _$P
    ]);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Or, {
        ref: _$L,
        className: F,
        children: [
            U && function() {
                var _$e = document.getElementById(b);
                if (_$e) return (0, (/*@__PURE__*/$parcel$interopDefault($e1a300cc66774841$exports))).createPortal(Y, _$e);
            }(),
            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Dr, {
                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Rr, {
                    className: q,
                    onClick: function() {
                        R || !f || y || f(_$p);
                    },
                    ref: N,
                    theme: _$z,
                    "aria-label": w,
                    dimension: E,
                    $timelinePointShape: _,
                    children: k || null
                })
            }),
            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Hr, {
                className: G,
                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Lr, {
                    title: w,
                    active: n && !W,
                    theme: _$z,
                    classString: null == j ? void 0 : j.title
                })
            })
        ]
    });
}, $36ad047dac3e028c$var$zr = $36ad047dac3e028c$var$ki.ul.withConfig({
    displayName: "TimelineHorizontalWrapper",
    componentId: "sc-1dd6qhe-0"
})([
    "display:flex;list-style:none;margin:0;width:100%;direction:",
    ";&.vertical{flex-direction:column;}&.horizontal{flex-direction:row;}"
], function(e) {
    return e.flipLayout ? "rtl" : "ltr";
}), $36ad047dac3e028c$var$_r = $36ad047dac3e028c$var$ki.li.withConfig({
    displayName: "TimelineItemWrapper",
    componentId: "sc-1dd6qhe-1"
})([
    "width:",
    "px;visibility:hidden;display:flex;align-items:center;justify-content:center;height:150px;flex-direction:column;&.vertical{margin-bottom:2rem;width:100%;}&.visible{visibility:visible;}"
], function(e) {
    return e.width;
}), $36ad047dac3e028c$var$Wr = function(param) {
    var t = param.items, n = param.handleItemClick, r = param.autoScroll, o = param.wrapperId, s = param.slideShowRunning, l = param.onElapsed, _$c = param.contentDetailsChildren, d = param.hasFocus, u = param.iconChildren, _$p = param.nestedCardHeight, _$m = param.isNested;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), tmp = _h.mode, f = tmp === void 0 ? "HORIZONTAL" : tmp, tmp1 = _h.itemWidth, g = tmp1 === void 0 ? 200 : tmp1, _$v = _h.cardHeight, y = _h.flipLayout, w = _h.showAllCardsHorizontal, b = _h.theme, x = _h.cardWidth, _$C = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee(f.toLowerCase(), "timeline-horizontal-container", w ? "show-all-cards-horizontal" : "");
    }, [
        f,
        w
    ]), k = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Children.toArray(u);
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$zr, {
        className: _$C,
        flipLayout: y,
        children: t.map(function(t, i) {
            return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$_r, {
                width: g,
                className: $36ad047dac3e028c$var$Ee(t.visible ? "visible" : "", "timeline-horz-item-container"),
                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$jr, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, t), {
                    onClick: n,
                    autoScroll: r,
                    wrapperId: o,
                    theme: b,
                    slideShowRunning: s,
                    cardHeight: _$v,
                    onElapsed: l,
                    customContent: _$c ? _$c[i] : null,
                    hasFocus: d,
                    iconChild: k[i],
                    active: t.active,
                    cardWidth: x,
                    isNested: _$m,
                    nestedCardHeight: _$p
                }))
            }, t.id);
        })
    });
}, $36ad047dac3e028c$var$Br = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelinePointWrapper",
    componentId: "sc-12rz3g8-0"
})([
    "align-items:center;display:flex;justify-content:center;position:relative;width:",
    ";&.left{order:2;}&.right{order:1;}&::before{background:",
    ";width:",
    ";height:2rem;position:absolute;content:'';display:block;left:50%;top:-1rem;transform:translateY(-50%) translateX(-50%);}&::after{background:",
    ";content:'';display:block;height:100%;left:50%;position:absolute;width:",
    ";z-index:0;transform:translateX(-50%);}"
], function(e) {
    return e.$isMobile ? "25%" : "10%";
}, function(e) {
    return e.bg;
}, function(e) {
    return e.width ? "".concat(e.width, "px") : "4px";
}, function(e) {
    return e.bg;
}, function(e) {
    return e.width ? "".concat(e.width, "px") : "4px";
}), $36ad047dac3e028c$var$Fr = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "TimelinePointContainer",
    componentId: "sc-12rz3g8-1"
})([
    "position:relative;z-index:1;visibility:",
    ";background:none;border:0;"
], function(e) {
    return e.$hide ? "hidden" : "visible";
}), $36ad047dac3e028c$var$Vr = (0, $33gHU.memo)(function(t) {
    var n = t.className, _$i = t.id, s = t.onClick, l = t.active, _$c = t.onActive, d = t.slideShowRunning, u = t.iconChild, _$p = t.timelinePointDimension, _$m = t.lineWidth, f = t.disableClickOnCircle, g = t.cardLess, _$v = t.isMobile, y = (0, $33gHU.useRef)(null), _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), w = _h.theme, b = _h.focusActiveItemOnLoad, x = _h.timelinePointShape, _$C = _h.disableTimelinePoint, k = (0, $33gHU.useRef)(!0), S = (0, $33gHU.useMemo)(function() {
        return b ? l : l && !k.current;
    }, [
        l
    ]);
    (0, $33gHU.useEffect)(function() {
        if (S) {
            var _$e = y.current;
            _$e && _$c(_$e.offsetTop);
        }
    }, [
        S,
        l
    ]);
    var T = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee({
            active: l,
            "using-icon": !!u
        });
    }, [
        l,
        u
    ]), $ = (0, $33gHU.useMemo)(function() {
        return !f && {
            onClick: function(e) {
                e.stopPropagation(), _$i && s && !d && s(_$i);
            }
        };
    }, [
        _$i,
        s,
        d,
        f
    ]);
    return (0, $33gHU.useEffect)(function() {
        k.current && (k.current = !1);
    }, []), (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Br, {
        width: _$m,
        bg: w && w.primary,
        className: n,
        $cardLess: g,
        $isMobile: _$v,
        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Fr, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({
            className: "".concat(n, " timeline-vertical-circle")
        }, $), {
            ref: y,
            "aria-label": "select timeline",
            $hide: _$C,
            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Rr, {
                className: T,
                theme: w,
                dimension: _$p,
                $timelinePointShape: x,
                children: u || null
            })
        }))
    });
}, function(e, t) {
    return e.active === t.active && e.isMobile === t.isMobile;
});
$36ad047dac3e028c$var$Vr.displayName = "TimelinePoint";
var $36ad047dac3e028c$var$Gr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineVerticalWrapper",
    componentId: "sc-1427v1d-0"
})([
    "display:flex;flex-direction:column;width:100%;padding:0.25rem;outline:0;"
]), $36ad047dac3e028c$var$qr = $36ad047dac3e028c$var$Si([
    "from{opacity:0;visibility:hidden;}to{opacity:1;visibility:visible;}"
]), $36ad047dac3e028c$var$Yr = $36ad047dac3e028c$var$ki.li.withConfig({
    displayName: "VerticalItemWrapper",
    componentId: "sc-1427v1d-1"
})([
    "display:flex;position:relative;visibility:hidden;width:100%;align-items:stretch;justify-content:center;margin:1rem 0;list-style:none;&.left{margin-right:auto;}&.right{margin-left:auto;}&.visible{visibility:visible;}",
    ""
], function(e) {
    return e.$isNested ? $36ad047dac3e028c$var$bi([
        "position:relative;&:not(:last-child)::after{content:'';position:absolute;width:2px;height:2rem;background:",
        ";left:50%;transform:translateX(-50%);bottom:-2rem;}"
    ], function(e) {
        return e.theme.primary;
    }) : $36ad047dac3e028c$var$bi([
        ""
    ]);
}), $36ad047dac3e028c$var$Ur = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineCardContentWrapper",
    componentId: "sc-1427v1d-2"
})([
    "visibility:hidden;position:relative;display:flex;align-items:center;",
    " ",
    " &.visible{visibility:visible;animation:",
    " 0.25s ease-in;}"
], function(e) {
    return e.$alternateCards ? "width: " + (e.$isMobile ? "75%;" : "37.5%;") : e.$noTitle ? "width: 95%;" : "" + (e.$isMobile ? "width: 75%;" : "width: 85%;");
}, function(e) {
    return e.$flip ? "\n        justify-content: flex-end;\n        &.left {\n          order: 3;\n        }\n        &.right {\n          order: 1;\n        }\n      " : "\n        &.left {\n          order: 1;\n          justify-content: flex-end;\n        }\n        &.right {\n          order: 3;\n          justify-content: flex-start;\n        }\n      ";
}, $36ad047dac3e028c$var$qr), $36ad047dac3e028c$var$Zr = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineTitleWrapper",
    componentId: "sc-1427v1d-3"
})([
    "align-items:center;display:",
    ";",
    ";&.left{justify-content:",
    ";order:",
    ";}&.right{",
    ";}"
], function(e) {
    return e.$hide && "VERTICAL" === e.mode ? "none" : "flex";
}, function(e) {
    return e.$alternateCards ? "width: 37.5%" : "width: 10%";
}, function(e) {
    return e.$flip ? "flex-end" : "flex-start";
}, function(e) {
    return e.$flip && "VERTICAL_ALTERNATING" === e.mode ? "1" : "3";
}, function(e) {
    return e.$flip ? "\n      order: 3;\n      justify-content: flex-start;" : "order: 1;\n    justify-content: flex-end;";
}), $36ad047dac3e028c$var$Xr = function(n) {
    var _$i = (0, $33gHU.useRef)(null), o = n.active, s = n.alternateCards, _$c = n.cardDetailedText, d = n.cardSubtitle, u = n.cardTitle, _$p = n.url, _$m = n.className, f = n.contentDetailsChildren, g = n.iconChild, _$v = n.hasFocus, y = n.id, w = n.media, b = n.onActive, x = n.onClick, _$C = n.onElapsed, k = n.slideShowRunning, S = n.title, T = n.visible, $ = n.timelineContent, I = n.items, A = n.isNested, N = n.nestedCardHeight, _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), _$L = _h.cardHeight, O = _h.mode, M = _h.flipLayout, D = _h.timelinePointDimension, E = _h.lineWidth, R = _h.disableClickOnCircle, H = _h.cardLess, _$P = _h.theme, j = _h.classNames, _$z = _h.textOverlay, _ = _h.mediaHeight, W = _h.disableInteraction, B = _h.isMobile, F = (0, $33gHU.useCallback)(function(e) {
        if (_$i.current) {
            var _i_current = _$i.current, _$t = _i_current.offsetTop, _$n = _i_current.clientHeight;
            b(_$t + e, _$t, _$n);
        }
    }, [
        b
    ]), V = (0, $33gHU.useCallback)(function() {
        setTimeout(function() {
            F(0);
        }, 100);
    }, [
        F
    ]), G = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Zr, {
            className: _$m,
            $alternateCards: s,
            mode: O,
            $hide: !S,
            $flip: !s && M,
            children: [
                (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Lr, {
                    title: S,
                    active: o && !W,
                    theme: _$P,
                    align: M ? "left" : "right",
                    classString: null == j ? void 0 : j.title
                }),
                " "
            ]
        });
    }, [
        o,
        S,
        _$m,
        s,
        O,
        M,
        _$P,
        j
    ]), q = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee((0, $6RwIG._)({}, _$m, !0), "vertical-item-row", T ? "visible" : "");
    }, [
        _$m,
        T
    ]), Y = $36ad047dac3e028c$var$Ee("card-content-wrapper", T ? "visible" : "", (0, $6RwIG._)({}, _$m, !0)), U = (0, $33gHU.useMemo)(function() {
        return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Vr, {
            active: o,
            alternateCards: s,
            className: _$m,
            id: y,
            mode: O,
            onActive: F,
            onClick: x,
            slideShowRunning: k,
            iconChild: g,
            timelinePointDimension: D,
            lineWidth: E,
            disableClickOnCircle: R,
            cardLess: H,
            isMobile: B
        });
    }, [
        k,
        o,
        s,
        _$m,
        y,
        O,
        F,
        x,
        g,
        D,
        E,
        R,
        H,
        B
    ]), Z = (0, $33gHU.useMemo)(function() {
        return !A && !B;
    }, [
        A,
        B
    ]);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Yr, {
        $alternateCards: s,
        $cardHeight: A ? N : _$L,
        className: q,
        ref: _$i,
        $cardLess: H,
        $isNested: A,
        theme: _$P,
        children: [
            Z ? G : null,
            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ur, {
                className: Y,
                $alternateCards: s,
                $noTitle: !S,
                $flip: !s && M,
                height: _$z ? _ : _$L,
                $isMobile: B,
                children: H ? null : (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ar, {
                    active: o,
                    branchDir: _$m,
                    content: d,
                    customContent: f,
                    detailedText: _$c,
                    hasFocus: _$v,
                    id: y,
                    media: w,
                    onClick: x,
                    onElapsed: _$C,
                    onShowMore: V,
                    slideShowActive: k,
                    theme: _$P,
                    url: _$p,
                    flip: !s && M,
                    timelineContent: $,
                    items: I,
                    isNested: A,
                    nestedCardHeight: N,
                    title: u,
                    cardTitle: S
                })
            }),
            A ? null : U
        ]
    }, y);
};
$36ad047dac3e028c$var$Xr.displayName = "VerticalItem";
var $36ad047dac3e028c$var$Jr = function(param) {
    var tmp = param.alternateCards, t = tmp === void 0 ? !0 : tmp, n = param.autoScroll, _$i = param.contentDetailsChildren, r = param.hasFocus, o = param.iconChildren, a = param.items, s = param.mode, _$c = param.onClick, d = param.onElapsed, _$p = param.onOutlineSelection, _$m = param.slideShowRunning, f = param.theme, g = param.cardLess, _$v = param.nestedCardHeight;
    var y = (0, $33gHU.useCallback)(function(e, t, i) {
        n({
            contentHeight: i,
            contentOffset: t,
            pointOffset: e
        });
    }, [
        n
    ]), w = (0, $33gHU.useCallback)(function() {}, []), _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), b = _h.isMobile;
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Gr, {
        role: "list",
        children: a.map(function(e, n) {
            var a = "";
            a = t && !b && n % 2 == 0 ? "left" : "right";
            var s = _$i && _$i[n] || null, _$l = Array.isArray(o) ? o[n] : 0 === n ? o : null;
            return (0, $33gHU.createElement)($36ad047dac3e028c$var$Xr, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, e), {
                alternateCards: t,
                className: a,
                contentDetailsChildren: s,
                iconChild: _$l,
                hasFocus: r,
                index: n,
                key: e.id,
                onActive: y,
                onClick: _$c,
                onElapsed: d,
                onShowMore: w,
                slideShowRunning: _$m,
                cardLess: g,
                nestedCardHeight: _$v
            }));
        })
    });
};
$36ad047dac3e028c$var$Jr.displayName = "TimelineVertical";
var $36ad047dac3e028c$var$Kr = function() {
    return (0, $978b871a0234f592$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevrons-left",
        children: [
            (0, $978b871a0234f592$exports.jsx)("polyline", {
                points: "11 17 6 12 11 7"
            }),
            (0, $978b871a0234f592$exports.jsx)("polyline", {
                points: "18 17 13 12 18 7"
            })
        ]
    });
}, $36ad047dac3e028c$var$Qr = function() {
    return (0, $978b871a0234f592$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-chevrons-right",
        children: [
            (0, $978b871a0234f592$exports.jsx)("polyline", {
                points: "13 17 18 12 13 7"
            }),
            (0, $978b871a0234f592$exports.jsx)("polyline", {
                points: "6 17 11 12 6 7"
            })
        ]
    });
}, $36ad047dac3e028c$var$eo = function() {
    return (0, $978b871a0234f592$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: (0, $978b871a0234f592$exports.jsx)("polygon", {
            points: "5 3 19 12 5 21 5 3"
        })
    });
}, $36ad047dac3e028c$var$to = $36ad047dac3e028c$var$ki.ul.withConfig({
    displayName: "TimelineNavWrapper",
    componentId: "sc-1apb8f9-0"
})([
    "border-radius:25px;display:flex;list-style:none;padding:0.25rem 0.25rem;box-shadow:0 1px 1px rgba(0,0,0,0.1);background:",
    ";"
], function(e) {
    return e.theme.toolbarBtnBgColor;
}), $36ad047dac3e028c$var$no = $36ad047dac3e028c$var$ki.li.withConfig({
    displayName: "TimelineNavItem",
    componentId: "sc-1apb8f9-1"
})([
    "padding:0.1em;display:flex;align-items:center;justify-content:center;",
    ";"
], function(e) {
    return e.$disable ? "pointer-events: none; filter: opacity(0.5) grayscale(95%);" : "";
}), $36ad047dac3e028c$var$io = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "TimelineNavButton",
    componentId: "sc-1apb8f9-2"
})([
    "align-items:center;background:",
    ";filter:brightness(1.25);border-radius:50%;border:0;color:#fff;cursor:pointer;display:flex;height:24px;justify-content:center;margin:0 0.2em;padding:0;transition:all 0.1s ease-in;width:24px;transform:",
    ";&:active{filter:drop-shadow(0 0 2px rgba(0,0,0,0.25));transform:",
    " scale(0.9);}svg{width:65%;height:65%;}"
], function(e) {
    return e.theme.primary;
}, function(e) {
    if ("TRUE" === e.rotate) return "rotate(90deg)";
}, function(e) {
    return "TRUE" === e.rotate ? "rotate(90deg)" : "";
}), $36ad047dac3e028c$var$ro = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineControlContainer",
    componentId: "sc-1apb8f9-3"
})([
    "align-items:center;display:flex;justify-content:center;margin:0.5rem 0;"
]), $36ad047dac3e028c$var$oo = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "ControlButton",
    componentId: "sc-1apb8f9-4"
})([
    "align-items:center;background:",
    ";border-radius:50%;cursor:pointer;display:flex;height:3em;justify-content:center;margin-left:0.5em;width:3em;outline:0;color:#fff;svg{width:80%;height:80%;}"
], function(e) {
    return e.theme.primary;
});
$36ad047dac3e028c$var$ki($36ad047dac3e028c$var$oo).withConfig({
    displayName: "MediaToggle",
    componentId: "sc-1apb8f9-5"
})([
    ""
]), $36ad047dac3e028c$var$ki($36ad047dac3e028c$var$oo).withConfig({
    displayName: "ReplayWrapper",
    componentId: "sc-1apb8f9-6"
})([
    ""
]);
var $36ad047dac3e028c$var$ao = function(param) {
    var _$i = param.onNext, r = param.onPrevious, o = param.onFirst, s = param.onLast, _$c = param.disableLeft, d = param.disableRight, u = param.slideShowRunning, _$p = param.onReplay, _$m = param.slideShowEnabled, f = param.onToggleDarkMode, g = param.isDark, _$v = param.onPaused;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), y = _h.mode, w = _h.flipLayout, b = _h.theme, x = _h.buttonTexts, _$C = _h.classNames, k = _h.enableDarkToggle, S = _h.disableInteraction, T = (0, $33gHU.useMemo)(function() {
        return "HORIZONTAL" !== y;
    }, [
        y
    ]), $ = (0, $33gHU.useMemo)(function() {
        return w && "HORIZONTAL" === y;
    }, []), I = (0, $33gHU.useMemo)(function() {
        return _$c || u;
    }, [
        _$c,
        u
    ]), A = (0, $33gHU.useMemo)(function() {
        return d || u;
    }, [
        d,
        u
    ]), N = (0, $33gHU.useCallback)(function() {
        u ? null == _$v || _$v() : null == _$p || _$p();
    }, [
        u
    ]), _$L = (0, $33gHU.useMemo)(function() {
        return w ? null == x ? void 0 : x.next : null == x ? void 0 : x.previous;
    }, [
        w
    ]), O = (0, $33gHU.useMemo)(function() {
        return w ? null == x ? void 0 : x.previous : null == x ? void 0 : x.next;
    }, [
        w
    ]), M = (0, $33gHU.useMemo)(function() {
        return u ? null == x ? void 0 : x.stop : null == x ? void 0 : x.play;
    }, [
        u
    ]), D = (0, $33gHU.useMemo)(function() {
        return w ? null == x ? void 0 : x.first : null == x ? void 0 : x.last;
    }, [
        w
    ]), E = (0, $33gHU.useMemo)(function() {
        return w ? null == x ? void 0 : x.last : null == x ? void 0 : x.first;
    }, [
        w
    ]);
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ro, {
        children: (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$to, {
            className: $36ad047dac3e028c$var$Ee("timeline-controls", null == _$C ? void 0 : _$C.controls),
            theme: b,
            children: [
                S ? null : (0, $978b871a0234f592$exports.jsxs)((0, $978b871a0234f592$exports.Fragment), {
                    children: [
                        (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$no, {
                            $disable: I,
                            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$io, {
                                mode: y,
                                theme: b,
                                onClick: $ ? s : o,
                                title: E,
                                "aria-label": E,
                                "aria-disabled": _$c,
                                "aria-controls": "timeline-main-wrapper",
                                tabIndex: _$c ? -1 : 0,
                                rotate: T ? "TRUE" : "FALSE",
                                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Kr, {})
                            })
                        }),
                        (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$no, {
                            $disable: I,
                            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$io, {
                                mode: y,
                                theme: b,
                                onClick: $ ? _$i : r,
                                title: _$L,
                                "aria-label": _$L,
                                "aria-disabled": _$c,
                                "aria-controls": "timeline-main-wrapper",
                                tabIndex: _$c ? -1 : 0,
                                rotate: T ? "TRUE" : "FALSE",
                                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Wi, {})
                            })
                        }),
                        (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$no, {
                            $disable: A,
                            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$io, {
                                mode: y,
                                theme: b,
                                onClick: $ ? r : _$i,
                                title: O,
                                "aria-label": O,
                                "aria-disabled": d,
                                "aria-controls": "timeline-main-wrapper",
                                rotate: T ? "TRUE" : "FALSE",
                                tabIndex: d ? -1 : 0,
                                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Bi, {})
                            })
                        }),
                        (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$no, {
                            $disable: A,
                            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$io, {
                                mode: y,
                                theme: b,
                                onClick: $ ? o : s,
                                title: D,
                                "aria-label": D,
                                "aria-disabled": d,
                                "aria-controls": "timeline-main-wrapper",
                                tabIndex: d ? -1 : 0,
                                rotate: T ? "TRUE" : "FALSE",
                                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Qr, {})
                            })
                        })
                    ]
                }),
                (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$no, {
                    children: _$m && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$io, {
                        theme: b,
                        onClick: N,
                        title: M,
                        tabIndex: 0,
                        "aria-controls": "timeline-main-wrapper",
                        "aria-label": M,
                        children: (0, $978b871a0234f592$exports.jsx)(u ? $36ad047dac3e028c$var$Xi : $36ad047dac3e028c$var$eo, {})
                    })
                }),
                k ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$no, {
                    $disable: u,
                    children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$io, {
                        theme: b,
                        onClick: f,
                        title: g ? null == x ? void 0 : x.light : null == x ? void 0 : x.dark,
                        tabIndex: 0,
                        "aria-controls": "timeline-main-wrapper",
                        "aria-label": g ? null == x ? void 0 : x.light : null == x ? void 0 : x.dark,
                        children: (0, $978b871a0234f592$exports.jsx)(g ? $36ad047dac3e028c$var$Ji : $36ad047dac3e028c$var$Ui, {})
                    })
                }) : null
            ]
        })
    }, "control-wrapper");
};
$36ad047dac3e028c$var$ao.displayName = "Timeline Control";
var $36ad047dac3e028c$var$so = $36ad047dac3e028c$var$ki.ul.withConfig({
    displayName: "ToolbarWrapper",
    componentId: "sc-exupb5-0"
})([
    "list-style:none;margin:0;display:flex;align-items:center;background-color:",
    ";box-shadow:0 2px 1px rgba(0,0,0,0.1);width:100%;height:100%;border-radius:6px;flex-wrap:wrap;padding:0.25rem;"
], function(e) {
    return e.theme.toolbarBgColor;
}), $36ad047dac3e028c$var$lo = $36ad047dac3e028c$var$ki.li.withConfig({
    displayName: "ToolbarListItem",
    componentId: "sc-exupb5-1"
})([
    "padding:0;margin:0 0.5rem;"
]), $36ad047dac3e028c$var$co = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-exupb5-2"
})([
    "display:flex;align-items:center;justify-content:center;width:1rem;height:1rem;"
]), $36ad047dac3e028c$var$uo = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "ContentWrapper",
    componentId: "sc-exupb5-3"
})([
    "display:flex;"
]), $36ad047dac3e028c$var$ho = function(param) {
    var n = param.items, tmp = param.children, _$i = tmp === void 0 ? [] : tmp, r = param.theme;
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$so, {
        theme: r,
        children: null == n ? void 0 : n.map(function(param, a) {
            var n = param.label, r = param.id, o = param.icon;
            return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$lo, {
                "aria-label": n,
                children: [
                    o ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$co, {
                        children: o
                    }) : null,
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$uo, {
                        children: _$i[a]
                    })
                ]
            }, r);
        })
    });
}, $36ad047dac3e028c$var$po = "rgba(0, 0, 0, 0.1)", $36ad047dac3e028c$var$mo = "\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: 4px;\n  box-shadow: 0px 1px 1px ".concat($36ad047dac3e028c$var$po, ";\n  display: flex;\n  margin: 0;\n  margin-bottom: 0.5rem;\n  // padding: 0.25rem 0.5rem;\n  width: 100%;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"), $36ad047dac3e028c$var$fo = $36ad047dac3e028c$var$ki.ul.withConfig({
    displayName: "ListStyle",
    componentId: "sc-1mak9q1-0"
})([
    "display:flex;flex-direction:column;justify-content:center;list-style:none;margin:0;padding:0;width:100%;align-items:center;"
]), $36ad047dac3e028c$var$go = $36ad047dac3e028c$var$ki.li.withConfig({
    displayName: "ListItemStyle",
    componentId: "sc-1mak9q1-1"
})([
    "",
    " border:",
    ";flex-direction:",
    ";background:",
    ";&:hover{border:1px solid ",
    ";cursor:pointer;}user-select:none;padding:0.25rem;width:calc(100% - 0.5rem);"
], $36ad047dac3e028c$var$mo, function(e) {
    return e.$active ? "1px solid ".concat(e.$theme.primary) : "1px solid transparent";
}, function(e) {
    return e.$selectable ? "row" : "column";
}, function(e) {
    return e.$theme.toolbarBtnBgColor;
}, function(e) {
    return e.$theme.primary;
}), $36ad047dac3e028c$var$vo = $36ad047dac3e028c$var$ki.h1.withConfig({
    displayName: "TitleStyle",
    componentId: "sc-1mak9q1-2"
})([
    "color:",
    ";font-size:1rem;font-weight:normal;margin:0.2rem 0;text-align:left;white-space:nowrap;"
], function(e) {
    return e.theme.primary;
}), $36ad047dac3e028c$var$yo = $36ad047dac3e028c$var$ki.p.withConfig({
    displayName: "TitleDescriptionStyle",
    componentId: "sc-1mak9q1-3"
})([
    "font-size:0.8rem;font-weight:normal;margin:0;padding:0.1rem;text-align:left;width:100%;color:",
    ";"
], function(e) {
    return e.theme.cardSubtitleColor;
}), $36ad047dac3e028c$var$wo = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "sc-1mak9q1-4"
})([
    "width:2rem;display:flex;align-items:center;justify-content:center;"
]), $36ad047dac3e028c$var$bo = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "CheckboxStyle",
    componentId: "sc-1mak9q1-5"
})([
    "align-items:center;background-color:white;",
    " background:",
    ";color:#fff;border-radius:50%;display:flex;height:1.25rem;justify-content:center;margin-right:0.25rem;margin-left:0.1rem;width:1.25rem;svg{width:80%;height:80%;}"
], function(e) {
    return !e.selected && "box-shadow: inset 0 0 0 1px ".concat($36ad047dac3e028c$var$po, ";");
}, function(e) {
    return e.selected ? e.theme.primary : e.theme.toolbarBgColor;
}), $36ad047dac3e028c$var$xo = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "StyleAndDescription",
    componentId: "sc-1mak9q1-6"
})([
    "flex-direction:column;display:flex;width:",
    ";"
], function(e) {
    return e.$selectable ? "calc(100% - 2rem)" : "100%";
}), $36ad047dac3e028c$var$Co = (0, $33gHU.memo)(function(param) {
    var n = param.title, _$i = param.id, r = param.description, o = param.theme, a = param.onClick, s = param.active, tmp = param.selected, _$c = tmp === void 0 ? !1 : tmp, tmp1 = param.selectable, d = tmp1 === void 0 ? !1 : tmp1;
    var u = (0, $33gHU.useCallback)(function(e) {
        return null == a ? void 0 : a(e);
    }, []), h = (0, $33gHU.useCallback)(function(e, t) {
        "Enter" === e.key && u(t);
    }, []);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$go, {
        $theme: o,
        onClick: function() {
            return u(_$i);
        },
        $active: s,
        tabIndex: 0,
        $selectable: d,
        onKeyUp: function(e) {
            return h(e, _$i);
        },
        children: [
            d ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$wo, {
                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$bo, {
                    role: "checkbox",
                    selected: _$c,
                    theme: o,
                    children: _$c && (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$zi, {})
                })
            }) : null,
            (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$xo, {
                $selectable: d,
                children: [
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$vo, {
                        theme: o,
                        children: n
                    }),
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$yo, {
                        theme: o,
                        children: r
                    })
                ]
            })
        ]
    }, _$i);
});
$36ad047dac3e028c$var$Co.displayName = "ListItem";
var $36ad047dac3e028c$var$ko = function(param) {
    var t = param.items, n = param.theme, _$i = param.onClick, r = param.activeItemIndex, tmp = param.multiSelectable, o = tmp === void 0 ? !1 : tmp;
    var _s = (0, $fTrHk._)((0, $33gHU.useState)(function() {
        return t.map(function(e) {
            return (0, $8b7df3d651e6781e$export$71511d61b312f219)({
                id: $36ad047dac3e028c$var$$e()
            }, e);
        });
    }), 2), a = _s[0], _$c = _s[1], d = (0, $33gHU.useCallback)(function(e) {
        var t = a.map(function(t) {
            return t.id === e ? (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, t), {
                selected: !0
            }) : (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, t), {
                selected: !1
            });
        });
        _$c(t);
    }, []), u = (0, $33gHU.useCallback)(function(e) {
        if (d(e), o) {
            var t = a.find(function(t) {
                return t.id === e;
            });
            t.onSelect && (0, $33gHU.startTransition)(function() {
                t.onSelect();
            });
        } else null == _$i || _$i(e);
    }, []);
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$fo, {
        children: null == a ? void 0 : a.map(function(param, l) {
            var t = param.title, _$i = param.id, a = param.description, _$s = param.selected;
            return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Co, {
                title: t,
                id: _$i,
                description: a,
                theme: n,
                onClick: u,
                selectable: o,
                selected: _$s,
                active: r === l
            }, _$i);
        })
    });
};
var $36ad047dac3e028c$var$So = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "PopoverWrapper",
    componentId: "sc-168kw5q-0"
})([
    ""
]), $36ad047dac3e028c$var$To = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "PopoverHolder",
    componentId: "sc-168kw5q-1"
})([
    "align-items:flex-start;background:",
    ";background:;border-radius:6px;box-shadow:0px 5px 16px rgba(0,0,0,0.5);display:flex;flex-direction:column;justify-content:space-between;max-height:500px;overflow-y:auto;padding:0.5rem;position:absolute;",
    ";",
    ";width:",
    ";z-index:100;opacity:",
    ";transition:opacity 0.1s ease-in-out;"
], function(param) {
    var e = param.$theme;
    return e.toolbarBgColor;
}, function(e) {
    return "bottom" === e.$position ? "bottom: 3.5rem" : "top: 4rem";
}, function(e) {
    return e.$isMobile ? "left: 4px;" : "";
}, function(param) {
    var e = param.$isMobile, t = param.$width;
    return e ? "90%" : "".concat(t, "px");
}, function(param) {
    var e = param.$visible;
    return e ? 1 : 0;
}), $36ad047dac3e028c$var$$o = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Selecter",
    componentId: "sc-168kw5q-2"
})([
    "align-items:center;background:",
    ";color:",
    ";border-radius:25px;box-shadow:",
    ";cursor:pointer;display:flex;font-weight:normal;justify-content:space-between;padding:",
    ";user-select:none;"
], function(param) {
    var e = param.$theme;
    return e.toolbarBtnBgColor;
}, function(param) {
    var e = param.$theme;
    return e.toolbarTextColor;
}, function(param) {
    var e = param.$open, t = param.$isDarkMode;
    return e ? "inset 0 0 1px 1px rgba(0, 0, 0, 0.2)" : "0px 1px 1px rgba(0, 0, 0, ".concat(t ? "0.85" : "0.2", ")");
}, function(e) {
    return e.$isMobile ? "0.4rem" : "0.4rem 0.5rem";
}), $36ad047dac3e028c$var$Io = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "SelecterIcon",
    componentId: "sc-168kw5q-3"
})([
    "align-items:center;color:",
    ";display:flex;height:1.25rem;justify-content:center;width:1.25rem;transition:transform 0.2s ease-in-out;margin-right:0.1rem;& svg{height:100%;width:100%;}"
], function(param) {
    var e = param.theme;
    return e.primary;
}), $36ad047dac3e028c$var$Ao = $36ad047dac3e028c$var$ki.span.withConfig({
    displayName: "SelecterLabel",
    componentId: "sc-168kw5q-4"
})([
    "font-size:0.9rem;text-align:left;white-space:nowrap;"
]), $36ad047dac3e028c$var$No = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Header",
    componentId: "sc-168kw5q-5"
})([
    "height:30px;width:100%;"
]), $36ad047dac3e028c$var$Lo = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Content",
    componentId: "sc-168kw5q-6"
})([
    "height:calc(100% - 30px);overflow-y:auto;width:calc(100% - 0rem);"
]), $36ad047dac3e028c$var$Oo = $36ad047dac3e028c$var$ki.button.withConfig({
    displayName: "CloseButton",
    componentId: "sc-168kw5q-7"
})([
    "align-items:center;background:transparent;border:none;color:",
    ";cursor:pointer;display:flex;justify-content:center;margin-bottom:0.5rem;margin-left:auto;"
], function(param) {
    var e = param.theme;
    return e.primary;
}), $36ad047dac3e028c$var$Mo = function(param) {
    var n = param.children, _$i = param.position, a = param.placeholder, _$c = param.theme, tmp = param.width, d = tmp === void 0 ? 350 : tmp, tmp1 = param.isDarkMode, u = tmp1 === void 0 ? !1 : tmp1, h = param.icon, tmp2 = param.$isMobile, _$p = tmp2 === void 0 ? !1 : tmp2;
    var _s = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), _$m = _s[0], f = _s[1], _s1 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), g = _s1[0], _$v = _s1[1], y = (0, $33gHU.useRef)(null), w = (0, $33gHU.useCallback)(function() {
        return f(!_$m);
    }, []), b = (0, $33gHU.useCallback)(function() {
        return f(!1);
    }, []), x = (0, $33gHU.useCallback)(function(e) {
        "Enter" === e.key && w();
    }, []);
    return function(e, t) {
        var n = (0, $33gHU.useRef)(), _$i = (0, $33gHU.useCallback)(function(e) {
            var _$i = n.current;
            _$i && (_$i.contains(e.target) || t());
        }, []), a = (0, $33gHU.useCallback)(function(e) {
            "Escape" === e.key && t();
        }, []);
        (0, $33gHU.useEffect)(function() {
            var _$t = e.current;
            _$t && (n.current = _$t, _$t.addEventListener("keyup", a));
        }, [
            e,
            t
        ]), (0, $33gHU.useEffect)(function() {
            return document.addEventListener("click", _$i), function() {
                var _$e = n.current;
                _$e && _$e.removeEventListener("keyup", a), document.removeEventListener("click", _$i);
            };
        }, []);
    }(y, b), (0, $33gHU.useEffect)(function() {
        _$m ? setTimeout(function() {
            _$v(!0);
        }, 10) : _$v(!1);
    }, [
        _$m
    ]), (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$So, {
        ref: y,
        children: [
            (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$$o, {
                role: "button",
                onClick: w,
                $theme: _$c,
                $open: _$m,
                $isDarkMode: u,
                tabIndex: 0,
                onKeyUp: x,
                $isMobile: _$p,
                title: a,
                children: [
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Io, {
                        theme: _$c,
                        open: _$m,
                        children: h || (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$_i, {})
                    }),
                    a && !_$p ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ao, {
                        children: a
                    }) : null
                ]
            }),
            _$m ? (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$To, {
                $position: _$i,
                $width: d,
                $theme: _$c,
                $isMobile: _$p,
                $visible: g,
                children: [
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$No, {
                        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Oo, {
                            theme: _$c,
                            onClick: b,
                            children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Fi, {})
                        })
                    }),
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Lo, {
                        children: n
                    })
                ]
            }) : null
        ]
    });
}, $36ad047dac3e028c$var$Do = function(param) {
    var t = param.onUpdateTimelineMode, n = param.theme, _$i = param.mode, r = param.isDarkMode, o = param.position, s = param.isMobile;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), l = _h.showAllCardsHorizontal, _$c = _h.buttonTexts, d = (0, $33gHU.useMemo)(function() {
        return _$i;
    }, [
        l,
        _$i
    ]), u = (0, $33gHU.useMemo)(function() {
        return {
            alternating: null == _$c ? void 0 : _$c.changeLayoutOptions.alternating,
            horizontal: null == _$c ? void 0 : _$c.changeLayoutOptions.horizontal,
            horizontal_all: null == _$c ? void 0 : _$c.changeLayoutOptions.horizontal_all,
            vertical: null == _$c ? void 0 : _$c.changeLayoutOptions.vertical
        };
    }, []), _$p = (0, $33gHU.useMemo)(function() {
        return [
            {
                description: u.vertical.helpText,
                id: "VERTICAL",
                onSelect: function() {
                    return t("VERTICAL");
                },
                selected: "VERTICAL" === d,
                title: u.vertical.text
            },
            {
                description: u.alternating.helpText,
                id: "VERTICAL_ALTERNATING",
                onSelect: function() {
                    return t("VERTICAL_ALTERNATING");
                },
                selected: "VERTICAL_ALTERNATING" === d,
                title: u.alternating.text
            }
        ];
    }, [
        d
    ]), _$m = (0, $33gHU.useMemo)(function() {
        return [
            {
                description: u.horizontal.helpText,
                id: "HORIZONTAL",
                onSelect: function() {
                    t("HORIZONTAL");
                },
                selected: "HORIZONTAL" === d,
                title: u.horizontal.text
            },
            {
                description: u.horizontal_all.helpText,
                id: "HORIZONTAL_ALL",
                onSelect: function() {
                    t("HORIZONTAL_ALL");
                },
                selected: "HORIZONTAL_ALL" === d,
                title: u.horizontal.text
            }
        ];
    }, [
        d
    ]);
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Mo, {
        placeholder: _$c.changeLayout,
        position: o,
        theme: n,
        isDarkMode: r,
        icon: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Vi, {}),
        $isMobile: s,
        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ko, {
            items: "HORIZONTAL" === _$i || "HORIZONTAL_ALL" === _$i ? _$m : _$p,
            theme: n,
            multiSelectable: !0
        })
    });
}, $36ad047dac3e028c$var$Eo = function(param) {
    var t = param.activeItem, n = param.items, _$i = param.theme, r = param.onActivateItem, o = param.isDarkMode, a = param.position, s = param.isMobile;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), l = _h.buttonTexts;
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Mo, {
        placeholder: l.jumpTo,
        position: a,
        theme: _$i,
        width: 400,
        isDarkMode: o,
        $isMobile: s,
        icon: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ji, {}),
        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ko, {
            items: n.map(function(e, n) {
                return {
                    active: n === t,
                    description: e.description,
                    id: e.id,
                    label: e.title,
                    onSelect: function() {},
                    title: e.title || "Item ".concat(n + 1)
                };
            }),
            theme: _$i,
            onClick: r
        })
    });
}, $36ad047dac3e028c$var$Ro = function(param) {
    var t = param.onChange, n = param.selectedDensity, _$i = param.theme, r = param.isDarkMode, o = param.position, s = param.isMobile;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), l = _h.buttonTexts, _$c = (0, $33gHU.useMemo)(function() {
        return [
            {
                description: "Show less text",
                id: "LOW",
                onSelect: function() {
                    return t("LOW");
                },
                selected: "LOW" === n,
                title: "Low"
            },
            {
                description: "Show more text",
                id: "HIGH",
                onSelect: function() {
                    return t("HIGH");
                },
                selected: "HIGH" === n,
                title: "High"
            }
        ];
    }, [
        n
    ]);
    return (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Mo, {
        placeholder: l.changeDensity,
        theme: _$i,
        isDarkMode: r,
        position: o,
        $isMobile: s,
        width: 300,
        icon: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ki, {}),
        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ko, {
            items: _$c,
            theme: _$i,
            multiSelectable: !0
        })
    });
}, $36ad047dac3e028c$var$Ho = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-cif21b-0"
})([
    "display:flex;flex-direction:column;height:100%;&:focus{outline:0;}overflow:hidden;position:relative;width:100%;&.horizontal{justify-content:flex-start;}&.js-focus-visible :focus:not(.focus-visible){}&.js-focus-visible .focus-visible{outline:2px solid #528deb;}"
]), $36ad047dac3e028c$var$Po = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineMainWrapper",
    componentId: "sc-cif21b-1"
})([
    "align-items:flex-start;display:flex;justify-content:center;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;",
    ";scroll-behavior:smooth;width:100%;",
    " &.horizontal{min-height:150px;}padding:",
    ";"
], function(e) {
    return "HORIZONTAL" === e.mode ? "position: relative" : "";
}, $36ad047dac3e028c$var$$i, function(param) {
    var e = param.$scrollable;
    return e ? "" : "0 1rem 0";
}), $36ad047dac3e028c$var$jo = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineMain",
    componentId: "sc-cif21b-2"
})([
    "position:absolute;top:50%;left:0;display:flex;align-items:center;transition:all 0.2s ease;transform:translate(0,-50%);&.vertical{align-items:flex-start;justify-content:flex-start;width:100%;height:100%;}"
]), $36ad047dac3e028c$var$zo = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "Outline",
    componentId: "sc-cif21b-3"
})([
    "position:absolute;right:0;left:0;width:100%;height:",
    ";margin-right:auto;margin-left:auto;background:",
    ";"
], function(e) {
    return "".concat(e.height, "px");
}, function(e) {
    return e.color;
});
$36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineControlContainer",
    componentId: "sc-cif21b-4"
})([
    "display:flex;align-items:center;justify-content:center;min-height:3rem;filter:",
    ";&.hide{visibility:hidden;}&.show{visibility:visible;}"
], function(e) {
    return e.active ? "opacity(1);" : "opacity(0.9);";
});
var $36ad047dac3e028c$var$_o = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "TimelineContentRender",
    componentId: "sc-cif21b-5"
})([
    "display:flex;align-items:flex-start;justify-content:",
    ";width:98%;margin-right:auto;margin-left:auto;overflow-x:hidden;"
], function(e) {
    return e.$showAllCards ? "flex-start" : "center";
}), $36ad047dac3e028c$var$Wo = $36ad047dac3e028c$var$ki.div.withConfig({
    displayName: "ToolbarWrapper",
    componentId: "sc-cif21b-6"
})([
    "display:flex;font-weight:bold;text-align:center;text-decoration:none;border-radius:6px;width:100%;padding:0;margin:",
    ";order:",
    ";"
], function(e) {
    return "top" === e.position ? "0 0 20px 0" : "20px 0 0 0";
}, function(e) {
    return "top" === e.position ? 0 : 1;
}), $36ad047dac3e028c$var$Bo = $36ad047dac3e028c$var$ki.ul.withConfig({
    displayName: "ExtraControls",
    componentId: "sc-cif21b-7"
})([
    "display:flex;align-items:center;list-style:none;margin:0;padding:0.1rem;visibility:",
    ";"
], function(e) {
    return e.$hide ? "hidden" : "visible";
}), $36ad047dac3e028c$var$Fo = $36ad047dac3e028c$var$ki.li.withConfig({
    displayName: "ExtraControlChild",
    componentId: "sc-cif21b-8"
})([
    "display:flex;margin:0.5rem 0;margin-right:0.5rem;"
]), $36ad047dac3e028c$var$Vo = function(param) {
    var n = param.activeTimelineItem, _$i = param.slideShowEnabled, r = param.slideShowRunning, o = param.flipLayout, s = param.toggleDarkMode, l = param.onPaused, _$c = param.onFirst, d = param.onLast, u = param.onNext, _$p = param.onPrevious, _$m = param.onRestartSlideshow, f = param.totalItems, tmp = param.items, g = tmp === void 0 ? [] : tmp, _$v = param.id, y = param.onActivateTimelineItem, w = param.onUpdateTimelineMode, b = param.onUpdateTextContentDensity, x = param.mode;
    var _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), _$C = _h.theme, k = _h.cardLess, S = _h.enableQuickJump, T = _h.darkMode, $ = _h.toolbarPosition, I = _h.textDensity, A = _h.isMobile, N = _h.enableLayoutSwitch, _$L = (0, $33gHU.useMemo)(function() {
        return [
            {
                id: "timeline-controls",
                label: "Timeline Controls",
                name: "timeline_control",
                onSelect: function() {}
            },
            {
                id: "timeline-popover",
                label: "timeline_popover",
                name: "popover",
                onSelect: function() {}
            },
            {
                id: "layout-popover",
                label: "layout_popover",
                name: "popover",
                onSelect: function() {}
            },
            {
                id: "change-density",
                label: "change_density",
                name: "changeDensity",
                onSelect: function() {}
            }
        ];
    }, []), O = (0, $33gHU.useMemo)(function() {
        return o ? n === f - 1 : 0 === n;
    }, [
        o,
        n,
        f
    ]), M = (0, $33gHU.useMemo)(function() {
        return o ? 0 === n : n === f - 1;
    }, [
        o,
        n,
        f
    ]), D = (0, $33gHU.useMemo)(function() {
        return k || r;
    }, [
        k,
        r
    ]), E = (0, $33gHU.useMemo)(function() {
        return g.every(function(e) {
            return e.cardDetailedText;
        });
    }, []);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$ho, {
        items: _$L,
        theme: _$C,
        children: [
            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$ao, {
                disableLeft: O,
                disableRight: M,
                id: _$v,
                onFirst: _$c,
                onLast: d,
                onNext: u,
                onPrevious: _$p,
                onReplay: _$m,
                slideShowEnabled: _$i,
                slideShowRunning: r,
                isDark: T,
                onToggleDarkMode: s,
                onPaused: l
            }),
            (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Bo, {
                $hide: D,
                $slideShowRunning: r,
                children: [
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Fo, {
                        children: S ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Eo, {
                            activeItem: n,
                            isDarkMode: T,
                            items: g.map(function(e) {
                                return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, e), {
                                    description: e.cardSubtitle,
                                    id: e.id,
                                    title: e.title
                                });
                            }),
                            onActivateItem: y,
                            theme: _$C,
                            position: $,
                            isMobile: A
                        }) : null
                    }, "quick-jump"),
                    (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Fo, {
                        children: !k && N ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Do, {
                            isDarkMode: T,
                            theme: _$C,
                            onUpdateTimelineMode: w,
                            mode: x,
                            position: $,
                            isMobile: A
                        }) : null
                    }, "layout-switcher"),
                    E ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Fo, {
                        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Ro, {
                            isDarkMode: T,
                            theme: _$C,
                            onChange: b,
                            position: $,
                            selectedDensity: I,
                            isMobile: A
                        })
                    }, "change-density") : null,
                    " "
                ]
            }, "timeline-extra-controls")
        ]
    });
}, $36ad047dac3e028c$var$Go = function(n) {
    var _$i = n.activeTimelineItem, _$c = n.contentDetailsChildren, d = n.iconChildren, tmp = n.items, u = tmp === void 0 ? [] : tmp, _$p = n.onFirst, _$m = n.onLast, f = n.onNext, g = n.onPrevious, _$v = n.onRestartSlideshow, y = n.onTimelineUpdated, w = n.onItemSelected, b = n.onOutlineSelection, x = n.slideShowEnabled, _$C = n.slideShowRunning, tmp1 = n.mode, k = tmp1 === void 0 ? "HORIZONTAL" : tmp1, S = n.nestedCardHeight, tmp2 = n.isChild, T = tmp2 === void 0 ? !1 : tmp2, $ = n.onPaused, I = n.uniqueId, A = n.noUniqueId, _h = (0, $33gHU.useContext)($36ad047dac3e028c$var$Le), N = _h.cardPositionHorizontal, _$L = _h.disableNavOnKey, O = _h.flipLayout, tmp3 = _h.itemWidth, M = tmp3 === void 0 ? 200 : tmp3, D = _h.lineWidth, E = _h.onScrollEnd, tmp4 = _h.scrollable, R = tmp4 === void 0 ? !0 : tmp4, H = _h.showAllCardsHorizontal, _$P = _h.theme, j = _h.darkMode, _$z = _h.toggleDarkMode, _ = _h.updateHorizontalAllCards, W = _h.toolbarPosition, B = _h.updateTextContentDensity, F = _h.disableToolbar, _ref = (0, $fTrHk._)(function(e, t) {
        var _s = (0, $fTrHk._)((0, $33gHU.useState)(0), 2), _$n = _s[0], _$i = _s[1];
        return [
            _$n,
            (0, $33gHU.useMemo)(function() {
                return function(n, r) {
                    var _$o = n.clientWidth, _$a = n.scrollLeft, _$s = n.scrollTop, _$l = n.clientHeight, _$c = r.pointOffset, d = r.pointWidth, u = r.contentHeight, _$h = r.contentOffset;
                    if ("HORIZONTAL" === e && t && d && _$c) {
                        var _$e = _$a + _$o, _$n = _$c + d, _$r = _$c - _$a, _$s1 = _$e - _$c;
                        (!(_$c >= _$a && _$n <= _$e) && !(_$c < _$a && _$n > _$a || _$n > _$e && _$c < _$e) || _$r <= t && _$r >= 0 || _$s1 <= t && _$s1 >= 0) && _$i(_$c - t);
                    } else if (("VERTICAL" === e || "VERTICAL_ALTERNATING" === e) && _$h && u) {
                        var _$e1 = _$s + _$l, _$t = _$h + u, _$n1 = _$h - u, _$r1 = !(_$h >= _$s && _$t <= _$e1) || _$h < _$s && _$t > _$s || _$t > _$e1 && _$h < _$e1;
                        _$r1 && _$n1 + u < _$e1 ? _$i(_$n1 + Math.round(u / 2)) : _$r1 && _$i(_$n1);
                    }
                };
            }, [
                e,
                t
            ])
        ];
    }(k, M), 2), V = _ref[0], G = _ref[1], q = (0, $33gHU.useRef)(null), _s = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), Y = _s[0], U = _s[1], Z = (0, $33gHU.useRef)(null), _s1 = (0, $fTrHk._)((0, $33gHU.useState)("HORIZONTAL" === k && H ? "HORIZONTAL_ALL" : k), 2), _$X = _s1[0], _$J = _s1[1], _$K = (0, $33gHU.useRef)(_$i), _$Q = (0, $33gHU.useRef)(null), _$ee = (0, $33gHU.useMemo)(function() {
        if (!_$C) {
            if ("boolean" == typeof R) return R;
            if ("object" == typeof R && R.scrollbar) return R.scrollbar;
        }
    }, [
        _$C,
        R
    ]), _$te = (0, $33gHU.useRef)("react-chrono-timeline-".concat(A ? I : $36ad047dac3e028c$var$$e())), _$ne = (0, $33gHU.useCallback)(function() {
        Y && (_$K.current = Math.min(_$K.current + 1, u.length - 1), null == f || f());
    }, [
        Y,
        f
    ]), ie = (0, $33gHU.useCallback)(function() {
        Y && (_$K.current = Math.max(_$K.current - 1, 0), null == g || g());
    }, [
        Y,
        g
    ]), re = (0, $33gHU.useCallback)(function() {
        Y && (_$K.current = 0, null == _$p || _$p());
    }, [
        Y,
        _$p
    ]), oe = (0, $33gHU.useCallback)(function() {
        Y && (_$K.current = u.length - 1, null == _$m || _$m());
    }, [
        Y,
        _$m
    ]), ae = (0, $33gHU.useCallback)(function(e) {
        var _$t = e.key;
        "HORIZONTAL" === k && "ArrowRight" === _$t ? O ? ie() : _$ne() : "HORIZONTAL" === k && "ArrowLeft" === _$t ? O ? _$ne() : ie() : "VERTICAL" !== k && "VERTICAL_ALTERNATING" !== k || "ArrowDown" !== _$t ? "VERTICAL" !== k && "VERTICAL_ALTERNATING" !== k || "ArrowUp" !== _$t ? "Home" === _$t ? re() : "End" === _$t && oe() : ie() : _$ne();
    }, [
        _$ne,
        ie,
        oe
    ]), se = function(e, t) {
        if (e) {
            for(var _$n = 0; _$n < u.length; _$n++)if (u[_$n].id === e) {
                _$K.current = _$n, t && _$n < u.length - 1 ? null == y || y(_$n + 1) : null == y || y(_$n);
                break;
            }
        }
    };
    (0, $33gHU.useEffect)(function() {
        var _$e = u[_$i || 0];
        if (_$C && (_$K.current = _$i), u.length && _$e) {
            var _$i1 = _$e.title, _$r = _$e.cardTitle, _$o = _$e.cardSubtitle, _$a = _$e.cardDetailedText;
            if (null == w || w({
                cardDetailedText: _$a,
                cardSubtitle: _$o,
                cardTitle: _$r,
                index: _$K.current,
                title: _$i1
            }), "HORIZONTAL" === k) {
                var _$t, _$n;
                var _$i2 = null === (_$t = Z.current) || void 0 === _$t ? void 0 : _$t.querySelector("#timeline-card-".concat(_$e.id)), _$r1 = null == _$i2 ? void 0 : _$i2.getBoundingClientRect(), _$o1 = null === (_$n = Z.current) || void 0 === _$n ? void 0 : _$n.getBoundingClientRect();
                if (_$r1 && _$o1) {
                    var _$e1 = _$r1.width, _$t1 = _$r1.left, _$n1 = _$o1.width, _$i3 = _$o1.left;
                    setTimeout(function() {
                        var _$r = Z.current;
                        _$r.style.scrollBehavior = "smooth", _$r.scrollLeft += _$t1 - _$i3 + _$e1 / 2 - _$n1 / 2;
                    }, 100);
                }
            }
        }
    }, [
        _$i,
        u.length,
        _$C
    ]);
    var le = function(e) {
        var _$t = _$Q.current;
        _$t && G(_$t, e);
    };
    (0, $33gHU.useEffect)(function() {
        var _$e = _$Q.current;
        _$e && ("HORIZONTAL" === k ? _$e.scrollLeft = Math.max(V, 0) : _$e.scrollTop = V);
    }, [
        V
    ]), (0, $33gHU.useEffect)(function() {
        setTimeout(function() {
            var _$e = _$Q.current;
            if (_$e) {
                var _$t = _$e.querySelectorAll(".vertical-item-row");
                Array.from(_$t).forEach(function(e) {
                    q.current && q.current.observe(e);
                });
            }
        }, 0);
        var _$e = function(e, t) {
            e.querySelectorAll("img,video").forEach(function(e) {
                return e.style.visibility = "hide" === t ? "hidden" : "visible";
            });
        };
        return "HORIZONTAL" !== k && (q.current = new IntersectionObserver(function(t) {
            t.forEach(function(t) {
                var _$n = t.target;
                t.isIntersecting ? _$e(_$n, "show") : (_$e(_$n, "hide"), _$n.querySelectorAll("iframe").forEach(function(e) {
                    var _$t;
                    null === (_$t = e.contentWindow) || void 0 === _$t || _$t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*");
                }));
            });
        }, {
            root: _$Q.current,
            threshold: 0
        })), function() {
            q.current && q.current.disconnect();
        };
    }, []);
    var ce = (0, $33gHU.useCallback)(function(e) {
        _$L || _$C || (U(!0), ae(e));
    }, [
        _$L,
        _$C,
        ae
    ]), de = (0, $33gHU.useCallback)(function(e) {
        "VERTICAL" === e ? _$J("VERTICAL") : "HORIZONTAL" === e ? (_$J("HORIZONTAL"), null == _ || _(!1)) : "VERTICAL_ALTERNATING" === e ? _$J("VERTICAL_ALTERNATING") : "HORIZONTAL_ALL" === e && (_$J("HORIZONTAL_ALL"), null == _ || _(!0));
    }, []), ue = (0, $33gHU.useMemo)(function() {
        return $36ad047dac3e028c$var$Ee(k.toLocaleLowerCase(), {
            "focus-visible": !T,
            "js-focus-visible": !T
        });
    }, [
        k,
        T
    ]), he = (0, $33gHU.useMemo)(function() {
        return !F && !T;
    }, [
        T,
        F
    ]);
    return (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Ho, {
        onKeyDown: ce,
        className: ue,
        cardPositionHorizontal: N,
        onMouseDown: function() {
            U(!0);
        },
        onKeyUp: function(e) {
            "Escape" === e.key && (null == $ || $());
        },
        children: [
            he ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Wo, {
                position: W,
                children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Vo, {
                    activeTimelineItem: _$i,
                    totalItems: u.length,
                    slideShowEnabled: x,
                    slideShowRunning: _$C,
                    onFirst: re,
                    onLast: oe,
                    onNext: _$ne,
                    onPrevious: ie,
                    onRestartSlideshow: _$v,
                    darkMode: j,
                    toggleDarkMode: _$z,
                    onPaused: $,
                    id: _$te.current,
                    flipLayout: O,
                    items: u,
                    onActivateTimelineItem: se,
                    onUpdateTimelineMode: de,
                    onUpdateTextContentDensity: B,
                    mode: _$X
                })
            }) : null,
            (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$Po, {
                ref: _$Q,
                $scrollable: _$ee,
                className: "".concat(k.toLowerCase(), " timeline-main-wrapper"),
                id: "timeline-main-wrapper",
                theme: _$P,
                mode: k,
                position: W,
                onScroll: function(e) {
                    var _$t = e.target;
                    var _$n = 0;
                    "VERTICAL" === k || "VERTICAL_ALTERNATING" === k ? (_$n = _$t.scrollTop + _$t.clientHeight, _$t.scrollHeight - _$n < 1 && (null == E || E())) : (_$n = _$t.scrollLeft + _$t.offsetWidth, _$t.scrollWidth === _$n && (null == E || E()));
                },
                children: [
                    "VERTICAL_ALTERNATING" === _$X ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Jr, {
                        activeTimelineItem: _$i,
                        autoScroll: le,
                        contentDetailsChildren: _$c,
                        hasFocus: Y,
                        iconChildren: d,
                        items: u,
                        mode: _$X,
                        onClick: se,
                        onElapsed: function(e) {
                            return se(e, !0);
                        },
                        onOutlineSelection: b,
                        slideShowRunning: _$C,
                        theme: _$P,
                        nestedCardHeight: S
                    }) : null,
                    "HORIZONTAL" === _$X || "HORIZONTAL_ALL" === _$X ? (0, $978b871a0234f592$exports.jsxs)($36ad047dac3e028c$var$jo, {
                        className: k.toLowerCase(),
                        children: [
                            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$zo, {
                                color: _$P && _$P.primary,
                                height: D
                            }),
                            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Wr, {
                                autoScroll: le,
                                contentDetailsChildren: _$c,
                                handleItemClick: se,
                                hasFocus: Y,
                                iconChildren: d,
                                items: u,
                                mode: _$X,
                                onElapsed: function(e) {
                                    return se(e, !0);
                                },
                                slideShowRunning: _$C,
                                wrapperId: _$te.current,
                                nestedCardHeight: S
                            })
                        ]
                    }) : null,
                    "VERTICAL" === _$X ? (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Jr, {
                        activeTimelineItem: _$i,
                        alternateCards: !1,
                        autoScroll: le,
                        contentDetailsChildren: _$c,
                        hasFocus: Y,
                        iconChildren: d,
                        items: u,
                        mode: k,
                        onClick: se,
                        onElapsed: function(e) {
                            return se(e, !0);
                        },
                        onOutlineSelection: b,
                        slideShowRunning: _$C,
                        theme: _$P,
                        nestedCardHeight: S
                    }) : null
                ]
            }),
            (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$_o, {
                id: _$te.current,
                $showAllCards: H,
                ref: Z
            })
        ]
    });
};
$36ad047dac3e028c$var$Go.displayName = "Timeline";
var $36ad047dac3e028c$var$qo = $36ad047dac3e028c$var$Go;
var $36ad047dac3e028c$var$Yo = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Children.toArray, $36ad047dac3e028c$export$263852f37093921b = function(t) {
    var tmp = t.allowDynamicUpdate, n = tmp === void 0 ? !1 : tmp, a = t.children, _$c = t.items, d = t.onScrollEnd, tmp1 = t.slideShow, u = tmp1 === void 0 ? !1 : tmp1, h = t.onItemSelected, tmp2 = t.activeItemIndex, _$p = tmp2 === void 0 ? 0 : tmp2, tmp3 = t.titleDateFormat, _$m = tmp3 === void 0 ? "MMM DD, YYYY" : tmp3, f = t.mode, _s = (0, $fTrHk._)((0, $33gHU.useState)([]), 2), g = _s[0], _$v = _s[1], y = (0, $33gHU.useRef)(), _s1 = (0, $fTrHk._)((0, $33gHU.useState)(!1), 2), w = _s1[0], b = _s1[1], _s2 = (0, $fTrHk._)((0, $33gHU.useState)(_$p), 2), x = _s2[0], _$C = _s2[1], k = function(e) {
        if (null != e && e.length) return e.map(function(e, t) {
            var n;
            var _$i = $36ad047dac3e028c$var$$e();
            return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, e), {
                _dayjs: $36ad047dac3e028c$var$Ae(e.date),
                active: t === _$p,
                id: _$i,
                items: null === (n = e.items) || void 0 === n ? void 0 : n.map(function(e) {
                    return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, e), {
                        _dayjs: $36ad047dac3e028c$var$Ae(e.date),
                        id: $36ad047dac3e028c$var$$e(),
                        isNested: !0,
                        visible: !0
                    });
                }),
                title: e.date ? $36ad047dac3e028c$var$Ae(e.date).format(_$m) : e.title,
                visible: !0
            });
        });
        var _$t = (0, (/*@__PURE__*/$parcel$interopDefault($33gHU))).Children.toArray(a).filter(function(e) {
            return "chrono-icons" !== e.props.className;
        }).length;
        return Array.from({
            length: _$t
        }).map(function(e, t) {
            return {
                active: t === _$p,
                id: $36ad047dac3e028c$var$$e(),
                visible: !0
            };
        });
    };
    (0, $33gHU.useEffect)(function() {
        var _$e = null == _$c ? void 0 : _$c.filter(function(e) {
            return e;
        });
        var _$t = [];
        if (null != _$e && _$e.length) g.length && _$e.length > g.length ? _$t = function(e) {
            if (e) {
                var _$t = g.length;
                return e.map(function(e, n) {
                    return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, e), {
                        active: n === _$t,
                        visible: !0
                    });
                });
            }
            return [];
        }(_$e) : _$e.length && (_$t = k(_$e)), _$t.length && (y.current = _$t, _$v(_$t), _$C(0));
        else {
            var _$e1 = k();
            _$v(_$e1);
        }
    }, [
        JSON.stringify(n ? _$c : null)
    ]);
    var S = (0, $33gHU.useCallback)(function(e) {
        _$v(function(t) {
            return t.map(function(t, n) {
                return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, t), {
                    active: n === e,
                    visible: e >= 0
                });
            });
        }), _$C(e), _$c && _$c.length - 1 === e && b(!1);
    }, []);
    (0, $33gHU.useEffect)(function() {
        S(_$p);
    }, [
        _$p
    ]);
    var T = (0, $33gHU.useCallback)(function() {
        S(-1), setTimeout(function() {
            b(!0), S(0);
        }, 0);
    }, []), $ = (0, $33gHU.useCallback)(function(e) {
        e >= 0 && (_$C(e), S(e));
    }, [
        g.length
    ]), I = (0, $33gHU.useCallback)(function() {
        b(!1);
    }, []);
    var A = $36ad047dac3e028c$var$Yo(a).filter(function(e) {
        return "chrono-icons" === e.props.className;
    });
    return A.length && (A = A[0].props.children), (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$Oe, (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, t), {
        children: (0, $978b871a0234f592$exports.jsx)($36ad047dac3e028c$var$qo, {
            activeTimelineItem: x,
            contentDetailsChildren: $36ad047dac3e028c$var$Yo(a).filter(function(e) {
                return "chrono-icons" !== e.props.className;
            }),
            iconChildren: A,
            items: g,
            onFirst: function() {
                _$C(0), S(0);
            },
            onLast: function() {
                if (g.length) {
                    var _$e = g.length - 1;
                    _$C(_$e), S(_$e);
                }
            },
            onNext: function() {
                if (g.length && x < g.length - 1) {
                    var _$e = x + 1;
                    S(_$e), _$C(_$e);
                }
            },
            onPrevious: function() {
                if (x > 0) {
                    var _$e = x - 1;
                    S(_$e), _$C(_$e);
                }
            },
            onRestartSlideshow: T,
            onTimelineUpdated: S,
            slideShow: u,
            slideShowEnabled: u,
            slideShowRunning: w,
            onScrollEnd: d,
            onItemSelected: h,
            onOutlineSelection: $,
            mode: f,
            onPaused: I
        })
    }));
};



var $f73399d3acc757b5$exports = {};
$f73399d3acc757b5$exports = JSON.parse('[{"time":"20160609","title":"\u7EBF\u4E0B\u6D3B\u52A8\u5F00\u542F\uFF0C\u5BA3\u5E03\u793E\u533A\u6210\u7ACB","type":"\u7F16\u7A0B\u8BA8\u8BBA","address":"\u62FE\u7EA7Cafe","describe":"\u7EBF\u4E0B\u6D3B\u52A8\u5F00\u542F\uFF0C\u5BA3\u5E03\u793E\u533A\u6210\u7ACB","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20160703","title":"\u643A\u624B\u7F16\u7A0B-\u6210\u90FD\u793E\u533A\u4E3B\u9875\u521D\u7248","type":"\u52A8\u624B\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"\u643A\u624B\u7F16\u7A0B-\u6210\u90FD\u793E\u533A\u4E3B\u9875\u521D\u7248","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20160911","title":"\u7ED3\u5BF9\u7F16\u7A0B\u7684\u7406\u5FF5","type":"\u4E2A\u4EBA\u5206\u4EAB+\u7ED3\u5BF9\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"\u7ED3\u5BF9\u7F16\u7A0B\u7684\u7406\u5FF5","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20161106","title":"console\u7684\u4E5D\u5927\u547D\u4EE4+\u5B66\u4E60\u8DEF\u7EBF\u5206\u4EAB","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"console\u7684\u4E5D\u5927\u547D\u4EE4+\u5B66\u4E60\u8DEF\u7EBF\u5206\u4EAB","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20161119","title":"git\u7684\u4F7F\u7528\u4E0E\u4E2A\u4EBA\u7B80\u5386\u5236\u4F5C","type":"\u5206\u4EAB+\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"git\u7684\u4F7F\u7528\u4E0E\u4E2A\u4EBA\u7B80\u5386\u5236\u4F5C","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20161204","title":"Chrome\u5F00\u53D1\u8005\u5DE5\u5177\u5168\u89E3","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"Chrome\u5F00\u53D1\u8005\u5DE5\u5177\u5168\u89E3","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20161217","title":"\u7ED3\u5BF9\u7F16\u7A0B-\u4FDD\u9F84\u7403\u79EF\u5206+FizzBuzz?","type":"\u7ED3\u5BF9\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"\u7ED3\u5BF9\u7F16\u7A0B-\u4FDD\u9F84\u7403\u79EF\u5206+FizzBuzz?","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20161231","title":"\u4E00\u4E2A\u5E73\u51E1\u7A0B\u5E8F\u5458\u7684\u81EA\u8FF0 + CSS\u5E03\u5C40\u90A3\u4E9B\u4E8B","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"\u4E00\u4E2A\u5E73\u51E1\u7A0B\u5E8F\u5458\u7684\u81EA\u8FF0 + CSS\u5E03\u5C40\u90A3\u4E9B\u4E8B","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170115","title":"JSpace_Plane\u5C0F\u6E38\u620F","type":"\u5206\u4EAB + \u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"JSpace_Plane\u5C0F\u6E38\u620F","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170212","title":"BootStrap + xMemory\u5BB6\u7528\u4E91\u670D\u52A1\u5668","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"BootStrap + xMemory\u5BB6\u7528\u4E91\u670D\u52A1\u5668","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170305","title":"\u534A\u7A0B\u9ED1\u5BA2\u677E - \u6625\u5B63","type":"\u7F16\u7A0B\u9ED1\u5BA2\u677E","address":"\u62FE\u7EA7Cafe","describe":"\u534A\u7A0B\u9ED1\u5BA2\u677E - \u6625\u5B63","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170318","title":"Bitmap & Sort + \u6280\u672F\u6587\u6863\u5BFC\u8BFB","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"Bitmap & Sort + \u6280\u672F\u6587\u6863\u5BFC\u8BFB","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170402","title":"React + \u865A\u62DFDOM","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"React + \u865A\u62DFDOM","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170415","title":"HTTP\u4E0ERESTful API + GraphQL","type":"\u4E2A\u4EBA\u5206\u4EAB\u4E0E\u8BA8\u8BBA","address":"\u62FE\u7EA7Cafe","describe":"HTTP\u4E0ERESTful API + GraphQL","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170429","title":"\u7F16\u7A0B\u7684\u601D\u60F3\uFF0C\u89E3\u51B3\u73B0\u5B9E\u751F\u6D3B\u4E2D\u7684\u95EE\u9898","type":"\u5206\u4EAB\u4E0E\u5F15\u5BFC","address":"\u62FE\u7EA7Cafe","describe":"\u7F16\u7A0B\u7684\u601D\u60F3\uFF0C\u89E3\u51B3\u73B0\u5B9E\u751F\u6D3B\u4E2D\u7684\u95EE\u9898","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170506","title":"\u5F00\u53D1\u8005\u5173\u7CFB\u5927\u4F1A-\u6210\u90FD\u5206\u4F1A\u573A","type":"\u76F4\u64AD\u89C2\u5F71 + \u73B0\u573A\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"\u5F00\u53D1\u8005\u5173\u7CFB\u5927\u4F1A-\u6210\u90FD\u5206\u4F1A\u573A","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170521","title":"Python+ Django \u5FEB\u901F\u642D\u5EFA Blog","type":"\u7F16\u7A0B\u6307\u5BFC","address":"\u62FE\u7EA7Cafe","describe":"Python+ Django \u5FEB\u901F\u642D\u5EFA Blog","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170603","title":"Game of Life. React?","type":"\u4E2A\u4EBA\u5206\u4EAB + \u7ED3\u5BF9\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"Game of Life. React?","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170618","title":"\u534A\u7A0B\u9ED1\u5BA2\u677E - \u590F\u5B63","type":"\u7F16\u7A0B\u9ED1\u5BA2\u677E","address":"\u62FE\u7EA7Cafe","describe":"\u534A\u7A0B\u9ED1\u5BA2\u677E - \u590F\u5B63","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170624","title":"Webassembly","type":"\u5FAE\u4FE1\u7FA4\u95EE\u7B54\u5F0F\u4EA4\u6D41","address":"\u62FE\u7EA7Cafe","describe":"Webassembly","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170702","title":"\u7A0B\u5E8F\u5458\u5982\u4F55\u63D0\u9AD8\u804C\u4E1A\u7ADE\u4E89\u529B + \u7A0B\u5E8F\u5458\u521B\u4E1A & \u9879\u76EE\u7BA1\u7406","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"\u7A0B\u5E8F\u5458\u5982\u4F55\u63D0\u9AD8\u804C\u4E1A\u7ADE\u4E89\u529B + \u7A0B\u5E8F\u5458\u521B\u4E1A & \u9879\u76EE\u7BA1\u7406","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170715","title":"DevOps\u4ECE\u7406\u8BBA\u5230\u5B9E\u8DF5 + \u654F\u6377\u56DB\u628A\u5200","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"DevOps\u4ECE\u7406\u8BBA\u5230\u5B9E\u8DF5 + \u654F\u6377\u56DB\u628A\u5200","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170730","title":"\u793E\u533A\u4E3B\u9875\u6539\u9020","type":"\u7ED3\u5BF9\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"\u793E\u533A\u4E3B\u9875\u6539\u9020","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170806","title":"\u7F16\u7A0B\u9759\u4FEE\u65E5","type":"\u81EA\u4E60\uFF0C\u4EA4\u6D41","address":"\u62FE\u7EA7Cafe","describe":"\u7F16\u7A0B\u9759\u4FEE\u65E5","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170812","title":"\u6D45\u8C08\u5982\u4F55\u63D0\u9AD8\u5DE5\u4F5C\u6548\u7387 + \u73B0\u573A\u7B54\u7591","type":"\u4E2A\u4EBA\u5206\u4EAB + \u73B0\u573A\u7B54\u7591","address":"\u62FE\u7EA7Cafe","describe":"\u6D45\u8C08\u5982\u4F55\u63D0\u9AD8\u5DE5\u4F5C\u6548\u7387 + \u73B0\u573A\u7B54\u7591","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170827","title":"H5 \u5728\u7EBF\u7F16\u8F91\u5668\u5DE5\u5177\u5F00\u53D1\u8BE6\u89E3","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"H5 \u5728\u7EBF\u7F16\u8F91\u5668\u5DE5\u5177\u5F00\u53D1\u8BE6\u89E3","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170910","title":"TypeScript\u5728\u9879\u76EE\u4E2D\u7684\u5E94\u7528","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"TypeScript\u5728\u9879\u76EE\u4E2D\u7684\u5E94\u7528","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20170924","title":"\u6709\u8DA3\u7684Three.js + \u9010\u6B65\u5728Docker\u4E2D\u6784\u5EFACI\u6D41\u7A0B","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"\u6709\u8DA3\u7684Three.js + \u9010\u6B65\u5728Docker\u4E2D\u6784\u5EFACI\u6D41\u7A0B","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20171021","title":"Jetbrains\u63D2\u4EF6\u5F00\u53D1\u5165\u95E8 + \u4E00\u5C0F\u65F6\u5165\u95E8Web\u5E94\u7528\u5F00\u53D1","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"Jetbrains\u63D2\u4EF6\u5F00\u53D1\u5165\u95E8 + \u4E00\u5C0F\u65F6\u5165\u95E8Web\u5E94\u7528\u5F00\u53D1","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20171105","title":"\u7528\u7B97\u6CD5\u89E3\u51B3\u5B9E\u9645\u95EE\u9898 + \u524D\u7AEF\u5B9E\u7528\u7B97\u6CD5\u4E32\u70E7","type":"\u4E2A\u4EBA\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"\u7528\u7B97\u6CD5\u89E3\u51B3\u5B9E\u9645\u95EE\u9898 + \u524D\u7AEF\u5B9E\u7528\u7B97\u6CD5\u4E32\u70E7","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20171119","title":"2017\u6210\u90FDWeb\u524D\u7AEF\u5927\u4F1A","type":"\u5927\u578B\u4EA4\u6D41\u6D3B\u52A8","address":"\u62FE\u7EA7Cafe","describe":"2017\u6210\u90FDWeb\u524D\u7AEF\u5927\u4F1A","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20171210","title":"\u7F16\u7A0B\u9053\u573A","type":"\u4E2A\u4EBA\u5206\u4EAB + \u7ED3\u5BF9\u7F16\u7A0B","address":"\u62FE\u7EA7Cafe","describe":"\u7F16\u7A0B\u9053\u573A","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]},{"time":"20180120","title":"\u3010Code for City\u3011\u9ED1\u5BA2\u677E","type":"\u7F16\u7A0B\u6BD4\u8D5B + \u8DEF\u6F14 + \u4E3B\u9898\u5206\u4EAB","address":"\u62FE\u7EA7Cafe","describe":"\u3010Code for City\u3011\u9ED1\u5BA2\u677E","imageList":[{"url":"./xxx","describe":"xxxxxxxxxxxx"}]}]');


var $ae100b1f0ce1f089$var$list = (0, (/*@__PURE__*/$parcel$interopDefault($f73399d3acc757b5$exports))).map(function(event) {
    return (0, $0187e934f6ca9418$export$71511d61b312f219)((0, $8b7df3d651e6781e$export$71511d61b312f219)({}, event), {
        date: "".concat(event.time.slice(0, 4), "\u5E74").concat(+event.time.slice(4, 6), "\u6708").concat(+event.time.slice(6), "\u65E5")
    });
}).reverse();
var $ae100b1f0ce1f089$var$items = $ae100b1f0ce1f089$var$list.map(function(param) {
    var type = param.type, title = param.title, date = param.date, describe = param.describe, _param_imageList = (0, $fTrHk._)(param.imageList, 1), tmp = _param_imageList[0], _ref = tmp === void 0 ? {} : tmp, _ref_url = _ref.url, url = _ref_url === void 0 ? "" : _ref_url;
    return {
        title: date,
        cardTitle: "".concat(type, " - ").concat(title),
        cardSubtitle: describe,
        cardDetailedText: describe,
        media: {
            type: "IMAGE",
            source: {
                url: url
            }
        }
    };
});
var $ae100b1f0ce1f089$export$ada873a34909da65 = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $efb54010aeb5074e$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $02be79ff10000d06$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                xs: 12,
                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $36ad047dac3e028c$export$263852f37093921b), {
                    items: $ae100b1f0ce1f089$var$items,
                    mode: "VERTICAL_ALTERNATING",
                    cardHeight: 200,
                    slideShow: true,
                    slideItemDuration: 3000,
                    theme: {
                        primary: "#0077B6",
                        secondary: "secondary",
                        cardBgColor: "bg-light",
                        cardForeColor: "text-dark",
                        titleColor: "text-primary"
                    },
                    fontSizes: {
                        cardTitle: "1.3rem",
                        cardSubtitle: "1rem",
                        cardText: "0.9rem",
                        title: "1rem"
                    },
                    timelinePointShape: "circle",
                    lineWidth: 3
                })
            })
        })
    });
};


/**
 * @desc 历史活动页面
 * @author
 */ 

var $fb6cbf916573ce97$exports = {};

$fb6cbf916573ce97$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "Microsoft.1f15902a.png";


var $304068456a8386da$exports = {};

$304068456a8386da$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "BBD.ad0b802e.png";


var $f3aa511826a1da33$exports = {};

$f3aa511826a1da33$exports = (parcelRequire("kqLtd")).getBundleURL("01RMl") + "GDG.0afa3c63.png";


var $0607539c0d7b4615$export$2e2bcd8739ae039 = [
    {
        title: "BBD",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($fb6cbf916573ce97$exports)))
    },
    {
        title: "MicroSoft",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($304068456a8386da$exports)))
    },
    {
        title: "GDG",
        img: (0, (/*@__PURE__*/$parcel$interopDefault($f3aa511826a1da33$exports)))
    }
];


var $c0dbca2a174d64e8$export$2ddb90ad54e5f587;
var $c0dbca2a174d64e8$export$334d3a9630770f88;
var $c0dbca2a174d64e8$export$63516df92e647578;
var $c0dbca2a174d64e8$export$fb184b623420d9be;
$c0dbca2a174d64e8$export$2ddb90ad54e5f587 = "uz6yJa_Panel";
$c0dbca2a174d64e8$export$334d3a9630770f88 = "uz6yJa_logo-img";
$c0dbca2a174d64e8$export$63516df92e647578 = "uz6yJa_logolist";
$c0dbca2a174d64e8$export$fb184b623420d9be = "uz6yJa_title";


var $87f77f1610b1f9a3$export$9648a89cfc14d8bd = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $02be79ff10000d06$export$2e2bcd8739ae039), {
        className: $c0dbca2a174d64e8$export$63516df92e647578,
        children: (0, $0607539c0d7b4615$export$2e2bcd8739ae039).map(function(param) {
            var img = param.img, title = param.title;
            return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $aa90d9fac4b169d8$export$2e2bcd8739ae039), {
                md: 2,
                xs: 4,
                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)("img", {
                    src: img,
                    alt: title,
                    className: $c0dbca2a174d64e8$export$334d3a9630770f88
                })
            }, img);
        })
    });
};


var $d8497a34fe1f473c$export$86fbec116b87613f = function() {
    return /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $f65357a60e386bb2$export$7c6e2c02157bb7d2), {
        children: [
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $91d6d90f0c403b88$export$d9b273488cd8ce6f), {}),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $684185656ea9d205$export$7221d69dcfc8e36b), {
                children: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsxs)((0, $826d0dca46b64dfb$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $826d0dca46b64dfb$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $6bd010c06d68f9a5$export$cf17b003b6192af3), {})
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $826d0dca46b64dfb$export$e7b0ac011bb776c6), {
                            path: "/events",
                            element: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $ae100b1f0ce1f089$export$ada873a34909da65), {})
                        }),
                        /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $826d0dca46b64dfb$export$e7b0ac011bb776c6), {
                            path: "/sponsors",
                            element: /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $87f77f1610b1f9a3$export$9648a89cfc14d8bd), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $3ad834f13fd9b8b2$export$a06f1c675e846f6f), {})
        ]
    });
};


var $1bf5cf6f7ebb5680$var$serviceWorker = window.navigator.serviceWorker, $1bf5cf6f7ebb5680$var$NODE_ENV = "production";
if ($1bf5cf6f7ebb5680$var$NODE_ENV !== "development") $1bf5cf6f7ebb5680$var$serviceWorker === null || $1bf5cf6f7ebb5680$var$serviceWorker === void 0 ? void 0 : $1bf5cf6f7ebb5680$var$serviceWorker.register("sw.js").then((0, $fa109827480cac3d$export$d635d04af3887bbe)).then(function(worker) {
    if (confirm("New version of this Web App detected, update now?")) worker.postMessage({
        type: "SKIP_WAITING"
    });
});
$1bf5cf6f7ebb5680$var$serviceWorker === null || $1bf5cf6f7ebb5680$var$serviceWorker === void 0 ? void 0 : $1bf5cf6f7ebb5680$var$serviceWorker.addEventListener("controllerchange", function() {
    return location.reload();
});
(0, $55c3e9599dcfbee0$export$882461b6382ed46c)(document.getElementById("root")).render(/*#__PURE__*/ (0, $978b871a0234f592$exports.jsx)((0, $d8497a34fe1f473c$export$86fbec116b87613f), {}));

})();
//# sourceMappingURL=index.01c2f1e3.js.map
